import { j as t, M as su } from "./react-markdown-D3zycGHc.js";
import xs, { memo as $e, useMemo as Pe, useCallback as Jt, useState as be, useEffect as kt, useContext as qu, createElement as Yu, useRef as wa } from "react";
import { Grid as g, ContentBlock as Re, FilterPanel as T0, transparentize as Wn, darken as _0, Box as le, lighten as Ma, NewTable as Ct, Spinner as ka, Block as Ci, Select as mn, Input as $n, Button as ct, Icon as bt, Alert as E0, Tooltip as Nt, Typography as ve, Paper as Hn, Divider as zt, AutocompleteInput as On, DatePicker as jr, CheckboxCell as st, InputCell as ba, Table as _n, Modal as _s, Checkbox as At, Autocomplete as Vt, Chip as A0, Rating as O0, flexRender as Xu, ButtonGroup as Es, EmptyTableStub as za, useWindowSize as R0, StyledTable as P0, TableHeadRow as lu, TableRow as as, StyledTableCell as si, BlockTitle as Ta, Radio as cu, Dialog as D0, DialogTitle as N0, IconButton as I0, DialogContent as L0, IconActionButtonFilled as F0, Slider as M0 } from "@prometheus/components";
import { DescriptionCard as wi, TitleWithCount as Ot, Chart as Ur, FormElement as Zt, Link as Zu, SpinnerWidgetContainer as k0, TabsNavigationNew as Ba, FormActionsContainer as Ju, InlineFormElement as Ke, BaseInfoWrapper as Qu, ActionCell as ed, ListCell as z0, IRChartScale as B0, DataSourceLogo as lr, NAME_COLUMN as Ti, SecondaryContentWrapper as td, CodeEditor as $0, FileContentType as W0, ListHeaderSecondary as H0, IconActionButton as V0 } from "@prometheus/features";
import Le from "@emotion/styled";
import { TypesOfContainer as os, AnalysisTypes as Sr, CreateSubmissionFormTabs as _a, AntivirusFileStatus as En, analysisTypes as nd, DateFormat as Tt, DateEdge as Oa, IntervalValue as rt, AnalysisSubmissionStatus as uu, FileExtension as Ra } from "@prometheus/enums";
import { formatNumber as te, capitalize as U0, uniqBy as ji, flattenDeep as G0, groupBy as rd, keyBy as Vn, reverse as id, sortBy as ad, debounce as od, api as As, convertExtendedToLegacyConcepts as K0, getFileExtension as q0, getFileIconName as sd, generateAlias as du, getLongNumberUUID as ld, formatDate as gs, isBoolean as Vr, isEqual as Os, convertFormatDate as Ca, checkFormatDate as hu, isString as cd, isObject as Pa, getCodeLanguageByFileExtension as ud, getUUID as ss } from "@prometheus/utils";
import { l as fu, c as dd, e as Y0, q as X0, t as hd, d as Z0, o as J0, a as Q0 } from "./d3-D2cgUV97.js";
import { Status as ir } from "@prometheus/types";
import { Rectangle as ey, Text as ty, ResponsiveContainer as Un, BarChart as Rs, CartesianGrid as _i, XAxis as Ei, YAxis as Ai, Tooltip as wr, Bar as Ps, Brush as fd, PieChart as pd, Pie as md, Cell as Ds, ScatterChart as ny, Scatter as ry, Legend as iy, ComposedChart as ay, ReferenceLine as pu, Area as oy, Line as sy } from "recharts";
import { ModalContext as xd, useSelectedConcepts as ly, getOverlayHistoryCount as ls, pushOverlayHistoryState as cy } from "@prometheus/hooks";
import { a as uy, c as Wr, P as dy } from "./plotly-vendor-Xl9RTeYD.js";
import { useParams as hy, Routes as fy, Route as li } from "react-router-dom";
import { c as py } from "./react-plotly.js-b7Wmpgy5.js";
Le.div`
  display: flex;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid
    ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.borderColor.main;
}};
`;
Le.div`
  font-size: 14px;
  color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
  font-weight: 700;
  padding-top: 16px;
`;
Le.div`
  font-size: 36px;
  text-align: center;
`;
const mu = Le.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 16px 0;
  color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.grey[400];
}};
`;
Le.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const my = Le.div`
  padding: 2px 15px;
`;
Le.div`
  margin: 15px;
`;
Le.div`
  /* background-color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.backgroundColor.main;
}}; */
  border-bottom: 1px solid
    ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.borderColor.main;
}};
  border-radius: 4px 4px 0 0;
  padding: 16px;
  h4 {
    margin: 0;
    color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    & + p {
      padding-top: 16px;
    }
  }
`;
const xy = Le.p`
  margin: 0;
  font-size: 14px;
`, It = (r, i, a) => {
  switch (r) {
    case os.WORKSPACE:
      return `/workspace/analyses/${i}`;
    case os.STUDY:
      return `/study-manager/${a}/analyses/${i}`;
    case os.LIBRARY:
      return `/library/analyses/${i}`;
  }
}, xu = {
  ARTIFACTS_LIBRARY: "ARTIFACTS_LIBRARY",
  CUSTOM_FEATURE_STORE: "CUSTOM_FEATURE_STORE"
}, Nj = $e((r) => {
  var v, b, E, A;
  const {
    id: i,
    subModules: a,
    parentId: s,
    typeContainer: l,
    design: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r, d = (R) => (D) => {
    m(R, D);
  }, f = Pe(
    () => Array.from(
      /* @__PURE__ */ new Set([
        ...(c == null ? void 0 : c.featureAnalyses) || [],
        ...(c == null ? void 0 : c.customFeatureAnalyses) || []
      ])
    ),
    [c == null ? void 0 : c.customFeatureAnalyses, c == null ? void 0 : c.featureAnalyses]
  ), C = Array.isArray(c == null ? void 0 : c.parameters) ? c.parameters.length : Object.keys((c == null ? void 0 : c.parameters) || {}).length;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1.5, children: [
    (!h || h && ((v = c == null ? void 0 : c.cohorts) == null ? void 0 : v.length) > 0) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(wi, { children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx("b", { children: "Cohort characterization" }),
        " is defined as the process of generating cohort level descriptive summary statistics from person level covariate data. Summary statistics of these person level covariates may be count, mean, sd, var, min, max, median, range, and quantiles. In addition, covariates during a period may be stratified into temporal units of time for time-series analysis such as fixed intervals of time relative to cohort_start_date (e.g. every 7 days, every 30 days etc.), or in absolute calendar intervals such as calendar-week, calendar-month, calendar-quarter, calendar-year."
      ] }) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        a.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: a,
          path: It(l, i, s),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ t.jsx(
              Ot,
              {
                title: "Target cohorts",
                count: (b = c == null ? void 0 : c.cohorts) == null ? void 0 : b.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: l,
            initialData: c == null ? void 0 : c.cohorts,
            onChange: d("cohorts"),
            isSelect: !0,
            parentId: s,
            returnEntityText: j,
            collapsible: !0,
            defaultState: !0,
            viewMode: h
          }
        }
      ) })
    ] }),
    (!h || h && f.length > 0) && /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      a.featureanalyses,
      {
        type: "component",
        name: "widget-feature-import-button",
        subModules: a,
        path: It(l, i, s),
        viewMode: h,
        config: {
          buttonText: "Import feature analysis",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Feature analyses",
              count: f.length
            }
          ),
          typeContainer: l,
          initialData: f,
          onChange: (R, D) => {
            var _;
            m("featureAnalyses", R), (_ = c == null ? void 0 : c.customFeatureAnalyses) != null && _.length && m("customFeatureAnalyses", []);
          },
          isSelect: !0,
          parentId: s,
          returnEntityText: j,
          defaultState: h,
          modalTitle: "Import feature analyses",
          availableSources: [
            xu.ARTIFACTS_LIBRARY,
            xu.CUSTOM_FEATURE_STORE
          ]
        }
      }
    ) }) }),
    (!h || h && C > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      a.featureanalyses,
      {
        type: "component",
        name: "widget-feature-params",
        subModules: a,
        path: It(l, i, s),
        config: {
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Feature analyses parameters",
              count: C
            }
          ),
          initialParams: c == null ? void 0 : c.parameters,
          onChange: (R) => {
            m(
              "parameters",
              Array.isArray(R) ? R : Object.values(R || {})
            );
          },
          defaultState: h,
          viewMode: h
        }
      }
    ) }),
    (!h || h && ((E = c == null ? void 0 : c.strata) == null ? void 0 : E.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
      Re,
      {
        collapsible: !0,
        title: /* @__PURE__ */ t.jsx(
          Ot,
          {
            title: "Subgroup analyses",
            count: (A = c == null ? void 0 : c.strata) == null ? void 0 : A.length
          }
        ),
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: [
          /* @__PURE__ */ t.jsx(xy, { children: "You can provide optional stratification criteria to the analysis that will divide the population into unique groups based on their satisfied criteria." }),
          /* @__PURE__ */ t.jsx(my, { children: /* @__PURE__ */ t.jsx(
            a.cohort,
            {
              type: "component",
              name: "widget-criteria-group",
              subModules: a,
              config: {
                onChange: (R, D) => {
                  m("strata", R);
                },
                onChangeStrataOnly: (R) => {
                  m("strataOnly", R);
                },
                onChangeStrataBy: (R) => {
                  m("stratifiedBy", R);
                },
                typeContainer: l,
                parentId: s,
                values: (c == null ? void 0 : c.strata) || [],
                buttonText: "New subgroup",
                titleText: "Subgroup analyses",
                isDesignStrata: !0,
                strataParams: {
                  strataOnly: c.strataOnly,
                  stratifiedBy: c.stratifiedBy
                },
                hiddenParentConcept: !0,
                contextConceptSets: {
                  conceptSets: c == null ? void 0 : c.strataConceptSets,
                  updateConceptSets: (R) => {
                    m("strataConceptSets", R);
                  }
                },
                viewMode: h
              }
            }
          ) })
        ]
      }
    ) })
  ] });
}), Ij = () => ({
  cohorts: [],
  featureAnalyses: [],
  customFeatureAnalyses: [],
  embeddedFeatureAnalyses: [],
  parameters: [],
  strata: [],
  strataConceptSets: [],
  strataOnly: !1,
  stratifiedBy: null
}), Lj = (r) => {
  var i;
  return `${te(((i = r == null ? void 0 : r.reports) == null ? void 0 : i.length) || 0)} reports`;
}, Fj = (r, i) => ({
  ...i,
  type: r.type
  // strataConceptSets: design.strataConceptSets.map(cs => ({
  //   ...cs,
  //   expression: {
  //     ...cs.expression,
  //     items: cs.expression.items.map(item => {
  //       const newItem = { ...item };
  //       if (
  //         item.concept.STANDARD_CONCEPT === StandardConceptTypes.NON_STANDARD
  //       ) {
  //         newItem.hierarchy = newItem.includeDescendants;
  //         delete newItem.includeMapped;
  //         delete newItem.includeDescendants;
  //       }
  //       return newItem;
  //     }),
  //   },
  // })),
}), gy = $e((r) => {
  const { reports: i, cohorts: a } = r, s = Pe(() => i.map((h) => {
    const d = h == null ? void 0 : h.analysisName, f = h != null && h.item ? h == null ? void 0 : h.item.map((C) => {
      var v, b, E, A;
      return {
        covariateName: C.covariateName,
        xValue: ((b = (v = C == null ? void 0 : C.records) == null ? void 0 : v[0]) == null ? void 0 : b.avg) * 100 || 0,
        yValue: ((A = (E = C == null ? void 0 : C.records) == null ? void 0 : E[1]) == null ? void 0 : A.avg) * 100 || 0
      };
    }) : [];
    return {
      name: d,
      values: f
    };
  }), [i]), l = fu().domain([0, 100]), c = fu().domain([0, 100]), m = dd;
  return /* @__PURE__ */ t.jsx(
    Ur,
    {
      type: "scatterplot",
      chartData: s,
      options: () => {
        var j, h;
        return {
          xLabel: (j = a == null ? void 0 : a[0]) == null ? void 0 : j.name,
          yLabel: (h = a == null ? void 0 : a[1]) == null ? void 0 : h.name,
          colors: m,
          circleRadius: 4,
          addDiagonal: !0,
          xScale: l,
          yScale: c,
          tooltip: (d) => `
            <div class="tooltip-scatterplot">Series: ${d.seriesName}</div>
            <div class="tooltip-scatterplot">Covariate: ${d.covariateName}</div>
            <div class="tooltip-scatterplot"> X: ${d.xValue.toFixed(2)}%</div>
            <div class="tooltip-scatterplot">Y: ${d.yValue.toFixed(2)}%</div>
            `
        };
      }
    }
  );
}), gd = $e((r) => {
  const { report: i, cohorts: a, items: s, records: l } = r, c = Pe(() => {
    var C, v, b, E, A, R;
    const m = s || [
      {
        covariateName: (v = (C = i.item) == null ? void 0 : C[0]) == null ? void 0 : v.covariateName,
        name: (E = (b = i.item) == null ? void 0 : b[0]) == null ? void 0 : E.name,
        records: l || ((R = (A = i.item) == null ? void 0 : A[0]) == null ? void 0 : R.records) || []
      }
    ], j = (D) => Array.isArray(D.records) ? D.records : Object.values(D.records || {}), h = (D) => D.covariateName || D.fullCovariateName || D.name || "", d = (D, _) => {
      const F = (_ == null ? void 0 : _.min) ?? (_ == null ? void 0 : _.minValue), P = (_ == null ? void 0 : _.max) ?? (_ == null ? void 0 : _.maxValue), x = (_ == null ? void 0 : _.median) ?? (_ == null ? void 0 : _.medianValue), p = (_ == null ? void 0 : _.p25) ?? (_ == null ? void 0 : _.p25Value) ?? x, y = (_ == null ? void 0 : _.p75) ?? (_ == null ? void 0 : _.p75Value) ?? x;
      return {
        Category: D.name,
        min: F,
        max: P,
        median: x,
        LIF: (_ == null ? void 0 : _.p10) ?? (_ == null ? void 0 : _.p10Value) ?? F,
        q1: p,
        q3: y,
        UIF: (_ == null ? void 0 : _.p90) ?? (_ == null ? void 0 : _.p90Value) ?? P
      };
    }, f = (D) => [D.min, D.max, D.median, D.q1, D.q3].every(
      (_) => _ != null && !Number.isNaN(_)
    );
    return m.map((D) => {
      const _ = j(D), F = d(
        a == null ? void 0 : a[0],
        _.find((x) => x.cohortId === (a == null ? void 0 : a[0].id))
      ), P = d(
        a == null ? void 0 : a[1],
        _.find((x) => x.cohortId === (a == null ? void 0 : a[1].id))
      );
      return {
        Category: h(D) || F.Category,
        target: F,
        compare: P
      };
    }).filter(
      (D) => f(D.target) && f(D.compare)
    );
  }, [a, s, l, i]);
  return /* @__PURE__ */ t.jsx(
    Ur,
    {
      type: "splitBoxplot",
      chartData: c,
      options: () => ({
        showYAxis: !0,
        boxHeight: 40,
        minHeight: 125,
        valueFormatter: (m) => m,
        format: {
          valueFormatter: (m) => m
        }
      })
    }
  );
}), vy = $e((r) => {
  const { report: i, cohorts: a, items: s, records: l } = r, c = Pe(() => {
    var j, h, d, f, C, v;
    return s || [
      {
        covariateName: (h = (j = i.item) == null ? void 0 : j[0]) == null ? void 0 : h.covariateName,
        name: (f = (d = i.item) == null ? void 0 : d[0]) == null ? void 0 : f.name,
        records: l || ((v = (C = i.item) == null ? void 0 : C[0]) == null ? void 0 : v.records) || []
      }
    ];
  }, [s, l, i]), m = Pe(() => {
    if (!c.length) return [];
    const j = (C) => Array.isArray(C.records) ? C.records : Object.values(C.records || {}), h = (C) => C.covariateName || C.fullCovariateName || C.name || "", d = (C, v) => {
      const b = (v == null ? void 0 : v.min) ?? (v == null ? void 0 : v.minValue), E = (v == null ? void 0 : v.max) ?? (v == null ? void 0 : v.maxValue), A = (v == null ? void 0 : v.median) ?? (v == null ? void 0 : v.medianValue), R = (v == null ? void 0 : v.p25) ?? (v == null ? void 0 : v.p25Value) ?? A, D = (v == null ? void 0 : v.p75) ?? (v == null ? void 0 : v.p75Value) ?? A;
      return {
        min: b,
        max: E,
        median: A,
        LIF: (v == null ? void 0 : v.p10) ?? (v == null ? void 0 : v.p10Value) ?? b,
        q1: R,
        q3: D,
        UIF: (v == null ? void 0 : v.p90) ?? (v == null ? void 0 : v.p90Value) ?? E
      };
    }, f = (C) => [C.min, C.max, C.median, C.q1, C.q3].every(
      (v) => v != null && !Number.isNaN(v)
    );
    return c.map((C) => {
      const v = j(C), b = h(C), E = a.map((A) => {
        const R = v.find(
          (_) => _.cohortId === A.id
        );
        return {
          ...d(A, R),
          Category: A.name
        };
      }).filter(f);
      return {
        name: b,
        data: E
      };
    }).filter((C) => C.data.length);
  }, [a, c]);
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: m.map((j, h) => {
    const d = Math.max(110, j.data.length * 34 + 42);
    return /* @__PURE__ */ t.jsxs("div", { children: [
      j.name && /* @__PURE__ */ t.jsx("div", { style: { fontWeight: 600, marginBottom: 4 }, children: j.name }),
      /* @__PURE__ */ t.jsx("div", { style: { width: "100%", height: d }, children: /* @__PURE__ */ t.jsx(
        Ur,
        {
          type: "horizontalBoxplot",
          chartData: j.data,
          options: () => ({
            showYAxis: !0,
            minHeight: 125,
            boxHeight: 20,
            valueFormatter: (f) => f,
            format: {
              valueFormatter: (f) => f
            }
          })
        }
      ) })
    ] }, `${j.name || "distribution"}-${h}`);
  }) });
});
var Dt = /* @__PURE__ */ ((r) => (r.PREVALENCE = "PREVALENCE", r.DISTRIBUTION = "DISTRIBUTION", r))(Dt || {}), vd = /* @__PURE__ */ ((r) => (r.PRESET = "PRESET", r))(vd || {});
const yy = Le.div`
  width: 100%;
  height: 450px;
`;
$e((r) => {
  const { reports: i, cohorts: a, type: s } = r, l = Jt(() => {
    switch (s) {
      case Dt.PREVALENCE:
        return /* @__PURE__ */ t.jsx(gy, { reports: i || [], cohorts: a || [] });
      case Dt.DISTRIBUTION: {
        const [c] = i;
        return /* @__PURE__ */ t.jsx(gd, { report: c || {}, cohorts: a || [] });
      }
      default:
        return /* @__PURE__ */ t.jsx(t.Fragment, {});
    }
  }, [i, a]);
  return /* @__PURE__ */ t.jsx(yy, { children: l() });
});
const by = Le.div`
  .filter-containter {
    display: flex;
    gap: 12px;

    .c-filter-panel {
      min-width: 300px;
    }
  }
`;
var Ea = /* @__PURE__ */ ((r) => (r.COHORTS = "cohorts", r.ANALYSES = "reports", r.DOMAINS = "domains", r))(Ea || {});
const cs = (r = [], i = null, a = null, s = !1) => r.map((l) => {
  const c = (l == null ? void 0 : l[a]) ?? (l == null ? void 0 : l.name) ?? (l == null ? void 0 : l.realNameAnalysis) ?? (l == null ? void 0 : l.analysisName) ?? (l == null ? void 0 : l.designName) ?? (l == null ? void 0 : l.domain) ?? (l == null ? void 0 : l.id) ?? (l == null ? void 0 : l.analysisId) ?? l, m = typeof c == "object" ? "" : String(c);
  return {
    value: (l == null ? void 0 : l[i]) ?? l,
    name: s ? U0(m) : m
  };
}), Cy = (r) => {
  const { reports: i, cohorts: a, onFilterResults: s, value: l, status: c } = r, m = cs(
    a,
    "id",
    "name"
  ), j = cs(
    i,
    "analysisId",
    "realNameAnalysis"
  ), h = cs(
    ji(i, "domain"),
    "domain",
    "domain",
    !0
  ), d = [
    {
      type: "multiselect",
      name: "cohorts",
      label: "Cohorts",
      options: m
    },
    {
      type: "multiselect",
      name: "reports",
      label: "Analyses",
      options: j
    },
    {
      type: "multiselect",
      name: "domains",
      label: "Domains",
      options: h
    }
  ], f = (v, b) => {
    switch (v) {
      case Ea.COHORTS:
        s(
          v,
          b.length ? a.filter((E) => b.includes(E.id)) : a[0] ? [a[0]] : []
        );
        break;
      case Ea.ANALYSES:
        s(
          v,
          b.length ? i.filter(
            (E) => b.includes(E.analysisId)
          ) : i
        );
        break;
      case Ea.DOMAINS:
        s(v, b);
        break;
    }
  }, C = Object.keys(l).reduce((v, b) => (v[b] = l[b].map(
    (E) => (E == null ? void 0 : E.value) || (E == null ? void 0 : E.analysisId) || (E == null ? void 0 : E.id) || E
  ), v), {});
  return /* @__PURE__ */ t.jsx(by, { children: /* @__PURE__ */ t.jsx(
    T0,
    {
      showLabel: !0,
      filters: d,
      hiddenTags: !0,
      value: C,
      className: "filter-containter",
      onChange: f,
      isReloading: c === ir.IN_PROGRESS
    }
  ) });
}, yd = (r) => {
  const { report: i, cohorts: a, items: s, records: l } = r;
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: a.length === 2 ? /* @__PURE__ */ t.jsx(
    gd,
    {
      report: i || {},
      cohorts: a || [],
      items: s,
      records: l
    }
  ) : /* @__PURE__ */ t.jsx(
    vy,
    {
      report: i || {},
      cohorts: a || [],
      items: s,
      records: l
    }
  ) });
};
function Da(r) {
  return r == null ? "" : r.replace(/([A-Z])/g, " $1").trim();
}
const Ns = Le.div`
  background: #ffffff;
  padding: 5px;
`, bd = (r) => {
  if (r.active && r.payload && r.payload.length) {
    const i = parseFloat(r.payload[0].value) < 100 ? r.payload[0].value : parseInt(r.payload[0].value), a = r.payload[0].payload;
    return /* @__PURE__ */ t.jsxs(Ns, { children: [
      /* @__PURE__ */ t.jsx(Zt, { name: "series", textLabel: "Series", inline: !0, children: ": " + Da(a == null ? void 0 : a.analysisType) }),
      /* @__PURE__ */ t.jsx(Zt, { name: "covariate", textLabel: "Covariate", inline: !0, children: ": " + Da(a == null ? void 0 : a.tooltip) }),
      /* @__PURE__ */ t.jsxs(
        Zt,
        {
          name: r.payload[0].payload.name,
          textLabel: "Pct, %",
          inline: !0,
          children: [
            ": " + i,
            "%"
          ]
        }
      )
    ] });
  }
  return null;
}, jy = (r) => r.active && r.payload && r.payload.length ? /* @__PURE__ */ t.jsx(Ns, { children: /* @__PURE__ */ t.jsx(
  Zt,
  {
    name: r.payload[0].payload.name,
    textLabel: r.payload[0].payload.name,
    children: r.labelField ? r.payload[0].payload[r.labelField] : r.payload[0].value
  }
) }) : null, Sy = (r) => /* @__PURE__ */ t.jsxs("g", { children: [
  /* @__PURE__ */ t.jsx(
    ey,
    {
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height,
      fill: r.fill
    }
  ),
  /* @__PURE__ */ t.jsx(
    ty,
    {
      angle: 90,
      x: r.x + r.width / 3.5,
      y: r.y + r.height - 10,
      fontSize: 12,
      fill: "#333",
      textAnchor: "end",
      dominantBaseline: "start",
      children: r.name
    }
  )
] }), Cd = $e((r) => {
  const { list: i, cohort: a } = r, s = Math.floor(450 / 6.8), l = Pe(() => i.map((c) => {
    var m, j, h, d;
    return {
      analysisType: c == null ? void 0 : c.analysisType,
      name: ((m = c.covariateName) == null ? void 0 : m.length) > s ? c.covariateName.slice(0, s) + "..." : c.covariateName,
      tooltip: c.covariateName,
      pct: ((((j = c.records[a.id]) == null ? void 0 : j.avg) || ((d = (h = c.records[a.id]) == null ? void 0 : h[0]) == null ? void 0 : d.avg)) * 100).toFixed(3)
    };
  }), [i]);
  return /* @__PURE__ */ t.jsx(Un, { height: 470, children: /* @__PURE__ */ t.jsxs(
    Rs,
    {
      data: l,
      margin: {
        top: 15,
        right: 10,
        left: 10,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ t.jsx(_i, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ t.jsx(
          Ei,
          {
            dataKey: "name",
            tickCount: 0,
            tick: !1,
            label: {
              value: "Covariate",
              position: "insideBottom",
              offset: 10,
              fontSize: "13px"
            }
          }
        ),
        /* @__PURE__ */ t.jsx(
          Ai,
          {
            unit: "%",
            tickSize: 1,
            domain: [0, 100],
            label: {
              value: "Pct, %",
              angle: -90,
              offset: 20,
              position: "insideLeft",
              fontSize: "13px"
            },
            tick: { fontSize: "13px" }
          }
        ),
        /* @__PURE__ */ t.jsx(
          wr,
          {
            content: /* @__PURE__ */ t.jsx(bd, {}),
            cursor: { fill: Wn(0.8, _0(0.2, "#ebeef4")) }
          }
        ),
        /* @__PURE__ */ t.jsx(
          Ps,
          {
            dataKey: "pct",
            fill: Wn(0.3, "#7ba9ff"),
            shape: /* @__PURE__ */ t.jsx(Sy, {})
          }
        ),
        l.length > 20 && /* @__PURE__ */ t.jsx(fd, { dataKey: "name", height: 20, stroke: "#7ba9ff" })
      ]
    }
  ) });
}), Mj = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], Hr = {
  COLORS: ["#7ba9ff", "#ff9315", "#55DBCB", "#DC6BAD"],
  RADIAN: Math.PI / 180
}, wy = ({
  cx: r,
  cy: i,
  midAngle: a,
  innerRadius: s,
  outerRadius: l,
  percent: c,
  index: m
}) => {
  const j = s + (l - s) * 0.5, h = r + j * Math.cos(-a * Hr.RADIAN), d = i + j * Math.sin(-a * Hr.RADIAN);
  return /* @__PURE__ */ t.jsx(
    "text",
    {
      x: h,
      y: d,
      fill: "white",
      textAnchor: h > r ? "start" : "end",
      dominantBaseline: "central",
      children: `${(c * 100).toFixed(2)}%`
    }
  );
}, jd = $e((r) => {
  const { list: i, cohort: a, addNA: s } = r, l = Pe(() => {
    let c = [];
    if (c = i.map((m) => {
      var j, h, d, f;
      return {
        name: m.covariateName,
        value: parseFloat(
          ((((j = m.records[a.id]) == null ? void 0 : j.avg) || ((d = (h = m.records[a.id]) == null ? void 0 : h[0]) == null ? void 0 : d.avg)) * 100).toFixed(2)
        ),
        count: (f = m.records[a.id]) == null ? void 0 : f.count
      };
    }), s) {
      const m = parseFloat(
        (i.reduce(
          (j, h) => {
            var d, f, C;
            return j + (((d = h.records[a.id]) == null ? void 0 : d.avg) || ((C = (f = h.records[a.id]) == null ? void 0 : f[0]) == null ? void 0 : C.avg));
          },
          0
        ) * 100).toFixed(2)
      );
      if (m < 100) {
        const j = parseFloat((100 - m).toFixed(2));
        c.push({
          name: "N/A",
          value: j,
          count: ""
        });
      }
    }
    return c;
  }, [i]);
  return /* @__PURE__ */ t.jsx(Un, { height: 450, children: /* @__PURE__ */ t.jsxs(pd, { children: [
    /* @__PURE__ */ t.jsx(
      md,
      {
        data: l,
        cx: "50%",
        cy: "50%",
        labelLine: !1,
        label: wy,
        fill: "#7ba9ff",
        dataKey: "value",
        children: l.map((c, m) => /* @__PURE__ */ t.jsx(
          Ds,
          {
            fill: Hr.COLORS[m % (Hr.COLORS.length - (m >= Hr.COLORS.length ? Hr.COLORS.length : 0))]
          },
          `cell-${m}`
        ))
      }
    ),
    /* @__PURE__ */ t.jsx(wr, { content: /* @__PURE__ */ t.jsx(jy, { labelField: "count" }) })
  ] }) });
}), Ty = (r) => {
  const { active: i, payload: a } = r;
  if (i && a && a.length) {
    const s = a[0].payload;
    return /* @__PURE__ */ t.jsxs(Ns, { children: [
      /* @__PURE__ */ t.jsx(Zt, { name: "series", textLabel: "Series", inline: !0, children: ": " + Da(s == null ? void 0 : s.analysisType) }),
      /* @__PURE__ */ t.jsx(Zt, { name: "covariate", textLabel: "Covariate", inline: !0, children: ": " + Da(s == null ? void 0 : s.covariateName) }),
      a.map((l, c) => /* @__PURE__ */ t.jsxs(Zt, { name: l == null ? void 0 : l.name, textLabel: l == null ? void 0 : l.name, inline: !0, children: [
        ": " + parseFloat(l == null ? void 0 : l.value).toFixed(2),
        l == null ? void 0 : l.unit
      ] }, c))
    ] });
  }
  return null;
}, _y = (r, i, a) => {
  if (a)
    switch (r.analysisType) {
      case "ConditionEraAnyTimePrior":
        return "#7ba9ff";
      case "DrugGroupEraAnyTimePrior":
        return "#7bffa4";
      case "ConditionGroupEraAnyTimePrior":
        return "#ff7b7b";
      case "MeasurementAnyTimePrior":
        return "#fcff7b";
      case "DrugExposureAnyTimePrior":
        return "#af7bff";
      case "ConditionOccurrenceAnyTimePrior":
        return "#ff7be2";
      case "DemographicsEthnicity":
        return "#ff4c4c";
      case "DemographicsAgeGroup":
        return "#6a4cff";
      case "DemographicsGender":
        return "#4cffef";
      case "DrugEraAnyTimePrior":
        return "#11ad07";
      case "CharlsonIndex":
        return "#6a7105";
      case "DemographicsAge":
        return "#a886b5";
      case "Chads2":
        return "#343434";
    }
  return "#7ba9ff";
}, Sd = $e((r) => {
  const { list: i, cohorts: a, allResults: s, fullList: l } = r, [c, m] = be({ width: 0, height: 0 }), j = Math.floor(c.width / 9), h = Math.floor(c.height / 9), d = Pe(() => i.map((v) => {
    var b, E, A, R, D, _, F, P, x, p, y, w, M, V;
    return {
      analysisType: v == null ? void 0 : v.analysisType,
      covariateName: v == null ? void 0 : v.covariateName,
      xValue: ((((A = (E = v == null ? void 0 : v.records) == null ? void 0 : E[(b = a[0]) == null ? void 0 : b.id]) == null ? void 0 : A.avg) || ((F = (_ = (D = v == null ? void 0 : v.records) == null ? void 0 : D[(R = a[0]) == null ? void 0 : R.id]) == null ? void 0 : _[0]) == null ? void 0 : F.avg)) * 100 || 0).toFixed(3),
      yValue: ((((p = (x = v == null ? void 0 : v.records) == null ? void 0 : x[(P = a[1]) == null ? void 0 : P.id]) == null ? void 0 : p.avg) || ((V = (M = (w = v == null ? void 0 : v.records) == null ? void 0 : w[(y = a[1]) == null ? void 0 : y.id]) == null ? void 0 : M[0]) == null ? void 0 : V.avg)) * 100 || 0).toFixed(3)
    };
  }), [i, a]), f = Pe(() => {
    if (s && a.length > 1) {
      const v = Object.keys(l).map((b) => l[b].map((A) => {
        var R, D, _, F, P, x, p, y, w, M, V, q, $, I;
        return {
          analysisType: A == null ? void 0 : A.analysisType,
          covariateName: A == null ? void 0 : A.covariateName,
          xValue: ((((_ = (D = A == null ? void 0 : A.records) == null ? void 0 : D[(R = a[0]) == null ? void 0 : R.id]) == null ? void 0 : _.avg) || ((p = (x = (P = A == null ? void 0 : A.records) == null ? void 0 : P[(F = a[0]) == null ? void 0 : F.id]) == null ? void 0 : x[0]) == null ? void 0 : p.avg)) * 100 || 0).toFixed(3),
          yValue: ((((M = (w = A == null ? void 0 : A.records) == null ? void 0 : w[(y = a[1]) == null ? void 0 : y.id]) == null ? void 0 : M.avg) || ((I = ($ = (q = A == null ? void 0 : A.records) == null ? void 0 : q[(V = a[1]) == null ? void 0 : V.id]) == null ? void 0 : $[0]) == null ? void 0 : I.avg)) * 100 || 0).toFixed(3)
        };
      }));
      return G0(v);
    }
  }, [a, s, l]), C = Jt((v, b) => (v == null ? void 0 : v.length) > b ? v.slice(0, b) + "..." : v, []);
  return /* @__PURE__ */ t.jsx(
    Un,
    {
      height: 450,
      onResize: (v, b) => m({ width: v, height: b }),
      children: /* @__PURE__ */ t.jsxs(
        ny,
        {
          margin: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          },
          children: [
            /* @__PURE__ */ t.jsx(_i, {}),
            /* @__PURE__ */ t.jsx(
              Ai,
              {
                label: {
                  value: C(a[1].name, h),
                  angle: -90,
                  position: "innerLeft",
                  fontSize: "13px",
                  dx: -20
                },
                name: a[1].name,
                type: "number",
                dataKey: "yValue",
                unit: "%",
                width: 40,
                tick: { fontSize: "13px" }
              }
            ),
            /* @__PURE__ */ t.jsx(
              Ei,
              {
                label: {
                  value: C(a[0].name, j),
                  position: "insideBottom",
                  fontSize: "13px",
                  dy: 15
                },
                type: "number",
                dataKey: "xValue",
                name: a[0].name,
                unit: "%",
                height: 30,
                width: c.width,
                tick: { fontSize: "13px" }
              }
            ),
            /* @__PURE__ */ t.jsx(
              wr,
              {
                cursor: { strokeDasharray: "3 3" },
                content: /* @__PURE__ */ t.jsx(Ty, {})
              }
            ),
            /* @__PURE__ */ t.jsx(
              ry,
              {
                name: "",
                data: s ? f : d,
                fill: "#7ba9ff",
                children: f && f.map((v, b) => /* @__PURE__ */ t.jsx(
                  Ds,
                  {
                    fill: _y(v, b, s)
                  },
                  `cell-${b}`
                ))
              }
            )
          ]
        }
      )
    }
  );
}), wd = (r, i = 10) => {
  const a = {};
  let s = 0;
  const l = r.length, c = l / i, m = parseInt(c) + (l % i > 0 ? 1 : 0);
  return r.forEach((j, h) => {
    s = Math.floor(h / i), a[s] || (a[s] = []), a[s].push(j);
  }), {
    list: a,
    countElements: l,
    countPage: m
  };
}, Ey = (r) => {
  const { payload: i, mapper: a } = r;
  return /* @__PURE__ */ t.jsx(le, { ml: 6, display: "flex", justifyContent: "space-around", flexWrap: "wrap", children: i.map((s, l) => /* @__PURE__ */ t.jsx(
    le,
    {
      sx: {
        fontSize: 13,
        color: s.color,
        lineHeight: "12px",
        mb: 1,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        "::before": {
          content: '""',
          height: "8px",
          width: "8px",
          backgroundColor: s.color,
          borderRadius: "50%",
          display: "inline-block",
          mr: 1
        }
      },
      children: a[s.value] || s.value
    },
    `item-${l}`
  )) });
}, An = ["#7ba9ff", "#ff9315", "#DC6BAD", "#55DBCB"], Td = $e((r) => {
  const { list: i, cohorts: a, xAxisTickFormatter: s } = r, l = Pe(() => i.map((c) => ({
    analysisType: c == null ? void 0 : c.analysisType,
    name: c.covariateName,
    ...a.reduce((m, j) => {
      var h, d, f;
      return m[j.id] = ((((h = c.records[j.id]) == null ? void 0 : h.avg) || ((f = (d = c.records[j.id]) == null ? void 0 : d[0]) == null ? void 0 : f.avg)) * 100).toFixed(3), m;
    }, {})
  })), [i]);
  return /* @__PURE__ */ t.jsx(Un, { height: 470, children: /* @__PURE__ */ t.jsxs(
    Rs,
    {
      data: l,
      margin: {
        top: 20,
        right: 10,
        left: 10,
        bottom: 5
      },
      children: [
        /* @__PURE__ */ t.jsx(_i, { strokeDasharray: "3 3" }),
        /* @__PURE__ */ t.jsx(
          Ei,
          {
            dataKey: "name",
            fontSize: 12,
            tickFormatter: s
          }
        ),
        /* @__PURE__ */ t.jsx(
          Ai,
          {
            unit: "%",
            tickSize: 1,
            domain: [0, 100],
            label: {
              value: "Pct, %",
              angle: -90,
              position: "innerLeft",
              fontSize: "13px",
              dx: -20
            },
            fontSize: 14
          }
        ),
        /* @__PURE__ */ t.jsx(
          iy,
          {
            align: "center",
            iconType: "circle",
            content: (c) => /* @__PURE__ */ t.jsx(
              Ey,
              {
                ...c,
                mapper: a.reduce(
                  (m, j) => ({ ...m, [j.id]: j.name }),
                  {}
                )
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(wr, { content: /* @__PURE__ */ t.jsx(bd, {}) }),
        a.map((c, m) => /* @__PURE__ */ t.jsx(
          Ps,
          {
            dataKey: c.id,
            fill: m >= An.length ? Ma(
              `0.${m / (1 * An.length)}`,
              An[m % An.length]
            ) : An[m]
          }
        )),
        l.length > 20 && /* @__PURE__ */ t.jsx(fd, { dataKey: "name", height: 20, stroke: "#7ba9ff" })
      ]
    }
  ) });
});
Le.div`
  flex: 1;
  min-width: 60%;
  margin-right: 16px;
`;
const vs = Le.div`
  width: calc(100% - 16px);
  background: var(--bgcolor-dark);
  font-size: 14px;
  padding: 0;
  color: #333333;
  position: absolute;
  height: calc(100% - 8px);
  z-index: 1;
  top: 4px;

  &::after {
    content: '${(r) => r.label}';
    text-indent: 8px;
    line-height: 1.8em;
    display: block;
    width: ${(r) => r.width || 0}%;
    background: ${(r) => Wn(0.3, r.color || "#7ba9ff")};

    padding: 0;
    position: absolute;
    height: 100%;
    z-index: 2;
  }
`, ys = Le.div`
  z-index: 3;
  position: relative;
`, Ay = "CUSTOM_FE", gu = (r) => r.find((i) => i != null && i !== ""), vu = (r, i) => {
  const a = (i == null ? void 0 : i.faType) === Ay, s = gu([
    r.fullCovariateName,
    r.full_covariate_name
  ]), l = gu([
    r.covariateName,
    r.covariate_name,
    r.name
  ]);
  return a ? s ?? l ?? r.covariateId ?? "" : l ?? s ?? r.covariateId ?? "";
}, Oy = (r, i, a) => {
  let s = [];
  switch (r) {
    case Dt.PREVALENCE:
      s = ((i == null ? void 0 : i.item) || []).map((l) => {
        const c = l.analysisType || a, m = vu(l, i), j = (l.records || []).reduce((h, d) => {
          const f = d.cohortId, C = d.strataId ?? 0;
          return h[f] || (h[f] = {}), h[f][C] || (h[f][C] = d), h;
        }, {});
        return {
          ...l,
          covariateName: m,
          analysisType: c,
          records: j
        };
      });
      break;
    case Dt.DISTRIBUTION:
      ((i == null ? void 0 : i.item) || []).map((l) => {
        const c = l.analysisType || a, m = vu(l, i);
        let j = {};
        Object.entries(
          rd(l.records || [], (h) => h.strataId || 0)
        ).forEach(([h, d]) => {
          j[h] = {
            covariateName: m,
            conceptId: l.conceptId,
            analysisType: c,
            records: Vn(d, "cohortId")
          };
        }), s.push(...Object.values(j));
      });
      break;
  }
  return s;
}, Ry = (r, i, a, s = !0, l = !1, c = !1) => {
  const m = (h) => {
    if (h == null || h === "") return 0;
    const d = Number(h);
    return Number.isNaN(d) ? 0 : d;
  };
  let j = [];
  switch (r) {
    case Dt.PREVALENCE:
      j = [
        {
          header: "Covariate",
          id: "covariateName",
          accessorKey: "covariateName",
          maxSize: 120,
          meta: {
            filterVariant: "value"
          }
          // sortType: sortByString('covariateName'),
        },
        {
          header: "Concept Id",
          id: "conceptId",
          accessorKey: "conceptId",
          maxSize: 120,
          minSize: 80,
          enableColumnFilter: !1,
          cell: ({ getValue: h }) => /* @__PURE__ */ t.jsx(Zu, { to: `modal/related/${h()}`, children: h() })
        },
        ...i.map((h, d) => ({
          header: /* @__PURE__ */ t.jsx(le, { sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: h.name }),
          id: h.id,
          // align: 'center',
          // disableSortBy: true,
          columns: [
            ...c ? [] : [
              {
                header: "Count",
                id: `records___${h.id}.0.count`,
                accessorFn: (f) => {
                  var C, v, b;
                  return m((b = (v = (C = f == null ? void 0 : f.records) == null ? void 0 : C[h.id]) == null ? void 0 : v[0]) == null ? void 0 : b.count);
                },
                minSize: 60,
                size: 80,
                maxSize: 150,
                cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
                enableColumnFilter: !1,
                sortingFn: "basic"
              },
              {
                header: "Pct, %",
                id: `avg___${d}`,
                accessorFn: (f) => {
                  var C, v, b;
                  return m((b = (v = (C = f == null ? void 0 : f.records) == null ? void 0 : C[h.id]) == null ? void 0 : v[0]) == null ? void 0 : b.avg);
                },
                maxSize: 150,
                size: 80,
                minSize: 60,
                enableColumnFilter: !1,
                sortingFn: "basic",
                cell: ({ getValue: f }) => {
                  const C = (f() || 0) * 100, v = te(C, 2, 2);
                  return /* @__PURE__ */ t.jsx(t.Fragment, { children: s ? /* @__PURE__ */ t.jsx(
                    vs,
                    {
                      width: C,
                      label: `${v}%`
                    }
                  ) : /* @__PURE__ */ t.jsx(ys, { children: `${v}%` }) });
                }
              }
            ],
            ...a ? a == null ? void 0 : a.map((f) => ({
              header: f.name,
              id: Math.abs(f.id),
              columns: [
                {
                  header: "Count",
                  id: `records___[${h.id}].${Math.abs(
                    f.id
                  )}.count`,
                  accessorFn: (C) => {
                    var v, b, E;
                    return m(
                      (E = (b = (v = C == null ? void 0 : C.records) == null ? void 0 : v[h.id]) == null ? void 0 : b[Math.abs(f.id)]) == null ? void 0 : E.count
                    );
                  },
                  cell: ({ getValue: C }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(C()) }),
                  minSize: 60,
                  size: 80,
                  enableColumnFilter: !1,
                  sortingFn: "basic"
                },
                {
                  header: "Pct, %",
                  id: `records___[${h.id}].${Math.abs(
                    f.id
                  )}.avg`,
                  accessorFn: (C) => {
                    var v, b, E;
                    return m(
                      (E = (b = (v = C == null ? void 0 : C.records) == null ? void 0 : v[h.id]) == null ? void 0 : b[Math.abs(f.id)]) == null ? void 0 : E.avg
                    );
                  },
                  minSize: 60,
                  size: 80,
                  enableColumnFilter: !1,
                  sortingFn: "basic",
                  // sortType: sortByNumber,
                  cell: ({ getValue: C }) => {
                    const v = (C() || 0) * 100, b = te(v, 2, 2);
                    return /* @__PURE__ */ t.jsx(t.Fragment, { children: s ? /* @__PURE__ */ t.jsx(
                      vs,
                      {
                        width: v,
                        label: `${b}%`
                      }
                    ) : /* @__PURE__ */ t.jsx(ys, { children: `${b}%` }) });
                  }
                }
              ]
            })) : []
          ]
        })),
        ...i.length === 2 && !(a != null && a.length) && !l ? [
          {
            header: "Std diff",
            id: "stdDiff",
            size: 80,
            maxSize: 80,
            enableColumnFilter: !1,
            cell: ({ row: h }) => {
              const d = yu(
                Object.values(h.original.records).map((f) => f[0])
              );
              return te(d, 4, 4);
            }
          }
        ] : []
      ];
      break;
    case Dt.DISTRIBUTION:
      j = [
        {
          header: "Strata",
          id: "strataName",
          accessorFn: (h) => {
            var d, f;
            return ((f = (d = h == null ? void 0 : h.records) == null ? void 0 : d[i[0].id]) == null ? void 0 : f.strataName) || "All Stratas";
          },
          meta: {
            filterVariant: "value"
          }
        },
        {
          header: "Covariate",
          id: "covariateName",
          accessorKey: "covariateName",
          maxSize: 120,
          meta: {
            filterVariant: "value"
          }
          // sortType: sortByString('covariateName'),
        },
        ...i.map((h, d) => ({
          header: /* @__PURE__ */ t.jsx(le, { sx: { overflow: "hidden", textOverflow: "ellipsis" }, children: h.name }),
          id: h.id,
          columns: [
            {
              header: "Persons",
              accessorKey: `records.${h.id}.count`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Avg",
              accessorKey: `records.${h.id}.avg`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Std Dev",
              accessorKey: `records.${h.id}.stdDev`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Min",
              accessorKey: `records.${h.id}.min`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P10",
              accessorKey: `records.${h.id}.p10`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P25",
              accessorKey: `records.${h.id}.p25`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Median",
              accessorKey: `records.${h.id}.median`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P75",
              accessorKey: `records.${h.id}.p75`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "P90",
              accessorKey: `records.${h.id}.p90`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            },
            {
              header: "Max",
              accessorKey: `records.${h.id}.max`,
              cell: ({ getValue: f }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(f()) }),
              size: 70,
              enableColumnFilter: !1
            }
          ]
        })),
        ...i.length === 2 && !l ? [
          {
            header: "Std diff",
            id: "stdDiff",
            size: 80,
            maxSize: 80,
            enableColumnFilter: !1,
            cell: ({ row: h }) => {
              const d = yu(
                Object.values(h.original.records)
              );
              return te(d, 4, 4);
            }
          }
        ] : []
      ];
  }
  return j;
}, yu = (r) => {
  const i = r == null ? void 0 : r[0], a = r == null ? void 0 : r[1], s = Math.sqrt(
    ((i == null ? void 0 : i.diffValue) + (a == null ? void 0 : a.diffValue)) / 2
  );
  return s == 0 ? 0 : ((i == null ? void 0 : i.avg) - (a == null ? void 0 : a.avg)) / s;
}, Py = (r) => {
  const {
    data: i,
    cohorts: a,
    analysis: s,
    subgroups: l,
    setChartData: c,
    resultType: m,
    strataOnly: j = !1,
    report: h,
    name: d
  } = r, f = Pe(() => Ry(
    m,
    a,
    l,
    i.length > 2,
    (s == null ? void 0 : s.type) === Sr.BULK_COHORT_COUNTS || (s == null ? void 0 : s.type) === Sr.FEASIBILITY,
    j
  ), [i, a]);
  return /* @__PURE__ */ t.jsx(
    le,
    {
      sx: {
        ".td": {
          height: 34
        }
      },
      children: /* @__PURE__ */ t.jsx(
        Ct,
        {
          columns: f,
          data: i,
          withDuplicates: !0,
          enableFiltering: !0,
          getCurrentPage: c,
          defaultSorting: ((h == null ? void 0 : h.designName) === "DemographicsAgeGroup" || d === "Demographics Age Group") && (a != null && a.length) ? {
            id: `records___${a[0].id}.0.count`,
            desc: !1
          } : void 0
        }
      )
    }
  );
}, $a = $e((r) => {
  const { name: i, report: a, cohorts: s, allResults: l, strataOnly: c } = r, [m, j] = be([]), h = a.resultType === Dt.DISTRIBUTION, d = Pe(() => {
    var v, b;
    const C = m == null ? void 0 : m[0];
    return C != null && C.records ? Object.values(C.records) : (b = (v = a == null ? void 0 : a.item) == null ? void 0 : v[0]) == null ? void 0 : b.records;
  }, [m, a]), f = Pe(() => {
    let C = Oy(a == null ? void 0 : a.resultType, a, i), v = wd(C).list;
    return { raw: C, groupedByPage: v };
  }, [a, s]);
  return /* @__PURE__ */ t.jsx(Re, { elevated: !0, outlined: !0, title: i, children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    !m && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(le, { display: "flex", justifyContent: "center", p: 3, children: "No items" }) }),
    /* @__PURE__ */ t.jsx(
      g,
      {
        item: !0,
        xs: c || h ? 12 : 8,
        sx: { minWidth: 0 },
        children: m && /* @__PURE__ */ t.jsx(
          Py,
          {
            ...r,
            setChartData: j,
            data: f.raw,
            resultType: a == null ? void 0 : a.resultType
          }
        )
      }
    ),
    !c && /* @__PURE__ */ t.jsx(g, { item: !0, xs: h ? 12 : 4, sx: { minWidth: 0 }, children: a.resultType !== Dt.DISTRIBUTION ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      s.length == 1 && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        a.item.length > 1 && a.item.length < 5 && /* @__PURE__ */ t.jsx(
          jd,
          {
            list: m,
            cohort: s == null ? void 0 : s[0],
            addNA: !0
          }
        ),
        a.item.length > 5 && /* @__PURE__ */ t.jsx(Cd, { list: m, cohort: s == null ? void 0 : s[0] })
      ] }),
      s.length == 2 && /* @__PURE__ */ t.jsx(
        Sd,
        {
          fullList: f.groupedByPage,
          cohorts: s,
          list: m,
          allResults: l,
          report: a
        }
      ),
      s.length > 2 && /* @__PURE__ */ t.jsx(Td, { cohorts: s, list: m })
    ] }) : h && /* @__PURE__ */ t.jsx(g, { container: !0, px: 2, children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Un, { height: 200, children: /* @__PURE__ */ t.jsx(
      yd,
      {
        report: a || {},
        cohorts: s || [],
        records: d
      }
    ) }) }) }) })
  ] }) });
}), Dy = $e((r) => {
  const { reports: i, cohorts: a, analyses: s, subgroups: l, strataOnly: c } = r, [m, j] = be(), [h, d] = be(ir.INITIAL);
  return kt(() => {
    const f = {
      analysisId: 0,
      resultType: Dt.PREVALENCE,
      item: [],
      analysisName: "",
      domain: null,
      faType: vd.PRESET,
      allData: !0
    };
    i.filter(
      (v) => (v == null ? void 0 : v.resultType) === Dt.PREVALENCE
    ).forEach((v) => {
      const b = v.item.map((E) => ({ ...E, analysisType: v.designName }));
      f.analysisId += v.analysisId, f.item = [...f.item, ...b];
    }), f.item = id(
      ad(f.item, (v) => v.records[0].avg)
    ), j(f), d(ir.SUCCESS);
  }, [i]), h === ir.INITIAL ? /* @__PURE__ */ t.jsx(k0, { children: /* @__PURE__ */ t.jsx(ka, { size: 32 }) }) : !m || (m == null ? void 0 : m.item.length) < 2 ? /* @__PURE__ */ t.jsx(t.Fragment, {}) : /* @__PURE__ */ t.jsx(
    $a,
    {
      name: "All Prevalence Covariates",
      report: m,
      cohorts: a,
      allResults: !0,
      analyses: s,
      subgroups: l,
      strataOnly: c
    }
  );
}), bu = (r, i) => r.map((a) => {
  var s;
  return {
    ...a,
    realNameAnalysis: (s = i.find(
      (l) => l.designName === a.designName
    )) == null ? void 0 : s.name
  };
});
var Ny = /* @__PURE__ */ ((r) => (r.PREVALENCE = "PREVALENCE", r.DISTRIBUTION = "DISTRIBUTION", r))(Ny || {}), Iy = /* @__PURE__ */ ((r) => (r.PRESET = "PRESET", r))(Iy || {});
const kj = $e((r) => {
  const { reports: i, cohorts: a, analyses: s, domains: l, stratas: c, strataOnly: m } = r.data, [j, h] = be({
    cohorts: a[0] ? [a[0]] : [],
    reports: bu(i, s) || [],
    domains: l
  }), [d, f] = be(
    ir.INITIAL
  ), C = od(
    (v, b) => {
      h((E) => ({ ...E, [v]: b })), f(ir.SUCCESS);
    },
    1e3
  );
  return i.length > 0 ? /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, p: 2, children: [
    /* @__PURE__ */ t.jsx(
      Cy,
      {
        value: j,
        onFilterResults: (v, b) => {
          f(ir.IN_PROGRESS), C(v, b);
        },
        cohorts: a,
        reports: bu(i, s),
        status: d
      }
    ),
    d === ir.IN_PROGRESS ? /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, pt: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(ka, { size: 50, color: "info" }) }) : j.cohorts.length > 0 && j.reports.length > 0 ? /* @__PURE__ */ t.jsxs(g, { container: !0, py: 2, spacing: 2, children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Dy,
        {
          reports: j.reports,
          cohorts: j.cohorts,
          analyses: s,
          subgroups: c,
          strataOnly: m
        }
      ) }),
      j.reports.map((v) => {
        const b = { ...v };
        if (b.item = id(
          ad(b.item, (E) => E.records[0].avg)
        ), j.domains.includes(v.domain))
          return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            $a,
            {
              name: v.realNameAnalysis,
              report: b,
              cohorts: j.cohorts,
              subgroups: c,
              strataOnly: m
            },
            v.analysisId
          ) }, v.analysisId);
      })
    ] }) : /* @__PURE__ */ t.jsx(mu, { children: "No data" })
  ] }) : /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(mu, { children: "No data visualization" }) });
});
Le.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const Ly = Le(g, {
  shouldForwardProp: (r) => r !== "isActive"
})`
  font-size: 14px;
  color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
  font-weight: 400;
  border-bottom: 1px solid
    ${({ theme: r }) => r.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: r, theme: i }) => r ? i.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: r, isActive: i }) => r.palette.info.main + (i ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, Fy = {
  entityNavigationPanel: (r) => [
    {
      value: _a.FILES_IN_ARCHIVE,
      title: "Files in archive",
      onTabClick: r
    }
    // {
    //   id: CreateSubmissionFormTabs.SEPARATE_FILES,
    //   title: 'Separate files',
    //   onTab: setActive,
    // },
  ]
}, My = (r) => {
  switch (r) {
    case En.SCANNING:
      return "warning";
    case En.OK:
      return "success";
    case En.INFECTED:
      return "error";
    case En.NOT_SCANNED:
    case En.WILL_NOT_SCAN:
      return "secondary";
  }
}, ky = (r, i) => As.post(`analysis/custom/${r}/upload/zip`, i), zy = (r, i, a) => As.post(`/analysis/custom/${r}/attach-custom-code/${i}`, a), By = $e((r) => {
  var P, x, p;
  const { id: i, afterCreate: a, onCancel: s, subModules: l, originalEntity: c, parentId: m } = r, [j, h] = be(!1), [d, f] = be([]), [C, v] = be(), [b, E] = be({
    title: c.title,
    analysisType: nd.find(
      (y) => y.value === c.type
    ).name || "-",
    analysisName: c == null ? void 0 : c.title,
    studyId: m,
    studyName: null,
    design: {
      executableFileName: null,
      cohorts: (P = c == null ? void 0 : c.design) == null ? void 0 : P.cohorts,
      conceptSets: (x = c == null ? void 0 : c.design) == null ? void 0 : x.conceptSets
    }
  }), [A, R] = be(
    _a.FILES_IN_ARCHIVE
  ), D = Pe(() => Fy.entityNavigationPanel(R), []), _ = Jt(() => {
    h(!0);
    let y = new FormData();
    y.append(
      "dto",
      new Blob([JSON.stringify(b)], {
        type: "application/json"
      })
    ), y.append("file", C), ky(i, y).then((w) => {
      h(!1), a == null || a(w);
    });
  }, [b]), F = Pe(() => b.design.executableFileName, [b]);
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(
      g,
      {
        item: !0,
        xs: 12,
        px: 2,
        sx: (y) => ({
          boxShadow: y.customShadows[2],
          background: "white"
        }),
        children: /* @__PURE__ */ t.jsx(Ba, { tabs: D, active: A, secondary: !0 })
      }
    ),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsx(Ci, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, p: 2, children: [
      A === _a.FILES_IN_ARCHIVE && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        l.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: l,
          config: {
            onChange: (y, w) => {
              const M = w ? Object.keys(w.files) : y;
              f((V) => M.map((q) => w ? w.files[q] : q).filter((q) => q.name.toLowerCase().includes(".sql") || q.name.toLowerCase().includes(".r")).map((q) => ({
                name: q.name,
                value: q.name
              }))), v(y);
            },
            localDownload: !0,
            createMethod: (y) => {
            },
            textAvailableExt: "ZIP",
            acceptExt: [
              "application/zip",
              "application/octet-stream",
              "application/x-zip-compressed",
              "multipart/x-zip"
            ]
          }
        }
      ) }),
      A === _a.SEPARATE_FILES && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        l.documents,
        {
          type: "component",
          name: "upload-new-document",
          subModules: l,
          config: {
            localDownload: !0,
            onChange: (y) => {
            },
            createMethod: (y) => {
            },
            freeUpload: !0
          }
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Zt, { name: "type", textLabel: "Entry point", required: !0, children: /* @__PURE__ */ t.jsx(
        mn,
        {
          className: "",
          name: "entry-point",
          disablePortal: !0,
          id: "entry point",
          options: d,
          value: (p = b.design) == null ? void 0 : p.executableFileName,
          placeholder: "Select entry point...",
          onChange: (y) => {
            var w, M;
            E({
              ...b,
              design: {
                executableFileName: y,
                cohorts: (w = b.design) == null ? void 0 : w.cohorts,
                conceptSets: (M = b.design) == null ? void 0 : M.conceptSets
              }
            });
          },
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Zt, { name: "analysis-name", textLabel: "Analysis name", children: /* @__PURE__ */ t.jsx(
        $n,
        {
          id: "analysis-name",
          name: "analysis-name",
          type: "text",
          size: "medium",
          disabled: !0,
          value: b.analysisName,
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Zt, { name: "analysis-type", textLabel: "Analysis type", children: /* @__PURE__ */ t.jsx(
        $n,
        {
          id: "analysis-type",
          name: "analysis-type",
          type: "text",
          size: "medium",
          disabled: !0,
          value: b.analysisType,
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Ju, { children: [
        /* @__PURE__ */ t.jsx(
          ct,
          {
            variant: "outlined",
            onClick: s,
            startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "deactivate" }),
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ t.jsx(
          ct,
          {
            disabled: j || !F,
            onClick: _,
            variant: "contained",
            color: "success",
            startIcon: j ? /* @__PURE__ */ t.jsx(ka, { size: 16 }) : /* @__PURE__ */ t.jsx(bt, { iconName: "submit" }),
            children: "Save design"
          }
        )
      ] }) })
    ] }) }) })
  ] });
}), zj = $e((r) => {
  var P, x;
  const {
    subModules: i,
    parentId: a,
    design: s,
    originalEntity: l,
    id: c,
    typeContainer: m,
    updateDesign: j,
    analysisName: h,
    viewMode: d
  } = r, { openModal: f, closeModal: C } = qu(xd), [v, b] = be(!1), [E, A] = be(s.files || []), R = (p) => {
    j(
      "cohorts",
      p.map((y) => ({
        ...y,
        alias: du(y)
      }))
    );
  }, D = (p) => {
    j(
      "conceptSets",
      p.map((y) => ({
        ...y,
        alias: du(y)
      }))
    );
  }, _ = (p) => {
    A(p.files), j("files", p.files), j("executableFileName", p.executableFileName), j("customCode", p.customCode);
  }, F = () => {
    f(
      () => /* @__PURE__ */ t.jsx(
        By,
        {
          id: c,
          subModules: i,
          originalEntity: l,
          onCancel: C,
          parentId: a,
          afterCreate: (p) => {
            _(p.design), C();
          }
        }
      ),
      "Upload analysis",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: C
      }
    );
  };
  return console.log("Design", s.customCode), /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1.5, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsxs(E0, { severity: "info", sx: { fontSize: 12, alignItems: "center" }, children: [
      "The JSON files containing the definitions of referenced Cohorts and Concept Sets will be included in the final package within the",
      " ",
      /* @__PURE__ */ t.jsx("b", { children: "cohorts" }),
      " and ",
      /* @__PURE__ */ t.jsx("b", { children: "conceptsets" }),
      " directories."
    ] }) }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        viewMode: d,
        config: {
          buttonText: "Import Cohorts",
          titleText: "Referenced Cohorts",
          classNameContainer: "target-import-button",
          typeContainer: m,
          initialData: s == null ? void 0 : s.cohorts,
          onChange: (p) => {
            R(p);
          },
          parentId: a,
          returnEntityText: h,
          viewMode: d,
          isSelect: !0,
          withAlias: !0
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.concept,
      {
        type: "component",
        name: "widget-concept-set-import-button",
        subModules: i,
        viewMode: d,
        config: {
          buttonText: "Import Concept Sets",
          titleText: "Referenced Concept Sets",
          classNameContainer: "target-import-button",
          typeContainer: m,
          initialData: s == null ? void 0 : s.conceptSets,
          onChange: (p) => {
            D(
              p.map((y) => ({
                ...y,
                items: K0(y.items)
              }))
            );
          },
          parentId: a,
          returnEntityText: h,
          viewMode: d,
          isSelect: !0,
          withAlias: !0
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        elevated: !0,
        outlined: !0,
        title: s.customCode ? `Files in ${s.customCode.name}` : "Files",
        actions: /* @__PURE__ */ t.jsx(g, { item: !0, display: "flex", children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          ((P = s.files) == null ? void 0 : P.length) > 0 && /* @__PURE__ */ t.jsx(
            ct,
            {
              onClick: (p) => {
                p.stopPropagation(), window.location.href = `/api/analysis/custom/${c}/download`;
              },
              variant: "outlined",
              startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "download" }),
              sx: {
                mr: 1.5,
                px: 2,
                color: "info.main",
                borderColor: "borderColor.main",
                ".start-icon-small svg": {
                  fontSize: 16
                }
              },
              className: "download-files",
              name: "download-files",
              children: "Download files"
            }
          ),
          !d && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            /* @__PURE__ */ t.jsx(
              ct,
              {
                onClick: F,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ t.jsx(
                  bt,
                  {
                    iconName: "download",
                    sx: { transform: "rotate(180deg)" }
                  }
                ),
                name: "upload",
                children: "Upload files"
              }
            ),
            /* @__PURE__ */ t.jsx(
              i.customCode,
              {
                type: "component",
                name: "add-custom-code-button",
                subModules: i,
                viewMode: d,
                config: {
                  instanceId: c,
                  isLoading: v,
                  onChange: async (p) => {
                    try {
                      b(!0);
                      const y = await zy(
                        c,
                        p[0].id,
                        l
                      );
                      _(y.design), b(!1);
                    } catch {
                      b(!1), console.log("something gone wrong");
                    }
                  }
                }
              }
            )
          ] })
        ] }) }),
        children: ((x = s.files) == null ? void 0 : x.length) > 0 ? /* @__PURE__ */ t.jsx(g, { container: !0, className: "table-files", mt: 1, children: E == null ? void 0 : E.map((p) => {
          const y = q0(p.realName), w = s.executableFileName && s.executableFileName === p.realName;
          return /* @__PURE__ */ t.jsxs(
            Ly,
            {
              xs: 12,
              px: 1,
              py: 0.5,
              isActive: w,
              children: [
                /* @__PURE__ */ t.jsx(
                  bt,
                  {
                    iconName: sd(y),
                    iconStatus: My(
                      p.antivirusFileStatusDto
                    ),
                    sx: { fontSize: 26 }
                  }
                ),
                /* @__PURE__ */ t.jsx("span", { children: p.realName }),
                w && /* @__PURE__ */ t.jsx(Nt, { text: "Entry point", children: /* @__PURE__ */ t.jsx(
                  le,
                  {
                    display: "inline-flex",
                    sx: { position: "absolute", top: 4, left: 10 },
                    children: /* @__PURE__ */ t.jsx(
                      bt,
                      {
                        iconName: "bookmark",
                        color: "success",
                        sx: { fontSize: 14 }
                      }
                    )
                  }
                ) })
              ]
            },
            p.path
          );
        }) }) : /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1,
              mt: 1
            },
            children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", color: "borderColor.main", children: "No files" })
          }
        )
      }
    ) })
  ] }) });
}), Bj = $e((r) => /* @__PURE__ */ t.jsx(t.Fragment, { children: "results" })), us = (r) => {
  const {
    subModules: i,
    viewMode: a,
    id: s,
    parentId: l,
    typeContainer: c,
    initialData: m,
    analysisName: j,
    titleText: h,
    buttonText: d,
    isSelect: f = !1,
    onChange: C
  } = r;
  return /* @__PURE__ */ t.jsx(
    i.cohort,
    {
      type: "component",
      name: "widget-cohort-import-button",
      subModules: i,
      path: It(c, s, l),
      config: {
        buttonText: d,
        titleText: h,
        typeContainer: c,
        initialData: m,
        onChange: C,
        isSelect: f,
        parentId: l,
        returnEntityText: j,
        viewMode: a
      }
    }
  );
}, hi = (r) => {
  const {
    subModules: i,
    viewMode: a,
    id: s,
    parentId: l,
    typeContainer: c,
    initialData: m,
    analysisName: j,
    titleText: h,
    buttonText: d,
    isSelect: f = !1,
    onChange: C,
    description: v,
    isDark: b = !1
  } = r;
  return /* @__PURE__ */ t.jsx(
    i.concept,
    {
      type: "component",
      name: "widget-concept-set-import-button",
      subModules: i,
      viewMode: a,
      config: {
        buttonText: d,
        titleText: h,
        description: v,
        typeContainer: c,
        initialData: m,
        onChange: C,
        isSelect: !1,
        parentId: l,
        returnEntityText: j,
        isDark: b
      }
    }
  );
}, _d = ({
  onSubmit: r,
  onCancel: i,
  cancelButtonText: a = "Cancel",
  submitButtonText: s = "Submit"
}) => /* @__PURE__ */ t.jsx(
  g,
  {
    item: !0,
    xs: 12,
    position: "sticky",
    zIndex: 1,
    bottom: 0,
    right: 0,
    width: "100%",
    children: /* @__PURE__ */ t.jsxs(
      Hn,
      {
        elevation: 1,
        sx: { borderRadius: 0, px: 6, py: 1, textAlign: "right" },
        children: [
          /* @__PURE__ */ t.jsx(
            ct,
            {
              variant: "outlined",
              color: "info",
              startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "close" }),
              sx: { mr: 1 },
              onClick: i,
              children: a
            }
          ),
          /* @__PURE__ */ t.jsx(
            ct,
            {
              variant: "contained",
              color: "success",
              startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "add" }),
              onClick: r,
              children: s
            }
          )
        ]
      }
    )
  }
), $y = $e((r) => {
  const { activeItem: i, designProps: a, onChange: s, onClose: l } = r, { typeContainer: c, id: m, parentId: j, subModules: h, analysisName: d, viewMode: f } = a, [C, v] = be(
    i.value || {
      targetId: void 0,
      comparatorId: void 0,
      outcomeIds: [],
      excludedCovariateConceptIds: [],
      includedCovariateConceptIds: [],
      outcomeCohorts: [],
      comparatorCohort: void 0,
      targetCohort: void 0,
      negativeControlConceptSet: void 0,
      includedCovariateConceptSet: void 0,
      excludedCovariateConceptSet: void 0
    }
  ), b = (D, _) => ([F]) => {
    v((P) => ({
      ...P,
      [D]: (F == null ? void 0 : F.versionId) || void 0,
      [_]: F || void 0
    }));
  }, E = (D) => {
    v((_) => {
      let F = D != null && D.length ? D.map((x) => x.versionId) : null;
      return {
        ..._,
        outcomeIds: F,
        outcomeCohorts: D
      };
    });
  }, A = (D) => (_) => {
    const [F] = _.map((P) => ({
      id: ld(),
      name: P.name,
      description: P.description,
      expression: { items: P.items }
      // type: 'by_value'
    }));
    v((P) => ({
      ...P,
      [D]: F
    }));
  }, R = () => {
    [
      C.targetCohort,
      C.comparatorCohort,
      ...C.outcomeCohorts
    ].filter((D) => !!D), s(C, i.index), l();
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, py: 2, px: 6, minHeight: "100%", children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
      /* @__PURE__ */ t.jsx(
        g,
        {
          item: !0,
          xs: 12,
          sx: {
            ".secondary-header-title": { fontWeight: 500, fontSize: 16 }
          },
          children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              us,
              {
                subModules: h,
                viewMode: f,
                id: m,
                parentId: j,
                typeContainer: c,
                initialData: [C.targetCohort],
                analysisName: d,
                titleText: "Target cohort:",
                buttonText: "Choose target cohort",
                onChange: b("targetId", "targetCohort")
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              us,
              {
                subModules: h,
                viewMode: f,
                id: m,
                parentId: j,
                typeContainer: c,
                initialData: [C.comparatorCohort],
                analysisName: d,
                titleText: "Comparator cohort:",
                buttonText: "Choose comparator cohort",
                onChange: b(
                  "comparatorId",
                  "comparatorCohort"
                )
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              us,
              {
                subModules: h,
                viewMode: f,
                id: m,
                parentId: j,
                typeContainer: c,
                initialData: C.outcomeCohorts,
                analysisName: d,
                titleText: "Outcome cohorts:",
                buttonText: "Add outcome cohorts",
                isSelect: !0,
                onChange: E
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              hi,
              {
                subModules: h,
                viewMode: f,
                id: m,
                parentId: j,
                typeContainer: c,
                initialData: [C.negativeControlConceptSet],
                analysisName: d,
                titleText: "Negative control concept set",
                description: "",
                buttonText: "Add negative control concept set",
                onChange: A("negativeControlConceptSet")
              }
            ) })
          ] })
        }
      ),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Covariate selection",
          outlined: !0,
          elevated: !0,
          children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
            /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
              /* @__PURE__ */ t.jsx(
                hi,
                {
                  subModules: h,
                  viewMode: f,
                  id: m,
                  parentId: j,
                  typeContainer: c,
                  initialData: [C.includedCovariateConceptSet],
                  analysisName: d,
                  titleText: "Included concept set",
                  description: "Concepts to include when constructing the covariates to be used in this study. (Leave blank if you want to include every concept).*",
                  buttonText: "Add included concept set",
                  isSelect: !1,
                  onChange: A("includedCovariateConceptSet")
                }
              ),
              /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Analysis settings section." })
            ] }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(zt, { sx: { my: 1, borderColor: "borderColor.light" } }) }),
            /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
              /* @__PURE__ */ t.jsx(
                hi,
                {
                  subModules: h,
                  viewMode: f,
                  id: m,
                  parentId: j,
                  typeContainer: c,
                  initialData: [C.excludedCovariateConceptSet],
                  analysisName: d,
                  titleText: "Excluded concept set",
                  description: "Concepts to exclude when constructing the covariates to be used in this study.*",
                  buttonText: "Add excluded concept set",
                  isSelect: !1,
                  onChange: A("excludedCovariateConceptSet")
                }
              ),
              /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Analysis settings section." })
            ] })
          ] })
        }
      ) })
    ] }) }),
    /* @__PURE__ */ t.jsx(
      _d,
      {
        submitButtonText: "Save Comparison",
        onSubmit: R,
        onCancel: l
      }
    )
  ] });
}), or = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], Wy = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  }
], Hy = [
  {
    value: !0,
    name: "yes"
  },
  {
    value: !1,
    name: "no"
  }
], _t = (r) => {
  const { value: i, propName: a, setState: s, textLabel: l, description: c, labelSize: m } = r;
  return /* @__PURE__ */ t.jsx(
    Ke,
    {
      htmlFor: a,
      textLabel: l,
      description: c,
      labelSize: m,
      children: /* @__PURE__ */ t.jsx(
        mn,
        {
          className: `${a}-control`,
          name: a,
          disablePortal: !0,
          id: a,
          options: Hy,
          value: i,
          placeholder: "Select value",
          onChange: (j) => {
            s((h) => ({
              ...h,
              [a]: j
            }));
          }
        }
      )
    }
  );
}, Je = (r) => {
  const {
    value: i,
    propName: a,
    options: s,
    setState: l,
    textLabel: c,
    autoselect: m,
    description: j,
    labelSize: h,
    multiple: d
  } = r;
  return /* @__PURE__ */ t.jsx(
    Ke,
    {
      htmlFor: a,
      textLabel: c,
      description: j,
      labelSize: h,
      children: m ? /* @__PURE__ */ t.jsx(
        On,
        {
          className: `${a}-control`,
          placeholder: "Select value",
          name: a,
          id: a,
          value: i,
          multiple: d,
          onChange: (f) => {
            l((C) => ({
              ...C,
              [a]: f
            }));
          },
          options: s,
          sx: {
            maxWidth: 200
          }
        }
      ) : /* @__PURE__ */ t.jsx(
        mn,
        {
          className: `${a}-control`,
          name: a,
          disablePortal: !0,
          id: a,
          multiple: d,
          options: s,
          value: i || (d ? [] : null),
          placeholder: "Select value",
          cropItems: !0,
          onChange: (f) => {
            l((C) => ({
              ...C,
              [a]: f
            }));
          }
        }
      )
    }
  );
};
var fi = /* @__PURE__ */ ((r) => (r.KEEP_ALL = "keep all", r.KEEP_FIRST = "keep first", r.REMOVE_ALL = "remove all", r))(fi || {});
const Vy = [
  {
    value: fi.KEEP_ALL,
    name: "keep all"
  },
  {
    value: fi.KEEP_FIRST,
    name: "keep first"
  },
  {
    value: fi.REMOVE_ALL,
    name: "remove all"
  }
], Uy = (r) => {
  const { values: i, onChange: a } = r;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, columnSpacing: 4, rowSpacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Ke,
      {
        htmlFor: "studyStartDate",
        textLabel: "Study start date",
        description: "A calendar date specifying the minimum date that a cohort index can appear (leave blank to use all time)",
        children: /* @__PURE__ */ t.jsx(
          jr,
          {
            fullWidth: !0,
            value: i.studyStartDate,
            format: Tt.DATEPICKER_DATE,
            onChange: (s) => {
              a((l) => ({
                ...l,
                studyStartDate: gs(s, Tt.ISO_DATE)
              }));
            },
            name: "studyStartDate"
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Ke,
      {
        htmlFor: "studyEndDate",
        textLabel: "Study end date",
        description: "A calendar date specifying the maximum date that a cohort index can appear (leave blank to use all time). Important: the study end date is also used to truncate risk windows, meaning no outcomes beyond the study end date will be considered.",
        children: /* @__PURE__ */ t.jsx(
          jr,
          {
            fullWidth: !1,
            value: i.studyEndDate,
            format: Tt.DATEPICKER_DATE,
            onChange: (s) => {
              a((l) => ({
                ...l,
                studyEndDate: gs(s, Tt.ISO_DATE)
              }));
            },
            name: "studyEndDate"
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Restrict the study to the period when both exposures are present in the data?",
        description: "(E.g. when both drugs are on the market)",
        propName: "restrictToCommonPeriod",
        value: i.restrictToCommonPeriod,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Should only the first exposure per subject be included?",
        propName: "firstExposureOnly",
        value: i.firstExposureOnly,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "The minimum required continuous observation time (in days) prior to index date for a person to be included in the cohort.",
        propName: "washoutPeriod",
        autoselect: !0,
        options: or,
        value: i.washoutPeriod,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Remove subjects that are in both the target and comparator cohort?",
        propName: "removeDuplicateSubjects",
        options: Vy,
        value: i.removeDuplicateSubjects,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "If a subject is in multiple cohorts, should time-at-risk be censored when the new time-at-risk start to prevent overlap?",
        propName: "censorAtNewRiskWindow",
        value: i.censorAtNewRiskWindow,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Remove subjects that have the outcome prior to the risk window start?",
        propName: "removeSubjectsWithPriorOutcome",
        value: i.removeSubjectsWithPriorOutcome,
        setState: a
      }
    ) }),
    i.removeSubjectsWithPriorOutcome && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "How many days should we look back when identifying prior outcomes?",
        propName: "priorOutcomeLookback",
        autoselect: !0,
        options: or,
        value: i.priorOutcomeLookback,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "If either the target or the comparator cohort is larger than this number it will be sampled to this size. (0 for this value indicates no maximum size)",
        propName: "maxCohortSize",
        options: Wy,
        autoselect: !0,
        value: i.maxCohortSize,
        setState: a
      }
    ) })
  ] });
}, Na = (r) => {
  const {
    valueRisk: i,
    propNameRisk: a,
    optionsRisk: s,
    valueTime: l,
    propNameTime: c,
    optionsTime: m,
    setState: j,
    textLabel: h,
    customTime: d
  } = r;
  return /* @__PURE__ */ t.jsx(
    Ke,
    {
      htmlFor: `${c}-${a}`,
      textLabel: h,
      children: /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
          On,
          {
            name: a,
            id: a,
            options: s,
            value: i,
            placeholder: "Select",
            onChange: (f) => {
              j((C) => ({
                ...C,
                [a]: f
              }));
            }
          }
        ) }),
        d || /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx(g, { item: !0, px: 1, fontSize: 12, children: "days from" }),
          /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
            mn,
            {
              className: "",
              name: c,
              disablePortal: !0,
              id: c,
              options: m,
              value: l,
              placeholder: "Select",
              onChange: (f) => {
                j((C) => ({
                  ...C,
                  [c]: f
                }));
              }
            }
          ) })
        ] })
      ] })
    }
  );
}, bs = {
  false: {
    value: !1,
    name: "cohort start date"
  },
  true: {
    value: !0,
    name: "cohort end date"
  }
}, Ia = Object.values(
  bs
), Gy = (r) => {
  const { values: i, onChange: a } = r;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Na,
      {
        textLabel: "Define the time-at-risk window start, relative to target/comparator cohort entry",
        propNameRisk: "riskWindowStart",
        valueRisk: i.riskWindowStart,
        optionsRisk: or,
        propNameTime: "addExposureDaysToStart",
        valueTime: i.addExposureDaysToStart,
        optionsTime: Ia,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Na,
      {
        textLabel: "Define the time-at-risk window end",
        propNameRisk: "riskWindowEnd",
        valueRisk: i.riskWindowEnd,
        optionsRisk: or,
        propNameTime: "addExposureDaysToEnd",
        valueTime: i.addExposureDaysToEnd,
        optionsTime: Ia,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "The minimum number of days at risk?",
        propName: "minDaysAtRisk",
        options: or,
        autoselect: !0,
        value: i.minDaysAtRisk,
        setState: a
      }
    ) })
  ] });
}, Ky = [
  {
    value: 100,
    name: "100"
  },
  {
    value: 500,
    name: "500"
  },
  {
    value: 1e3,
    name: "1000"
  }
], qy = [
  {
    value: 0.1,
    name: "0.1"
  },
  {
    value: 0.01,
    name: "0.01"
  },
  {
    value: 1e-3,
    name: "0.001"
  },
  {
    value: 1e-4,
    name: "0.0001"
  },
  {
    value: 1e-5,
    name: "0.00001"
  },
  {
    value: 1e-6,
    name: "0.000001"
  }
];
var Si = /* @__PURE__ */ ((r) => (r.AUTO = "auto", r.GRID = "grid", r))(Si || {});
const Yy = [
  {
    value: Si.AUTO,
    name: "auto"
  },
  {
    value: Si.GRID,
    name: "grid"
  }
];
var pi = /* @__PURE__ */ ((r) => (r.GRADIENT = "gradient", r.MITTAL = "mittal", r.LANGE = "lange", r))(pi || {});
const Xy = [
  {
    value: pi.GRADIENT,
    name: "gradient"
  },
  {
    value: pi.MITTAL,
    name: "mittal"
  },
  {
    value: pi.LANGE,
    name: "lange"
  }
], rr = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  }
];
var mi = /* @__PURE__ */ ((r) => (r.SILENT = "silent", r.QUIET = "quiet", r.NOISY = "noisy", r))(mi || {});
const Zy = [
  {
    value: mi.SILENT,
    name: "silent"
  },
  {
    value: mi.QUIET,
    name: "quiet"
  },
  {
    value: mi.NOISY,
    name: "noisy"
  }
], Jy = [
  {
    value: -1,
    name: "-1"
  },
  {
    value: -0.01,
    name: "-0.01"
  },
  {
    value: 0,
    name: "0"
  },
  {
    value: 0.01,
    name: "0.01"
  },
  {
    value: 1,
    name: "1"
  }
];
var xi = /* @__PURE__ */ ((r) => (r.BY_PID = "byPid", r.BY_ROW = "byRow", r.AUTO = "auto", r))(xi || {});
const Qy = [
  {
    value: xi.AUTO,
    name: "auto"
  },
  {
    value: xi.BY_PID,
    name: "by pid"
  },
  {
    value: xi.BY_ROW,
    name: "by row"
  }
], on = (r) => {
  const { value: i, propName: a, setState: s, textLabel: l } = r;
  return /* @__PURE__ */ t.jsx(Ke, { htmlFor: a, textLabel: l, children: /* @__PURE__ */ t.jsx(
    $n,
    {
      id: a,
      name: a,
      type: "text",
      size: "medium",
      placeholder: "Enter",
      value: i,
      onChange: (c) => {
        s((m) => ({
          ...m,
          [a]: c.target.value
        }));
      }
    }
  ) });
}, Ed = (r) => {
  const { values: i, onChange: a } = r, s = (l) => {
    a((c) => ({ ...c, control: l(c.control) }));
  };
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Maximum iterations of Cyclops to attempt before returning a failed-to-converge error.",
        propName: "maxIterations",
        options: Ky,
        autoselect: !0,
        value: i.maxIterations,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Maximum relative change in convergence criterion from successive iterations to achieve convergence.",
        propName: "tolerance",
        options: qy,
        autoselect: !0,
        value: i.tolerance,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Select the convergence type",
        propName: "convergenceType",
        options: Xy,
        value: i.convergenceType,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Select the cross validation search type",
        propName: "cvType",
        options: Yy,
        value: i.cvType,
        setState: s,
        labelSize: 8
      }
    ) }),
    i.cvType === Si.GRID && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        on,
        {
          textLabel: "Lower prior variance limit",
          propName: "lowerLimit",
          value: i.lowerLimit,
          setState: s
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        on,
        {
          textLabel: "Upper prior variance limit",
          propName: "upperLimit",
          value: i.upperLimit,
          setState: s
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        on,
        {
          textLabel: "Number of steps",
          propName: "gridSteps",
          value: i.gridSteps,
          setState: s
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Number of random folds to employ in cross validation",
        propName: "fold",
        autoselect: !0,
        options: rr,
        value: i.fold,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Number of repetitions of 10-fold cross validation",
        propName: "cvRepetitions",
        autoselect: !0,
        options: rr,
        value: i.cvRepetitions,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Number of repetitions of data for cross validation:",
        propName: "minCVData",
        autoselect: !0,
        options: rr,
        value: i.minCVData,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Noise level for Cyclops screen output",
        propName: "noiseLevel",
        options: Zy,
        value: i.noiseLevel,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Reset all coefficients to 0 between model fits under cross-validation",
        propName: "resetCoefficients",
        value: i.resetCoefficients,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Starting variance for auto-search cross-validation",
        description: "-1 = use estimate based on data",
        propName: "startingVariance",
        autoselect: !0,
        options: Jy,
        value: i.startingVariance,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Use the Karush-Kuhn-Tucker conditions to limit search",
        propName: "useKKTSwindle",
        value: i.useKKTSwindle,
        setState: s,
        labelSize: 8
      }
    ) }),
    i.useKKTSwindle && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Size multiplier for active set",
        propName: "tuneSwindle",
        autoselect: !0,
        options: rr,
        value: i.tuneSwindle,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Name of exchangeable sampling unit. Option byPid selects entire strata.",
        description: "Option byRow selects single rows. If set to auto, byRow will be used for all models except conditional models where the average number of rows per stratum is smaller than the number of strata.",
        propName: "selectorType",
        options: Qy,
        value: i.selectorType,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Initial bound",
        propName: "initialBound",
        autoselect: !0,
        options: rr,
        value: i.initialBound,
        setState: s,
        labelSize: 8
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Max bound count",
        propName: "maxBoundCount",
        autoselect: !0,
        options: rr,
        value: i.maxBoundCount,
        setState: s,
        labelSize: 8
      }
    ) })
  ] });
};
var br = /* @__PURE__ */ ((r) => (r.NONE = "none", r.HIERARCHICAL = "hierarchical", r.LAPLACE = "laplace", r.NORMAL = "normal", r))(br || {});
const eb = [
  {
    value: br.NONE,
    name: "none"
  },
  {
    value: br.HIERARCHICAL,
    name: "hierarchical"
  },
  {
    value: br.LAPLACE,
    name: "laplace"
  },
  {
    value: br.NORMAL,
    name: "normal"
  }
], Ad = (r) => {
  const { values: i, onChange: a } = r, s = (l) => {
    a((c) => ({ ...c, prior: l(c.prior) }));
  };
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Specify the prior distribution",
        propName: "priorType",
        options: eb,
        value: i.priorType,
        setState: s
      }
    ) }),
    i.priorType === br.HIERARCHICAL && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "Child-to-parent mapping for a hierarchical prior",
        propName: "graph",
        value: i.graph,
        setState: s
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Perform cross-validation to determine prior-variance",
        propName: "useCrossValidation",
        value: i.useCrossValidation,
        setState: s
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Force intercept coefficient into prior",
        propName: "forceIntercept",
        value: i.forceIntercept,
        setState: s
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "Specify the prior distribution variance",
        propName: "variance",
        value: i.variance,
        setState: s
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "Specify a vector of numbers or covariate Ids to exclude from prior",
        propName: "exclude",
        value: i.exclude,
        setState: s
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "A list of first-order neighborhoods for a partially fused prior",
        propName: "neighborhood",
        value: i.neighborhood,
        setState: s
      }
    ) })
  ] });
};
var bn = /* @__PURE__ */ ((r) => (r.NONE = "none", r.MATCH_ON_PS = "matchOnPs", r.STRATIFY_BY_PS = "stratifyByPs", r))(bn || {});
const tb = [
  {
    value: bn.NONE,
    name: "none"
  },
  {
    value: bn.MATCH_ON_PS,
    name: "match on propensity score"
  },
  {
    value: bn.STRATIFY_BY_PS,
    name: "stratify on propensity score"
  }
];
var Cn = /* @__PURE__ */ ((r) => (r.NONE = "none", r.BY_PERCENT = "byPercent", r.BY_EQUIPOISE = "toEquipoise", r))(Cn || {});
const nb = [
  {
    value: Cn.NONE,
    name: "none"
  },
  {
    value: Cn.BY_PERCENT,
    name: "by percent"
  },
  {
    value: Cn.BY_EQUIPOISE,
    name: "by equipoise"
  }
];
var gi = /* @__PURE__ */ ((r) => (r.STANDARDIZED_LOGIT = "standardized logit", r.STANDARDIZED = "standardized", r.PROPENSITY_SCORE = "propensity score", r))(gi || {});
const rb = [
  {
    value: gi.STANDARDIZED_LOGIT,
    name: "standardized logit"
  },
  {
    value: gi.STANDARDIZED,
    name: "standardized"
  },
  {
    value: gi.PROPENSITY_SCORE,
    name: "propensity score"
  }
];
var vi = /* @__PURE__ */ ((r) => (r.ALL = "all", r.TARGET = "target", r.COMPARATOR = "comparator", r))(vi || {});
const ib = [
  {
    value: vi.ALL,
    name: "all"
  },
  {
    value: vi.TARGET,
    name: "target"
  },
  {
    value: vi.COMPARATOR,
    name: "comparator"
  }
], ab = [
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  },
  {
    value: 105e3,
    name: "105000"
  },
  {
    value: 25e4,
    name: "250000"
  }
], ob = (r) => {
  const { values: i, onChange: a } = r;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "How do you want to trim your cohorts based on the propensity score distribution?",
        propName: "trimSelection",
        options: nb,
        value: i.trimSelection,
        setState: a
      }
    ) }),
    i.trimSelection === Cn.BY_PERCENT && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "Trim Fraction (1-100%)",
        propName: "trimFraction",
        value: i.trimFraction,
        setState: a
      }
    ) }),
    i.trimSelection === Cn.BY_EQUIPOISE && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      on,
      {
        textLabel: "Specify the lower and upper bound on the preference score for keeping persons (specify as: min %, max %, eg: 25,75)",
        propName: "bounds",
        value: i.bounds,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Do you want to perform matching or stratification?",
        propName: "matchStratifySelection",
        options: tb,
        value: i.matchStratifySelection,
        setState: a
      }
    ) }),
    i.matchStratifySelection === bn.MATCH_ON_PS && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "What is the maximum number of persons in the comparator arm to be matched to each person in the target arm within the defined caliper? (0 = means no maximum - all comparators will be assigned to a target person):",
          propName: "maxRatio",
          autoselect: !0,
          options: rr,
          value: i.maxRatio,
          setState: a
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        on,
        {
          textLabel: "What is the caliper for matching:",
          propName: "caliper",
          value: i.caliper,
          setState: a
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "What is the caliper scale:",
          propName: "caliperScale",
          options: rb,
          value: i.caliperScale,
          setState: a
        }
      ) })
    ] }),
    i.matchStratifySelection === bn.STRATIFY_BY_PS && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "Into how many strata should the propensity score be divided?",
          description: "The boundaries of the strata are automatically defined to contain equal numbers of target persons",
          propName: "numberOfStrata",
          autoselect: !0,
          options: rr,
          value: i.numberOfStrata,
          setState: a
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "What is the base selection of subjects where the strata bounds are to be determined?",
          description: "Strata are defined as equally-sized strata inside this selection.",
          options: ib,
          value: i.baseSelection,
          setState: a,
          propName: "baseSelection"
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "What is the maximum number of people to include in the propensity score model when fitting?",
        description: "Setting this number to 0 means no down-sampling will be applied",
        propName: "maxCohortSizeForFitting",
        autoselect: !0,
        options: ab,
        value: i.maxCohortSizeForFitting,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Test each covariate for correlation with the target assignment? ",
        description: "If any covariate has an unusually high correlation (either positive or negative), this will throw an error.",
        propName: "errorOnHighCorrelation",
        value: i.errorOnHighCorrelation,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Use regularization when fitting the propensity model?",
        propName: "useRegularization",
        value: i.useRegularization,
        setState: a
      }
    ) }),
    i.useRegularization && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, pr: 1, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Control settings",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            Ed,
            {
              values: i.control,
              onChange: a
            }
          )
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, pl: 1, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Prior",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            Ad,
            {
              values: i.prior,
              onChange: a
            }
          )
        }
      ) })
    ] })
  ] });
};
var Tn = /* @__PURE__ */ ((r) => (r.LOGISTIC_REGRESSION = "logistic", r.POISSON_REGRESSION = "poisson", r.COX = "cox", r.SURVIVAL = "survival", r))(Tn || {});
const Od = {
  [Tn.LOGISTIC_REGRESSION]: {
    value: Tn.LOGISTIC_REGRESSION,
    name: "logistic regression"
  },
  [Tn.POISSON_REGRESSION]: {
    value: Tn.POISSON_REGRESSION,
    name: "poisson regression"
  },
  [Tn.COX]: {
    value: Tn.COX,
    name: "cox proportional hazards"
  }
}, sb = Object.values(Od), lb = (r) => {
  const { values: i, onChange: a } = r;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "Specify the statistical model used to estimate the risk of outcome between target and comparator cohorts",
        propName: "modelType",
        options: sb,
        value: i.modelType,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Should the regression be conditioned on the strata defined in the population object?",
        description: "(e.g. by matching or stratifying on propensity scores)",
        propName: "stratified",
        value: i.stratified,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Should the covariates also be included in the outcome model?",
        propName: "useCovariates",
        value: i.useCovariates,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Use inverse probability of treatment weighting?",
        propName: "inversePtWeighting",
        value: i.inversePtWeighting,
        setState: a
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Use regularization when fitting the outcome model?",
        propName: "useRegularization",
        value: i.useRegularization,
        setState: a
      }
    ) }),
    i.useRegularization && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, pr: 1, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Control settings",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            Ed,
            {
              values: i.control,
              onChange: a
            }
          )
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, pl: 1, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Prior",
          defaultState: !1,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            Ad,
            {
              values: i.prior,
              onChange: a
            }
          )
        }
      ) })
    ] })
  ] });
};
var Cs = /* @__PURE__ */ ((r) => (r.ALL = "all", r.FIRST = "first", r))(Cs || {});
const cb = (r) => {
  var h, d, f;
  const i = Vn(
    r == null ? void 0 : r.conceptSetCrossReference,
    (C) => `${C.targetName}.${C.propertyName}.${C.targetIndex}`
  ), a = "negativeControlOutcomes.outcomeId", s = "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes.includedCovariateConceptIds", l = "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes.excludedCovariateConceptIds", c = r == null ? void 0 : r.cohortDefinitions, m = r == null ? void 0 : r.conceptSets;
  return ((f = (d = (h = r.estimationAnalysisSettings) == null ? void 0 : h.analysisSpecification) == null ? void 0 : d.targetComparatorOutcomes) == null ? void 0 : f.map(
    (C, v) => ({
      ...C,
      targetCohort: c.find(
        (b) => b.versionId === C.targetId
      ),
      comparatorCohort: c.find(
        (b) => b.versionId === C.comparatorId
      ),
      outcomeCohorts: c.filter(
        (b) => C.outcomeIds.includes(b.versionId)
      ),
      negativeControlConceptSet: yi(
        m,
        i[`${a}.${v}`]
      ),
      includedCovariateConceptSet: yi(
        m,
        i[`${s}.${v}`]
      ),
      excludedCovariateConceptSet: yi(
        m,
        i[`${l}.${v}`]
      )
    })
  )) || [];
}, ub = (r) => ({
  studyStartDate: (r == null ? void 0 : r.getDbCohortMethodDataArgs.studyStartDate) || null,
  studyEndDate: (r == null ? void 0 : r.getDbCohortMethodDataArgs.studyEndDate) || null,
  restrictToCommonPeriod: (r == null ? void 0 : r.getDbCohortMethodDataArgs.restrictToCommonPeriod) || !1,
  firstExposureOnly: (r == null ? void 0 : r.getDbCohortMethodDataArgs.firstExposureOnly) || !1,
  washoutPeriod: (r == null ? void 0 : r.getDbCohortMethodDataArgs.washoutPeriod) || 0,
  removeDuplicateSubjects: (r == null ? void 0 : r.getDbCohortMethodDataArgs.removeDuplicateSubjects) || fi.KEEP_ALL,
  censorAtNewRiskWindow: (r == null ? void 0 : r.createStudyPopArgs.censorAtNewRiskWindow) || !1,
  removeSubjectsWithPriorOutcome: (r == null ? void 0 : r.createStudyPopArgs.removeSubjectsWithPriorOutcome) || !1,
  priorOutcomeLookback: (r == null ? void 0 : r.createStudyPopArgs.priorOutcomeLookback) === 0 ? 0 : (r == null ? void 0 : r.createStudyPopArgs.priorOutcomeLookback) || 99999,
  maxCohortSize: (r == null ? void 0 : r.getDbCohortMethodDataArgs.maxCohortSize) || 0
}), db = (r, i) => ({
  getDbCohortMethodDataArgs: {
    studyStartDate: r.studyStartDate,
    studyEndDate: r.studyEndDate,
    restrictToCommonPeriod: r.restrictToCommonPeriod,
    firstExposureOnly: r.firstExposureOnly,
    washoutPeriod: r.washoutPeriod,
    removeDuplicateSubjects: r.removeDuplicateSubjects,
    maxCohortSize: r.maxCohortSize,
    covariateSettings: i
  },
  createStudyPopArgs: {
    censorAtNewRiskWindow: r.censorAtNewRiskWindow,
    removeSubjectsWithPriorOutcome: r.removeSubjectsWithPriorOutcome,
    priorOutcomeLookback: r.priorOutcomeLookback
  }
}), yi = (r, i) => r.find((a) => a.id === (i == null ? void 0 : i.conceptSetId)), hb = (r) => {
  var m, j, h;
  const i = Vn(
    r == null ? void 0 : r.conceptSetCrossReference,
    (d) => `${d.targetName}.${d.propertyName}.${d.targetIndex}`
  ), a = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings.includedCovariateConceptIds", s = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings.excludedCovariateConceptIds", l = r == null ? void 0 : r.conceptSets;
  return ((h = (j = (m = r.estimationAnalysisSettings) == null ? void 0 : m.analysisSpecification) == null ? void 0 : j.cohortMethodAnalysisList) == null ? void 0 : h.map(
    (d, f) => ({
      ...d,
      // studyPopulation: mapStudyPopulationSection(analysis),
      covariateSettingsConcepts: {
        includedCovariateConceptSet: yi(
          l,
          i[`${a}.${f}`]
        ),
        excludedCovariateConceptSet: yi(
          l,
          i[`${s}.${f}`]
        )
      }
      // timeAtRisk: populateTimeAtRisk(analysis),
      // scoreAdjustment: populateScoreAdjustment(analysis),
      // outcomeModel: populateOutcomeModel(analysis),
    })
  )) || [];
}, Rd = (r = {}) => ({
  maxIterations: 1e3,
  tolerance: 1e-6,
  convergenceType: pi.GRADIENT,
  cvType: Si.AUTO,
  fold: 10,
  cvRepetitions: 10,
  minCVData: 10,
  noiseLevel: mi.SILENT,
  resetCoefficients: !1,
  startingVariance: (r == null ? void 0 : r.startingVariance) || 0.01,
  useKKTSwindle: !1,
  tuneSwindle: 10,
  selectorType: xi.AUTO,
  initialBound: 2,
  maxBoundCount: 5,
  // some unused stuff
  lowerLimit: 0.01,
  upperLimit: 20,
  gridSteps: 10,
  threads: 1,
  seed: 1,
  autoSearch: !0,
  algorithm: "ccd",
  ...r
}), Pd = (r = {}) => {
  var i, a, s;
  return {
    priorType: br.HIERARCHICAL,
    graph: void 0,
    useCrossValidation: !0,
    forceIntercept: !1,
    ...r,
    exclude: (i = r == null ? void 0 : r.exclude) == null ? void 0 : i.toString(),
    neighborhood: (a = r == null ? void 0 : r.neighborhood) == null ? void 0 : a.toString(),
    variance: (s = r == null ? void 0 : r.variance) == null ? void 0 : s.toString()
  };
}, fb = (r) => {
  var s, l, c, m;
  let i = Cn.NONE, a = bn.STRATIFY_BY_PS;
  return r != null && r.trimByPs ? i = Cn.BY_PERCENT : r != null && r.trimByPsToEquipoise && (i = Cn.BY_EQUIPOISE), r != null && r.matchOnPs ? a = bn.MATCH_ON_PS : r != null && r.stratifyByPs && (a = bn.STRATIFY_BY_PS), {
    trimSelection: i,
    matchStratifySelection: a,
    trimFraction: (r == null ? void 0 : r.trimByPsArgs.trimFraction) * 100 || 5,
    bounds: ((l = (s = r == null ? void 0 : r.trimByPsToEquipoiseArgs) == null ? void 0 : s.bounds) == null ? void 0 : l.map((j) => j * 100).toString()) || "25,75",
    maxRatio: (r == null ? void 0 : r.matchOnPsArgs.maxRatio) || 1,
    caliper: (r == null ? void 0 : r.matchOnPsArgs.caliper) || 0.2,
    caliperScale: (r == null ? void 0 : r.matchOnPsArgs.caliperScale) || gi.STANDARDIZED_LOGIT,
    numberOfStrata: (r == null ? void 0 : r.stratifyByPsArgs.numberOfStrata) || 5,
    baseSelection: (r == null ? void 0 : r.stratifyByPsArgs.baseSelection) || vi.ALL,
    maxCohortSizeForFitting: (r == null ? void 0 : r.createPsArgs.maxCohortSizeForFitting) || 25e4,
    errorOnHighCorrelation: Vr(
      r == null ? void 0 : r.createPsArgs.errorOnHighCorrelation
    ) ? r == null ? void 0 : r.createPsArgs.errorOnHighCorrelation : !0,
    useRegularization: Vr(r == null ? void 0 : r.createPsArgs.stopOnError) ? r == null ? void 0 : r.createPsArgs.stopOnError : !0,
    control: Rd((c = r == null ? void 0 : r.createPsArgs) == null ? void 0 : c.control),
    prior: Pd((m = r == null ? void 0 : r.createPsArgs) == null ? void 0 : m.prior)
  };
}, pb = (r) => {
  var i, a, s, l, c, m, j;
  return {
    trimByPs: r.trimSelection === Cn.BY_PERCENT,
    trimByPsToEquipoise: r.trimSelection === Cn.BY_EQUIPOISE,
    matchOnPs: (r == null ? void 0 : r.matchStratifySelection) === bn.MATCH_ON_PS,
    stratifyByPs: (r == null ? void 0 : r.matchStratifySelection) === bn.STRATIFY_BY_PS,
    trimByPsArgs: {
      trimFraction: r.trimFraction / 100
    },
    trimByPsToEquipoiseArgs: {
      bounds: (i = r.bounds.split(",")) == null ? void 0 : i.map((h) => h / 100)
    },
    matchOnPsArgs: {
      maxRatio: r.maxRatio,
      caliper: r.caliper,
      caliperScale: r.caliperScale
    },
    stratifyByPsArgs: {
      numberOfStrata: r.numberOfStrata,
      baseSelection: r.baseSelection
    },
    createPsArgs: {
      maxCohortSizeForFitting: r.maxCohortSizeForFitting,
      errorOnHighCorrelation: r.errorOnHighCorrelation,
      stopOnError: r.stopOnError,
      control: r.control,
      prior: {
        ...r.prior,
        exclude: (s = (a = r == null ? void 0 : r.prior) == null ? void 0 : a.exclude) == null ? void 0 : s.split(","),
        neighborhood: (c = (l = r == null ? void 0 : r.prior) == null ? void 0 : l.neighborhood) == null ? void 0 : c.split(","),
        variance: (j = (m = r == null ? void 0 : r.prior) == null ? void 0 : m.variance) == null ? void 0 : j.split(",")
      }
    }
  };
}, mb = (r) => {
  var i, a, s, l, c, m, j;
  return {
    modelType: ((i = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : i.modelType) || Tn.COX,
    stratified: Vr((a = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : a.stratified) ? (s = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : s.stratified : !0,
    useCovariates: ((l = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : l.useCovariates) || !1,
    inversePtWeighting: ((c = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : c.inversePtWeighting) || !1,
    useRegularization: Vr(r == null ? void 0 : r.fitOutcomeModel) ? r == null ? void 0 : r.fitOutcomeModel : !0,
    control: Rd((m = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : m.control),
    prior: Pd((j = r == null ? void 0 : r.fitOutcomeModelArgs) == null ? void 0 : j.prior)
  };
}, xb = (r) => {
  var i, a, s, l, c, m;
  return {
    fitOutcomeModelArgs: {
      modelType: r.modelType,
      stratified: r.stratified,
      useCovariates: r.useCovariates,
      inversePtWeighting: r.inversePtWeighting,
      fitOutcomeModel: r.useRegularization,
      control: r.control,
      prior: {
        ...r.prior,
        exclude: (a = (i = r == null ? void 0 : r.prior) == null ? void 0 : i.exclude) == null ? void 0 : a.split(","),
        neighborhood: (l = (s = r == null ? void 0 : r.prior) == null ? void 0 : s.neighborhood) == null ? void 0 : l.split(","),
        variance: (m = (c = r == null ? void 0 : r.prior) == null ? void 0 : c.variance) == null ? void 0 : m.split(",")
      }
    }
  };
}, gb = (r) => [
  {
    propertyName: "excludedCovariateConceptIds",
    cs: r.excludedCovariateConceptSet,
    targetName: "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes"
  },
  {
    propertyName: "includedCovariateConceptIds",
    cs: r.includedCovariateConceptSet,
    targetName: "estimationAnalysisSettings.analysisSpecification.targetComparatorOutcomes"
  },
  {
    propertyName: "outcomeId",
    cs: r.negativeControlConceptSet,
    targetName: "negativeControlOutcomes"
  }
], vb = (r) => {
  const i = "estimationAnalysisSettings.analysisSpecification.cohortMethodAnalysisList.getDbCohortMethodDataArgs.covariateSettings";
  return [
    {
      propertyName: "excludedCovariateConceptIds",
      cs: r.covariateSettingsConcepts.excludedCovariateConceptSet,
      targetName: i
    },
    {
      propertyName: "includedCovariateConceptIds",
      cs: r.covariateSettingsConcepts.includedCovariateConceptSet,
      targetName: i
    }
  ];
}, Cu = (r, i) => {
  let a = [], s = [];
  return r.forEach((l, c) => {
    i(l).forEach((j) => {
      var h;
      (h = j.cs) != null && h.id && (a.push({
        conceptSetId: j.cs.id,
        propertyName: j.propertyName,
        targetIndex: c,
        targetName: j.targetName
      }), s.push(j.cs));
    });
  }), s = ji(s, "id"), { csRefs: a, conceptSets: s };
}, ju = (r, i) => {
  const a = Cu(
    r,
    vb
  ), s = Cu(
    i,
    gb
  );
  return {
    conceptSetCrossReference: [
      ...a.csRefs,
      ...s.csRefs
    ],
    conceptSets: [
      ...a.conceptSets,
      ...s.conceptSets
    ]
  };
}, yb = (r) => {
  const i = [];
  return r.forEach((a) => {
    a.comparatorCohort && i.push(a.comparatorCohort), a.targetCohort && i.push(a.targetCohort), a.outcomeCohorts.forEach((s) => {
      i.push(s);
    });
  }), ji(i, "id");
}, bb = (r) => {
  const {
    riskWindowStart: i,
    addExposureDaysToStart: a,
    riskWindowEnd: s,
    addExposureDaysToEnd: l,
    minDaysAtRisk: c
  } = (r == null ? void 0 : r.createStudyPopArgs) || {};
  return {
    riskWindowStart: i || 0,
    addExposureDaysToStart: Vr(a) ? a : !1,
    riskWindowEnd: s || 0,
    addExposureDaysToEnd: Vr(l) ? l : !0,
    minDaysAtRisk: c || 0
  };
}, Cb = (r, i) => ({
  ...r,
  createStudyPopArgs: {
    ...r.createStudyPopArgs,
    riskWindowStart: i.riskWindowStart,
    addExposureDaysToStart: i.addExposureDaysToStart,
    riskWindowEnd: i.riskWindowEnd,
    addExposureDaysToEnd: i.addExposureDaysToEnd,
    minDaysAtRisk: i.minDaysAtRisk
  }
}), $j = () => ({}), Wj = (r, i) => ({
  ...i,
  name: i.title || i.name,
  type: r.type
}), jb = (r) => r || {
  attr_class: "covariateSettings",
  temporal: !1,
  DemographicsGender: !0,
  DemographicsAge: !1,
  DemographicsAgeGroup: !0,
  DemographicsRace: !0,
  DemographicsEthnicity: !0,
  DemographicsIndexYear: !0,
  DemographicsIndexMonth: !0,
  DemographicsPriorObservationTime: !1,
  DemographicsPostObservationTime: !1,
  DemographicsTimeInCohort: !1,
  DemographicsIndexYearMonth: !1,
  ConditionOccurrenceAnyTimePrior: !1,
  ConditionOccurrenceLongTerm: !1,
  ConditionOccurrenceMediumTerm: !1,
  ConditionOccurrenceShortTerm: !1,
  ConditionOccurrencePrimaryInpatientAnyTimePrior: !1,
  ConditionOccurrencePrimaryInpatientLongTerm: !1,
  ConditionOccurrencePrimaryInpatientMediumTerm: !1,
  ConditionOccurrencePrimaryInpatientShortTerm: !1,
  ConditionEraAnyTimePrior: !1,
  ConditionEraLongTerm: !1,
  ConditionEraMediumTerm: !1,
  ConditionEraShortTerm: !1,
  ConditionEraOverlapping: !1,
  ConditionEraStartLongTerm: !1,
  ConditionEraStartMediumTerm: !1,
  ConditionEraStartShortTerm: !1,
  ConditionGroupEraAnyTimePrior: !1,
  ConditionGroupEraLongTerm: !0,
  ConditionGroupEraMediumTerm: !1,
  ConditionGroupEraShortTerm: !0,
  ConditionGroupEraOverlapping: !1,
  ConditionGroupEraStartLongTerm: !1,
  ConditionGroupEraStartMediumTerm: !1,
  ConditionGroupEraStartShortTerm: !1,
  DrugExposureAnyTimePrior: !1,
  DrugExposureLongTerm: !1,
  DrugExposureMediumTerm: !1,
  DrugExposureShortTerm: !1,
  DrugEraAnyTimePrior: !1,
  DrugEraLongTerm: !1,
  DrugEraMediumTerm: !1,
  DrugEraShortTerm: !1,
  DrugEraOverlapping: !1,
  DrugEraStartLongTerm: !1,
  DrugEraStartMediumTerm: !1,
  DrugEraStartShortTerm: !1,
  DrugGroupEraAnyTimePrior: !1,
  DrugGroupEraLongTerm: !0,
  DrugGroupEraMediumTerm: !1,
  DrugGroupEraShortTerm: !0,
  DrugGroupEraOverlapping: !0,
  DrugGroupEraStartLongTerm: !1,
  DrugGroupEraStartMediumTerm: !1,
  DrugGroupEraStartShortTerm: !1,
  ProcedureOccurrenceAnyTimePrior: !1,
  ProcedureOccurrenceLongTerm: !0,
  ProcedureOccurrenceMediumTerm: !1,
  ProcedureOccurrenceShortTerm: !0,
  DeviceExposureAnyTimePrior: !1,
  DeviceExposureLongTerm: !0,
  DeviceExposureMediumTerm: !1,
  DeviceExposureShortTerm: !0,
  MeasurementAnyTimePrior: !1,
  MeasurementLongTerm: !0,
  MeasurementMediumTerm: !1,
  MeasurementShortTerm: !0,
  MeasurementValueAnyTimePrior: !1,
  MeasurementValueLongTerm: !1,
  MeasurementValueMediumTerm: !1,
  MeasurementValueShortTerm: !1,
  MeasurementRangeGroupAnyTimePrior: !1,
  MeasurementRangeGroupLongTerm: !0,
  MeasurementRangeGroupMediumTerm: !1,
  MeasurementRangeGroupShortTerm: !1,
  ObservationAnyTimePrior: !1,
  ObservationLongTerm: !0,
  ObservationMediumTerm: !1,
  ObservationShortTerm: !0,
  CharlsonIndex: !0,
  Dcsi: !0,
  Chads2: !0,
  Chads2Vasc: !0,
  DistinctConditionCountLongTerm: !1,
  DistinctConditionCountMediumTerm: !1,
  DistinctConditionCountShortTerm: !1,
  DistinctIngredientCountLongTerm: !1,
  DistinctIngredientCountMediumTerm: !1,
  DistinctIngredientCountShortTerm: !1,
  DistinctProcedureCountLongTerm: !1,
  DistinctProcedureCountMediumTerm: !1,
  DistinctProcedureCountShortTerm: !1,
  DistinctMeasurementCountLongTerm: !1,
  DistinctMeasurementCountMediumTerm: !1,
  DistinctMeasurementCountShortTerm: !1,
  DistinctObservationCountLongTerm: !1,
  DistinctObservationCountMediumTerm: !1,
  DistinctObservationCountShortTerm: !1,
  VisitCountLongTerm: !1,
  VisitCountMediumTerm: !1,
  VisitCountShortTerm: !1,
  VisitConceptCountLongTerm: !1,
  VisitConceptCountMediumTerm: !1,
  VisitConceptCountShortTerm: !1,
  longTermStartDays: -365,
  mediumTermStartDays: -180,
  shortTermStartDays: -30,
  endDays: 0,
  addDescendantsToInclude: !1,
  addDescendantsToExclude: !1,
  attr_fun: "getDbDefaultCovariateData",
  includedCovariateConceptIds: [],
  excludedCovariateConceptIds: [],
  includedCovariateIds: []
}, Sb = (r) => [
  {
    Header: "Domain",
    rowSpan: 2,
    columns: [{ Header: "", invisible: !0, accessor: "domain" }]
  },
  {
    Header: "Any Time Prior",
    rowSpan: 2,
    align: "center",
    accessor: "EraAnyTimePrior",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraAnyTimePrior",
        accessor: "EraAnyTimePrior.value",
        Cell: st
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Long Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.longTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraLongTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraLongTerm",
        accessor: "EraLongTerm.value",
        Cell: st
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Medium Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.mediumTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraMediumTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraMediumTerm",
        accessor: "EraMediumTerm.value",
        Cell: st
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Short Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.shortTermStartDays,
        " days)"
      ] })
    ] }),
    rowSpan: 2,
    align: "center",
    accessor: "EraShortTerm",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraShortTerm",
        accessor: "EraShortTerm.value",
        Cell: st
      }
    ]
  },
  {
    Header: "Overlapping",
    rowSpan: 2,
    accessor: "EraOverlapping",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "EraOverlapping",
        accessor: "EraOverlapping.value",
        Cell: st
      }
    ]
  },
  {
    Header: "Era Start",
    colSpan: 3,
    align: "center",
    disableSortBy: !0,
    columns: [
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Long Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.longTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartLongTerm",
        accessor: "EraStartLongTerm.value",
        Cell: st
      },
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Medium Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.mediumTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartMediumTerm",
        accessor: "EraStartMediumTerm.value",
        Cell: st
      },
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Short Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.shortTermStartDays,
            " days)"
          ] })
        ] }),
        align: "center",
        id: "EraStartShortTerm",
        accessor: "EraStartShortTerm.value",
        Cell: st
      }
    ]
  }
], wb = [
  "EraAnyTimePrior",
  "EraLongTerm",
  "EraMediumTerm",
  "EraShortTerm",
  "EraOverlapping",
  "EraStartLongTerm",
  "EraStartMediumTerm",
  "EraStartShortTerm"
], Tb = [
  { name: "Condition", value: "Condition" },
  { name: "Condition Group", value: "ConditionGroup" },
  { name: "Drug", value: "Drug" },
  { name: "Drug Group", value: "DrugGroup" }
], _b = (r) => {
  let i = [];
  for (const a of Tb) {
    const s = {
      domain: a.name
    };
    for (const l of wb)
      for (const [c, m] of Object.entries(r || {}))
        c === a.value + l && (s[l] = { value: m, id: c });
    i.push(s);
  }
  return i;
}, Eb = [
  { Header: "", align: "center", accessor: "demographics" },
  {
    Header: "Gender",
    align: "center",
    accessor: "DemographicsGender",
    Cell: st
  },
  {
    Header: "Age",
    align: "center",
    accessor: "DemographicsAge",
    Cell: st
  },
  {
    Header: "Age Groups",
    align: "center",
    accessor: "DemographicsAgeGroup",
    Cell: st
  },
  {
    Header: "Race",
    align: "center",
    accessor: "DemographicsRace",
    Cell: st
  },
  {
    Header: "Ethnicity",
    align: "center",
    accessor: "DemographicsEthnicity",
    Cell: st
  },
  {
    Header: "Index Year",
    align: "center",
    accessor: "DemographicsIndexYear",
    Cell: st
  },
  {
    Header: "Index Month",
    align: "center",
    accessor: "DemographicsIndexMonth",
    Cell: st
  },
  {
    Header: "Prior Observation Time",
    align: "center",
    accessor: "DemographicsPriorObservationTime",
    Cell: st
  },
  {
    Header: "Post Observation Time",
    align: "center",
    accessor: "DemographicsPostObservationTime",
    Cell: st
  },
  {
    Header: "Time In Cohort",
    align: "center",
    accessor: "DemographicsTimeInCohort",
    Cell: st
  },
  {
    Header: "Index Year & Month",
    align: "center",
    accessor: "DemographicsIndexYearMonth",
    Cell: st
  }
], Ab = {
  demographics: "Demographics"
}, Ob = [
  { Header: "", align: "center", accessor: "timeWindows" },
  {
    Header: "Any Time Prior",
    align: "center",
    accessor: "allTime"
  },
  {
    Header: "Long Term",
    align: "center",
    accessor: "longTermStartDays",
    Cell: ba
  },
  {
    Header: "Medium Term",
    align: "center",
    accessor: "mediumTermStartDays",
    Cell: ba
  },
  {
    Header: "Short Term",
    align: "center",
    accessor: "shortTermStartDays",
    Cell: ba
  },
  {
    Header: "End Days",
    align: "center",
    accessor: "endDays",
    Cell: ba
  }
], ds = {
  timeWindows: "Time Windows",
  allTime: "All Time",
  longTermStartDays: -365,
  mediumTermStartDays: -180,
  shortTermStartDays: -30,
  endDays: 0
}, Rb = (r) => [
  {
    Header: "Domain",
    disableSortBy: !0,
    rowSpan: 2,
    columns: [{ Header: "", invisible: !0, accessor: "domain" }]
  },
  {
    Header: "Any Time Prior",
    disableSortBy: !0,
    rowSpan: 2,
    align: "center",
    columns: [
      {
        Header: "",
        invisible: !0,
        id: "AnyTimePrior",
        accessor: "AnyTimePrior.value",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Long Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.longTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "longTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "LongTerm.value",
        id: "LongTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Medium Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.mediumTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "mediumTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "MediumTerm.value",
        id: "MediumTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      }
    ]
  },
  {
    Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx("div", { children: "Short Term" }),
      /* @__PURE__ */ t.jsxs("div", { children: [
        "(",
        r.shortTermStartDays,
        " days)"
      ] })
    ] }),
    disableSortBy: !0,
    align: "center",
    id: "shortTerm",
    rowSpan: 2,
    columns: [
      {
        Header: "",
        invisible: !0,
        accessor: "ShortTerm.value",
        id: "ShortTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      }
    ]
  },
  {
    Header: "Distinct Count",
    disableSortBy: !0,
    colSpan: 3,
    align: "center",
    columns: [
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Long Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.longTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountLongTerm.value",
        id: "CountLongTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      },
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Medium Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.mediumTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountMediumTerm.value",
        id: "CountMediumTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      },
      {
        Header: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("div", { children: "Short Term" }),
          /* @__PURE__ */ t.jsxs("div", { children: [
            "(",
            r.shortTermStartDays,
            " days)"
          ] })
        ] }),
        disableSortBy: !0,
        align: "center",
        accessor: "CountShortTerm.value",
        id: "CountShortTerm",
        Cell: (i) => i.value != null && /* @__PURE__ */ t.jsx(st, { ...i })
      }
    ]
  }
], Pb = [
  "AnyTimePrior",
  "LongTerm",
  "MediumTerm",
  "ShortTerm",
  "CountLongTerm",
  "CountMediumTerm",
  "CountShortTerm"
], Db = [
  {
    name: "Condition",
    value: "ConditionOccurrence",
    distinctValue: "DistinctCondition"
  },
  {
    name: "Condition - Primary Inpatient",
    value: "ConditionOccurrencePrimaryInpatient"
  },
  { name: "Drug", value: "DrugExposure", distinctValue: "DistinctIngredient" },
  {
    name: "Procedure",
    value: "ProcedureOccurrence",
    distinctValue: "DistinctProcedure"
  },
  {
    name: "Measurement",
    value: "Measurement",
    distinctValue: "DistinctMeasurement"
  },
  {
    name: "Measurement - Value",
    value: "MeasurementValue"
  },
  {
    name: "Measurement - Range Group",
    value: "MeasurementRangeGroup"
  },
  {
    name: "Observation",
    value: "Observation",
    distinctValue: "DistinctObservation"
  },
  {
    name: "Device",
    value: "DeviceExposure"
  },
  {
    name: "Visit - Count",
    value: "VisitCount"
  },
  {
    name: "Visit - Concept Count",
    value: "VisitConceptCount"
  }
], Nb = (r) => {
  let i = [];
  for (const a of Db) {
    const s = {
      domain: a.name
    };
    for (const l of Pb)
      for (const [c, m] of Object.entries(r || {}))
        (c === a.value + l || a.distinctValue && c === a.distinctValue + l) && (s[l] = { value: m, id: c });
    i.push(s);
  }
  return i;
}, Ib = [
  {
    Header: "Index Score Type",
    accessor: "name",
    Cell: (r) => /* @__PURE__ */ t.jsx(t.Fragment, { children: r.value })
  },
  {
    Header: "",
    id: "item",
    accessor: "item.value",
    align: "center",
    Cell: st
  }
], Lb = (r) => [
  {
    name: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      "CHADS",
      /* @__PURE__ */ t.jsx("sub", { children: "2" })
    ] }),
    item: {
      id: "Chads2",
      value: r.Chads2
    }
  },
  {
    name: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      "CHA",
      /* @__PURE__ */ t.jsx("sub", { children: "2" }),
      "DS",
      /* @__PURE__ */ t.jsx("sub", { children: "2" }),
      "VASc"
    ] }),
    item: {
      id: "Chads2Vasc",
      value: r.Chads2Vasc
    }
  },
  {
    name: "DCSI",
    item: {
      id: "Dcsi",
      value: r.Dcsi
    }
  },
  {
    name: "Charlson",
    item: {
      id: "CharlsonIndex",
      value: r.CharlsonIndex
    }
  }
], Dd = ({ onClose: r, covariateSettings: i, onChange: a }) => {
  const s = _b(i), l = Nb(i), c = Lb(i);
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(Qu, { children: /* @__PURE__ */ t.jsxs(
      g,
      {
        container: !0,
        py: 2,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "h2", children: "Select Covariates..." }) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsxs(
            ct,
            {
              onClick: () => {
                r();
              },
              variant: "text",
              color: "info",
              name: "add",
              children: [
                "<",
                " Back to Analysis settings"
              ]
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, px: 6, py: 2, children: /* @__PURE__ */ t.jsx(
      Hn,
      {
        elevation: 0,
        sx: {
          p: 2,
          "th, td": {
            //   whiteSpace: 'break-spaces',
            border: "1px solid",
            borderColor: "borderColor.light"
          }
        },
        children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            _n,
            {
              data: [{ ...Ab, ...i }],
              columns: Eb,
              onEdit: (m) => a((j) => ({ ...j, [m.columnId]: m.value }))
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(ve, { variant: "h2", children: "Time bound covariates" }) }),
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(ve, { variant: "h3", children: "Set the time windows for the time bound covariates in days relative to the cohort index" }) }),
            /* @__PURE__ */ t.jsx(
              _n,
              {
                data: [{ ...ds, ...i }],
                columns: Ob,
                onEdit: (m) => a((j) => ({ ...j, [m.columnId]: m.value }))
              }
            )
          ] }),
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(ve, { variant: "h3", children: "Set the time bound era covariates" }) }),
            /* @__PURE__ */ t.jsx(
              _n,
              {
                data: s,
                columns: Sb({
                  ...ds,
                  ...i
                }),
                onEdit: (m) => {
                  const j = m.row[m.columnId];
                  a((h) => ({
                    ...h,
                    [j.id]: m.value
                  }));
                }
              }
            )
          ] }),
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(ve, { variant: "h3", children: "Set the time bound covariates" }) }),
            /* @__PURE__ */ t.jsx(
              _n,
              {
                data: l,
                columns: Rb({
                  ...ds,
                  ...i
                }),
                pageSize: l == null ? void 0 : l.length,
                onEdit: (m) => {
                  const j = m.row[m.columnId];
                  a((h) => ({
                    ...h,
                    [j.id]: m.value
                  }));
                }
              }
            )
          ] }),
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 6, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsx(ve, { variant: "h3", children: "Set the index score covariates" }) }),
            /* @__PURE__ */ t.jsx(
              _n,
              {
                data: c,
                columns: Ib,
                onEdit: (m) => {
                  const j = m.row[m.columnId];
                  a((h) => ({
                    ...h,
                    [j.id]: m.value
                  }));
                }
              }
            )
          ] })
        ] })
      }
    ) })
  ] });
}, Fb = $e(
  (r) => {
    var I, k, G, X;
    const { activeItem: i, designProps: a, onClose: s, onChange: l } = r, { typeContainer: c, id: m, parentId: j, subModules: h, analysisName: d, viewMode: f } = a, [C, v] = be(!1), [b, E] = be(
      (I = i.value) == null ? void 0 : I.description
    ), [A, R] = be(
      ub(i.value)
    ), [D, _] = be((k = i.value) == null ? void 0 : k.covariateSettingsConcepts), [F, P] = be(
      bb(i.value)
    ), [x, p] = be(
      fb(i.value)
    ), [y, w] = be(
      mb(i.value)
    ), [M, V] = be(
      jb(
        (X = (G = i.value) == null ? void 0 : G.getDbCohortMethodDataArgs) == null ? void 0 : X.covariateSettings
      )
    ), q = (ie) => (K) => {
      const [N] = K.map((B) => ({
        id: ld(),
        name: B.name,
        description: B.description,
        expression: { items: B.items },
        type: "by_value"
      }));
      _((B) => ({
        ...B,
        [ie]: N
      }));
    }, $ = () => {
      const { excludedCovariateConceptSet: ie, includedCovariateConceptSet: K } = D, N = {
        excludedCovariateConceptIds: ie ? [ie.id] : [],
        includedCovariateConceptIds: K ? [K.id] : []
      }, B = {
        ...Cb(
          db(A, {
            ...M,
            ...N
          }),
          F
        ),
        ...pb(x),
        ...xb(y),
        description: b
      };
      l(
        { ...i.value, ...B, covariateSettingsConcepts: D },
        i.index
      ), s();
    };
    return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, py: 2, px: 6, minHeight: "100%", children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(Zt, { name: "description", textLabel: "Analysis name", children: /* @__PURE__ */ t.jsx(
          $n,
          {
            id: "description",
            name: "description",
            type: "text",
            size: "medium",
            placeholder: "Enter",
            fullWidth: !0,
            value: b,
            onChange: (ie) => {
              E(ie.target.value);
            }
          }
        ) }) }) }) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            collapsible: !0,
            title: "Study Population",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ t.jsx(
              Uy,
              {
                values: A,
                onChange: R
              }
            )
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            collapsible: !0,
            title: "Covariate Settings",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
              /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", children: [
                "Using OHDSI covariates for propensity score model.",
                " ",
                /* @__PURE__ */ t.jsx(
                  ve,
                  {
                    onClick: (ie) => {
                      ie.preventDefault(), v(!0);
                    },
                    component: "a",
                    sx: {
                      fontSize: 12,
                      color: "info.main",
                      fontWeight: 500,
                      cursor: "pointer"
                    },
                    children: "(Click to view details)"
                  }
                )
              ] }) }),
              /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
                /* @__PURE__ */ t.jsx(
                  hi,
                  {
                    subModules: h,
                    viewMode: f,
                    id: m,
                    parentId: j,
                    typeContainer: c,
                    initialData: [
                      D == null ? void 0 : D.includedCovariateConceptSet
                    ],
                    analysisName: d,
                    buttonText: "Import include concept set",
                    titleText: "Concepts to include when constructing the covariates to be used in this study. *",
                    description: "(Leave blank if you want to include every concept).",
                    onChange: q("includedCovariateConceptSet")
                  }
                ),
                /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Comparisons section." })
              ] }),
              /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(zt, { sx: { my: 2, borderColor: "borderColor.light" } }) }),
              /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
                /* @__PURE__ */ t.jsx(
                  hi,
                  {
                    subModules: h,
                    viewMode: f,
                    id: m,
                    parentId: j,
                    typeContainer: c,
                    initialData: [
                      D == null ? void 0 : D.excludedCovariateConceptSet
                    ],
                    analysisName: d,
                    titleText: "Concepts to exclude when constructing the covariates to be used in this study.*",
                    buttonText: "Import exclude concept set",
                    onChange: q("excludedCovariateConceptSet")
                  }
                ),
                /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mt: 1, children: "* Concepts defined here are combined with those defined in the Comparisons section." })
              ] })
            ] })
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            collapsible: !0,
            title: "Time At Risk",
            outlined: !0,
            elevated: !0,
            children: /* @__PURE__ */ t.jsx(
              Gy,
              {
                values: F,
                onChange: P
              }
            )
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            collapsible: !0,
            title: "Propensity Score Adjustment",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ t.jsx(
              ob,
              {
                values: x,
                onChange: p
              }
            )
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            collapsible: !0,
            title: "Outcome Model",
            elevated: !0,
            outlined: !0,
            children: /* @__PURE__ */ t.jsx(
              lb,
              {
                values: y,
                onChange: w
              }
            )
          }
        ) })
      ] }) }),
      /* @__PURE__ */ t.jsx(
        _d,
        {
          submitButtonText: "Save analysis settings",
          onSubmit: $,
          onCancel: s
        }
      ),
      /* @__PURE__ */ t.jsx(
        _s,
        {
          open: C,
          onClose: () => {
            v(!1);
          },
          width: "90%",
          children: /* @__PURE__ */ t.jsx(
            Dd,
            {
              onClose: () => v(!1),
              covariateSettings: M || {},
              onChange: V
            }
          )
        }
      )
    ] });
  }
), Mb = [
  {
    value: Cs.ALL,
    name: "all occurrence"
  },
  {
    value: Cs.FIRST,
    name: "first occurrence"
  }
], kb = [
  { name: "Condition", value: "condition" },
  { name: "Drug", value: "drug" },
  { name: "Device", value: "device" },
  { name: "Measurement", value: "measurement" },
  { name: "Observation", value: "observation" },
  { name: "Procedure", value: "procedure" },
  { name: "Visit", value: "visit" }
], zb = (r) => {
  const { values: i, onChange: a } = r, [s, l] = be(
    i || {
      occurrenceType: void 0,
      detectOnDescendants: !1,
      domains: []
    }
  );
  return kt(() => {
    a({
      negativeControlOutcomeCohortDefinition: s
    });
  }, [s]), /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: `This expression will define the criteria for inclusion and duration of time for cohorts intended for use as negative control outcomes.
          The type of occurrence of the event when selecting from the domain.`,
        propName: "occurrenceType",
        options: Mb,
        value: s.occurrenceType,
        setState: l
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "When true, descendant concepts for the negative control outcome concept IDs will be used to detect the outcome and roll up the occurrence to the concept ID",
        propName: "detectOnDescendants",
        value: s.detectOnDescendants,
        setState: l
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Je,
      {
        textLabel: "What domains should be considered to detect negative control outcomes?",
        propName: "domains",
        options: kb,
        cropItems: !0,
        value: s.domains,
        setState: l,
        multiple: !0
      }
    ) })
  ] });
}, Bb = [
  {
    value: Tn.POISSON_REGRESSION,
    name: "Poisson"
  },
  {
    value: Tn.SURVIVAL,
    name: "Survival"
  }
], $b = [
  {
    value: 1e3,
    name: "1000"
  },
  {
    value: 5e3,
    name: "5000"
  },
  {
    value: 1e4,
    name: "10000"
  },
  {
    value: 5e4,
    name: "50000"
  },
  {
    value: 1e5,
    name: "100000"
  },
  {
    value: 105e3,
    name: "105000"
  },
  {
    value: 2e5,
    name: "200000"
  },
  {
    value: 25e4,
    name: "250000"
  }
], Su = [
  {
    value: 100,
    name: "100"
  },
  {
    value: 75,
    name: "75"
  },
  {
    value: 50,
    name: "50"
  },
  {
    value: 25,
    name: "25"
  },
  {
    value: 10,
    name: "10"
  }
], Wb = (r) => {
  var d;
  const { values: i, onChange: a } = r, [s, l] = be(
    { ...i, effectSizes: (d = i == null ? void 0 : i.effectSizes) == null ? void 0 : d.toString() }
    // || {
    //   doPositiveControlSynthesis: false,
    //   modelType: undefined,
    //   riskWindowStart: 0,
    //   addExposureDaysToStart: false,
    //   riskWindowEnd: 60,
    //   addExposureDaysToEnd: true,
    //   washoutPeriod: undefined,
    //   firstExposureOnly: false,
    //   firstOutcomeOnly: false,
    //   removePeopleWithPriorOutcomes: false,
    //   maxSubjectsForModel: undefined,
    //   effectSizes: undefined,
    //   precision: undefined,
    //   outputIdOffset: undefined,
    //   minOutcomeCountForModel: undefined,
    //   minOutcomeCountForInjection: undefined,
    // }
  ), [c, m] = be(
    i.covariateSettings
  ), [j, h] = be(!1);
  return kt(() => {
    var f;
    a({
      doPositiveControlSynthesis: s.doPositiveControlSynthesis,
      positiveControlSynthesisArgs: {
        modelType: s.modelType,
        riskWindowStart: s.riskWindowStart,
        addExposureDaysToStart: s.addExposureDaysToStart,
        riskWindowEnd: s.riskWindowEnd,
        addExposureDaysToEnd: s.addExposureDaysToEnd,
        washoutPeriod: s.washoutPeriod,
        firstExposureOnly: s.firstExposureOnly,
        firstOutcomeOnly: s.firstOutcomeOnly,
        removePeopleWithPriorOutcomes: s.removePeopleWithPriorOutcomes,
        maxSubjectsForModel: s.maxSubjectsForModel,
        effectSizes: (f = s == null ? void 0 : s.effectSizes) == null ? void 0 : f.split(","),
        precision: s.precision,
        outputIdOffset: s.outputIdOffset,
        minOutcomeCountForModel: s.minOutcomeCountForModel,
        minOutcomeCountForInjection: s.minOutcomeCountForInjection,
        prior: s.prior,
        covariateSettings: c,
        control: s.control
      }
    });
  }, [s, c]), /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      _t,
      {
        textLabel: "Should we perform positive control synthesis? ",
        description: "(to calibrate confidence intervals)",
        propName: "doPositiveControlSynthesis",
        value: s.doPositiveControlSynthesis,
        setState: l
      }
    ) }),
    s.doPositiveControlSynthesis && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "Model Type",
          propName: "modelType",
          options: Bb,
          value: s.modelType,
          setState: l
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", children: [
        "Using OHDSI covariates for propensity score model.",
        " ",
        /* @__PURE__ */ t.jsx(
          ve,
          {
            onClick: (f) => {
              f.preventDefault(), h(!0);
            },
            component: "a",
            sx: {
              fontSize: 12,
              color: "info.main",
              fontWeight: 500,
              cursor: "pointer"
            },
            children: "(Click to view details)"
          }
        )
      ] }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Na,
        {
          textLabel: "Define the time-at-risk window start, relative to target/comparator cohort entry",
          propNameRisk: "riskWindowStart",
          valueRisk: s.riskWindowStart,
          optionsRisk: or,
          propNameTime: "addExposureDaysToStart",
          valueTime: s.addExposureDaysToStart,
          optionsTime: Ia,
          setState: l,
          customTime: /* @__PURE__ */ t.jsx(g, { item: !0, px: 1, fontSize: 12, children: "days from cohort start date" })
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Na,
        {
          textLabel: "Define the time-at-risk window end",
          propNameRisk: "riskWindowEnd",
          valueRisk: s.riskWindowEnd,
          optionsRisk: or,
          propNameTime: "addExposureDaysToEnd",
          valueTime: s.addExposureDaysToEnd,
          optionsTime: Ia,
          setState: l
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Je,
        {
          textLabel: "The minimum required continuous observation time (in days) prior to exposure:",
          propName: "washoutPeriod",
          options: or,
          autoselect: !0,
          value: s.washoutPeriod,
          setState: l
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        _t,
        {
          textLabel: "Should only the first exposure per subject be included?",
          propName: "firstExposureOnly",
          value: s.firstExposureOnly,
          setState: l
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        _t,
        {
          textLabel: "Should only the first exposure per subject be included?",
          propName: "firstOutcomeOnly",
          value: s.firstOutcomeOnly,
          setState: l
        }
      ) }),
      /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(
          _t,
          {
            textLabel: "Remove people with prior outcomes?",
            propName: "removePeopleWithPriorOutcomes",
            value: s.removePeopleWithPriorOutcomes,
            setState: l
          }
        ),
        /* @__PURE__ */ t.jsx(zt, { sx: { m: 1 } })
      ] }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, pt: 2, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Additional settings",
          defaultState: !1,
          isDark: !0,
          children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Je,
              {
                textLabel: "Maximum number of people used to fit an outcome model",
                propName: "maxSubjectsForModel",
                options: $b,
                autoselect: !0,
                value: s.maxSubjectsForModel,
                setState: l
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              on,
              {
                textLabel: "What effect sizes should be inserted",
                propName: "effectSizes",
                value: s.effectSizes,
                setState: l
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              on,
              {
                textLabel: "The allowed ratio between target and injected signal size",
                propName: "precision",
                value: s.precision,
                setState: l
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              on,
              {
                textLabel: "What should be the first new outcome ID that is to be created",
                propName: "outputIdOffset",
                value: s.outputIdOffset,
                setState: l
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Je,
              {
                textLabel: "Minimum number of outcome events required to build a model",
                propName: "minOutcomeCountForModel",
                options: Su,
                autoselect: !0,
                value: s.minOutcomeCountForModel,
                setState: l
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Je,
              {
                textLabel: "Minimum number of outcome events required to inject a signal",
                propName: "minOutcomeCountForInjection",
                options: Su,
                autoselect: !0,
                value: s.minOutcomeCountForInjection,
                setState: l
              }
            ) })
          ] })
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsx(
      _s,
      {
        open: j,
        onClose: () => {
          h(!1);
        },
        width: "90%",
        children: /* @__PURE__ */ t.jsx(
          Dd,
          {
            onClose: () => h(!1),
            covariateSettings: c || {},
            onChange: m
          }
        )
      }
    )
  ] });
}, Hb = (r) => {
  const { values: i, onChange: a } = r;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
    /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx(ve, { variant: "h3", sx: { px: 1 }, children: "Negative Control Outcome Cohort Definition" }),
      /* @__PURE__ */ t.jsx(
        zb,
        {
          values: i.negativeControlOutcomeCohortDefinition,
          onChange: a
        }
      ),
      /* @__PURE__ */ t.jsx(zt, { sx: { m: 1 } })
    ] }),
    /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx(ve, { variant: "h3", sx: { px: 1 }, children: "Positive Control Synthesis" }),
      /* @__PURE__ */ t.jsx(
        Wb,
        {
          values: {
            ...i.positiveControlSynthesisArgs,
            doPositiveControlSynthesis: i.doPositiveControlSynthesis
          },
          onChange: a
        }
      )
    ] })
  ] });
}, Vb = (r, i) => [
  {
    Header: "Desciption",
    accessor: "description"
  },
  {
    Header: "Time at risk start",
    accessor: (a) => {
      var s;
      return `${((s = a.createStudyPopArgs) == null ? void 0 : s.riskWindowStart) || 0}d from ${bs[`${a.createStudyPopArgs.addExposureDaysToStart}`].name}`;
    }
  },
  {
    Header: "Time at risk end",
    accessor: (a) => {
      var s;
      return `${((s = a.createStudyPopArgs) == null ? void 0 : s.riskWindowEnd) || 0}d from ${bs[`${a.createStudyPopArgs.addExposureDaysToEnd}`].name}`;
    }
  },
  {
    Header: "Minimum time at risk",
    accessor: (a) => (a.createStudyPopArgs.minDaysAtRisk || 0) + "d"
  },
  {
    Header: "Adjustment strategy",
    accessor: (a) => {
      const { matchOnPs: s, stratifyByPs: l, matchOnPsArgs: c, stratifyByPsArgs: m } = a;
      return s ? `${c.maxRatio}:1 matching` : l ? `Stratification (stratum: ${m.numberOfStrata})` : "None";
    }
  },
  {
    Header: "Outcome Model",
    accessor: (a) => {
      var s;
      return ((s = Od[a.fitOutcomeModelArgs.modelType]) == null ? void 0 : s.name) || "";
    }
  },
  ...i ? [] : [
    {
      Header: "",
      accessor: "actions",
      isCropped: !0,
      disableSortBy: !0,
      maxWidth: 100,
      Cell: (a) => /* @__PURE__ */ t.jsx(
        ed,
        {
          onRemove: () => {
            r(a.row);
          }
        }
      )
    }
  ]
], Ub = (r) => {
  const { data: i, onRowClick: a, onRemoveRow: s, viewMode: l } = r;
  return /* @__PURE__ */ t.jsx(
    _n,
    {
      columns: Vb(s, l),
      data: i,
      loadingMessage: "",
      enableSorting: !0,
      enablePagination: !0,
      totalElements: i.length,
      onRowClick: (c) => {
        a(c.original, c.index);
      }
    }
  );
}, Gb = (r, i) => [
  {
    Header: "Target",
    accessor: "targetCohort.name",
    width: "22%",
    maxWidth: 240
  },
  {
    Header: "Comparator",
    accessor: "comparatorCohort.name",
    width: "22%",
    maxWidth: 240
  },
  {
    Header: "Outcomes",
    accessor: (a) => {
      var s;
      return (s = a.outcomeCohorts) == null ? void 0 : s.map((l) => l.name);
    },
    Cell: z0,
    width: "22%",
    isCropped: !0,
    disableSortBy: !0
  },
  {
    Header: "NC Outcomes",
    accessor: "negativeControlConceptSet.name",
    width: "22%",
    maxWidth: 240
  },
  ...i ? [] : [
    {
      Header: "",
      accessor: "actions",
      isCropped: !0,
      disableSortBy: !0,
      maxWidth: 100,
      Cell: (a) => /* @__PURE__ */ t.jsx(
        ed,
        {
          onRemove: () => {
            r(a.row);
          }
        }
      )
    }
  ]
], Kb = (r) => {
  const { data: i, onRowClick: a, onRemoveRow: s, viewMode: l } = r;
  return /* @__PURE__ */ t.jsx(
    _n,
    {
      columns: Gb(s, l),
      data: i,
      loadingMessage: "",
      enableSorting: !0,
      enablePagination: !0,
      totalElements: i.length,
      onRowClick: (c) => {
        a(c.original, c.index);
      }
    }
  );
}, Hj = $e(
  (r) => {
    const {
      subModules: i,
      parentId: a,
      design: s,
      reloadDesign: l,
      id: c,
      typeContainer: m,
      // setDesign,
      analysisName: j,
      viewMode: h
    } = r, [d, f] = be(s), [C, v] = be(
      cb(s)
    ), [b, E] = be(
      hb(s)
    ), [A, R] = be(!1), [D, _] = be(
      "COMPARISONS"
      /* COMPARISONS */
    ), [F, P] = be({
      value: null,
      index: null
    }), x = () => {
      R(!1), _(null), P({ value: null, index: null });
    };
    return kt(() => {
      const p = ju(
        b,
        C
      );
      f({
        ...d,
        ...p,
        estimationAnalysisSettings: {
          analysisSpecification: {
            ...d.estimationAnalysisSettings.analysisSpecification,
            cohortMethodAnalysisList: b
          }
        }
      });
    }, [b]), kt(() => {
      const p = ju(
        b,
        C
      ), y = yb(C);
      f({
        ...d,
        ...p,
        cohorts: y,
        estimationAnalysisSettings: {
          analysisSpecification: {
            ...d.estimationAnalysisSettings.analysisSpecification,
            targetComparatorOutcomes: C.map((w) => ({
              comparatorId: w.comparatorId,
              targetId: w.targetId,
              outcomeIds: w.outcomeIds,
              excludedCovariateConceptIds: [],
              includedCovariateConceptIds: []
            }))
          }
        }
      });
    }, [C]), kt(() => {
      Os(d, s) || l(d);
    }, [d]), /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
      (!h || h && (C == null ? void 0 : C.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          elevated: !0,
          outlined: !0,
          title: /* @__PURE__ */ t.jsxs(
            g,
            {
              item: !0,
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  Ot,
                  {
                    title: "Comparisons",
                    count: C == null ? void 0 : C.length
                  }
                ) }),
                !h && /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  ct,
                  {
                    onClick: (p) => {
                      p.stopPropagation(), R(!0), _(
                        "COMPARISONS"
                        /* COMPARISONS */
                      );
                    },
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "add" }),
                    name: "add",
                    children: "Add comparisons"
                  }
                ) })
              ]
            }
          ),
          children: /* @__PURE__ */ t.jsx(g, { container: !0, children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Kb,
            {
              viewMode: h,
              data: C,
              onRowClick: (p, y) => {
                P({ value: p, index: y }), R(!0), _(
                  "COMPARISONS"
                  /* COMPARISONS */
                );
              },
              onRemoveRow: (p) => {
                v((y) => {
                  const w = [...y];
                  return w.splice(p.index, 1), w;
                });
              }
            }
          ) }) })
        }
      ) }),
      (!h || h && (b == null ? void 0 : b.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          elevated: !0,
          outlined: !0,
          collapsible: !0,
          title: /* @__PURE__ */ t.jsxs(
            g,
            {
              item: !0,
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              children: [
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  Ot,
                  {
                    title: "Analysis Settings",
                    count: b == null ? void 0 : b.length
                  }
                ) }),
                !h && /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  ct,
                  {
                    onClick: (p) => {
                      p.stopPropagation(), R(!0), _(
                        "ANALYSIS_SETTINGS"
                        /* ANALYSIS_SETTINGS */
                      );
                    },
                    variant: "contained",
                    color: "info",
                    startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "add" }),
                    name: "add",
                    children: "Add analysis settings"
                  }
                ) })
              ]
            }
          ),
          children: /* @__PURE__ */ t.jsx(
            Ub,
            {
              data: b,
              viewMode: h,
              onRowClick: (p, y) => {
                P({ value: p, index: y }), R(!0), _(
                  "ANALYSIS_SETTINGS"
                  /* ANALYSIS_SETTINGS */
                );
              },
              onRemoveRow: (p) => {
                E((y) => {
                  const w = [...y];
                  return w.splice(p.index, 1), w;
                });
              }
            }
          )
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: "Evaluation Settings",
          defaultState: h,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            Hb,
            {
              values: {
                doPositiveControlSynthesis: d.doPositiveControlSynthesis,
                negativeControlOutcomeCohortDefinition: d.negativeControlOutcomeCohortDefinition,
                positiveControlSynthesisArgs: d.positiveControlSynthesisArgs
              },
              onChange: (p) => {
                f({
                  ...d,
                  ...p
                });
              }
            }
          )
        }
      ) }),
      /* @__PURE__ */ t.jsxs(_s, { open: A, onClose: x, width: "80%", children: [
        /* @__PURE__ */ t.jsx(Qu, { children: /* @__PURE__ */ t.jsxs(
          g,
          {
            container: !0,
            py: 2,
            alignItems: "center",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsxs(ve, { variant: "h2", children: [
                D === "ANALYSIS_SETTINGS" && "Analysis settings",
                D === "COMPARISONS" && "Comparison"
              ] }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsxs(
                ct,
                {
                  onClick: () => {
                    x();
                  },
                  variant: "text",
                  color: "info",
                  name: "add",
                  children: [
                    "<",
                    " Back to design"
                  ]
                }
              ) })
            ]
          }
        ) }),
        /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          D === "COMPARISONS" && /* @__PURE__ */ t.jsx(
            $y,
            {
              onChange: (p, y) => {
                v((w) => {
                  const M = [...w];
                  return y != null ? M.splice(y, 1, p) : M.push(p), M;
                });
              },
              onClose: x,
              activeItem: F,
              designProps: {
                subModules: i,
                analysisName: j,
                parentId: a,
                id: c,
                typeContainer: m,
                viewMode: h
              }
            }
          ),
          D === "ANALYSIS_SETTINGS" && /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
            Fb,
            {
              activeItem: F,
              onClose: x,
              designProps: {
                subModules: i,
                analysisName: j,
                parentId: a,
                id: c,
                typeContainer: m
              },
              onChange: (p, y) => {
                E((w) => {
                  const M = [...w];
                  return y != null ? M.splice(y, 1, p) : M.push(p), M;
                });
              }
            }
          ) })
        ] })
      ] })
    ] });
  }
), Vj = $e((r) => /* @__PURE__ */ t.jsx(t.Fragment, { children: "results" })), Uj = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], wu = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 21,
    name: "21"
  },
  {
    value: 30,
    name: "30"
  },
  {
    value: 60,
    name: "60"
  },
  {
    value: 90,
    name: "90"
  },
  {
    value: 120,
    name: "120"
  },
  {
    value: 180,
    name: "180"
  },
  {
    value: 365,
    name: "365"
  },
  {
    value: 548,
    name: "548"
  },
  {
    value: 730,
    name: "730"
  },
  {
    value: 1095,
    name: "1095"
  }
], Tu = [
  {
    value: Oa.START_DATE,
    name: "start date"
  },
  {
    value: Oa.END_DATE,
    name: "end date"
  }
];
Le.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
Le.div`
  padding: 10px 20px;
  font-size: 12px;
  color: #ffffff;
  font-weight: 700;
`;
Le.div`
  padding: 10px 8px;
  font-size: 11px;
  color: #000000;
  font-weight: 500;
`;
Le.div`
  background: #ffffff;
  padding: 5px;
`;
const qb = Le.div`
  /* font-size: 36px; */
  text-align: center;
  padding: 16px;
`, Yb = Le.div``;
Le.div`
  padding: 2px 15px;
  label {
    color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    color: #2a2a2a;
    font-weight: 500;
    display: block;
    font-size: 13px;
    margin-top: 10px;
    font-style: italic;
  }
  .MuiCheckbox-root {
    margin-right: 10px;
  }
`;
const _u = Le.div`
  margin-top: 20px;
  padding: 0;
  label {
    color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    color: #2a2a2a;
    font-weight: 500;
    display: block;
    font-size: 13px;
    margin-top: 4px;
    font-style: italic;
  }
  .MuiCheckbox-root {
    margin-right: 10px;
  }
`, Eu = Le.div`
  /* background-color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.backgroundColor.main;
}}; */
  border-bottom: 1px solid
    ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.borderColor.main;
}};
  border-radius: 4px 4px 0 0;
  padding: 0 0 12px;
  h4 {
    margin: 0;
    color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
    font-weight: 700;
    display: block;
    font-size: 16px;
    & + p {
      padding-top: 16px;
    }
  }
`, Au = Le.p`
  font-size: 14px;
  margin: 0;
`, Gj = $e((r) => {
  var f, C, v, b, E, A, R, D, _, F, P, x, p, y, w, M, V, q;
  const {
    id: i,
    subModules: a,
    parentId: s,
    typeContainer: l,
    design: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r, d = ($) => (I) => {
    m($, I);
  };
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
    (!h || h && ((f = c == null ? void 0 : c.targetCohorts) == null ? void 0 : f.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      a.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: a,
        path: It(l, i, s),
        config: {
          buttonText: "Import target cohort",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Target cohorts",
              count: (C = c == null ? void 0 : c.targetCohorts) == null ? void 0 : C.length
            }
          ),
          typeContainer: l,
          classNameContainer: "target-import-button",
          initialData: c == null ? void 0 : c.targetCohorts,
          onChange: d("targetCohorts"),
          isSelect: !0,
          parentId: s,
          returnEntityText: j,
          collapsible: !0,
          defaultState: !0,
          viewMode: h
        }
      }
    ) }),
    (!h || h && ((v = c == null ? void 0 : c.outcomeCohorts) == null ? void 0 : v.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      a.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: a,
        path: It(l, i, s),
        config: {
          buttonText: "Import outcome cohort",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Outcome cohorts",
              count: (b = c == null ? void 0 : c.outcomeCohorts) == null ? void 0 : b.length
            }
          ),
          classNameContainer: "outcome-import-button",
          initialData: c == null ? void 0 : c.outcomeCohorts,
          typeContainer: l,
          onChange: d("outcomeCohorts"),
          isSelect: !0,
          parentId: s,
          returnEntityText: j,
          collapsible: !0,
          defaultState: h,
          viewMode: h
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
      Re,
      {
        collapsible: !0,
        title: "Time At Risk",
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: [
          /* @__PURE__ */ t.jsx(Eu, { children: /* @__PURE__ */ t.jsx(Au, { children: "Time at risk defines the time window relative to the cohort start or end date with an offset to consider the person 'at risk' of the outcome." }) }),
          /* @__PURE__ */ t.jsxs(_u, { children: [
            /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "Time at risk starts with" }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                mn,
                {
                  className: "",
                  name: "dateEdgeStart",
                  disablePortal: !0,
                  size: "small",
                  id: "dateEdgeStart",
                  options: Tu,
                  value: (A = (E = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : E.start) == null ? void 0 : A.DateField,
                  placeholder: "Select date edge...",
                  onChange: ($) => {
                    m("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      start: {
                        ...c == null ? void 0 : c.timeAtRisk.start,
                        DateField: $
                      }
                    });
                  },
                  disabled: h
                }
              ) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "plus" }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  name: "startOffset",
                  disablePortal: !0,
                  size: "small",
                  id: "startOffset",
                  options: wu,
                  value: (D = (R = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : R.start) == null ? void 0 : D.Offset,
                  placeholder: "Select offset...",
                  onChange: ($) => {
                    m("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      start: {
                        ...c == null ? void 0 : c.timeAtRisk.start,
                        Offset: $ === "undefined" ? void 0 : $
                      }
                    });
                  },
                  disabled: h
                }
              ) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "days" }) })
            ] }),
            /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "Time at risk ends with" }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                mn,
                {
                  className: "",
                  name: "dateEdgeStart",
                  disablePortal: !0,
                  size: "small",
                  id: "dateEdgeStart",
                  options: Tu,
                  value: (F = (_ = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : _.end) == null ? void 0 : F.DateField,
                  placeholder: "Select date edge...",
                  onChange: ($) => {
                    m("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      end: {
                        ...c == null ? void 0 : c.timeAtRisk.end,
                        DateField: $
                      }
                    });
                  },
                  disabled: h
                }
              ) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "plus" }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  className: "",
                  name: "endOffset",
                  disablePortal: !0,
                  size: "small",
                  id: "endOffset",
                  options: wu,
                  value: (x = (P = c == null ? void 0 : c.timeAtRisk) == null ? void 0 : P.end) == null ? void 0 : x.Offset,
                  placeholder: "Select offset...",
                  onChange: ($) => {
                    m("timeAtRisk", {
                      ...c == null ? void 0 : c.timeAtRisk,
                      end: {
                        ...c == null ? void 0 : c.timeAtRisk.end,
                        Offset: $ === "undefined" ? void 0 : $
                      }
                    });
                  },
                  disabled: h
                }
              ) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "days" }) })
            ] })
          ] }),
          /* @__PURE__ */ t.jsx(_u, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "Study window begins on" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
              jr,
              {
                size: "small",
                fullWidth: !1,
                value: (p = c == null ? void 0 : c.studyWindow) != null && p.startDate ? Ca(
                  (y = c == null ? void 0 : c.studyWindow) == null ? void 0 : y.startDate,
                  Tt.ISO_DATE,
                  Tt.DATE
                ) : null,
                format: Tt.DATEPICKER_DATE,
                onChange: ($) => {
                  hu($, Tt.DATE) ? m("studyWindow", {
                    ...c.studyWindow,
                    startDate: Ca(
                      new Date($).toISOString(),
                      Tt.ISO_DATE_TIME,
                      Tt.ISO_DATE
                    )
                  }) : m("studyWindow", {
                    ...c.studyWindow,
                    startDate: new Date($).toString()
                  });
                },
                name: "dateAttrPickerEnd",
                disabled: h
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx("p", { children: "and ends on" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
              jr,
              {
                size: "small",
                fullWidth: !1,
                value: (w = c == null ? void 0 : c.studyWindow) != null && w.endDate ? Ca(
                  (M = c == null ? void 0 : c.studyWindow) == null ? void 0 : M.endDate,
                  Tt.ISO_DATE,
                  Tt.DATE
                ) : null,
                format: Tt.DATEPICKER_DATE,
                onChange: ($) => {
                  hu($, Tt.DATE) ? m("studyWindow", {
                    ...c.studyWindow,
                    endDate: Ca(
                      new Date($).toISOString(),
                      Tt.ISO_DATE_TIME,
                      Tt.ISO_DATE
                    )
                  }) : m("studyWindow", {
                    ...c.studyWindow,
                    endDate: new Date($).toString()
                  });
                },
                name: "dateAttrPickerEnd",
                disabled: h
              }
            ) })
          ] }) })
        ]
      }
    ) }),
    (!h || h && ((V = c == null ? void 0 : c.strata) == null ? void 0 : V.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
      Re,
      {
        collapsible: !0,
        title: /* @__PURE__ */ t.jsx(
          Ot,
          {
            title: "Stratify Criteria",
            count: (q = c == null ? void 0 : c.strata) == null ? void 0 : q.length
          }
        ),
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: [
          /* @__PURE__ */ t.jsx(Eu, { children: /* @__PURE__ */ t.jsx(Au, { children: "You can provide optional stratification criteria to the analysis that will divide the population into unique groups based on their satisfied criteria." }) }),
          /* @__PURE__ */ t.jsx(Yb, { children: /* @__PURE__ */ t.jsx(
            a.cohort,
            {
              type: "component",
              name: "widget-criteria-group",
              subModules: a,
              config: {
                onChange: ($) => {
                  m("strata", $);
                },
                hiddenParentConcept: !0,
                typeContainer: l,
                parentId: s,
                values: (c == null ? void 0 : c.strata) || [],
                buttonText: "New stratify Criteria",
                titleText: "Stratify Criteria",
                contextConceptSets: {
                  conceptSets: c == null ? void 0 : c.conceptSets,
                  updateConceptSets: ($) => {
                    m("conceptSets", $);
                  }
                },
                viewMode: h
              }
            }
          ) })
        ]
      }
    ) })
  ] });
}), Kj = [
  {
    name: "Target Cohorts",
    value: "targetCohorts"
  },
  {
    name: "Outcome Cohorts",
    value: "outcomeCohorts"
  }
], Xb = {
  columns: [
    {
      Header: "Target Cohort",
      accessor: "targetName",
      isCropped: !0,
      maxWidth: 250
    },
    {
      Header: "Outcome Cohort",
      accessor: "outcomeName",
      isCropped: !0,
      maxWidth: 250
    },
    {
      Header: "Persons",
      accessor: "personCount",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Cases",
      accessor: "cases",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Proportion (per 1k persons)",
      accessor: "proportion",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Time at risk (years)",
      accessor: "timeAtRisk",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Rate (per 1k years)",
      accessor: "rate",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    }
  ]
}, Zb = {
  columns: [
    {
      Header: "Stratify Rule",
      accessor: "name"
    },
    {
      Header: "Persons",
      accessor: "personCount",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Cases",
      accessor: "cases",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Proportion (per 1k persons)",
      accessor: "proportion",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Time at risk (years)",
      accessor: "timeAtRisk",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    },
    {
      Header: "Rate (per 1k years)",
      accessor: "rate",
      Cell: ({ value: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r) })
    }
  ]
}, qj = () => ({
  targetCohorts: [],
  outcomeCohorts: [],
  strata: [],
  conceptSets: [],
  // studyWindow: {
  //   endDate: null,
  //   startDate: null,
  // },
  timeAtRisk: {
    start: {
      DateField: Oa.START_DATE,
      Offset: 0
    },
    end: {
      DateField: Oa.END_DATE,
      Offset: 0
    }
  }
}), Yj = (r) => {
  var i, a;
  return r != null && r.summaries ? r.summaries.length > 1 ? `${te(r == null ? void 0 : r.summaries.length)} combinations` : `${te(((a = (i = r == null ? void 0 : r.summaries) == null ? void 0 : i[0]) == null ? void 0 : a.cases) || 0)} cases` : "0 cases";
}, Xj = (r, i) => {
  const a = cd(i.expression) ? JSON.parse(i.expression) : i.expression;
  return {
    ...i,
    type: r.type,
    expression: a
    // strataConceptSets: design.map(item => {
    //   if (item.concept.STANDARD_CONCEPT === StandardConceptTypes.NON_STANDARD) {
    //     item.hierarchy = item.includeDescendants;
    //     delete item.includeMapped;
    //     delete item.includeDescendants;
    //   }
    //   return item;
    // }),
  };
}, Jb = [
  "#0082cc",
  "#00a2d7",
  "#00c1c8",
  "#7ae59f",
  "#fefa82",
  "#ffd13c",
  "#ffa500",
  "#ff7300",
  "#fe0000"
], Ou = (r, i) => i > 0 ? (1 * r / (1 * i) * 1e3).toFixed(2) : 0 .toFixed(2);
function Qb(r, i) {
  var c, m, j;
  const a = r.stata || r.strata ? i.targetCohort && i.outcomeCohort ? (r.stata || r.strata).filter(
    (h) => h.outcomeId === i.outcomeCohort && h.targetId === i.targetCohort
  ) : r.stata || r.strata : [], s = ((c = r.summaries) == null ? void 0 : c.filter(
    (h) => h.outcomeId === i.outcomeCohort && h.targetId === i.targetCohort
  )) || [], l = (j = (m = r.treemapData) == null ? void 0 : m[i.targetCohort]) == null ? void 0 : j[i.outcomeCohort];
  return {
    strata: a,
    treemapData: l,
    summaries: s
  };
}
const e1 = ({ summary: r, filteredStrataSize: i }) => {
  var a, s;
  return /* @__PURE__ */ t.jsx(ve, { fontSize: 12, textAlign: "center", children: r ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    r.cases,
    " cases, ",
    r.timeAtRisk,
    " TAR, Rate: ",
    r.rate,
    " ",
    "per 1k years",
    /* @__PURE__ */ t.jsx("br", {}),
    " ",
    r.size,
    " (",
    r.percentage,
    "%) people,",
    " ",
    (a = r.passed) == null ? void 0 : a.length,
    " criteria passed,",
    " ",
    i - ((s = r.passed) == null ? void 0 : s.length),
    " ",
    "criteria failed."
  ] }) : /* @__PURE__ */ t.jsx(t.Fragment, {}) });
}, Ru = (r, i, a) => r.map((s) => ({
  value: s[i],
  name: s[a]
})), t1 = (r) => {
  const i = {
    targetCohort: null,
    outcomeCohort: null
  };
  return r.length > 0 ? {
    targetCohort: r[0].targetId,
    outcomeCohort: r[0].outcomeId
  } : i;
}, Zj = $e(
  (r) => {
    var v, b, E;
    const { data: i } = r, [a, s] = be(null), [l, c] = be(
      t1(i.summaries)
    ), m = Pe(
      () => Qb(i, l),
      [i, l]
    ), j = Pe(() => {
      let A = [];
      function R(_) {
        _.hasOwnProperty("timeAtRisk") && _.timeAtRisk > 0 && _.cases > 0 && A.push(_.cases / _.timeAtRisk), _.hasOwnProperty("children") && _.children.forEach(R);
      }
      m.treemapData && R(m.treemapData);
      const D = Y0(A);
      return [D[0], Math.max(D[0] * 1.001, D[1])];
    }, [m]), h = Pe(() => {
      const A = X0().domain([j[0], j[1]]).range(Jb);
      let R = function(D) {
        return D.cases == 0 ? "#A0A8BA" : D.timeAtRisk > 0 ? A(D.cases / D.timeAtRisk) : "#bababa";
      };
      return R.scale = A, R;
    }, [j]);
    function d() {
      s(null);
    }
    Pe(() => "per 1k years", [j]);
    function f(A, R, D, _) {
      let F = [], P = [];
      for (let y = 0; y < A.length; y++) {
        let w = i.strata[y];
        A[y] == "1" ? F.push(w) : P.push(w);
      }
      const x = m.summaries.find(
        (y) => y.targetId === l.targetCohort && y.outcomeId === l.outcomeCohort
      ), p = x.personCount > 0 ? R / x.personCount * 100 : 0;
      s({
        cases: D.toLocaleString(),
        timeAtRisk: _.toLocaleString(),
        rate: Ou(D, _),
        size: R.toLocaleString(),
        percentage: p.toFixed(2),
        passed: F,
        failed: P
      });
    }
    function C(A, R, D) {
      if (D) {
        let _ = D.data;
        f(
          _.name,
          _.size,
          _.cases,
          _.timeAtRisk
        );
      } else
        return !1;
    }
    return /* @__PURE__ */ t.jsx(g, { container: !0, children: l.targetCohort && l.outcomeCohort ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      i.summaries.length > 1 && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 2, children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 3, children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(
          Zt,
          {
            name: "targetCohort",
            textLabel: "Target cohort",
            required: !0,
            children: /* @__PURE__ */ t.jsx(
              mn,
              {
                className: "",
                name: "targetCohort",
                disablePortal: !0,
                id: "targetCohort",
                options: Ru(
                  ji(i.summaries, "targetId"),
                  "targetId",
                  "targetName"
                ),
                value: l.targetCohort,
                placeholder: "Select target cohort",
                onChange: (A) => {
                  c((R) => ({
                    ...R,
                    targetCohort: A
                  }));
                },
                fullWidth: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, children: /* @__PURE__ */ t.jsx(
          Zt,
          {
            name: "outcomeCohort",
            textLabel: "Outcome cohort",
            required: !0,
            children: /* @__PURE__ */ t.jsx(
              mn,
              {
                className: "",
                name: "outcomeCohort",
                disablePortal: !0,
                id: "outcomeCohort",
                options: Ru(
                  ji(i.summaries, "outcomeId"),
                  "outcomeId",
                  "outcomeName"
                ),
                value: l.outcomeCohort,
                placeholder: "Select outcome cohort",
                onChange: (A) => {
                  c((R) => ({
                    ...R,
                    outcomeCohort: A
                  }));
                },
                fullWidth: !0
              }
            )
          }
        ) })
      ] }) }),
      /* @__PURE__ */ t.jsx(
        Hn,
        {
          elevation: 3,
          variant: "outlined",
          sx: (A) => ({ mb: 2, boxShadow: A.customShadows[3] }),
          children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            _n,
            {
              columns: Xb.columns,
              data: m.summaries,
              totalElements: (v = m.summaries) == null ? void 0 : v.length
            }
          ) })
        }
      ),
      m.strata && m.strata.length > 0 && /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
        /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            boxSizing: "border-box",
            xs: 12,
            md: 5.5,
            lg: 7,
            minHeight: { xs: "auto", md: 500 },
            children: /* @__PURE__ */ t.jsx(
              Hn,
              {
                elevation: 3,
                variant: "outlined",
                sx: (A) => ({
                  width: "100%",
                  height: "100%",
                  boxShadow: A.customShadows[3]
                }),
                children: /* @__PURE__ */ t.jsx(
                  _n,
                  {
                    columns: Zb.columns,
                    data: m.strata,
                    totalElements: (b = m.strata) == null ? void 0 : b.length
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            xs: 12,
            md: 6.5,
            lg: 5,
            height: 500,
            boxSizing: "border-box",
            children: /* @__PURE__ */ t.jsx(
              Hn,
              {
                variant: "outlined",
                sx: (A) => ({
                  height: "calc(100% - 32px)",
                  p: 2,
                  boxShadow: A.customShadows[3]
                }),
                children: i.treemapData ? [
                  /* @__PURE__ */ t.jsx(le, { height: 40, children: /* @__PURE__ */ t.jsx(
                    e1,
                    {
                      summary: a,
                      filteredStrataSize: (E = m.strata) == null ? void 0 : E.length
                    }
                  ) }),
                  /* @__PURE__ */ t.jsx(
                    g,
                    {
                      sx: { minHeight: "calc(100% - 100px)" },
                      container: !0,
                      children: /* @__PURE__ */ t.jsx(
                        Ur,
                        {
                          type: "treeMapCustom",
                          chartData: m.treemapData,
                          fileName: "any",
                          options: {
                            handleCellOver: C,
                            handleCellOut: d,
                            selectedConcepts: [],
                            colorPicker: h
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ t.jsx(le, { height: 60, pt: 2, textAlign: "center", children: /* @__PURE__ */ t.jsx(
                    B0,
                    {
                      colorPicker: h,
                      calculateRate: Ou
                    }
                  ) })
                ] : /* @__PURE__ */ t.jsx(
                  ve,
                  {
                    fontSize: 14,
                    variant: "subtitle1",
                    fontWeight: 400,
                    textAlign: "center",
                    children: "No visualization available"
                  }
                )
              }
            )
          }
        )
      ] })
    ] }) : /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(qb, { children: "No data visualization" }) }) });
  }
), Pu = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 2,
    name: "2"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 4,
    name: "4"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 6,
    name: "6"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 8,
    name: "8"
  },
  {
    value: 9,
    name: "9"
  },
  {
    value: 10,
    name: "10"
  }
], n1 = [
  {
    value: 0,
    name: "0"
  },
  {
    value: 1,
    name: "1"
  },
  {
    value: 3,
    name: "3"
  },
  {
    value: 5,
    name: "5"
  },
  {
    value: 7,
    name: "7"
  },
  {
    value: 10,
    name: "10"
  },
  {
    value: 14,
    name: "14"
  },
  {
    value: 30,
    name: "30"
  }
], Jj = $e((r) => {
  var f, C, v, b;
  const {
    subModules: i,
    parentId: a,
    updateDesign: s,
    design: l,
    id: c,
    typeContainer: m,
    analysisName: j,
    viewMode: h
  } = r, d = (E) => (A) => {
    s(E, A);
  };
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
    (!h || h && ((f = l == null ? void 0 : l.targetCohorts) == null ? void 0 : f.length) > 0) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(wi, { children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx("b", { children: "Cohort Pathway" }),
        " is defined as the process of generating an aggregated sequence of transitions between the Event Cohorts among those people in the Target Cohorts."
      ] }) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        i.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: i,
          path: It(m, c, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ t.jsx(
              Ot,
              {
                title: "Target cohorts",
                count: (C = l == null ? void 0 : l.targetCohorts) == null ? void 0 : C.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: m,
            initialData: l == null ? void 0 : l.targetCohorts,
            onChange: d("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: j,
            collapsible: !0,
            defaultState: !0,
            description: "Each of the Target Cohorts will be analyzed for the pathways through the event cohorts.",
            viewMode: h
          }
        }
      ) })
    ] }),
    (!h || h && ((v = l == null ? void 0 : l.eventCohorts) == null ? void 0 : v.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        path: It(m, c, a),
        config: {
          buttonText: "Import event cohort",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Event cohorts",
              count: (b = l == null ? void 0 : l.eventCohorts) == null ? void 0 : b.length
            }
          ),
          classNameContainer: "event-import-button",
          typeContainer: m,
          initialData: l == null ? void 0 : l.eventCohorts,
          onChange: d("eventCohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: j,
          collapsible: !0,
          defaultState: h,
          description: "Each Event Cohort defines the step in a pathway that may occur for a person in the Target Cohort.",
          viewMode: h
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        collapsible: !0,
        title: "Analysis Settings",
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, px: 1, children: [
            /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the pathway analysis." }),
            /* @__PURE__ */ t.jsx(zt, { sx: { borderColor: "borderColor.light" } })
          ] }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "collapse-days",
              textLabel: "Collapse days",
              description: "Any dates found within the specified collapse days will be reassigned the earliest date. Collapsing dates reduces pathway variation, leading to a reduction in 'noise' in the result.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 80, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  className: "",
                  name: "collapse-days",
                  disablePortal: !0,
                  id: "collapse-days",
                  options: n1,
                  value: l.combinationWindow,
                  placeholder: "Select days...",
                  onChange: (E) => {
                    s("combinationWindow", E);
                  },
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "minimumCellCount",
              textLabel: "Minimum cell count",
              description: "Minimum number of subjects in the target cohort for a given event in order to be counted in the pathway.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 80, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  className: "",
                  name: "minimumCellCount",
                  disablePortal: !0,
                  id: "minimumCellCount",
                  options: Pu,
                  value: l.minCellCount,
                  placeholder: "Select count...",
                  onChange: (E) => {
                    s("minCellCount", E);
                  },
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "maximumPathLength",
              textLabel: "Maximum path length",
              description: "Maximum number of steps in a given pathway to be included in the sunburst plot.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 80, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  className: "",
                  name: "maximumPathLength",
                  disablePortal: !0,
                  id: "maximumPathLength",
                  options: Pu,
                  value: l.maxDepth,
                  placeholder: "Select length...",
                  onChange: (E) => {
                    s("maxDepth", E);
                  },
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "allowRepeats",
              textLabel: "Allow repeats",
              description: "Allow cohort events/combos to appear multiple times in the same pathway.",
              children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "allowRepeats",
                  name: "allowRepeats",
                  onChange: () => {
                    s("allowRepeats", !l.allowRepeats);
                  },
                  checked: l.allowRepeats,
                  disabled: h
                }
              )
            }
          ) })
        ] })
      }
    ) })
  ] });
}), js = Le.div`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme: r }) => {
  var i;
  return Wn(0.5, (i = r.palette) == null ? void 0 : i.primary.main);
}};
  text-align: center;
`, r1 = Le.div`
  font-size: 12px;
  font-weight: 500;
`, i1 = (r) => {
  const {
    targetCohortCount: i,
    pathwaysCount: a,
    targetCohortName: s,
    personsReportedPct: l
  } = r;
  return /* @__PURE__ */ t.jsxs(le, { children: [
    /* @__PURE__ */ t.jsx(ve, { variant: "h3", children: "Target Cohort" }),
    /* @__PURE__ */ t.jsx(ve, { variant: "body2", mt: 1, children: s }),
    /* @__PURE__ */ t.jsxs(
      ve,
      {
        component: "ul",
        my: 1,
        sx: {
          paddingInlineStart: "32px"
        },
        children: [
          /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", component: "li", children: [
            "Target cohort count: ",
            i
          ] }),
          /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", component: "li", children: [
            "Persons with pathways count: ",
            te(a)
          ] }),
          /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", component: "li", children: [
            "Persons with pathways portion: ",
            l
          ] })
        ]
      }
    )
  ] });
}, a1 = Le.div`
  display: flex;
  align-items: center;
  padding-bottom: 8px;
  padding-left: 20px;
`, o1 = Le.div`
  background: ${({ color: r }) => `${r}`};
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 2px;
`;
Le(r1)``;
const s1 = (r) => {
  const { eventCohorts: i, colors: a } = r, s = i.map((l) => /* @__PURE__ */ t.jsxs(a1, { children: [
    /* @__PURE__ */ t.jsx(o1, { color: a(l.code) }),
    /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", children: l.name })
  ] }, l.code));
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(ve, { variant: "h3", mb: 1, children: "Event Cohorts" }),
    s
  ] });
};
function l1(r) {
  for (var i = [], a = r; a.parent; )
    i.unshift(a), a = a.parent;
  return i;
}
function Nd(r, i, a) {
  return l1(r).map(
    (c) => c.data.name == "end" ? { names: [{ name: "end", color: i("end") }], count: c.value } : {
      names: a.filter((m) => (m.code & Number.parseInt(c.data.name)) > 0).map((m) => ({ name: m.name, color: i(m.code) })),
      count: c.value
    }
  );
}
function c1(r, i, a) {
  const s = (m, j) => `<span class="tip-name" style="background-color:${j}; color:${m == "end" ? "black" : "white"}">${m}</span>`, l = (m) => `<div class="tip-step">${m.names.map((j) => s(j.name, j.color)).join("")}</div>`;
  return `<div class="tip-container">${Nd(r, i, a).map((m) => l(m)).join("")}</div>`;
}
const u1 = (r) => {
  if (isNaN(r.data.name))
    return [r];
  let i = [...Number.parseInt(r.data.name).toString(2)].reverse().reduce((s, l, c) => {
    if (l == "1") {
      let m = Object.assign({}, r);
      m.data = { name: (1 << c).toString() }, s.push(m);
    }
    return s;
  }, []);
  const a = (r.y1 - r.y0) / i.length;
  return i.map((s, l) => (s.y0 = s.y0 + l * a, s.y1 = s.y0 + a, s));
}, d1 = (r, i) => r && r.pathways ? {
  ...r,
  pathways: r.pathways.map((a) => {
    var s, l;
    return {
      ...a,
      path: cd(a.path) ? ((l = (s = a.path) == null ? void 0 : s.split("-")) == null ? void 0 : l.length) < i ? a.path + "-end" : a.path : `${a.path.join("-")}-end`
    };
  })
} : r, h1 = { end: "#efefef" }, f1 = Le.span`
  background: ${({ color: r }) => `${r}`};
  padding: 2px 6px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 2px;
`, Qj = () => ({
  cohortVersionId: void 0
}), eS = (r) => {
  const i = Pa(r) ? r == null ? void 0 : r.personCount : r;
  return `${te(i || 0)} persons`;
}, tS = (r, i) => ({
  title: r.title,
  type: r.type,
  cohortName: r.cohortName,
  design: i
}), Id = hd().domain([0.1, 0.25, 0.5, 0.75]).range(["#FF3D19", "#E77F13", "#C9C40D", "#95B90A", "#7BB209"]), La = function(r) {
  return (100 * r).toFixed(2) + "%";
}, p1 = (r) => {
  var i = JSON.parse(r.treemapData), a = 1, s = r.inclusionRuleStats.map(function(l, c) {
    var m = Ld(i, "1".repeat(c + 1)), j = r.summary.baseCount != 0 ? m / r.summary.baseCount : 0, h = a - j;
    return a = j, {
      name: l.name,
      countSatisfying: m,
      percentSatisfying: j,
      pctDiff: h
    };
  });
  return s;
};
function Ld(r, i) {
  var a = 0;
  return r.hasOwnProperty("children") ? r.children.forEach(function(s) {
    a += Ld(s, i);
  }) : a = r.name.startsWith(i) ? r.size : 0, a;
}
function Fd(r, i) {
  const a = p1(i);
  if (a) {
    let s = a[r];
    return "Rule " + s.name + ": " + s.countSatisfying.toLocaleString() + ", " + La(s.percentSatisfying);
  }
  return "";
}
const Md = (r, i) => {
  let a = [
    {
      key: "ethnicity",
      name: "Demographics Ethnicity",
      designName: "DemographicsEthnicity"
    },
    {
      key: "gender",
      name: "Demographics Gender",
      designName: "DemographicsGender"
    },
    {
      key: "ageGroup",
      name: "Demographics Age Group",
      designName: "DemographicsAgeGroup"
    },
    {
      key: "race",
      name: "Demographics Race",
      designName: "DemographicsRace"
    }
  ];
  const s = [];
  return a.forEach((l) => {
    var c;
    ((c = r[l.key]) == null ? void 0 : c.length) > 0 && s.push(
      m1(
        r[l.key],
        i,
        l.name,
        l.designName
      )
    );
  }), s;
}, m1 = (r, i, a, s) => ({
  name: a,
  designName: s,
  resultType: Dt.PREVALENCE,
  ...i,
  item: r.map((l) => {
    var c, m;
    return {
      ...l,
      covariateName: l.name,
      records: l.records ? l.records : [
        {
          ...l,
          cohortId: l.cohortId ? l.cohortId : (m = (c = i == null ? void 0 : i.design) == null ? void 0 : c.cohort) == null ? void 0 : m.id
        }
      ]
    };
  })
}), x1 = [
  {
    header: "Name",
    accessorKey: "names",
    enableResizing: !1,
    size: 180,
    cell: (r) => /* @__PURE__ */ t.jsx(le, { display: "flex", flexWrap: "wrap", p: 0.5, alignItems: "center", children: r.getValue().map((i, a) => /* @__PURE__ */ t.jsx(
      f1,
      {
        color: i.color,
        children: i.name
      },
      `${a}-${i.name}`
    )) })
  },
  {
    header: "Remain",
    id: "remain",
    enableResizing: !1,
    size: 100,
    minSize: 120,
    cell: (r) => /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", children: [
      te(r.row.original.personCount),
      " (",
      La(r.row.original.remainPct),
      ")"
    ] })
  },
  {
    header: "Diff",
    id: "diff",
    enableResizing: !1,
    size: 100,
    minSize: 120,
    cell: (r) => /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", children: [
      te(r.row.original.diff),
      " (",
      La(r.row.original.diffPct),
      ")"
    ] })
  }
], g1 = $e((r) => {
  const { pathData: i, colors: a, eventCohorts: s, pathwaysCount: l } = r;
  if (!i)
    return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(ve, { variant: "h3", mb: 1, children: "Path Details" }),
      /* @__PURE__ */ t.jsx(js, { children: "No path selected: click path to see details." })
    ] });
  const c = Pe(() => {
    let m = Nd(i, a, s);
    const j = (d) => ({
      names: d.names,
      personCount: d.count,
      remainPct: d.count / l,
      diffPct: null,
      diff: null
    });
    let h = m.map(j);
    return h.forEach((d, f) => {
      f > 0 ? (d.diffPct = h[f - 1].remainPct - d.remainPct, d.diff = h[f - 1].personCount - d.personCount) : (d.diffPct = 1 - d.remainPct, d.diff = l - d.personCount);
    }), h;
  }, [i]);
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(ve, { variant: "h3", mb: 1, children: "Path Details" }),
    /* @__PURE__ */ t.jsx(
      Ct,
      {
        columns: x1,
        data: c || [],
        pageSize: c == null ? void 0 : c.length
      }
    )
  ] });
}), v1 = $e((r) => {
  const { eventCohorts: i, colors: a, pathData: s, targetCohort: l, summary: c } = r;
  return /* @__PURE__ */ t.jsxs(
    le,
    {
      sx: {
        display: "flex",
        flexDirection: "column"
      },
      minHeight: "100%",
      children: [
        /* @__PURE__ */ t.jsxs(Hn, { elevation: 3, sx: { p: 1 }, children: [
          /* @__PURE__ */ t.jsx(
            i1,
            {
              targetCohortName: l.name,
              targetCohortCount: l.targetCohortCount,
              pathwaysCount: c.totalPathways,
              personsReportedPct: l.personsReportedPct
            }
          ),
          /* @__PURE__ */ t.jsx(s1, { eventCohorts: i, colors: a })
        ] }),
        /* @__PURE__ */ t.jsx(Hn, { elevation: 3, sx: { mt: 2, flexGrow: 1, p: 1 }, children: /* @__PURE__ */ t.jsx(
          g1,
          {
            pathData: s,
            colors: a,
            eventCohorts: i,
            pathwaysCount: c.totalPathways
          }
        ) })
      ]
    }
  );
}), y1 = ({ value: r, options: i, onChange: a }) => /* @__PURE__ */ t.jsx(
  Vt,
  {
    multiple: !0,
    name: "cohorts",
    id: "cohorts",
    value: r,
    placeholder: "Select cohorts...",
    options: i || [],
    fullWidth: !0,
    getOptionLabel: (s) => s.name,
    onChange: (s, l) => {
      a(l);
    },
    isOptionEqualToValue: (s, l) => s.id === l.id,
    limitTags: 2,
    renderTags: (s, l) => {
      const c = s.length, m = 2;
      return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        s.slice(0, m).map((j, h) => /* @__PURE__ */ Yu(
          A0,
          {
            ...l({ index: h }),
            key: h,
            label: j.name,
            size: "small"
          }
        )),
        c > m && ` +${c - m}`
      ] });
    }
  }
);
var kd = { exports: {} };
const b1 = /* @__PURE__ */ uy(Z0);
var di = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
di.exports;
var Du;
function C1() {
  return Du || (Du = 1, function(r, i) {
    (function() {
      var a, s = "4.17.21", l = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", m = "Expected a function", j = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", C = 1, v = 2, b = 4, E = 1, A = 2, R = 1, D = 2, _ = 4, F = 8, P = 16, x = 32, p = 64, y = 128, w = 256, M = 512, V = 30, q = "...", $ = 800, I = 16, k = 1, G = 2, X = 3, ie = 1 / 0, K = 9007199254740991, N = 17976931348623157e292, B = NaN, oe = 4294967295, ne = oe - 1, re = oe >>> 1, je = [
        ["ary", y],
        ["bind", R],
        ["bindKey", D],
        ["curry", F],
        ["curryRight", P],
        ["flip", M],
        ["partial", x],
        ["partialRight", p],
        ["rearg", w]
      ], Z = "[object Arguments]", de = "[object Array]", U = "[object AsyncFunction]", ce = "[object Boolean]", fe = "[object Date]", he = "[object DOMException]", ye = "[object Error]", Ee = "[object Function]", ue = "[object GeneratorFunction]", Oe = "[object Map]", pe = "[object Number]", se = "[object Null]", Ae = "[object Object]", He = "[object Promise]", qe = "[object Proxy]", Ce = "[object RegExp]", xe = "[object Set]", Se = "[object String]", Te = "[object Symbol]", me = "[object Undefined]", et = "[object WeakMap]", Be = "[object WeakSet]", xt = "[object ArrayBuffer]", jt = "[object DataView]", ut = "[object Float32Array]", Qe = "[object Float64Array]", pt = "[object Int8Array]", Rn = "[object Int16Array]", Gn = "[object Int32Array]", Me = "[object Uint8Array]", Fe = "[object Uint8ClampedArray]", Xe = "[object Uint16Array]", at = "[object Uint32Array]", Bt = /\b__p \+= '';/g, Ut = /\b(__p \+=) '' \+/g, Tr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, gt = /&(?:amp|lt|gt|quot|#39);/g, Gt = /[&<>"']/g, Pn = RegExp(gt.source), Lt = RegExp(Gt.source), _r = /<%-([\s\S]+?)%>/g, cr = /<%([\s\S]+?)%>/g, Ri = /<%=([\s\S]+?)%>/g, Ua = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Er = /^\w*$/, Ga = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Pi = /[\\^$.*+?()[\]{}|]/g, th = RegExp(Pi.source), Ka = /^\s+/, nh = /\s/, rh = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ih = /\{\n\/\* \[wrapped with (.+)\] \*/, ah = /,? & /, oh = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, sh = /[()=,{}\[\]\/\s]/, lh = /\\(\\)?/g, ch = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ls = /\w*$/, uh = /^[-+]0x[0-9a-f]+$/i, dh = /^0b[01]+$/i, hh = /^\[object .+?Constructor\]$/, fh = /^0o[0-7]+$/i, ph = /^(?:0|[1-9]\d*)$/, mh = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Di = /($^)/, xh = /['\n\r\u2028\u2029\\]/g, Ni = "\\ud800-\\udfff", gh = "\\u0300-\\u036f", vh = "\\ufe20-\\ufe2f", yh = "\\u20d0-\\u20ff", Fs = gh + vh + yh, Ms = "\\u2700-\\u27bf", ks = "a-z\\xdf-\\xf6\\xf8-\\xff", bh = "\\xac\\xb1\\xd7\\xf7", Ch = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", jh = "\\u2000-\\u206f", Sh = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", zs = "A-Z\\xc0-\\xd6\\xd8-\\xde", Bs = "\\ufe0e\\ufe0f", $s = bh + Ch + jh + Sh, qa = "['’]", wh = "[" + Ni + "]", Ws = "[" + $s + "]", Ii = "[" + Fs + "]", Hs = "\\d+", Th = "[" + Ms + "]", Vs = "[" + ks + "]", Us = "[^" + Ni + $s + Hs + Ms + ks + zs + "]", Ya = "\\ud83c[\\udffb-\\udfff]", _h = "(?:" + Ii + "|" + Ya + ")", Gs = "[^" + Ni + "]", Xa = "(?:\\ud83c[\\udde6-\\uddff]){2}", Za = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ar = "[" + zs + "]", Ks = "\\u200d", qs = "(?:" + Vs + "|" + Us + ")", Eh = "(?:" + Ar + "|" + Us + ")", Ys = "(?:" + qa + "(?:d|ll|m|re|s|t|ve))?", Xs = "(?:" + qa + "(?:D|LL|M|RE|S|T|VE))?", Zs = _h + "?", Js = "[" + Bs + "]?", Ah = "(?:" + Ks + "(?:" + [Gs, Xa, Za].join("|") + ")" + Js + Zs + ")*", Oh = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Rh = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Qs = Js + Zs + Ah, Ph = "(?:" + [Th, Xa, Za].join("|") + ")" + Qs, Dh = "(?:" + [Gs + Ii + "?", Ii, Xa, Za, wh].join("|") + ")", Nh = RegExp(qa, "g"), Ih = RegExp(Ii, "g"), Ja = RegExp(Ya + "(?=" + Ya + ")|" + Dh + Qs, "g"), Lh = RegExp([
        Ar + "?" + Vs + "+" + Ys + "(?=" + [Ws, Ar, "$"].join("|") + ")",
        Eh + "+" + Xs + "(?=" + [Ws, Ar + qs, "$"].join("|") + ")",
        Ar + "?" + qs + "+" + Ys,
        Ar + "+" + Xs,
        Rh,
        Oh,
        Hs,
        Ph
      ].join("|"), "g"), Fh = RegExp("[" + Ks + Ni + Fs + Bs + "]"), Mh = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, kh = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], zh = -1, dt = {};
      dt[ut] = dt[Qe] = dt[pt] = dt[Rn] = dt[Gn] = dt[Me] = dt[Fe] = dt[Xe] = dt[at] = !0, dt[Z] = dt[de] = dt[xt] = dt[ce] = dt[jt] = dt[fe] = dt[ye] = dt[Ee] = dt[Oe] = dt[pe] = dt[Ae] = dt[Ce] = dt[xe] = dt[Se] = dt[et] = !1;
      var lt = {};
      lt[Z] = lt[de] = lt[xt] = lt[jt] = lt[ce] = lt[fe] = lt[ut] = lt[Qe] = lt[pt] = lt[Rn] = lt[Gn] = lt[Oe] = lt[pe] = lt[Ae] = lt[Ce] = lt[xe] = lt[Se] = lt[Te] = lt[Me] = lt[Fe] = lt[Xe] = lt[at] = !0, lt[ye] = lt[Ee] = lt[et] = !1;
      var Bh = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, $h = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Wh = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Hh = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Vh = parseFloat, Uh = parseInt, el = typeof Wr == "object" && Wr && Wr.Object === Object && Wr, Gh = typeof self == "object" && self && self.Object === Object && self, Rt = el || Gh || Function("return this")(), Qa = i && !i.nodeType && i, ur = Qa && !0 && r && !r.nodeType && r, tl = ur && ur.exports === Qa, eo = tl && el.process, sn = function() {
        try {
          var W = ur && ur.require && ur.require("util").types;
          return W || eo && eo.binding && eo.binding("util");
        } catch {
        }
      }(), nl = sn && sn.isArrayBuffer, rl = sn && sn.isDate, il = sn && sn.isMap, al = sn && sn.isRegExp, ol = sn && sn.isSet, sl = sn && sn.isTypedArray;
      function Qt(W, J, Y) {
        switch (Y.length) {
          case 0:
            return W.call(J);
          case 1:
            return W.call(J, Y[0]);
          case 2:
            return W.call(J, Y[0], Y[1]);
          case 3:
            return W.call(J, Y[0], Y[1], Y[2]);
        }
        return W.apply(J, Y);
      }
      function Kh(W, J, Y, we) {
        for (var ke = -1, tt = W == null ? 0 : W.length; ++ke < tt; ) {
          var St = W[ke];
          J(we, St, Y(St), W);
        }
        return we;
      }
      function ln(W, J) {
        for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we && J(W[Y], Y, W) !== !1; )
          ;
        return W;
      }
      function qh(W, J) {
        for (var Y = W == null ? 0 : W.length; Y-- && J(W[Y], Y, W) !== !1; )
          ;
        return W;
      }
      function ll(W, J) {
        for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we; )
          if (!J(W[Y], Y, W))
            return !1;
        return !0;
      }
      function Kn(W, J) {
        for (var Y = -1, we = W == null ? 0 : W.length, ke = 0, tt = []; ++Y < we; ) {
          var St = W[Y];
          J(St, Y, W) && (tt[ke++] = St);
        }
        return tt;
      }
      function Li(W, J) {
        var Y = W == null ? 0 : W.length;
        return !!Y && Or(W, J, 0) > -1;
      }
      function to(W, J, Y) {
        for (var we = -1, ke = W == null ? 0 : W.length; ++we < ke; )
          if (Y(J, W[we]))
            return !0;
        return !1;
      }
      function ht(W, J) {
        for (var Y = -1, we = W == null ? 0 : W.length, ke = Array(we); ++Y < we; )
          ke[Y] = J(W[Y], Y, W);
        return ke;
      }
      function qn(W, J) {
        for (var Y = -1, we = J.length, ke = W.length; ++Y < we; )
          W[ke + Y] = J[Y];
        return W;
      }
      function no(W, J, Y, we) {
        var ke = -1, tt = W == null ? 0 : W.length;
        for (we && tt && (Y = W[++ke]); ++ke < tt; )
          Y = J(Y, W[ke], ke, W);
        return Y;
      }
      function Yh(W, J, Y, we) {
        var ke = W == null ? 0 : W.length;
        for (we && ke && (Y = W[--ke]); ke--; )
          Y = J(Y, W[ke], ke, W);
        return Y;
      }
      function ro(W, J) {
        for (var Y = -1, we = W == null ? 0 : W.length; ++Y < we; )
          if (J(W[Y], Y, W))
            return !0;
        return !1;
      }
      var Xh = io("length");
      function Zh(W) {
        return W.split("");
      }
      function Jh(W) {
        return W.match(oh) || [];
      }
      function cl(W, J, Y) {
        var we;
        return Y(W, function(ke, tt, St) {
          if (J(ke, tt, St))
            return we = tt, !1;
        }), we;
      }
      function Fi(W, J, Y, we) {
        for (var ke = W.length, tt = Y + (we ? 1 : -1); we ? tt-- : ++tt < ke; )
          if (J(W[tt], tt, W))
            return tt;
        return -1;
      }
      function Or(W, J, Y) {
        return J === J ? df(W, J, Y) : Fi(W, ul, Y);
      }
      function Qh(W, J, Y, we) {
        for (var ke = Y - 1, tt = W.length; ++ke < tt; )
          if (we(W[ke], J))
            return ke;
        return -1;
      }
      function ul(W) {
        return W !== W;
      }
      function dl(W, J) {
        var Y = W == null ? 0 : W.length;
        return Y ? oo(W, J) / Y : B;
      }
      function io(W) {
        return function(J) {
          return J == null ? a : J[W];
        };
      }
      function ao(W) {
        return function(J) {
          return W == null ? a : W[J];
        };
      }
      function hl(W, J, Y, we, ke) {
        return ke(W, function(tt, St, ot) {
          Y = we ? (we = !1, tt) : J(Y, tt, St, ot);
        }), Y;
      }
      function ef(W, J) {
        var Y = W.length;
        for (W.sort(J); Y--; )
          W[Y] = W[Y].value;
        return W;
      }
      function oo(W, J) {
        for (var Y, we = -1, ke = W.length; ++we < ke; ) {
          var tt = J(W[we]);
          tt !== a && (Y = Y === a ? tt : Y + tt);
        }
        return Y;
      }
      function so(W, J) {
        for (var Y = -1, we = Array(W); ++Y < W; )
          we[Y] = J(Y);
        return we;
      }
      function tf(W, J) {
        return ht(J, function(Y) {
          return [Y, W[Y]];
        });
      }
      function fl(W) {
        return W && W.slice(0, gl(W) + 1).replace(Ka, "");
      }
      function en(W) {
        return function(J) {
          return W(J);
        };
      }
      function lo(W, J) {
        return ht(J, function(Y) {
          return W[Y];
        });
      }
      function Gr(W, J) {
        return W.has(J);
      }
      function pl(W, J) {
        for (var Y = -1, we = W.length; ++Y < we && Or(J, W[Y], 0) > -1; )
          ;
        return Y;
      }
      function ml(W, J) {
        for (var Y = W.length; Y-- && Or(J, W[Y], 0) > -1; )
          ;
        return Y;
      }
      function nf(W, J) {
        for (var Y = W.length, we = 0; Y--; )
          W[Y] === J && ++we;
        return we;
      }
      var rf = ao(Bh), af = ao($h);
      function of(W) {
        return "\\" + Hh[W];
      }
      function sf(W, J) {
        return W == null ? a : W[J];
      }
      function Rr(W) {
        return Fh.test(W);
      }
      function lf(W) {
        return Mh.test(W);
      }
      function cf(W) {
        for (var J, Y = []; !(J = W.next()).done; )
          Y.push(J.value);
        return Y;
      }
      function co(W) {
        var J = -1, Y = Array(W.size);
        return W.forEach(function(we, ke) {
          Y[++J] = [ke, we];
        }), Y;
      }
      function xl(W, J) {
        return function(Y) {
          return W(J(Y));
        };
      }
      function Yn(W, J) {
        for (var Y = -1, we = W.length, ke = 0, tt = []; ++Y < we; ) {
          var St = W[Y];
          (St === J || St === f) && (W[Y] = f, tt[ke++] = Y);
        }
        return tt;
      }
      function Mi(W) {
        var J = -1, Y = Array(W.size);
        return W.forEach(function(we) {
          Y[++J] = we;
        }), Y;
      }
      function uf(W) {
        var J = -1, Y = Array(W.size);
        return W.forEach(function(we) {
          Y[++J] = [we, we];
        }), Y;
      }
      function df(W, J, Y) {
        for (var we = Y - 1, ke = W.length; ++we < ke; )
          if (W[we] === J)
            return we;
        return -1;
      }
      function hf(W, J, Y) {
        for (var we = Y + 1; we--; )
          if (W[we] === J)
            return we;
        return we;
      }
      function Pr(W) {
        return Rr(W) ? pf(W) : Xh(W);
      }
      function xn(W) {
        return Rr(W) ? mf(W) : Zh(W);
      }
      function gl(W) {
        for (var J = W.length; J-- && nh.test(W.charAt(J)); )
          ;
        return J;
      }
      var ff = ao(Wh);
      function pf(W) {
        for (var J = Ja.lastIndex = 0; Ja.test(W); )
          ++J;
        return J;
      }
      function mf(W) {
        return W.match(Ja) || [];
      }
      function xf(W) {
        return W.match(Lh) || [];
      }
      var gf = function W(J) {
        J = J == null ? Rt : Dr.defaults(Rt.Object(), J, Dr.pick(Rt, kh));
        var Y = J.Array, we = J.Date, ke = J.Error, tt = J.Function, St = J.Math, ot = J.Object, uo = J.RegExp, vf = J.String, cn = J.TypeError, ki = Y.prototype, yf = tt.prototype, Nr = ot.prototype, zi = J["__core-js_shared__"], Bi = yf.toString, it = Nr.hasOwnProperty, bf = 0, vl = function() {
          var e = /[^.]+$/.exec(zi && zi.keys && zi.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        }(), $i = Nr.toString, Cf = Bi.call(ot), jf = Rt._, Sf = uo(
          "^" + Bi.call(it).replace(Pi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Wi = tl ? J.Buffer : a, Xn = J.Symbol, Hi = J.Uint8Array, yl = Wi ? Wi.allocUnsafe : a, Vi = xl(ot.getPrototypeOf, ot), bl = ot.create, Cl = Nr.propertyIsEnumerable, Ui = ki.splice, jl = Xn ? Xn.isConcatSpreadable : a, Kr = Xn ? Xn.iterator : a, dr = Xn ? Xn.toStringTag : a, Gi = function() {
          try {
            var e = xr(ot, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        }(), wf = J.clearTimeout !== Rt.clearTimeout && J.clearTimeout, Tf = we && we.now !== Rt.Date.now && we.now, _f = J.setTimeout !== Rt.setTimeout && J.setTimeout, Ki = St.ceil, qi = St.floor, ho = ot.getOwnPropertySymbols, Ef = Wi ? Wi.isBuffer : a, Sl = J.isFinite, Af = ki.join, Of = xl(ot.keys, ot), wt = St.max, Ft = St.min, Rf = we.now, Pf = J.parseInt, wl = St.random, Df = ki.reverse, fo = xr(J, "DataView"), qr = xr(J, "Map"), po = xr(J, "Promise"), Ir = xr(J, "Set"), Yr = xr(J, "WeakMap"), Xr = xr(ot, "create"), Yi = Yr && new Yr(), Lr = {}, Nf = gr(fo), If = gr(qr), Lf = gr(po), Ff = gr(Ir), Mf = gr(Yr), Xi = Xn ? Xn.prototype : a, Zr = Xi ? Xi.valueOf : a, Tl = Xi ? Xi.toString : a;
        function T(e) {
          if (mt(e) && !ze(e) && !(e instanceof Ye)) {
            if (e instanceof un)
              return e;
            if (it.call(e, "__wrapped__"))
              return _c(e);
          }
          return new un(e);
        }
        var Fr = /* @__PURE__ */ function() {
          function e() {
          }
          return function(n) {
            if (!ft(n))
              return {};
            if (bl)
              return bl(n);
            e.prototype = n;
            var o = new e();
            return e.prototype = a, o;
          };
        }();
        function Zi() {
        }
        function un(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = a;
        }
        T.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: _r,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: cr,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Ri,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: T
          }
        }, T.prototype = Zi.prototype, T.prototype.constructor = T, un.prototype = Fr(Zi.prototype), un.prototype.constructor = un;
        function Ye(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = oe, this.__views__ = [];
        }
        function kf() {
          var e = new Ye(this.__wrapped__);
          return e.__actions__ = Kt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Kt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Kt(this.__views__), e;
        }
        function zf() {
          if (this.__filtered__) {
            var e = new Ye(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Bf() {
          var e = this.__wrapped__.value(), n = this.__dir__, o = ze(e), u = n < 0, S = o ? e.length : 0, O = Jp(0, S, this.__views__), L = O.start, z = O.end, H = z - L, Q = u ? z : L - 1, ee = this.__iteratees__, ae = ee.length, ge = 0, _e = Ft(H, this.__takeCount__);
          if (!o || !u && S == H && _e == H)
            return Yl(e, this.__actions__);
          var Ne = [];
          e:
            for (; H-- && ge < _e; ) {
              Q += n;
              for (var Ve = -1, Ie = e[Q]; ++Ve < ae; ) {
                var Ge = ee[Ve], Ze = Ge.iteratee, rn = Ge.type, Ht = Ze(Ie);
                if (rn == G)
                  Ie = Ht;
                else if (!Ht) {
                  if (rn == k)
                    continue e;
                  break e;
                }
              }
              Ne[ge++] = Ie;
            }
          return Ne;
        }
        Ye.prototype = Fr(Zi.prototype), Ye.prototype.constructor = Ye;
        function hr(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var u = e[n];
            this.set(u[0], u[1]);
          }
        }
        function $f() {
          this.__data__ = Xr ? Xr(null) : {}, this.size = 0;
        }
        function Wf(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function Hf(e) {
          var n = this.__data__;
          if (Xr) {
            var o = n[e];
            return o === h ? a : o;
          }
          return it.call(n, e) ? n[e] : a;
        }
        function Vf(e) {
          var n = this.__data__;
          return Xr ? n[e] !== a : it.call(n, e);
        }
        function Uf(e, n) {
          var o = this.__data__;
          return this.size += this.has(e) ? 0 : 1, o[e] = Xr && n === a ? h : n, this;
        }
        hr.prototype.clear = $f, hr.prototype.delete = Wf, hr.prototype.get = Hf, hr.prototype.has = Vf, hr.prototype.set = Uf;
        function Dn(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var u = e[n];
            this.set(u[0], u[1]);
          }
        }
        function Gf() {
          this.__data__ = [], this.size = 0;
        }
        function Kf(e) {
          var n = this.__data__, o = Ji(n, e);
          if (o < 0)
            return !1;
          var u = n.length - 1;
          return o == u ? n.pop() : Ui.call(n, o, 1), --this.size, !0;
        }
        function qf(e) {
          var n = this.__data__, o = Ji(n, e);
          return o < 0 ? a : n[o][1];
        }
        function Yf(e) {
          return Ji(this.__data__, e) > -1;
        }
        function Xf(e, n) {
          var o = this.__data__, u = Ji(o, e);
          return u < 0 ? (++this.size, o.push([e, n])) : o[u][1] = n, this;
        }
        Dn.prototype.clear = Gf, Dn.prototype.delete = Kf, Dn.prototype.get = qf, Dn.prototype.has = Yf, Dn.prototype.set = Xf;
        function Nn(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.clear(); ++n < o; ) {
            var u = e[n];
            this.set(u[0], u[1]);
          }
        }
        function Zf() {
          this.size = 0, this.__data__ = {
            hash: new hr(),
            map: new (qr || Dn)(),
            string: new hr()
          };
        }
        function Jf(e) {
          var n = ua(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function Qf(e) {
          return ua(this, e).get(e);
        }
        function ep(e) {
          return ua(this, e).has(e);
        }
        function tp(e, n) {
          var o = ua(this, e), u = o.size;
          return o.set(e, n), this.size += o.size == u ? 0 : 1, this;
        }
        Nn.prototype.clear = Zf, Nn.prototype.delete = Jf, Nn.prototype.get = Qf, Nn.prototype.has = ep, Nn.prototype.set = tp;
        function fr(e) {
          var n = -1, o = e == null ? 0 : e.length;
          for (this.__data__ = new Nn(); ++n < o; )
            this.add(e[n]);
        }
        function np(e) {
          return this.__data__.set(e, h), this;
        }
        function rp(e) {
          return this.__data__.has(e);
        }
        fr.prototype.add = fr.prototype.push = np, fr.prototype.has = rp;
        function gn(e) {
          var n = this.__data__ = new Dn(e);
          this.size = n.size;
        }
        function ip() {
          this.__data__ = new Dn(), this.size = 0;
        }
        function ap(e) {
          var n = this.__data__, o = n.delete(e);
          return this.size = n.size, o;
        }
        function op(e) {
          return this.__data__.get(e);
        }
        function sp(e) {
          return this.__data__.has(e);
        }
        function lp(e, n) {
          var o = this.__data__;
          if (o instanceof Dn) {
            var u = o.__data__;
            if (!qr || u.length < l - 1)
              return u.push([e, n]), this.size = ++o.size, this;
            o = this.__data__ = new Nn(u);
          }
          return o.set(e, n), this.size = o.size, this;
        }
        gn.prototype.clear = ip, gn.prototype.delete = ap, gn.prototype.get = op, gn.prototype.has = sp, gn.prototype.set = lp;
        function _l(e, n) {
          var o = ze(e), u = !o && vr(e), S = !o && !u && tr(e), O = !o && !u && !S && Br(e), L = o || u || S || O, z = L ? so(e.length, vf) : [], H = z.length;
          for (var Q in e)
            (n || it.call(e, Q)) && !(L && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Q == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            S && (Q == "offset" || Q == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            O && (Q == "buffer" || Q == "byteLength" || Q == "byteOffset") || // Skip index properties.
            Mn(Q, H))) && z.push(Q);
          return z;
        }
        function El(e) {
          var n = e.length;
          return n ? e[To(0, n - 1)] : a;
        }
        function cp(e, n) {
          return da(Kt(e), pr(n, 0, e.length));
        }
        function up(e) {
          return da(Kt(e));
        }
        function mo(e, n, o) {
          (o !== a && !vn(e[n], o) || o === a && !(n in e)) && In(e, n, o);
        }
        function Jr(e, n, o) {
          var u = e[n];
          (!(it.call(e, n) && vn(u, o)) || o === a && !(n in e)) && In(e, n, o);
        }
        function Ji(e, n) {
          for (var o = e.length; o--; )
            if (vn(e[o][0], n))
              return o;
          return -1;
        }
        function dp(e, n, o, u) {
          return Zn(e, function(S, O, L) {
            n(u, S, o(S), L);
          }), u;
        }
        function Al(e, n) {
          return e && Sn(n, Et(n), e);
        }
        function hp(e, n) {
          return e && Sn(n, Yt(n), e);
        }
        function In(e, n, o) {
          n == "__proto__" && Gi ? Gi(e, n, {
            configurable: !0,
            enumerable: !0,
            value: o,
            writable: !0
          }) : e[n] = o;
        }
        function xo(e, n) {
          for (var o = -1, u = n.length, S = Y(u), O = e == null; ++o < u; )
            S[o] = O ? a : Xo(e, n[o]);
          return S;
        }
        function pr(e, n, o) {
          return e === e && (o !== a && (e = e <= o ? e : o), n !== a && (e = e >= n ? e : n)), e;
        }
        function dn(e, n, o, u, S, O) {
          var L, z = n & C, H = n & v, Q = n & b;
          if (o && (L = S ? o(e, u, S, O) : o(e)), L !== a)
            return L;
          if (!ft(e))
            return e;
          var ee = ze(e);
          if (ee) {
            if (L = em(e), !z)
              return Kt(e, L);
          } else {
            var ae = Mt(e), ge = ae == Ee || ae == ue;
            if (tr(e))
              return Jl(e, z);
            if (ae == Ae || ae == Z || ge && !S) {
              if (L = H || ge ? {} : gc(e), !z)
                return H ? Hp(e, hp(L, e)) : Wp(e, Al(L, e));
            } else {
              if (!lt[ae])
                return S ? e : {};
              L = tm(e, ae, z);
            }
          }
          O || (O = new gn());
          var _e = O.get(e);
          if (_e)
            return _e;
          O.set(e, L), Gc(e) ? e.forEach(function(Ie) {
            L.add(dn(Ie, n, o, Ie, e, O));
          }) : Vc(e) && e.forEach(function(Ie, Ge) {
            L.set(Ge, dn(Ie, n, o, Ge, e, O));
          });
          var Ne = Q ? H ? Fo : Lo : H ? Yt : Et, Ve = ee ? a : Ne(e);
          return ln(Ve || e, function(Ie, Ge) {
            Ve && (Ge = Ie, Ie = e[Ge]), Jr(L, Ge, dn(Ie, n, o, Ge, e, O));
          }), L;
        }
        function fp(e) {
          var n = Et(e);
          return function(o) {
            return Ol(o, e, n);
          };
        }
        function Ol(e, n, o) {
          var u = o.length;
          if (e == null)
            return !u;
          for (e = ot(e); u--; ) {
            var S = o[u], O = n[S], L = e[S];
            if (L === a && !(S in e) || !O(L))
              return !1;
          }
          return !0;
        }
        function Rl(e, n, o) {
          if (typeof e != "function")
            throw new cn(m);
          return ai(function() {
            e.apply(a, o);
          }, n);
        }
        function Qr(e, n, o, u) {
          var S = -1, O = Li, L = !0, z = e.length, H = [], Q = n.length;
          if (!z)
            return H;
          o && (n = ht(n, en(o))), u ? (O = to, L = !1) : n.length >= l && (O = Gr, L = !1, n = new fr(n));
          e:
            for (; ++S < z; ) {
              var ee = e[S], ae = o == null ? ee : o(ee);
              if (ee = u || ee !== 0 ? ee : 0, L && ae === ae) {
                for (var ge = Q; ge--; )
                  if (n[ge] === ae)
                    continue e;
                H.push(ee);
              } else O(n, ae, u) || H.push(ee);
            }
          return H;
        }
        var Zn = rc(jn), Pl = rc(vo, !0);
        function pp(e, n) {
          var o = !0;
          return Zn(e, function(u, S, O) {
            return o = !!n(u, S, O), o;
          }), o;
        }
        function Qi(e, n, o) {
          for (var u = -1, S = e.length; ++u < S; ) {
            var O = e[u], L = n(O);
            if (L != null && (z === a ? L === L && !nn(L) : o(L, z)))
              var z = L, H = O;
          }
          return H;
        }
        function mp(e, n, o, u) {
          var S = e.length;
          for (o = We(o), o < 0 && (o = -o > S ? 0 : S + o), u = u === a || u > S ? S : We(u), u < 0 && (u += S), u = o > u ? 0 : qc(u); o < u; )
            e[o++] = n;
          return e;
        }
        function Dl(e, n) {
          var o = [];
          return Zn(e, function(u, S, O) {
            n(u, S, O) && o.push(u);
          }), o;
        }
        function Pt(e, n, o, u, S) {
          var O = -1, L = e.length;
          for (o || (o = rm), S || (S = []); ++O < L; ) {
            var z = e[O];
            n > 0 && o(z) ? n > 1 ? Pt(z, n - 1, o, u, S) : qn(S, z) : u || (S[S.length] = z);
          }
          return S;
        }
        var go = ic(), Nl = ic(!0);
        function jn(e, n) {
          return e && go(e, n, Et);
        }
        function vo(e, n) {
          return e && Nl(e, n, Et);
        }
        function ea(e, n) {
          return Kn(n, function(o) {
            return kn(e[o]);
          });
        }
        function mr(e, n) {
          n = Qn(n, e);
          for (var o = 0, u = n.length; e != null && o < u; )
            e = e[wn(n[o++])];
          return o && o == u ? e : a;
        }
        function Il(e, n, o) {
          var u = n(e);
          return ze(e) ? u : qn(u, o(e));
        }
        function $t(e) {
          return e == null ? e === a ? me : se : dr && dr in ot(e) ? Zp(e) : um(e);
        }
        function yo(e, n) {
          return e > n;
        }
        function xp(e, n) {
          return e != null && it.call(e, n);
        }
        function gp(e, n) {
          return e != null && n in ot(e);
        }
        function vp(e, n, o) {
          return e >= Ft(n, o) && e < wt(n, o);
        }
        function bo(e, n, o) {
          for (var u = o ? to : Li, S = e[0].length, O = e.length, L = O, z = Y(O), H = 1 / 0, Q = []; L--; ) {
            var ee = e[L];
            L && n && (ee = ht(ee, en(n))), H = Ft(ee.length, H), z[L] = !o && (n || S >= 120 && ee.length >= 120) ? new fr(L && ee) : a;
          }
          ee = e[0];
          var ae = -1, ge = z[0];
          e:
            for (; ++ae < S && Q.length < H; ) {
              var _e = ee[ae], Ne = n ? n(_e) : _e;
              if (_e = o || _e !== 0 ? _e : 0, !(ge ? Gr(ge, Ne) : u(Q, Ne, o))) {
                for (L = O; --L; ) {
                  var Ve = z[L];
                  if (!(Ve ? Gr(Ve, Ne) : u(e[L], Ne, o)))
                    continue e;
                }
                ge && ge.push(Ne), Q.push(_e);
              }
            }
          return Q;
        }
        function yp(e, n, o, u) {
          return jn(e, function(S, O, L) {
            n(u, o(S), O, L);
          }), u;
        }
        function ei(e, n, o) {
          n = Qn(n, e), e = Cc(e, n);
          var u = e == null ? e : e[wn(fn(n))];
          return u == null ? a : Qt(u, e, o);
        }
        function Ll(e) {
          return mt(e) && $t(e) == Z;
        }
        function bp(e) {
          return mt(e) && $t(e) == xt;
        }
        function Cp(e) {
          return mt(e) && $t(e) == fe;
        }
        function ti(e, n, o, u, S) {
          return e === n ? !0 : e == null || n == null || !mt(e) && !mt(n) ? e !== e && n !== n : jp(e, n, o, u, ti, S);
        }
        function jp(e, n, o, u, S, O) {
          var L = ze(e), z = ze(n), H = L ? de : Mt(e), Q = z ? de : Mt(n);
          H = H == Z ? Ae : H, Q = Q == Z ? Ae : Q;
          var ee = H == Ae, ae = Q == Ae, ge = H == Q;
          if (ge && tr(e)) {
            if (!tr(n))
              return !1;
            L = !0, ee = !1;
          }
          if (ge && !ee)
            return O || (O = new gn()), L || Br(e) ? pc(e, n, o, u, S, O) : Yp(e, n, H, o, u, S, O);
          if (!(o & E)) {
            var _e = ee && it.call(e, "__wrapped__"), Ne = ae && it.call(n, "__wrapped__");
            if (_e || Ne) {
              var Ve = _e ? e.value() : e, Ie = Ne ? n.value() : n;
              return O || (O = new gn()), S(Ve, Ie, o, u, O);
            }
          }
          return ge ? (O || (O = new gn()), Xp(e, n, o, u, S, O)) : !1;
        }
        function Sp(e) {
          return mt(e) && Mt(e) == Oe;
        }
        function Co(e, n, o, u) {
          var S = o.length, O = S, L = !u;
          if (e == null)
            return !O;
          for (e = ot(e); S--; ) {
            var z = o[S];
            if (L && z[2] ? z[1] !== e[z[0]] : !(z[0] in e))
              return !1;
          }
          for (; ++S < O; ) {
            z = o[S];
            var H = z[0], Q = e[H], ee = z[1];
            if (L && z[2]) {
              if (Q === a && !(H in e))
                return !1;
            } else {
              var ae = new gn();
              if (u)
                var ge = u(Q, ee, H, e, n, ae);
              if (!(ge === a ? ti(ee, Q, E | A, u, ae) : ge))
                return !1;
            }
          }
          return !0;
        }
        function Fl(e) {
          if (!ft(e) || am(e))
            return !1;
          var n = kn(e) ? Sf : hh;
          return n.test(gr(e));
        }
        function wp(e) {
          return mt(e) && $t(e) == Ce;
        }
        function Tp(e) {
          return mt(e) && Mt(e) == xe;
        }
        function _p(e) {
          return mt(e) && ga(e.length) && !!dt[$t(e)];
        }
        function Ml(e) {
          return typeof e == "function" ? e : e == null ? Xt : typeof e == "object" ? ze(e) ? Bl(e[0], e[1]) : zl(e) : au(e);
        }
        function jo(e) {
          if (!ii(e))
            return Of(e);
          var n = [];
          for (var o in ot(e))
            it.call(e, o) && o != "constructor" && n.push(o);
          return n;
        }
        function Ep(e) {
          if (!ft(e))
            return cm(e);
          var n = ii(e), o = [];
          for (var u in e)
            u == "constructor" && (n || !it.call(e, u)) || o.push(u);
          return o;
        }
        function So(e, n) {
          return e < n;
        }
        function kl(e, n) {
          var o = -1, u = qt(e) ? Y(e.length) : [];
          return Zn(e, function(S, O, L) {
            u[++o] = n(S, O, L);
          }), u;
        }
        function zl(e) {
          var n = ko(e);
          return n.length == 1 && n[0][2] ? yc(n[0][0], n[0][1]) : function(o) {
            return o === e || Co(o, e, n);
          };
        }
        function Bl(e, n) {
          return Bo(e) && vc(n) ? yc(wn(e), n) : function(o) {
            var u = Xo(o, e);
            return u === a && u === n ? Zo(o, e) : ti(n, u, E | A);
          };
        }
        function ta(e, n, o, u, S) {
          e !== n && go(n, function(O, L) {
            if (S || (S = new gn()), ft(O))
              Ap(e, n, L, o, ta, u, S);
            else {
              var z = u ? u(Wo(e, L), O, L + "", e, n, S) : a;
              z === a && (z = O), mo(e, L, z);
            }
          }, Yt);
        }
        function Ap(e, n, o, u, S, O, L) {
          var z = Wo(e, o), H = Wo(n, o), Q = L.get(H);
          if (Q) {
            mo(e, o, Q);
            return;
          }
          var ee = O ? O(z, H, o + "", e, n, L) : a, ae = ee === a;
          if (ae) {
            var ge = ze(H), _e = !ge && tr(H), Ne = !ge && !_e && Br(H);
            ee = H, ge || _e || Ne ? ze(z) ? ee = z : vt(z) ? ee = Kt(z) : _e ? (ae = !1, ee = Jl(H, !0)) : Ne ? (ae = !1, ee = Ql(H, !0)) : ee = [] : oi(H) || vr(H) ? (ee = z, vr(z) ? ee = Yc(z) : (!ft(z) || kn(z)) && (ee = gc(H))) : ae = !1;
          }
          ae && (L.set(H, ee), S(ee, H, u, O, L), L.delete(H)), mo(e, o, ee);
        }
        function $l(e, n) {
          var o = e.length;
          if (o)
            return n += n < 0 ? o : 0, Mn(n, o) ? e[n] : a;
        }
        function Wl(e, n, o) {
          n.length ? n = ht(n, function(O) {
            return ze(O) ? function(L) {
              return mr(L, O.length === 1 ? O[0] : O);
            } : O;
          }) : n = [Xt];
          var u = -1;
          n = ht(n, en(De()));
          var S = kl(e, function(O, L, z) {
            var H = ht(n, function(Q) {
              return Q(O);
            });
            return { criteria: H, index: ++u, value: O };
          });
          return ef(S, function(O, L) {
            return $p(O, L, o);
          });
        }
        function Op(e, n) {
          return Hl(e, n, function(o, u) {
            return Zo(e, u);
          });
        }
        function Hl(e, n, o) {
          for (var u = -1, S = n.length, O = {}; ++u < S; ) {
            var L = n[u], z = mr(e, L);
            o(z, L) && ni(O, Qn(L, e), z);
          }
          return O;
        }
        function Rp(e) {
          return function(n) {
            return mr(n, e);
          };
        }
        function wo(e, n, o, u) {
          var S = u ? Qh : Or, O = -1, L = n.length, z = e;
          for (e === n && (n = Kt(n)), o && (z = ht(e, en(o))); ++O < L; )
            for (var H = 0, Q = n[O], ee = o ? o(Q) : Q; (H = S(z, ee, H, u)) > -1; )
              z !== e && Ui.call(z, H, 1), Ui.call(e, H, 1);
          return e;
        }
        function Vl(e, n) {
          for (var o = e ? n.length : 0, u = o - 1; o--; ) {
            var S = n[o];
            if (o == u || S !== O) {
              var O = S;
              Mn(S) ? Ui.call(e, S, 1) : Ao(e, S);
            }
          }
          return e;
        }
        function To(e, n) {
          return e + qi(wl() * (n - e + 1));
        }
        function Pp(e, n, o, u) {
          for (var S = -1, O = wt(Ki((n - e) / (o || 1)), 0), L = Y(O); O--; )
            L[u ? O : ++S] = e, e += o;
          return L;
        }
        function _o(e, n) {
          var o = "";
          if (!e || n < 1 || n > K)
            return o;
          do
            n % 2 && (o += e), n = qi(n / 2), n && (e += e);
          while (n);
          return o;
        }
        function Ue(e, n) {
          return Ho(bc(e, n, Xt), e + "");
        }
        function Dp(e) {
          return El($r(e));
        }
        function Np(e, n) {
          var o = $r(e);
          return da(o, pr(n, 0, o.length));
        }
        function ni(e, n, o, u) {
          if (!ft(e))
            return e;
          n = Qn(n, e);
          for (var S = -1, O = n.length, L = O - 1, z = e; z != null && ++S < O; ) {
            var H = wn(n[S]), Q = o;
            if (H === "__proto__" || H === "constructor" || H === "prototype")
              return e;
            if (S != L) {
              var ee = z[H];
              Q = u ? u(ee, H, z) : a, Q === a && (Q = ft(ee) ? ee : Mn(n[S + 1]) ? [] : {});
            }
            Jr(z, H, Q), z = z[H];
          }
          return e;
        }
        var Ul = Yi ? function(e, n) {
          return Yi.set(e, n), e;
        } : Xt, Ip = Gi ? function(e, n) {
          return Gi(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Qo(n),
            writable: !0
          });
        } : Xt;
        function Lp(e) {
          return da($r(e));
        }
        function hn(e, n, o) {
          var u = -1, S = e.length;
          n < 0 && (n = -n > S ? 0 : S + n), o = o > S ? S : o, o < 0 && (o += S), S = n > o ? 0 : o - n >>> 0, n >>>= 0;
          for (var O = Y(S); ++u < S; )
            O[u] = e[u + n];
          return O;
        }
        function Fp(e, n) {
          var o;
          return Zn(e, function(u, S, O) {
            return o = n(u, S, O), !o;
          }), !!o;
        }
        function na(e, n, o) {
          var u = 0, S = e == null ? u : e.length;
          if (typeof n == "number" && n === n && S <= re) {
            for (; u < S; ) {
              var O = u + S >>> 1, L = e[O];
              L !== null && !nn(L) && (o ? L <= n : L < n) ? u = O + 1 : S = O;
            }
            return S;
          }
          return Eo(e, n, Xt, o);
        }
        function Eo(e, n, o, u) {
          var S = 0, O = e == null ? 0 : e.length;
          if (O === 0)
            return 0;
          n = o(n);
          for (var L = n !== n, z = n === null, H = nn(n), Q = n === a; S < O; ) {
            var ee = qi((S + O) / 2), ae = o(e[ee]), ge = ae !== a, _e = ae === null, Ne = ae === ae, Ve = nn(ae);
            if (L)
              var Ie = u || Ne;
            else Q ? Ie = Ne && (u || ge) : z ? Ie = Ne && ge && (u || !_e) : H ? Ie = Ne && ge && !_e && (u || !Ve) : _e || Ve ? Ie = !1 : Ie = u ? ae <= n : ae < n;
            Ie ? S = ee + 1 : O = ee;
          }
          return Ft(O, ne);
        }
        function Gl(e, n) {
          for (var o = -1, u = e.length, S = 0, O = []; ++o < u; ) {
            var L = e[o], z = n ? n(L) : L;
            if (!o || !vn(z, H)) {
              var H = z;
              O[S++] = L === 0 ? 0 : L;
            }
          }
          return O;
        }
        function Kl(e) {
          return typeof e == "number" ? e : nn(e) ? B : +e;
        }
        function tn(e) {
          if (typeof e == "string")
            return e;
          if (ze(e))
            return ht(e, tn) + "";
          if (nn(e))
            return Tl ? Tl.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -ie ? "-0" : n;
        }
        function Jn(e, n, o) {
          var u = -1, S = Li, O = e.length, L = !0, z = [], H = z;
          if (o)
            L = !1, S = to;
          else if (O >= l) {
            var Q = n ? null : Kp(e);
            if (Q)
              return Mi(Q);
            L = !1, S = Gr, H = new fr();
          } else
            H = n ? [] : z;
          e:
            for (; ++u < O; ) {
              var ee = e[u], ae = n ? n(ee) : ee;
              if (ee = o || ee !== 0 ? ee : 0, L && ae === ae) {
                for (var ge = H.length; ge--; )
                  if (H[ge] === ae)
                    continue e;
                n && H.push(ae), z.push(ee);
              } else S(H, ae, o) || (H !== z && H.push(ae), z.push(ee));
            }
          return z;
        }
        function Ao(e, n) {
          return n = Qn(n, e), e = Cc(e, n), e == null || delete e[wn(fn(n))];
        }
        function ql(e, n, o, u) {
          return ni(e, n, o(mr(e, n)), u);
        }
        function ra(e, n, o, u) {
          for (var S = e.length, O = u ? S : -1; (u ? O-- : ++O < S) && n(e[O], O, e); )
            ;
          return o ? hn(e, u ? 0 : O, u ? O + 1 : S) : hn(e, u ? O + 1 : 0, u ? S : O);
        }
        function Yl(e, n) {
          var o = e;
          return o instanceof Ye && (o = o.value()), no(n, function(u, S) {
            return S.func.apply(S.thisArg, qn([u], S.args));
          }, o);
        }
        function Oo(e, n, o) {
          var u = e.length;
          if (u < 2)
            return u ? Jn(e[0]) : [];
          for (var S = -1, O = Y(u); ++S < u; )
            for (var L = e[S], z = -1; ++z < u; )
              z != S && (O[S] = Qr(O[S] || L, e[z], n, o));
          return Jn(Pt(O, 1), n, o);
        }
        function Xl(e, n, o) {
          for (var u = -1, S = e.length, O = n.length, L = {}; ++u < S; ) {
            var z = u < O ? n[u] : a;
            o(L, e[u], z);
          }
          return L;
        }
        function Ro(e) {
          return vt(e) ? e : [];
        }
        function Po(e) {
          return typeof e == "function" ? e : Xt;
        }
        function Qn(e, n) {
          return ze(e) ? e : Bo(e, n) ? [e] : Tc(nt(e));
        }
        var Mp = Ue;
        function er(e, n, o) {
          var u = e.length;
          return o = o === a ? u : o, !n && o >= u ? e : hn(e, n, o);
        }
        var Zl = wf || function(e) {
          return Rt.clearTimeout(e);
        };
        function Jl(e, n) {
          if (n)
            return e.slice();
          var o = e.length, u = yl ? yl(o) : new e.constructor(o);
          return e.copy(u), u;
        }
        function Do(e) {
          var n = new e.constructor(e.byteLength);
          return new Hi(n).set(new Hi(e)), n;
        }
        function kp(e, n) {
          var o = n ? Do(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.byteLength);
        }
        function zp(e) {
          var n = new e.constructor(e.source, Ls.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function Bp(e) {
          return Zr ? ot(Zr.call(e)) : {};
        }
        function Ql(e, n) {
          var o = n ? Do(e.buffer) : e.buffer;
          return new e.constructor(o, e.byteOffset, e.length);
        }
        function ec(e, n) {
          if (e !== n) {
            var o = e !== a, u = e === null, S = e === e, O = nn(e), L = n !== a, z = n === null, H = n === n, Q = nn(n);
            if (!z && !Q && !O && e > n || O && L && H && !z && !Q || u && L && H || !o && H || !S)
              return 1;
            if (!u && !O && !Q && e < n || Q && o && S && !u && !O || z && o && S || !L && S || !H)
              return -1;
          }
          return 0;
        }
        function $p(e, n, o) {
          for (var u = -1, S = e.criteria, O = n.criteria, L = S.length, z = o.length; ++u < L; ) {
            var H = ec(S[u], O[u]);
            if (H) {
              if (u >= z)
                return H;
              var Q = o[u];
              return H * (Q == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function tc(e, n, o, u) {
          for (var S = -1, O = e.length, L = o.length, z = -1, H = n.length, Q = wt(O - L, 0), ee = Y(H + Q), ae = !u; ++z < H; )
            ee[z] = n[z];
          for (; ++S < L; )
            (ae || S < O) && (ee[o[S]] = e[S]);
          for (; Q--; )
            ee[z++] = e[S++];
          return ee;
        }
        function nc(e, n, o, u) {
          for (var S = -1, O = e.length, L = -1, z = o.length, H = -1, Q = n.length, ee = wt(O - z, 0), ae = Y(ee + Q), ge = !u; ++S < ee; )
            ae[S] = e[S];
          for (var _e = S; ++H < Q; )
            ae[_e + H] = n[H];
          for (; ++L < z; )
            (ge || S < O) && (ae[_e + o[L]] = e[S++]);
          return ae;
        }
        function Kt(e, n) {
          var o = -1, u = e.length;
          for (n || (n = Y(u)); ++o < u; )
            n[o] = e[o];
          return n;
        }
        function Sn(e, n, o, u) {
          var S = !o;
          o || (o = {});
          for (var O = -1, L = n.length; ++O < L; ) {
            var z = n[O], H = u ? u(o[z], e[z], z, o, e) : a;
            H === a && (H = e[z]), S ? In(o, z, H) : Jr(o, z, H);
          }
          return o;
        }
        function Wp(e, n) {
          return Sn(e, zo(e), n);
        }
        function Hp(e, n) {
          return Sn(e, mc(e), n);
        }
        function ia(e, n) {
          return function(o, u) {
            var S = ze(o) ? Kh : dp, O = n ? n() : {};
            return S(o, e, De(u, 2), O);
          };
        }
        function Mr(e) {
          return Ue(function(n, o) {
            var u = -1, S = o.length, O = S > 1 ? o[S - 1] : a, L = S > 2 ? o[2] : a;
            for (O = e.length > 3 && typeof O == "function" ? (S--, O) : a, L && Wt(o[0], o[1], L) && (O = S < 3 ? a : O, S = 1), n = ot(n); ++u < S; ) {
              var z = o[u];
              z && e(n, z, u, O);
            }
            return n;
          });
        }
        function rc(e, n) {
          return function(o, u) {
            if (o == null)
              return o;
            if (!qt(o))
              return e(o, u);
            for (var S = o.length, O = n ? S : -1, L = ot(o); (n ? O-- : ++O < S) && u(L[O], O, L) !== !1; )
              ;
            return o;
          };
        }
        function ic(e) {
          return function(n, o, u) {
            for (var S = -1, O = ot(n), L = u(n), z = L.length; z--; ) {
              var H = L[e ? z : ++S];
              if (o(O[H], H, O) === !1)
                break;
            }
            return n;
          };
        }
        function Vp(e, n, o) {
          var u = n & R, S = ri(e);
          function O() {
            var L = this && this !== Rt && this instanceof O ? S : e;
            return L.apply(u ? o : this, arguments);
          }
          return O;
        }
        function ac(e) {
          return function(n) {
            n = nt(n);
            var o = Rr(n) ? xn(n) : a, u = o ? o[0] : n.charAt(0), S = o ? er(o, 1).join("") : n.slice(1);
            return u[e]() + S;
          };
        }
        function kr(e) {
          return function(n) {
            return no(ru(nu(n).replace(Nh, "")), e, "");
          };
        }
        function ri(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var o = Fr(e.prototype), u = e.apply(o, n);
            return ft(u) ? u : o;
          };
        }
        function Up(e, n, o) {
          var u = ri(e);
          function S() {
            for (var O = arguments.length, L = Y(O), z = O, H = zr(S); z--; )
              L[z] = arguments[z];
            var Q = O < 3 && L[0] !== H && L[O - 1] !== H ? [] : Yn(L, H);
            if (O -= Q.length, O < o)
              return uc(
                e,
                n,
                aa,
                S.placeholder,
                a,
                L,
                Q,
                a,
                a,
                o - O
              );
            var ee = this && this !== Rt && this instanceof S ? u : e;
            return Qt(ee, this, L);
          }
          return S;
        }
        function oc(e) {
          return function(n, o, u) {
            var S = ot(n);
            if (!qt(n)) {
              var O = De(o, 3);
              n = Et(n), o = function(z) {
                return O(S[z], z, S);
              };
            }
            var L = e(n, o, u);
            return L > -1 ? S[O ? n[L] : L] : a;
          };
        }
        function sc(e) {
          return Fn(function(n) {
            var o = n.length, u = o, S = un.prototype.thru;
            for (e && n.reverse(); u--; ) {
              var O = n[u];
              if (typeof O != "function")
                throw new cn(m);
              if (S && !L && ca(O) == "wrapper")
                var L = new un([], !0);
            }
            for (u = L ? u : o; ++u < o; ) {
              O = n[u];
              var z = ca(O), H = z == "wrapper" ? Mo(O) : a;
              H && $o(H[0]) && H[1] == (y | F | x | w) && !H[4].length && H[9] == 1 ? L = L[ca(H[0])].apply(L, H[3]) : L = O.length == 1 && $o(O) ? L[z]() : L.thru(O);
            }
            return function() {
              var Q = arguments, ee = Q[0];
              if (L && Q.length == 1 && ze(ee))
                return L.plant(ee).value();
              for (var ae = 0, ge = o ? n[ae].apply(this, Q) : ee; ++ae < o; )
                ge = n[ae].call(this, ge);
              return ge;
            };
          });
        }
        function aa(e, n, o, u, S, O, L, z, H, Q) {
          var ee = n & y, ae = n & R, ge = n & D, _e = n & (F | P), Ne = n & M, Ve = ge ? a : ri(e);
          function Ie() {
            for (var Ge = arguments.length, Ze = Y(Ge), rn = Ge; rn--; )
              Ze[rn] = arguments[rn];
            if (_e)
              var Ht = zr(Ie), an = nf(Ze, Ht);
            if (u && (Ze = tc(Ze, u, S, _e)), O && (Ze = nc(Ze, O, L, _e)), Ge -= an, _e && Ge < Q) {
              var yt = Yn(Ze, Ht);
              return uc(
                e,
                n,
                aa,
                Ie.placeholder,
                o,
                Ze,
                yt,
                z,
                H,
                Q - Ge
              );
            }
            var yn = ae ? o : this, Bn = ge ? yn[e] : e;
            return Ge = Ze.length, z ? Ze = dm(Ze, z) : Ne && Ge > 1 && Ze.reverse(), ee && H < Ge && (Ze.length = H), this && this !== Rt && this instanceof Ie && (Bn = Ve || ri(Bn)), Bn.apply(yn, Ze);
          }
          return Ie;
        }
        function lc(e, n) {
          return function(o, u) {
            return yp(o, e, n(u), {});
          };
        }
        function oa(e, n) {
          return function(o, u) {
            var S;
            if (o === a && u === a)
              return n;
            if (o !== a && (S = o), u !== a) {
              if (S === a)
                return u;
              typeof o == "string" || typeof u == "string" ? (o = tn(o), u = tn(u)) : (o = Kl(o), u = Kl(u)), S = e(o, u);
            }
            return S;
          };
        }
        function No(e) {
          return Fn(function(n) {
            return n = ht(n, en(De())), Ue(function(o) {
              var u = this;
              return e(n, function(S) {
                return Qt(S, u, o);
              });
            });
          });
        }
        function sa(e, n) {
          n = n === a ? " " : tn(n);
          var o = n.length;
          if (o < 2)
            return o ? _o(n, e) : n;
          var u = _o(n, Ki(e / Pr(n)));
          return Rr(n) ? er(xn(u), 0, e).join("") : u.slice(0, e);
        }
        function Gp(e, n, o, u) {
          var S = n & R, O = ri(e);
          function L() {
            for (var z = -1, H = arguments.length, Q = -1, ee = u.length, ae = Y(ee + H), ge = this && this !== Rt && this instanceof L ? O : e; ++Q < ee; )
              ae[Q] = u[Q];
            for (; H--; )
              ae[Q++] = arguments[++z];
            return Qt(ge, S ? o : this, ae);
          }
          return L;
        }
        function cc(e) {
          return function(n, o, u) {
            return u && typeof u != "number" && Wt(n, o, u) && (o = u = a), n = zn(n), o === a ? (o = n, n = 0) : o = zn(o), u = u === a ? n < o ? 1 : -1 : zn(u), Pp(n, o, u, e);
          };
        }
        function la(e) {
          return function(n, o) {
            return typeof n == "string" && typeof o == "string" || (n = pn(n), o = pn(o)), e(n, o);
          };
        }
        function uc(e, n, o, u, S, O, L, z, H, Q) {
          var ee = n & F, ae = ee ? L : a, ge = ee ? a : L, _e = ee ? O : a, Ne = ee ? a : O;
          n |= ee ? x : p, n &= ~(ee ? p : x), n & _ || (n &= -4);
          var Ve = [
            e,
            n,
            S,
            _e,
            ae,
            Ne,
            ge,
            z,
            H,
            Q
          ], Ie = o.apply(a, Ve);
          return $o(e) && jc(Ie, Ve), Ie.placeholder = u, Sc(Ie, e, n);
        }
        function Io(e) {
          var n = St[e];
          return function(o, u) {
            if (o = pn(o), u = u == null ? 0 : Ft(We(u), 292), u && Sl(o)) {
              var S = (nt(o) + "e").split("e"), O = n(S[0] + "e" + (+S[1] + u));
              return S = (nt(O) + "e").split("e"), +(S[0] + "e" + (+S[1] - u));
            }
            return n(o);
          };
        }
        var Kp = Ir && 1 / Mi(new Ir([, -0]))[1] == ie ? function(e) {
          return new Ir(e);
        } : ns;
        function dc(e) {
          return function(n) {
            var o = Mt(n);
            return o == Oe ? co(n) : o == xe ? uf(n) : tf(n, e(n));
          };
        }
        function Ln(e, n, o, u, S, O, L, z) {
          var H = n & D;
          if (!H && typeof e != "function")
            throw new cn(m);
          var Q = u ? u.length : 0;
          if (Q || (n &= -97, u = S = a), L = L === a ? L : wt(We(L), 0), z = z === a ? z : We(z), Q -= S ? S.length : 0, n & p) {
            var ee = u, ae = S;
            u = S = a;
          }
          var ge = H ? a : Mo(e), _e = [
            e,
            n,
            o,
            u,
            S,
            ee,
            ae,
            O,
            L,
            z
          ];
          if (ge && lm(_e, ge), e = _e[0], n = _e[1], o = _e[2], u = _e[3], S = _e[4], z = _e[9] = _e[9] === a ? H ? 0 : e.length : wt(_e[9] - Q, 0), !z && n & (F | P) && (n &= -25), !n || n == R)
            var Ne = Vp(e, n, o);
          else n == F || n == P ? Ne = Up(e, n, z) : (n == x || n == (R | x)) && !S.length ? Ne = Gp(e, n, o, u) : Ne = aa.apply(a, _e);
          var Ve = ge ? Ul : jc;
          return Sc(Ve(Ne, _e), e, n);
        }
        function hc(e, n, o, u) {
          return e === a || vn(e, Nr[o]) && !it.call(u, o) ? n : e;
        }
        function fc(e, n, o, u, S, O) {
          return ft(e) && ft(n) && (O.set(n, e), ta(e, n, a, fc, O), O.delete(n)), e;
        }
        function qp(e) {
          return oi(e) ? a : e;
        }
        function pc(e, n, o, u, S, O) {
          var L = o & E, z = e.length, H = n.length;
          if (z != H && !(L && H > z))
            return !1;
          var Q = O.get(e), ee = O.get(n);
          if (Q && ee)
            return Q == n && ee == e;
          var ae = -1, ge = !0, _e = o & A ? new fr() : a;
          for (O.set(e, n), O.set(n, e); ++ae < z; ) {
            var Ne = e[ae], Ve = n[ae];
            if (u)
              var Ie = L ? u(Ve, Ne, ae, n, e, O) : u(Ne, Ve, ae, e, n, O);
            if (Ie !== a) {
              if (Ie)
                continue;
              ge = !1;
              break;
            }
            if (_e) {
              if (!ro(n, function(Ge, Ze) {
                if (!Gr(_e, Ze) && (Ne === Ge || S(Ne, Ge, o, u, O)))
                  return _e.push(Ze);
              })) {
                ge = !1;
                break;
              }
            } else if (!(Ne === Ve || S(Ne, Ve, o, u, O))) {
              ge = !1;
              break;
            }
          }
          return O.delete(e), O.delete(n), ge;
        }
        function Yp(e, n, o, u, S, O, L) {
          switch (o) {
            case jt:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case xt:
              return !(e.byteLength != n.byteLength || !O(new Hi(e), new Hi(n)));
            case ce:
            case fe:
            case pe:
              return vn(+e, +n);
            case ye:
              return e.name == n.name && e.message == n.message;
            case Ce:
            case Se:
              return e == n + "";
            case Oe:
              var z = co;
            case xe:
              var H = u & E;
              if (z || (z = Mi), e.size != n.size && !H)
                return !1;
              var Q = L.get(e);
              if (Q)
                return Q == n;
              u |= A, L.set(e, n);
              var ee = pc(z(e), z(n), u, S, O, L);
              return L.delete(e), ee;
            case Te:
              if (Zr)
                return Zr.call(e) == Zr.call(n);
          }
          return !1;
        }
        function Xp(e, n, o, u, S, O) {
          var L = o & E, z = Lo(e), H = z.length, Q = Lo(n), ee = Q.length;
          if (H != ee && !L)
            return !1;
          for (var ae = H; ae--; ) {
            var ge = z[ae];
            if (!(L ? ge in n : it.call(n, ge)))
              return !1;
          }
          var _e = O.get(e), Ne = O.get(n);
          if (_e && Ne)
            return _e == n && Ne == e;
          var Ve = !0;
          O.set(e, n), O.set(n, e);
          for (var Ie = L; ++ae < H; ) {
            ge = z[ae];
            var Ge = e[ge], Ze = n[ge];
            if (u)
              var rn = L ? u(Ze, Ge, ge, n, e, O) : u(Ge, Ze, ge, e, n, O);
            if (!(rn === a ? Ge === Ze || S(Ge, Ze, o, u, O) : rn)) {
              Ve = !1;
              break;
            }
            Ie || (Ie = ge == "constructor");
          }
          if (Ve && !Ie) {
            var Ht = e.constructor, an = n.constructor;
            Ht != an && "constructor" in e && "constructor" in n && !(typeof Ht == "function" && Ht instanceof Ht && typeof an == "function" && an instanceof an) && (Ve = !1);
          }
          return O.delete(e), O.delete(n), Ve;
        }
        function Fn(e) {
          return Ho(bc(e, a, Oc), e + "");
        }
        function Lo(e) {
          return Il(e, Et, zo);
        }
        function Fo(e) {
          return Il(e, Yt, mc);
        }
        var Mo = Yi ? function(e) {
          return Yi.get(e);
        } : ns;
        function ca(e) {
          for (var n = e.name + "", o = Lr[n], u = it.call(Lr, n) ? o.length : 0; u--; ) {
            var S = o[u], O = S.func;
            if (O == null || O == e)
              return S.name;
          }
          return n;
        }
        function zr(e) {
          var n = it.call(T, "placeholder") ? T : e;
          return n.placeholder;
        }
        function De() {
          var e = T.iteratee || es;
          return e = e === es ? Ml : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function ua(e, n) {
          var o = e.__data__;
          return im(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
        }
        function ko(e) {
          for (var n = Et(e), o = n.length; o--; ) {
            var u = n[o], S = e[u];
            n[o] = [u, S, vc(S)];
          }
          return n;
        }
        function xr(e, n) {
          var o = sf(e, n);
          return Fl(o) ? o : a;
        }
        function Zp(e) {
          var n = it.call(e, dr), o = e[dr];
          try {
            e[dr] = a;
            var u = !0;
          } catch {
          }
          var S = $i.call(e);
          return u && (n ? e[dr] = o : delete e[dr]), S;
        }
        var zo = ho ? function(e) {
          return e == null ? [] : (e = ot(e), Kn(ho(e), function(n) {
            return Cl.call(e, n);
          }));
        } : rs, mc = ho ? function(e) {
          for (var n = []; e; )
            qn(n, zo(e)), e = Vi(e);
          return n;
        } : rs, Mt = $t;
        (fo && Mt(new fo(new ArrayBuffer(1))) != jt || qr && Mt(new qr()) != Oe || po && Mt(po.resolve()) != He || Ir && Mt(new Ir()) != xe || Yr && Mt(new Yr()) != et) && (Mt = function(e) {
          var n = $t(e), o = n == Ae ? e.constructor : a, u = o ? gr(o) : "";
          if (u)
            switch (u) {
              case Nf:
                return jt;
              case If:
                return Oe;
              case Lf:
                return He;
              case Ff:
                return xe;
              case Mf:
                return et;
            }
          return n;
        });
        function Jp(e, n, o) {
          for (var u = -1, S = o.length; ++u < S; ) {
            var O = o[u], L = O.size;
            switch (O.type) {
              case "drop":
                e += L;
                break;
              case "dropRight":
                n -= L;
                break;
              case "take":
                n = Ft(n, e + L);
                break;
              case "takeRight":
                e = wt(e, n - L);
                break;
            }
          }
          return { start: e, end: n };
        }
        function Qp(e) {
          var n = e.match(ih);
          return n ? n[1].split(ah) : [];
        }
        function xc(e, n, o) {
          n = Qn(n, e);
          for (var u = -1, S = n.length, O = !1; ++u < S; ) {
            var L = wn(n[u]);
            if (!(O = e != null && o(e, L)))
              break;
            e = e[L];
          }
          return O || ++u != S ? O : (S = e == null ? 0 : e.length, !!S && ga(S) && Mn(L, S) && (ze(e) || vr(e)));
        }
        function em(e) {
          var n = e.length, o = new e.constructor(n);
          return n && typeof e[0] == "string" && it.call(e, "index") && (o.index = e.index, o.input = e.input), o;
        }
        function gc(e) {
          return typeof e.constructor == "function" && !ii(e) ? Fr(Vi(e)) : {};
        }
        function tm(e, n, o) {
          var u = e.constructor;
          switch (n) {
            case xt:
              return Do(e);
            case ce:
            case fe:
              return new u(+e);
            case jt:
              return kp(e, o);
            case ut:
            case Qe:
            case pt:
            case Rn:
            case Gn:
            case Me:
            case Fe:
            case Xe:
            case at:
              return Ql(e, o);
            case Oe:
              return new u();
            case pe:
            case Se:
              return new u(e);
            case Ce:
              return zp(e);
            case xe:
              return new u();
            case Te:
              return Bp(e);
          }
        }
        function nm(e, n) {
          var o = n.length;
          if (!o)
            return e;
          var u = o - 1;
          return n[u] = (o > 1 ? "& " : "") + n[u], n = n.join(o > 2 ? ", " : " "), e.replace(rh, `{
/* [wrapped with ` + n + `] */
`);
        }
        function rm(e) {
          return ze(e) || vr(e) || !!(jl && e && e[jl]);
        }
        function Mn(e, n) {
          var o = typeof e;
          return n = n ?? K, !!n && (o == "number" || o != "symbol" && ph.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function Wt(e, n, o) {
          if (!ft(o))
            return !1;
          var u = typeof n;
          return (u == "number" ? qt(o) && Mn(n, o.length) : u == "string" && n in o) ? vn(o[n], e) : !1;
        }
        function Bo(e, n) {
          if (ze(e))
            return !1;
          var o = typeof e;
          return o == "number" || o == "symbol" || o == "boolean" || e == null || nn(e) ? !0 : Er.test(e) || !Ua.test(e) || n != null && e in ot(n);
        }
        function im(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function $o(e) {
          var n = ca(e), o = T[n];
          if (typeof o != "function" || !(n in Ye.prototype))
            return !1;
          if (e === o)
            return !0;
          var u = Mo(o);
          return !!u && e === u[0];
        }
        function am(e) {
          return !!vl && vl in e;
        }
        var om = zi ? kn : is;
        function ii(e) {
          var n = e && e.constructor, o = typeof n == "function" && n.prototype || Nr;
          return e === o;
        }
        function vc(e) {
          return e === e && !ft(e);
        }
        function yc(e, n) {
          return function(o) {
            return o == null ? !1 : o[e] === n && (n !== a || e in ot(o));
          };
        }
        function sm(e) {
          var n = ma(e, function(u) {
            return o.size === d && o.clear(), u;
          }), o = n.cache;
          return n;
        }
        function lm(e, n) {
          var o = e[1], u = n[1], S = o | u, O = S < (R | D | y), L = u == y && o == F || u == y && o == w && e[7].length <= n[8] || u == (y | w) && n[7].length <= n[8] && o == F;
          if (!(O || L))
            return e;
          u & R && (e[2] = n[2], S |= o & R ? 0 : _);
          var z = n[3];
          if (z) {
            var H = e[3];
            e[3] = H ? tc(H, z, n[4]) : z, e[4] = H ? Yn(e[3], f) : n[4];
          }
          return z = n[5], z && (H = e[5], e[5] = H ? nc(H, z, n[6]) : z, e[6] = H ? Yn(e[5], f) : n[6]), z = n[7], z && (e[7] = z), u & y && (e[8] = e[8] == null ? n[8] : Ft(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = S, e;
        }
        function cm(e) {
          var n = [];
          if (e != null)
            for (var o in ot(e))
              n.push(o);
          return n;
        }
        function um(e) {
          return $i.call(e);
        }
        function bc(e, n, o) {
          return n = wt(n === a ? e.length - 1 : n, 0), function() {
            for (var u = arguments, S = -1, O = wt(u.length - n, 0), L = Y(O); ++S < O; )
              L[S] = u[n + S];
            S = -1;
            for (var z = Y(n + 1); ++S < n; )
              z[S] = u[S];
            return z[n] = o(L), Qt(e, this, z);
          };
        }
        function Cc(e, n) {
          return n.length < 2 ? e : mr(e, hn(n, 0, -1));
        }
        function dm(e, n) {
          for (var o = e.length, u = Ft(n.length, o), S = Kt(e); u--; ) {
            var O = n[u];
            e[u] = Mn(O, o) ? S[O] : a;
          }
          return e;
        }
        function Wo(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var jc = wc(Ul), ai = _f || function(e, n) {
          return Rt.setTimeout(e, n);
        }, Ho = wc(Ip);
        function Sc(e, n, o) {
          var u = n + "";
          return Ho(e, nm(u, hm(Qp(u), o)));
        }
        function wc(e) {
          var n = 0, o = 0;
          return function() {
            var u = Rf(), S = I - (u - o);
            if (o = u, S > 0) {
              if (++n >= $)
                return arguments[0];
            } else
              n = 0;
            return e.apply(a, arguments);
          };
        }
        function da(e, n) {
          var o = -1, u = e.length, S = u - 1;
          for (n = n === a ? u : n; ++o < n; ) {
            var O = To(o, S), L = e[O];
            e[O] = e[o], e[o] = L;
          }
          return e.length = n, e;
        }
        var Tc = sm(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(Ga, function(o, u, S, O) {
            n.push(S ? O.replace(lh, "$1") : u || o);
          }), n;
        });
        function wn(e) {
          if (typeof e == "string" || nn(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -ie ? "-0" : n;
        }
        function gr(e) {
          if (e != null) {
            try {
              return Bi.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function hm(e, n) {
          return ln(je, function(o) {
            var u = "_." + o[0];
            n & o[1] && !Li(e, u) && e.push(u);
          }), e.sort();
        }
        function _c(e) {
          if (e instanceof Ye)
            return e.clone();
          var n = new un(e.__wrapped__, e.__chain__);
          return n.__actions__ = Kt(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function fm(e, n, o) {
          (o ? Wt(e, n, o) : n === a) ? n = 1 : n = wt(We(n), 0);
          var u = e == null ? 0 : e.length;
          if (!u || n < 1)
            return [];
          for (var S = 0, O = 0, L = Y(Ki(u / n)); S < u; )
            L[O++] = hn(e, S, S += n);
          return L;
        }
        function pm(e) {
          for (var n = -1, o = e == null ? 0 : e.length, u = 0, S = []; ++n < o; ) {
            var O = e[n];
            O && (S[u++] = O);
          }
          return S;
        }
        function mm() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = Y(e - 1), o = arguments[0], u = e; u--; )
            n[u - 1] = arguments[u];
          return qn(ze(o) ? Kt(o) : [o], Pt(n, 1));
        }
        var xm = Ue(function(e, n) {
          return vt(e) ? Qr(e, Pt(n, 1, vt, !0)) : [];
        }), gm = Ue(function(e, n) {
          var o = fn(n);
          return vt(o) && (o = a), vt(e) ? Qr(e, Pt(n, 1, vt, !0), De(o, 2)) : [];
        }), vm = Ue(function(e, n) {
          var o = fn(n);
          return vt(o) && (o = a), vt(e) ? Qr(e, Pt(n, 1, vt, !0), a, o) : [];
        });
        function ym(e, n, o) {
          var u = e == null ? 0 : e.length;
          return u ? (n = o || n === a ? 1 : We(n), hn(e, n < 0 ? 0 : n, u)) : [];
        }
        function bm(e, n, o) {
          var u = e == null ? 0 : e.length;
          return u ? (n = o || n === a ? 1 : We(n), n = u - n, hn(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Cm(e, n) {
          return e && e.length ? ra(e, De(n, 3), !0, !0) : [];
        }
        function jm(e, n) {
          return e && e.length ? ra(e, De(n, 3), !0) : [];
        }
        function Sm(e, n, o, u) {
          var S = e == null ? 0 : e.length;
          return S ? (o && typeof o != "number" && Wt(e, n, o) && (o = 0, u = S), mp(e, n, o, u)) : [];
        }
        function Ec(e, n, o) {
          var u = e == null ? 0 : e.length;
          if (!u)
            return -1;
          var S = o == null ? 0 : We(o);
          return S < 0 && (S = wt(u + S, 0)), Fi(e, De(n, 3), S);
        }
        function Ac(e, n, o) {
          var u = e == null ? 0 : e.length;
          if (!u)
            return -1;
          var S = u - 1;
          return o !== a && (S = We(o), S = o < 0 ? wt(u + S, 0) : Ft(S, u - 1)), Fi(e, De(n, 3), S, !0);
        }
        function Oc(e) {
          var n = e == null ? 0 : e.length;
          return n ? Pt(e, 1) : [];
        }
        function wm(e) {
          var n = e == null ? 0 : e.length;
          return n ? Pt(e, ie) : [];
        }
        function Tm(e, n) {
          var o = e == null ? 0 : e.length;
          return o ? (n = n === a ? 1 : We(n), Pt(e, n)) : [];
        }
        function _m(e) {
          for (var n = -1, o = e == null ? 0 : e.length, u = {}; ++n < o; ) {
            var S = e[n];
            u[S[0]] = S[1];
          }
          return u;
        }
        function Rc(e) {
          return e && e.length ? e[0] : a;
        }
        function Em(e, n, o) {
          var u = e == null ? 0 : e.length;
          if (!u)
            return -1;
          var S = o == null ? 0 : We(o);
          return S < 0 && (S = wt(u + S, 0)), Or(e, n, S);
        }
        function Am(e) {
          var n = e == null ? 0 : e.length;
          return n ? hn(e, 0, -1) : [];
        }
        var Om = Ue(function(e) {
          var n = ht(e, Ro);
          return n.length && n[0] === e[0] ? bo(n) : [];
        }), Rm = Ue(function(e) {
          var n = fn(e), o = ht(e, Ro);
          return n === fn(o) ? n = a : o.pop(), o.length && o[0] === e[0] ? bo(o, De(n, 2)) : [];
        }), Pm = Ue(function(e) {
          var n = fn(e), o = ht(e, Ro);
          return n = typeof n == "function" ? n : a, n && o.pop(), o.length && o[0] === e[0] ? bo(o, a, n) : [];
        });
        function Dm(e, n) {
          return e == null ? "" : Af.call(e, n);
        }
        function fn(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : a;
        }
        function Nm(e, n, o) {
          var u = e == null ? 0 : e.length;
          if (!u)
            return -1;
          var S = u;
          return o !== a && (S = We(o), S = S < 0 ? wt(u + S, 0) : Ft(S, u - 1)), n === n ? hf(e, n, S) : Fi(e, ul, S, !0);
        }
        function Im(e, n) {
          return e && e.length ? $l(e, We(n)) : a;
        }
        var Lm = Ue(Pc);
        function Pc(e, n) {
          return e && e.length && n && n.length ? wo(e, n) : e;
        }
        function Fm(e, n, o) {
          return e && e.length && n && n.length ? wo(e, n, De(o, 2)) : e;
        }
        function Mm(e, n, o) {
          return e && e.length && n && n.length ? wo(e, n, a, o) : e;
        }
        var km = Fn(function(e, n) {
          var o = e == null ? 0 : e.length, u = xo(e, n);
          return Vl(e, ht(n, function(S) {
            return Mn(S, o) ? +S : S;
          }).sort(ec)), u;
        });
        function zm(e, n) {
          var o = [];
          if (!(e && e.length))
            return o;
          var u = -1, S = [], O = e.length;
          for (n = De(n, 3); ++u < O; ) {
            var L = e[u];
            n(L, u, e) && (o.push(L), S.push(u));
          }
          return Vl(e, S), o;
        }
        function Vo(e) {
          return e == null ? e : Df.call(e);
        }
        function Bm(e, n, o) {
          var u = e == null ? 0 : e.length;
          return u ? (o && typeof o != "number" && Wt(e, n, o) ? (n = 0, o = u) : (n = n == null ? 0 : We(n), o = o === a ? u : We(o)), hn(e, n, o)) : [];
        }
        function $m(e, n) {
          return na(e, n);
        }
        function Wm(e, n, o) {
          return Eo(e, n, De(o, 2));
        }
        function Hm(e, n) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var u = na(e, n);
            if (u < o && vn(e[u], n))
              return u;
          }
          return -1;
        }
        function Vm(e, n) {
          return na(e, n, !0);
        }
        function Um(e, n, o) {
          return Eo(e, n, De(o, 2), !0);
        }
        function Gm(e, n) {
          var o = e == null ? 0 : e.length;
          if (o) {
            var u = na(e, n, !0) - 1;
            if (vn(e[u], n))
              return u;
          }
          return -1;
        }
        function Km(e) {
          return e && e.length ? Gl(e) : [];
        }
        function qm(e, n) {
          return e && e.length ? Gl(e, De(n, 2)) : [];
        }
        function Ym(e) {
          var n = e == null ? 0 : e.length;
          return n ? hn(e, 1, n) : [];
        }
        function Xm(e, n, o) {
          return e && e.length ? (n = o || n === a ? 1 : We(n), hn(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Zm(e, n, o) {
          var u = e == null ? 0 : e.length;
          return u ? (n = o || n === a ? 1 : We(n), n = u - n, hn(e, n < 0 ? 0 : n, u)) : [];
        }
        function Jm(e, n) {
          return e && e.length ? ra(e, De(n, 3), !1, !0) : [];
        }
        function Qm(e, n) {
          return e && e.length ? ra(e, De(n, 3)) : [];
        }
        var ex = Ue(function(e) {
          return Jn(Pt(e, 1, vt, !0));
        }), tx = Ue(function(e) {
          var n = fn(e);
          return vt(n) && (n = a), Jn(Pt(e, 1, vt, !0), De(n, 2));
        }), nx = Ue(function(e) {
          var n = fn(e);
          return n = typeof n == "function" ? n : a, Jn(Pt(e, 1, vt, !0), a, n);
        });
        function rx(e) {
          return e && e.length ? Jn(e) : [];
        }
        function ix(e, n) {
          return e && e.length ? Jn(e, De(n, 2)) : [];
        }
        function ax(e, n) {
          return n = typeof n == "function" ? n : a, e && e.length ? Jn(e, a, n) : [];
        }
        function Uo(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = Kn(e, function(o) {
            if (vt(o))
              return n = wt(o.length, n), !0;
          }), so(n, function(o) {
            return ht(e, io(o));
          });
        }
        function Dc(e, n) {
          if (!(e && e.length))
            return [];
          var o = Uo(e);
          return n == null ? o : ht(o, function(u) {
            return Qt(n, a, u);
          });
        }
        var ox = Ue(function(e, n) {
          return vt(e) ? Qr(e, n) : [];
        }), sx = Ue(function(e) {
          return Oo(Kn(e, vt));
        }), lx = Ue(function(e) {
          var n = fn(e);
          return vt(n) && (n = a), Oo(Kn(e, vt), De(n, 2));
        }), cx = Ue(function(e) {
          var n = fn(e);
          return n = typeof n == "function" ? n : a, Oo(Kn(e, vt), a, n);
        }), ux = Ue(Uo);
        function dx(e, n) {
          return Xl(e || [], n || [], Jr);
        }
        function hx(e, n) {
          return Xl(e || [], n || [], ni);
        }
        var fx = Ue(function(e) {
          var n = e.length, o = n > 1 ? e[n - 1] : a;
          return o = typeof o == "function" ? (e.pop(), o) : a, Dc(e, o);
        });
        function Nc(e) {
          var n = T(e);
          return n.__chain__ = !0, n;
        }
        function px(e, n) {
          return n(e), e;
        }
        function ha(e, n) {
          return n(e);
        }
        var mx = Fn(function(e) {
          var n = e.length, o = n ? e[0] : 0, u = this.__wrapped__, S = function(O) {
            return xo(O, e);
          };
          return n > 1 || this.__actions__.length || !(u instanceof Ye) || !Mn(o) ? this.thru(S) : (u = u.slice(o, +o + (n ? 1 : 0)), u.__actions__.push({
            func: ha,
            args: [S],
            thisArg: a
          }), new un(u, this.__chain__).thru(function(O) {
            return n && !O.length && O.push(a), O;
          }));
        });
        function xx() {
          return Nc(this);
        }
        function gx() {
          return new un(this.value(), this.__chain__);
        }
        function vx() {
          this.__values__ === a && (this.__values__ = Kc(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? a : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function yx() {
          return this;
        }
        function bx(e) {
          for (var n, o = this; o instanceof Zi; ) {
            var u = _c(o);
            u.__index__ = 0, u.__values__ = a, n ? S.__wrapped__ = u : n = u;
            var S = u;
            o = o.__wrapped__;
          }
          return S.__wrapped__ = e, n;
        }
        function Cx() {
          var e = this.__wrapped__;
          if (e instanceof Ye) {
            var n = e;
            return this.__actions__.length && (n = new Ye(this)), n = n.reverse(), n.__actions__.push({
              func: ha,
              args: [Vo],
              thisArg: a
            }), new un(n, this.__chain__);
          }
          return this.thru(Vo);
        }
        function jx() {
          return Yl(this.__wrapped__, this.__actions__);
        }
        var Sx = ia(function(e, n, o) {
          it.call(e, o) ? ++e[o] : In(e, o, 1);
        });
        function wx(e, n, o) {
          var u = ze(e) ? ll : pp;
          return o && Wt(e, n, o) && (n = a), u(e, De(n, 3));
        }
        function Tx(e, n) {
          var o = ze(e) ? Kn : Dl;
          return o(e, De(n, 3));
        }
        var _x = oc(Ec), Ex = oc(Ac);
        function Ax(e, n) {
          return Pt(fa(e, n), 1);
        }
        function Ox(e, n) {
          return Pt(fa(e, n), ie);
        }
        function Rx(e, n, o) {
          return o = o === a ? 1 : We(o), Pt(fa(e, n), o);
        }
        function Ic(e, n) {
          var o = ze(e) ? ln : Zn;
          return o(e, De(n, 3));
        }
        function Lc(e, n) {
          var o = ze(e) ? qh : Pl;
          return o(e, De(n, 3));
        }
        var Px = ia(function(e, n, o) {
          it.call(e, o) ? e[o].push(n) : In(e, o, [n]);
        });
        function Dx(e, n, o, u) {
          e = qt(e) ? e : $r(e), o = o && !u ? We(o) : 0;
          var S = e.length;
          return o < 0 && (o = wt(S + o, 0)), va(e) ? o <= S && e.indexOf(n, o) > -1 : !!S && Or(e, n, o) > -1;
        }
        var Nx = Ue(function(e, n, o) {
          var u = -1, S = typeof n == "function", O = qt(e) ? Y(e.length) : [];
          return Zn(e, function(L) {
            O[++u] = S ? Qt(n, L, o) : ei(L, n, o);
          }), O;
        }), Ix = ia(function(e, n, o) {
          In(e, o, n);
        });
        function fa(e, n) {
          var o = ze(e) ? ht : kl;
          return o(e, De(n, 3));
        }
        function Lx(e, n, o, u) {
          return e == null ? [] : (ze(n) || (n = n == null ? [] : [n]), o = u ? a : o, ze(o) || (o = o == null ? [] : [o]), Wl(e, n, o));
        }
        var Fx = ia(function(e, n, o) {
          e[o ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function Mx(e, n, o) {
          var u = ze(e) ? no : hl, S = arguments.length < 3;
          return u(e, De(n, 4), o, S, Zn);
        }
        function kx(e, n, o) {
          var u = ze(e) ? Yh : hl, S = arguments.length < 3;
          return u(e, De(n, 4), o, S, Pl);
        }
        function zx(e, n) {
          var o = ze(e) ? Kn : Dl;
          return o(e, xa(De(n, 3)));
        }
        function Bx(e) {
          var n = ze(e) ? El : Dp;
          return n(e);
        }
        function $x(e, n, o) {
          (o ? Wt(e, n, o) : n === a) ? n = 1 : n = We(n);
          var u = ze(e) ? cp : Np;
          return u(e, n);
        }
        function Wx(e) {
          var n = ze(e) ? up : Lp;
          return n(e);
        }
        function Hx(e) {
          if (e == null)
            return 0;
          if (qt(e))
            return va(e) ? Pr(e) : e.length;
          var n = Mt(e);
          return n == Oe || n == xe ? e.size : jo(e).length;
        }
        function Vx(e, n, o) {
          var u = ze(e) ? ro : Fp;
          return o && Wt(e, n, o) && (n = a), u(e, De(n, 3));
        }
        var Ux = Ue(function(e, n) {
          if (e == null)
            return [];
          var o = n.length;
          return o > 1 && Wt(e, n[0], n[1]) ? n = [] : o > 2 && Wt(n[0], n[1], n[2]) && (n = [n[0]]), Wl(e, Pt(n, 1), []);
        }), pa = Tf || function() {
          return Rt.Date.now();
        };
        function Gx(e, n) {
          if (typeof n != "function")
            throw new cn(m);
          return e = We(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function Fc(e, n, o) {
          return n = o ? a : n, n = e && n == null ? e.length : n, Ln(e, y, a, a, a, a, n);
        }
        function Mc(e, n) {
          var o;
          if (typeof n != "function")
            throw new cn(m);
          return e = We(e), function() {
            return --e > 0 && (o = n.apply(this, arguments)), e <= 1 && (n = a), o;
          };
        }
        var Go = Ue(function(e, n, o) {
          var u = R;
          if (o.length) {
            var S = Yn(o, zr(Go));
            u |= x;
          }
          return Ln(e, u, n, o, S);
        }), kc = Ue(function(e, n, o) {
          var u = R | D;
          if (o.length) {
            var S = Yn(o, zr(kc));
            u |= x;
          }
          return Ln(n, u, e, o, S);
        });
        function zc(e, n, o) {
          n = o ? a : n;
          var u = Ln(e, F, a, a, a, a, a, n);
          return u.placeholder = zc.placeholder, u;
        }
        function Bc(e, n, o) {
          n = o ? a : n;
          var u = Ln(e, P, a, a, a, a, a, n);
          return u.placeholder = Bc.placeholder, u;
        }
        function $c(e, n, o) {
          var u, S, O, L, z, H, Q = 0, ee = !1, ae = !1, ge = !0;
          if (typeof e != "function")
            throw new cn(m);
          n = pn(n) || 0, ft(o) && (ee = !!o.leading, ae = "maxWait" in o, O = ae ? wt(pn(o.maxWait) || 0, n) : O, ge = "trailing" in o ? !!o.trailing : ge);
          function _e(yt) {
            var yn = u, Bn = S;
            return u = S = a, Q = yt, L = e.apply(Bn, yn), L;
          }
          function Ne(yt) {
            return Q = yt, z = ai(Ge, n), ee ? _e(yt) : L;
          }
          function Ve(yt) {
            var yn = yt - H, Bn = yt - Q, ou = n - yn;
            return ae ? Ft(ou, O - Bn) : ou;
          }
          function Ie(yt) {
            var yn = yt - H, Bn = yt - Q;
            return H === a || yn >= n || yn < 0 || ae && Bn >= O;
          }
          function Ge() {
            var yt = pa();
            if (Ie(yt))
              return Ze(yt);
            z = ai(Ge, Ve(yt));
          }
          function Ze(yt) {
            return z = a, ge && u ? _e(yt) : (u = S = a, L);
          }
          function rn() {
            z !== a && Zl(z), Q = 0, u = H = S = z = a;
          }
          function Ht() {
            return z === a ? L : Ze(pa());
          }
          function an() {
            var yt = pa(), yn = Ie(yt);
            if (u = arguments, S = this, H = yt, yn) {
              if (z === a)
                return Ne(H);
              if (ae)
                return Zl(z), z = ai(Ge, n), _e(H);
            }
            return z === a && (z = ai(Ge, n)), L;
          }
          return an.cancel = rn, an.flush = Ht, an;
        }
        var Kx = Ue(function(e, n) {
          return Rl(e, 1, n);
        }), qx = Ue(function(e, n, o) {
          return Rl(e, pn(n) || 0, o);
        });
        function Yx(e) {
          return Ln(e, M);
        }
        function ma(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new cn(m);
          var o = function() {
            var u = arguments, S = n ? n.apply(this, u) : u[0], O = o.cache;
            if (O.has(S))
              return O.get(S);
            var L = e.apply(this, u);
            return o.cache = O.set(S, L) || O, L;
          };
          return o.cache = new (ma.Cache || Nn)(), o;
        }
        ma.Cache = Nn;
        function xa(e) {
          if (typeof e != "function")
            throw new cn(m);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function Xx(e) {
          return Mc(2, e);
        }
        var Zx = Mp(function(e, n) {
          n = n.length == 1 && ze(n[0]) ? ht(n[0], en(De())) : ht(Pt(n, 1), en(De()));
          var o = n.length;
          return Ue(function(u) {
            for (var S = -1, O = Ft(u.length, o); ++S < O; )
              u[S] = n[S].call(this, u[S]);
            return Qt(e, this, u);
          });
        }), Ko = Ue(function(e, n) {
          var o = Yn(n, zr(Ko));
          return Ln(e, x, a, n, o);
        }), Wc = Ue(function(e, n) {
          var o = Yn(n, zr(Wc));
          return Ln(e, p, a, n, o);
        }), Jx = Fn(function(e, n) {
          return Ln(e, w, a, a, a, n);
        });
        function Qx(e, n) {
          if (typeof e != "function")
            throw new cn(m);
          return n = n === a ? n : We(n), Ue(e, n);
        }
        function eg(e, n) {
          if (typeof e != "function")
            throw new cn(m);
          return n = n == null ? 0 : wt(We(n), 0), Ue(function(o) {
            var u = o[n], S = er(o, 0, n);
            return u && qn(S, u), Qt(e, this, S);
          });
        }
        function tg(e, n, o) {
          var u = !0, S = !0;
          if (typeof e != "function")
            throw new cn(m);
          return ft(o) && (u = "leading" in o ? !!o.leading : u, S = "trailing" in o ? !!o.trailing : S), $c(e, n, {
            leading: u,
            maxWait: n,
            trailing: S
          });
        }
        function ng(e) {
          return Fc(e, 1);
        }
        function rg(e, n) {
          return Ko(Po(n), e);
        }
        function ig() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return ze(e) ? e : [e];
        }
        function ag(e) {
          return dn(e, b);
        }
        function og(e, n) {
          return n = typeof n == "function" ? n : a, dn(e, b, n);
        }
        function sg(e) {
          return dn(e, C | b);
        }
        function lg(e, n) {
          return n = typeof n == "function" ? n : a, dn(e, C | b, n);
        }
        function cg(e, n) {
          return n == null || Ol(e, n, Et(n));
        }
        function vn(e, n) {
          return e === n || e !== e && n !== n;
        }
        var ug = la(yo), dg = la(function(e, n) {
          return e >= n;
        }), vr = Ll(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Ll : function(e) {
          return mt(e) && it.call(e, "callee") && !Cl.call(e, "callee");
        }, ze = Y.isArray, hg = nl ? en(nl) : bp;
        function qt(e) {
          return e != null && ga(e.length) && !kn(e);
        }
        function vt(e) {
          return mt(e) && qt(e);
        }
        function fg(e) {
          return e === !0 || e === !1 || mt(e) && $t(e) == ce;
        }
        var tr = Ef || is, pg = rl ? en(rl) : Cp;
        function mg(e) {
          return mt(e) && e.nodeType === 1 && !oi(e);
        }
        function xg(e) {
          if (e == null)
            return !0;
          if (qt(e) && (ze(e) || typeof e == "string" || typeof e.splice == "function" || tr(e) || Br(e) || vr(e)))
            return !e.length;
          var n = Mt(e);
          if (n == Oe || n == xe)
            return !e.size;
          if (ii(e))
            return !jo(e).length;
          for (var o in e)
            if (it.call(e, o))
              return !1;
          return !0;
        }
        function gg(e, n) {
          return ti(e, n);
        }
        function vg(e, n, o) {
          o = typeof o == "function" ? o : a;
          var u = o ? o(e, n) : a;
          return u === a ? ti(e, n, a, o) : !!u;
        }
        function qo(e) {
          if (!mt(e))
            return !1;
          var n = $t(e);
          return n == ye || n == he || typeof e.message == "string" && typeof e.name == "string" && !oi(e);
        }
        function yg(e) {
          return typeof e == "number" && Sl(e);
        }
        function kn(e) {
          if (!ft(e))
            return !1;
          var n = $t(e);
          return n == Ee || n == ue || n == U || n == qe;
        }
        function Hc(e) {
          return typeof e == "number" && e == We(e);
        }
        function ga(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= K;
        }
        function ft(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function mt(e) {
          return e != null && typeof e == "object";
        }
        var Vc = il ? en(il) : Sp;
        function bg(e, n) {
          return e === n || Co(e, n, ko(n));
        }
        function Cg(e, n, o) {
          return o = typeof o == "function" ? o : a, Co(e, n, ko(n), o);
        }
        function jg(e) {
          return Uc(e) && e != +e;
        }
        function Sg(e) {
          if (om(e))
            throw new ke(c);
          return Fl(e);
        }
        function wg(e) {
          return e === null;
        }
        function Tg(e) {
          return e == null;
        }
        function Uc(e) {
          return typeof e == "number" || mt(e) && $t(e) == pe;
        }
        function oi(e) {
          if (!mt(e) || $t(e) != Ae)
            return !1;
          var n = Vi(e);
          if (n === null)
            return !0;
          var o = it.call(n, "constructor") && n.constructor;
          return typeof o == "function" && o instanceof o && Bi.call(o) == Cf;
        }
        var Yo = al ? en(al) : wp;
        function _g(e) {
          return Hc(e) && e >= -K && e <= K;
        }
        var Gc = ol ? en(ol) : Tp;
        function va(e) {
          return typeof e == "string" || !ze(e) && mt(e) && $t(e) == Se;
        }
        function nn(e) {
          return typeof e == "symbol" || mt(e) && $t(e) == Te;
        }
        var Br = sl ? en(sl) : _p;
        function Eg(e) {
          return e === a;
        }
        function Ag(e) {
          return mt(e) && Mt(e) == et;
        }
        function Og(e) {
          return mt(e) && $t(e) == Be;
        }
        var Rg = la(So), Pg = la(function(e, n) {
          return e <= n;
        });
        function Kc(e) {
          if (!e)
            return [];
          if (qt(e))
            return va(e) ? xn(e) : Kt(e);
          if (Kr && e[Kr])
            return cf(e[Kr]());
          var n = Mt(e), o = n == Oe ? co : n == xe ? Mi : $r;
          return o(e);
        }
        function zn(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = pn(e), e === ie || e === -ie) {
            var n = e < 0 ? -1 : 1;
            return n * N;
          }
          return e === e ? e : 0;
        }
        function We(e) {
          var n = zn(e), o = n % 1;
          return n === n ? o ? n - o : n : 0;
        }
        function qc(e) {
          return e ? pr(We(e), 0, oe) : 0;
        }
        function pn(e) {
          if (typeof e == "number")
            return e;
          if (nn(e))
            return B;
          if (ft(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ft(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = fl(e);
          var o = dh.test(e);
          return o || fh.test(e) ? Uh(e.slice(2), o ? 2 : 8) : uh.test(e) ? B : +e;
        }
        function Yc(e) {
          return Sn(e, Yt(e));
        }
        function Dg(e) {
          return e ? pr(We(e), -K, K) : e === 0 ? e : 0;
        }
        function nt(e) {
          return e == null ? "" : tn(e);
        }
        var Ng = Mr(function(e, n) {
          if (ii(n) || qt(n)) {
            Sn(n, Et(n), e);
            return;
          }
          for (var o in n)
            it.call(n, o) && Jr(e, o, n[o]);
        }), Xc = Mr(function(e, n) {
          Sn(n, Yt(n), e);
        }), ya = Mr(function(e, n, o, u) {
          Sn(n, Yt(n), e, u);
        }), Ig = Mr(function(e, n, o, u) {
          Sn(n, Et(n), e, u);
        }), Lg = Fn(xo);
        function Fg(e, n) {
          var o = Fr(e);
          return n == null ? o : Al(o, n);
        }
        var Mg = Ue(function(e, n) {
          e = ot(e);
          var o = -1, u = n.length, S = u > 2 ? n[2] : a;
          for (S && Wt(n[0], n[1], S) && (u = 1); ++o < u; )
            for (var O = n[o], L = Yt(O), z = -1, H = L.length; ++z < H; ) {
              var Q = L[z], ee = e[Q];
              (ee === a || vn(ee, Nr[Q]) && !it.call(e, Q)) && (e[Q] = O[Q]);
            }
          return e;
        }), kg = Ue(function(e) {
          return e.push(a, fc), Qt(Zc, a, e);
        });
        function zg(e, n) {
          return cl(e, De(n, 3), jn);
        }
        function Bg(e, n) {
          return cl(e, De(n, 3), vo);
        }
        function $g(e, n) {
          return e == null ? e : go(e, De(n, 3), Yt);
        }
        function Wg(e, n) {
          return e == null ? e : Nl(e, De(n, 3), Yt);
        }
        function Hg(e, n) {
          return e && jn(e, De(n, 3));
        }
        function Vg(e, n) {
          return e && vo(e, De(n, 3));
        }
        function Ug(e) {
          return e == null ? [] : ea(e, Et(e));
        }
        function Gg(e) {
          return e == null ? [] : ea(e, Yt(e));
        }
        function Xo(e, n, o) {
          var u = e == null ? a : mr(e, n);
          return u === a ? o : u;
        }
        function Kg(e, n) {
          return e != null && xc(e, n, xp);
        }
        function Zo(e, n) {
          return e != null && xc(e, n, gp);
        }
        var qg = lc(function(e, n, o) {
          n != null && typeof n.toString != "function" && (n = $i.call(n)), e[n] = o;
        }, Qo(Xt)), Yg = lc(function(e, n, o) {
          n != null && typeof n.toString != "function" && (n = $i.call(n)), it.call(e, n) ? e[n].push(o) : e[n] = [o];
        }, De), Xg = Ue(ei);
        function Et(e) {
          return qt(e) ? _l(e) : jo(e);
        }
        function Yt(e) {
          return qt(e) ? _l(e, !0) : Ep(e);
        }
        function Zg(e, n) {
          var o = {};
          return n = De(n, 3), jn(e, function(u, S, O) {
            In(o, n(u, S, O), u);
          }), o;
        }
        function Jg(e, n) {
          var o = {};
          return n = De(n, 3), jn(e, function(u, S, O) {
            In(o, S, n(u, S, O));
          }), o;
        }
        var Qg = Mr(function(e, n, o) {
          ta(e, n, o);
        }), Zc = Mr(function(e, n, o, u) {
          ta(e, n, o, u);
        }), ev = Fn(function(e, n) {
          var o = {};
          if (e == null)
            return o;
          var u = !1;
          n = ht(n, function(O) {
            return O = Qn(O, e), u || (u = O.length > 1), O;
          }), Sn(e, Fo(e), o), u && (o = dn(o, C | v | b, qp));
          for (var S = n.length; S--; )
            Ao(o, n[S]);
          return o;
        });
        function tv(e, n) {
          return Jc(e, xa(De(n)));
        }
        var nv = Fn(function(e, n) {
          return e == null ? {} : Op(e, n);
        });
        function Jc(e, n) {
          if (e == null)
            return {};
          var o = ht(Fo(e), function(u) {
            return [u];
          });
          return n = De(n), Hl(e, o, function(u, S) {
            return n(u, S[0]);
          });
        }
        function rv(e, n, o) {
          n = Qn(n, e);
          var u = -1, S = n.length;
          for (S || (S = 1, e = a); ++u < S; ) {
            var O = e == null ? a : e[wn(n[u])];
            O === a && (u = S, O = o), e = kn(O) ? O.call(e) : O;
          }
          return e;
        }
        function iv(e, n, o) {
          return e == null ? e : ni(e, n, o);
        }
        function av(e, n, o, u) {
          return u = typeof u == "function" ? u : a, e == null ? e : ni(e, n, o, u);
        }
        var Qc = dc(Et), eu = dc(Yt);
        function ov(e, n, o) {
          var u = ze(e), S = u || tr(e) || Br(e);
          if (n = De(n, 4), o == null) {
            var O = e && e.constructor;
            S ? o = u ? new O() : [] : ft(e) ? o = kn(O) ? Fr(Vi(e)) : {} : o = {};
          }
          return (S ? ln : jn)(e, function(L, z, H) {
            return n(o, L, z, H);
          }), o;
        }
        function sv(e, n) {
          return e == null ? !0 : Ao(e, n);
        }
        function lv(e, n, o) {
          return e == null ? e : ql(e, n, Po(o));
        }
        function cv(e, n, o, u) {
          return u = typeof u == "function" ? u : a, e == null ? e : ql(e, n, Po(o), u);
        }
        function $r(e) {
          return e == null ? [] : lo(e, Et(e));
        }
        function uv(e) {
          return e == null ? [] : lo(e, Yt(e));
        }
        function dv(e, n, o) {
          return o === a && (o = n, n = a), o !== a && (o = pn(o), o = o === o ? o : 0), n !== a && (n = pn(n), n = n === n ? n : 0), pr(pn(e), n, o);
        }
        function hv(e, n, o) {
          return n = zn(n), o === a ? (o = n, n = 0) : o = zn(o), e = pn(e), vp(e, n, o);
        }
        function fv(e, n, o) {
          if (o && typeof o != "boolean" && Wt(e, n, o) && (n = o = a), o === a && (typeof n == "boolean" ? (o = n, n = a) : typeof e == "boolean" && (o = e, e = a)), e === a && n === a ? (e = 0, n = 1) : (e = zn(e), n === a ? (n = e, e = 0) : n = zn(n)), e > n) {
            var u = e;
            e = n, n = u;
          }
          if (o || e % 1 || n % 1) {
            var S = wl();
            return Ft(e + S * (n - e + Vh("1e-" + ((S + "").length - 1))), n);
          }
          return To(e, n);
        }
        var pv = kr(function(e, n, o) {
          return n = n.toLowerCase(), e + (o ? tu(n) : n);
        });
        function tu(e) {
          return Jo(nt(e).toLowerCase());
        }
        function nu(e) {
          return e = nt(e), e && e.replace(mh, rf).replace(Ih, "");
        }
        function mv(e, n, o) {
          e = nt(e), n = tn(n);
          var u = e.length;
          o = o === a ? u : pr(We(o), 0, u);
          var S = o;
          return o -= n.length, o >= 0 && e.slice(o, S) == n;
        }
        function xv(e) {
          return e = nt(e), e && Lt.test(e) ? e.replace(Gt, af) : e;
        }
        function gv(e) {
          return e = nt(e), e && th.test(e) ? e.replace(Pi, "\\$&") : e;
        }
        var vv = kr(function(e, n, o) {
          return e + (o ? "-" : "") + n.toLowerCase();
        }), yv = kr(function(e, n, o) {
          return e + (o ? " " : "") + n.toLowerCase();
        }), bv = ac("toLowerCase");
        function Cv(e, n, o) {
          e = nt(e), n = We(n);
          var u = n ? Pr(e) : 0;
          if (!n || u >= n)
            return e;
          var S = (n - u) / 2;
          return sa(qi(S), o) + e + sa(Ki(S), o);
        }
        function jv(e, n, o) {
          e = nt(e), n = We(n);
          var u = n ? Pr(e) : 0;
          return n && u < n ? e + sa(n - u, o) : e;
        }
        function Sv(e, n, o) {
          e = nt(e), n = We(n);
          var u = n ? Pr(e) : 0;
          return n && u < n ? sa(n - u, o) + e : e;
        }
        function wv(e, n, o) {
          return o || n == null ? n = 0 : n && (n = +n), Pf(nt(e).replace(Ka, ""), n || 0);
        }
        function Tv(e, n, o) {
          return (o ? Wt(e, n, o) : n === a) ? n = 1 : n = We(n), _o(nt(e), n);
        }
        function _v() {
          var e = arguments, n = nt(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var Ev = kr(function(e, n, o) {
          return e + (o ? "_" : "") + n.toLowerCase();
        });
        function Av(e, n, o) {
          return o && typeof o != "number" && Wt(e, n, o) && (n = o = a), o = o === a ? oe : o >>> 0, o ? (e = nt(e), e && (typeof n == "string" || n != null && !Yo(n)) && (n = tn(n), !n && Rr(e)) ? er(xn(e), 0, o) : e.split(n, o)) : [];
        }
        var Ov = kr(function(e, n, o) {
          return e + (o ? " " : "") + Jo(n);
        });
        function Rv(e, n, o) {
          return e = nt(e), o = o == null ? 0 : pr(We(o), 0, e.length), n = tn(n), e.slice(o, o + n.length) == n;
        }
        function Pv(e, n, o) {
          var u = T.templateSettings;
          o && Wt(e, n, o) && (n = a), e = nt(e), n = ya({}, n, u, hc);
          var S = ya({}, n.imports, u.imports, hc), O = Et(S), L = lo(S, O), z, H, Q = 0, ee = n.interpolate || Di, ae = "__p += '", ge = uo(
            (n.escape || Di).source + "|" + ee.source + "|" + (ee === Ri ? ch : Di).source + "|" + (n.evaluate || Di).source + "|$",
            "g"
          ), _e = "//# sourceURL=" + (it.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++zh + "]") + `
`;
          e.replace(ge, function(Ie, Ge, Ze, rn, Ht, an) {
            return Ze || (Ze = rn), ae += e.slice(Q, an).replace(xh, of), Ge && (z = !0, ae += `' +
__e(` + Ge + `) +
'`), Ht && (H = !0, ae += `';
` + Ht + `;
__p += '`), Ze && (ae += `' +
((__t = (` + Ze + `)) == null ? '' : __t) +
'`), Q = an + Ie.length, Ie;
          }), ae += `';
`;
          var Ne = it.call(n, "variable") && n.variable;
          if (!Ne)
            ae = `with (obj) {
` + ae + `
}
`;
          else if (sh.test(Ne))
            throw new ke(j);
          ae = (H ? ae.replace(Bt, "") : ae).replace(Ut, "$1").replace(Tr, "$1;"), ae = "function(" + (Ne || "obj") + `) {
` + (Ne ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (z ? ", __e = _.escape" : "") + (H ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ae + `return __p
}`;
          var Ve = iu(function() {
            return tt(O, _e + "return " + ae).apply(a, L);
          });
          if (Ve.source = ae, qo(Ve))
            throw Ve;
          return Ve;
        }
        function Dv(e) {
          return nt(e).toLowerCase();
        }
        function Nv(e) {
          return nt(e).toUpperCase();
        }
        function Iv(e, n, o) {
          if (e = nt(e), e && (o || n === a))
            return fl(e);
          if (!e || !(n = tn(n)))
            return e;
          var u = xn(e), S = xn(n), O = pl(u, S), L = ml(u, S) + 1;
          return er(u, O, L).join("");
        }
        function Lv(e, n, o) {
          if (e = nt(e), e && (o || n === a))
            return e.slice(0, gl(e) + 1);
          if (!e || !(n = tn(n)))
            return e;
          var u = xn(e), S = ml(u, xn(n)) + 1;
          return er(u, 0, S).join("");
        }
        function Fv(e, n, o) {
          if (e = nt(e), e && (o || n === a))
            return e.replace(Ka, "");
          if (!e || !(n = tn(n)))
            return e;
          var u = xn(e), S = pl(u, xn(n));
          return er(u, S).join("");
        }
        function Mv(e, n) {
          var o = V, u = q;
          if (ft(n)) {
            var S = "separator" in n ? n.separator : S;
            o = "length" in n ? We(n.length) : o, u = "omission" in n ? tn(n.omission) : u;
          }
          e = nt(e);
          var O = e.length;
          if (Rr(e)) {
            var L = xn(e);
            O = L.length;
          }
          if (o >= O)
            return e;
          var z = o - Pr(u);
          if (z < 1)
            return u;
          var H = L ? er(L, 0, z).join("") : e.slice(0, z);
          if (S === a)
            return H + u;
          if (L && (z += H.length - z), Yo(S)) {
            if (e.slice(z).search(S)) {
              var Q, ee = H;
              for (S.global || (S = uo(S.source, nt(Ls.exec(S)) + "g")), S.lastIndex = 0; Q = S.exec(ee); )
                var ae = Q.index;
              H = H.slice(0, ae === a ? z : ae);
            }
          } else if (e.indexOf(tn(S), z) != z) {
            var ge = H.lastIndexOf(S);
            ge > -1 && (H = H.slice(0, ge));
          }
          return H + u;
        }
        function kv(e) {
          return e = nt(e), e && Pn.test(e) ? e.replace(gt, ff) : e;
        }
        var zv = kr(function(e, n, o) {
          return e + (o ? " " : "") + n.toUpperCase();
        }), Jo = ac("toUpperCase");
        function ru(e, n, o) {
          return e = nt(e), n = o ? a : n, n === a ? lf(e) ? xf(e) : Jh(e) : e.match(n) || [];
        }
        var iu = Ue(function(e, n) {
          try {
            return Qt(e, a, n);
          } catch (o) {
            return qo(o) ? o : new ke(o);
          }
        }), Bv = Fn(function(e, n) {
          return ln(n, function(o) {
            o = wn(o), In(e, o, Go(e[o], e));
          }), e;
        });
        function $v(e) {
          var n = e == null ? 0 : e.length, o = De();
          return e = n ? ht(e, function(u) {
            if (typeof u[1] != "function")
              throw new cn(m);
            return [o(u[0]), u[1]];
          }) : [], Ue(function(u) {
            for (var S = -1; ++S < n; ) {
              var O = e[S];
              if (Qt(O[0], this, u))
                return Qt(O[1], this, u);
            }
          });
        }
        function Wv(e) {
          return fp(dn(e, C));
        }
        function Qo(e) {
          return function() {
            return e;
          };
        }
        function Hv(e, n) {
          return e == null || e !== e ? n : e;
        }
        var Vv = sc(), Uv = sc(!0);
        function Xt(e) {
          return e;
        }
        function es(e) {
          return Ml(typeof e == "function" ? e : dn(e, C));
        }
        function Gv(e) {
          return zl(dn(e, C));
        }
        function Kv(e, n) {
          return Bl(e, dn(n, C));
        }
        var qv = Ue(function(e, n) {
          return function(o) {
            return ei(o, e, n);
          };
        }), Yv = Ue(function(e, n) {
          return function(o) {
            return ei(e, o, n);
          };
        });
        function ts(e, n, o) {
          var u = Et(n), S = ea(n, u);
          o == null && !(ft(n) && (S.length || !u.length)) && (o = n, n = e, e = this, S = ea(n, Et(n)));
          var O = !(ft(o) && "chain" in o) || !!o.chain, L = kn(e);
          return ln(S, function(z) {
            var H = n[z];
            e[z] = H, L && (e.prototype[z] = function() {
              var Q = this.__chain__;
              if (O || Q) {
                var ee = e(this.__wrapped__), ae = ee.__actions__ = Kt(this.__actions__);
                return ae.push({ func: H, args: arguments, thisArg: e }), ee.__chain__ = Q, ee;
              }
              return H.apply(e, qn([this.value()], arguments));
            });
          }), e;
        }
        function Xv() {
          return Rt._ === this && (Rt._ = jf), this;
        }
        function ns() {
        }
        function Zv(e) {
          return e = We(e), Ue(function(n) {
            return $l(n, e);
          });
        }
        var Jv = No(ht), Qv = No(ll), e0 = No(ro);
        function au(e) {
          return Bo(e) ? io(wn(e)) : Rp(e);
        }
        function t0(e) {
          return function(n) {
            return e == null ? a : mr(e, n);
          };
        }
        var n0 = cc(), r0 = cc(!0);
        function rs() {
          return [];
        }
        function is() {
          return !1;
        }
        function i0() {
          return {};
        }
        function a0() {
          return "";
        }
        function o0() {
          return !0;
        }
        function s0(e, n) {
          if (e = We(e), e < 1 || e > K)
            return [];
          var o = oe, u = Ft(e, oe);
          n = De(n), e -= oe;
          for (var S = so(u, n); ++o < e; )
            n(o);
          return S;
        }
        function l0(e) {
          return ze(e) ? ht(e, wn) : nn(e) ? [e] : Kt(Tc(nt(e)));
        }
        function c0(e) {
          var n = ++bf;
          return nt(e) + n;
        }
        var u0 = oa(function(e, n) {
          return e + n;
        }, 0), d0 = Io("ceil"), h0 = oa(function(e, n) {
          return e / n;
        }, 1), f0 = Io("floor");
        function p0(e) {
          return e && e.length ? Qi(e, Xt, yo) : a;
        }
        function m0(e, n) {
          return e && e.length ? Qi(e, De(n, 2), yo) : a;
        }
        function x0(e) {
          return dl(e, Xt);
        }
        function g0(e, n) {
          return dl(e, De(n, 2));
        }
        function v0(e) {
          return e && e.length ? Qi(e, Xt, So) : a;
        }
        function y0(e, n) {
          return e && e.length ? Qi(e, De(n, 2), So) : a;
        }
        var b0 = oa(function(e, n) {
          return e * n;
        }, 1), C0 = Io("round"), j0 = oa(function(e, n) {
          return e - n;
        }, 0);
        function S0(e) {
          return e && e.length ? oo(e, Xt) : 0;
        }
        function w0(e, n) {
          return e && e.length ? oo(e, De(n, 2)) : 0;
        }
        return T.after = Gx, T.ary = Fc, T.assign = Ng, T.assignIn = Xc, T.assignInWith = ya, T.assignWith = Ig, T.at = Lg, T.before = Mc, T.bind = Go, T.bindAll = Bv, T.bindKey = kc, T.castArray = ig, T.chain = Nc, T.chunk = fm, T.compact = pm, T.concat = mm, T.cond = $v, T.conforms = Wv, T.constant = Qo, T.countBy = Sx, T.create = Fg, T.curry = zc, T.curryRight = Bc, T.debounce = $c, T.defaults = Mg, T.defaultsDeep = kg, T.defer = Kx, T.delay = qx, T.difference = xm, T.differenceBy = gm, T.differenceWith = vm, T.drop = ym, T.dropRight = bm, T.dropRightWhile = Cm, T.dropWhile = jm, T.fill = Sm, T.filter = Tx, T.flatMap = Ax, T.flatMapDeep = Ox, T.flatMapDepth = Rx, T.flatten = Oc, T.flattenDeep = wm, T.flattenDepth = Tm, T.flip = Yx, T.flow = Vv, T.flowRight = Uv, T.fromPairs = _m, T.functions = Ug, T.functionsIn = Gg, T.groupBy = Px, T.initial = Am, T.intersection = Om, T.intersectionBy = Rm, T.intersectionWith = Pm, T.invert = qg, T.invertBy = Yg, T.invokeMap = Nx, T.iteratee = es, T.keyBy = Ix, T.keys = Et, T.keysIn = Yt, T.map = fa, T.mapKeys = Zg, T.mapValues = Jg, T.matches = Gv, T.matchesProperty = Kv, T.memoize = ma, T.merge = Qg, T.mergeWith = Zc, T.method = qv, T.methodOf = Yv, T.mixin = ts, T.negate = xa, T.nthArg = Zv, T.omit = ev, T.omitBy = tv, T.once = Xx, T.orderBy = Lx, T.over = Jv, T.overArgs = Zx, T.overEvery = Qv, T.overSome = e0, T.partial = Ko, T.partialRight = Wc, T.partition = Fx, T.pick = nv, T.pickBy = Jc, T.property = au, T.propertyOf = t0, T.pull = Lm, T.pullAll = Pc, T.pullAllBy = Fm, T.pullAllWith = Mm, T.pullAt = km, T.range = n0, T.rangeRight = r0, T.rearg = Jx, T.reject = zx, T.remove = zm, T.rest = Qx, T.reverse = Vo, T.sampleSize = $x, T.set = iv, T.setWith = av, T.shuffle = Wx, T.slice = Bm, T.sortBy = Ux, T.sortedUniq = Km, T.sortedUniqBy = qm, T.split = Av, T.spread = eg, T.tail = Ym, T.take = Xm, T.takeRight = Zm, T.takeRightWhile = Jm, T.takeWhile = Qm, T.tap = px, T.throttle = tg, T.thru = ha, T.toArray = Kc, T.toPairs = Qc, T.toPairsIn = eu, T.toPath = l0, T.toPlainObject = Yc, T.transform = ov, T.unary = ng, T.union = ex, T.unionBy = tx, T.unionWith = nx, T.uniq = rx, T.uniqBy = ix, T.uniqWith = ax, T.unset = sv, T.unzip = Uo, T.unzipWith = Dc, T.update = lv, T.updateWith = cv, T.values = $r, T.valuesIn = uv, T.without = ox, T.words = ru, T.wrap = rg, T.xor = sx, T.xorBy = lx, T.xorWith = cx, T.zip = ux, T.zipObject = dx, T.zipObjectDeep = hx, T.zipWith = fx, T.entries = Qc, T.entriesIn = eu, T.extend = Xc, T.extendWith = ya, ts(T, T), T.add = u0, T.attempt = iu, T.camelCase = pv, T.capitalize = tu, T.ceil = d0, T.clamp = dv, T.clone = ag, T.cloneDeep = sg, T.cloneDeepWith = lg, T.cloneWith = og, T.conformsTo = cg, T.deburr = nu, T.defaultTo = Hv, T.divide = h0, T.endsWith = mv, T.eq = vn, T.escape = xv, T.escapeRegExp = gv, T.every = wx, T.find = _x, T.findIndex = Ec, T.findKey = zg, T.findLast = Ex, T.findLastIndex = Ac, T.findLastKey = Bg, T.floor = f0, T.forEach = Ic, T.forEachRight = Lc, T.forIn = $g, T.forInRight = Wg, T.forOwn = Hg, T.forOwnRight = Vg, T.get = Xo, T.gt = ug, T.gte = dg, T.has = Kg, T.hasIn = Zo, T.head = Rc, T.identity = Xt, T.includes = Dx, T.indexOf = Em, T.inRange = hv, T.invoke = Xg, T.isArguments = vr, T.isArray = ze, T.isArrayBuffer = hg, T.isArrayLike = qt, T.isArrayLikeObject = vt, T.isBoolean = fg, T.isBuffer = tr, T.isDate = pg, T.isElement = mg, T.isEmpty = xg, T.isEqual = gg, T.isEqualWith = vg, T.isError = qo, T.isFinite = yg, T.isFunction = kn, T.isInteger = Hc, T.isLength = ga, T.isMap = Vc, T.isMatch = bg, T.isMatchWith = Cg, T.isNaN = jg, T.isNative = Sg, T.isNil = Tg, T.isNull = wg, T.isNumber = Uc, T.isObject = ft, T.isObjectLike = mt, T.isPlainObject = oi, T.isRegExp = Yo, T.isSafeInteger = _g, T.isSet = Gc, T.isString = va, T.isSymbol = nn, T.isTypedArray = Br, T.isUndefined = Eg, T.isWeakMap = Ag, T.isWeakSet = Og, T.join = Dm, T.kebabCase = vv, T.last = fn, T.lastIndexOf = Nm, T.lowerCase = yv, T.lowerFirst = bv, T.lt = Rg, T.lte = Pg, T.max = p0, T.maxBy = m0, T.mean = x0, T.meanBy = g0, T.min = v0, T.minBy = y0, T.stubArray = rs, T.stubFalse = is, T.stubObject = i0, T.stubString = a0, T.stubTrue = o0, T.multiply = b0, T.nth = Im, T.noConflict = Xv, T.noop = ns, T.now = pa, T.pad = Cv, T.padEnd = jv, T.padStart = Sv, T.parseInt = wv, T.random = fv, T.reduce = Mx, T.reduceRight = kx, T.repeat = Tv, T.replace = _v, T.result = rv, T.round = C0, T.runInContext = W, T.sample = Bx, T.size = Hx, T.snakeCase = Ev, T.some = Vx, T.sortedIndex = $m, T.sortedIndexBy = Wm, T.sortedIndexOf = Hm, T.sortedLastIndex = Vm, T.sortedLastIndexBy = Um, T.sortedLastIndexOf = Gm, T.startCase = Ov, T.startsWith = Rv, T.subtract = j0, T.sum = S0, T.sumBy = w0, T.template = Pv, T.times = s0, T.toFinite = zn, T.toInteger = We, T.toLength = qc, T.toLower = Dv, T.toNumber = pn, T.toSafeInteger = Dg, T.toString = nt, T.toUpper = Nv, T.trim = Iv, T.trimEnd = Lv, T.trimStart = Fv, T.truncate = Mv, T.unescape = kv, T.uniqueId = c0, T.upperCase = zv, T.upperFirst = Jo, T.each = Ic, T.eachRight = Lc, T.first = Rc, ts(T, function() {
          var e = {};
          return jn(T, function(n, o) {
            it.call(T.prototype, o) || (e[o] = n);
          }), e;
        }(), { chain: !1 }), T.VERSION = s, ln(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          T[e].placeholder = T;
        }), ln(["drop", "take"], function(e, n) {
          Ye.prototype[e] = function(o) {
            o = o === a ? 1 : wt(We(o), 0);
            var u = this.__filtered__ && !n ? new Ye(this) : this.clone();
            return u.__filtered__ ? u.__takeCount__ = Ft(o, u.__takeCount__) : u.__views__.push({
              size: Ft(o, oe),
              type: e + (u.__dir__ < 0 ? "Right" : "")
            }), u;
          }, Ye.prototype[e + "Right"] = function(o) {
            return this.reverse()[e](o).reverse();
          };
        }), ln(["filter", "map", "takeWhile"], function(e, n) {
          var o = n + 1, u = o == k || o == X;
          Ye.prototype[e] = function(S) {
            var O = this.clone();
            return O.__iteratees__.push({
              iteratee: De(S, 3),
              type: o
            }), O.__filtered__ = O.__filtered__ || u, O;
          };
        }), ln(["head", "last"], function(e, n) {
          var o = "take" + (n ? "Right" : "");
          Ye.prototype[e] = function() {
            return this[o](1).value()[0];
          };
        }), ln(["initial", "tail"], function(e, n) {
          var o = "drop" + (n ? "" : "Right");
          Ye.prototype[e] = function() {
            return this.__filtered__ ? new Ye(this) : this[o](1);
          };
        }), Ye.prototype.compact = function() {
          return this.filter(Xt);
        }, Ye.prototype.find = function(e) {
          return this.filter(e).head();
        }, Ye.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, Ye.prototype.invokeMap = Ue(function(e, n) {
          return typeof e == "function" ? new Ye(this) : this.map(function(o) {
            return ei(o, e, n);
          });
        }), Ye.prototype.reject = function(e) {
          return this.filter(xa(De(e)));
        }, Ye.prototype.slice = function(e, n) {
          e = We(e);
          var o = this;
          return o.__filtered__ && (e > 0 || n < 0) ? new Ye(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), n !== a && (n = We(n), o = n < 0 ? o.dropRight(-n) : o.take(n - e)), o);
        }, Ye.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, Ye.prototype.toArray = function() {
          return this.take(oe);
        }, jn(Ye.prototype, function(e, n) {
          var o = /^(?:filter|find|map|reject)|While$/.test(n), u = /^(?:head|last)$/.test(n), S = T[u ? "take" + (n == "last" ? "Right" : "") : n], O = u || /^find/.test(n);
          S && (T.prototype[n] = function() {
            var L = this.__wrapped__, z = u ? [1] : arguments, H = L instanceof Ye, Q = z[0], ee = H || ze(L), ae = function(Ge) {
              var Ze = S.apply(T, qn([Ge], z));
              return u && ge ? Ze[0] : Ze;
            };
            ee && o && typeof Q == "function" && Q.length != 1 && (H = ee = !1);
            var ge = this.__chain__, _e = !!this.__actions__.length, Ne = O && !ge, Ve = H && !_e;
            if (!O && ee) {
              L = Ve ? L : new Ye(this);
              var Ie = e.apply(L, z);
              return Ie.__actions__.push({ func: ha, args: [ae], thisArg: a }), new un(Ie, ge);
            }
            return Ne && Ve ? e.apply(this, z) : (Ie = this.thru(ae), Ne ? u ? Ie.value()[0] : Ie.value() : Ie);
          });
        }), ln(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = ki[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(e);
          T.prototype[e] = function() {
            var S = arguments;
            if (u && !this.__chain__) {
              var O = this.value();
              return n.apply(ze(O) ? O : [], S);
            }
            return this[o](function(L) {
              return n.apply(ze(L) ? L : [], S);
            });
          };
        }), jn(Ye.prototype, function(e, n) {
          var o = T[n];
          if (o) {
            var u = o.name + "";
            it.call(Lr, u) || (Lr[u] = []), Lr[u].push({ name: n, func: o });
          }
        }), Lr[aa(a, D).name] = [{
          name: "wrapper",
          func: a
        }], Ye.prototype.clone = kf, Ye.prototype.reverse = zf, Ye.prototype.value = Bf, T.prototype.at = mx, T.prototype.chain = xx, T.prototype.commit = gx, T.prototype.next = vx, T.prototype.plant = bx, T.prototype.reverse = Cx, T.prototype.toJSON = T.prototype.valueOf = T.prototype.value = jx, T.prototype.first = T.prototype.head, Kr && (T.prototype[Kr] = yx), T;
      }, Dr = gf();
      ur ? ((ur.exports = Dr)._ = Dr, Qa._ = Dr) : Rt._ = Dr;
    }).call(Wr);
  }(di, di.exports)), di.exports;
}
var hs = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
var Nu;
function j1() {
  return Nu || (Nu = 1, function(r) {
    (function(i, a) {
      r.exports ? r.exports = a() : i.numeral = a();
    })(Wr, function() {
      var i, a, s = "2.0.6", l = {}, c = {}, m = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: !0
      }, j = {
        currentLocale: m.currentLocale,
        zeroFormat: m.zeroFormat,
        nullFormat: m.nullFormat,
        defaultFormat: m.defaultFormat,
        scalePercentBy100: m.scalePercentBy100
      };
      function h(d, f) {
        this._input = d, this._value = f;
      }
      return i = function(d) {
        var f, C, v, b;
        if (i.isNumeral(d))
          f = d.value();
        else if (d === 0 || typeof d > "u")
          f = 0;
        else if (d === null || a.isNaN(d))
          f = null;
        else if (typeof d == "string")
          if (j.zeroFormat && d === j.zeroFormat)
            f = 0;
          else if (j.nullFormat && d === j.nullFormat || !d.replace(/[^0-9]+/g, "").length)
            f = null;
          else {
            for (C in l)
              if (b = typeof l[C].regexps.unformat == "function" ? l[C].regexps.unformat() : l[C].regexps.unformat, b && d.match(b)) {
                v = l[C].unformat;
                break;
              }
            v = v || i._.stringToNumber, f = v(d);
          }
        else
          f = Number(d) || null;
        return new h(d, f);
      }, i.version = s, i.isNumeral = function(d) {
        return d instanceof h;
      }, i._ = a = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(d, f, C) {
          var v = c[i.options.currentLocale], b = !1, E = !1, A = 0, R = "", D = 1e12, _ = 1e9, F = 1e6, P = 1e3, x = "", p = !1, y, w, M, V, q, $, I;
          if (d = d || 0, w = Math.abs(d), i._.includes(f, "(") ? (b = !0, f = f.replace(/[\(|\)]/g, "")) : (i._.includes(f, "+") || i._.includes(f, "-")) && (q = i._.includes(f, "+") ? f.indexOf("+") : d < 0 ? f.indexOf("-") : -1, f = f.replace(/[\+|\-]/g, "")), i._.includes(f, "a") && (y = f.match(/a(k|m|b|t)?/), y = y ? y[1] : !1, i._.includes(f, " a") && (R = " "), f = f.replace(new RegExp(R + "a[kmbt]?"), ""), w >= D && !y || y === "t" ? (R += v.abbreviations.trillion, d = d / D) : w < D && w >= _ && !y || y === "b" ? (R += v.abbreviations.billion, d = d / _) : w < _ && w >= F && !y || y === "m" ? (R += v.abbreviations.million, d = d / F) : (w < F && w >= P && !y || y === "k") && (R += v.abbreviations.thousand, d = d / P)), i._.includes(f, "[.]") && (E = !0, f = f.replace("[.]", ".")), M = d.toString().split(".")[0], V = f.split(".")[1], $ = f.indexOf(","), A = (f.split(".")[0].split(",")[0].match(/0/g) || []).length, V ? (i._.includes(V, "[") ? (V = V.replace("]", ""), V = V.split("["), x = i._.toFixed(d, V[0].length + V[1].length, C, V[1].length)) : x = i._.toFixed(d, V.length, C), M = x.split(".")[0], i._.includes(x, ".") ? x = v.delimiters.decimal + x.split(".")[1] : x = "", E && Number(x.slice(1)) === 0 && (x = "")) : M = i._.toFixed(d, 0, C), R && !y && Number(M) >= 1e3 && R !== v.abbreviations.trillion)
            switch (M = String(Number(M) / 1e3), R) {
              case v.abbreviations.thousand:
                R = v.abbreviations.million;
                break;
              case v.abbreviations.million:
                R = v.abbreviations.billion;
                break;
              case v.abbreviations.billion:
                R = v.abbreviations.trillion;
                break;
            }
          if (i._.includes(M, "-") && (M = M.slice(1), p = !0), M.length < A)
            for (var k = A - M.length; k > 0; k--)
              M = "0" + M;
          return $ > -1 && (M = M.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + v.delimiters.thousands)), f.indexOf(".") === 0 && (M = ""), I = M + x + (R || ""), b ? I = (b && p ? "(" : "") + I + (b && p ? ")" : "") : q >= 0 ? I = q === 0 ? (p ? "-" : "+") + I : I + (p ? "-" : "+") : p && (I = "-" + I), I;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(d) {
          var f = c[j.currentLocale], C = d, v = {
            thousand: 3,
            million: 6,
            billion: 9,
            trillion: 12
          }, b, E, A;
          if (j.zeroFormat && d === j.zeroFormat)
            E = 0;
          else if (j.nullFormat && d === j.nullFormat || !d.replace(/[^0-9]+/g, "").length)
            E = null;
          else {
            E = 1, f.delimiters.decimal !== "." && (d = d.replace(/\./g, "").replace(f.delimiters.decimal, "."));
            for (b in v)
              if (A = new RegExp("[^a-zA-Z]" + f.abbreviations[b] + "(?:\\)|(\\" + f.currency.symbol + ")?(?:\\))?)?$"), C.match(A)) {
                E *= Math.pow(10, v[b]);
                break;
              }
            E *= (d.split("-").length + Math.min(d.split("(").length - 1, d.split(")").length - 1)) % 2 ? 1 : -1, d = d.replace(/[^0-9\.]+/g, ""), E *= Number(d);
          }
          return E;
        },
        isNaN: function(d) {
          return typeof d == "number" && isNaN(d);
        },
        includes: function(d, f) {
          return d.indexOf(f) !== -1;
        },
        insert: function(d, f, C) {
          return d.slice(0, C) + f + d.slice(C);
        },
        reduce: function(d, f) {
          if (this === null)
            throw new TypeError("Array.prototype.reduce called on null or undefined");
          if (typeof f != "function")
            throw new TypeError(f + " is not a function");
          var C = Object(d), v = C.length >>> 0, b = 0, E;
          if (arguments.length === 3)
            E = arguments[2];
          else {
            for (; b < v && !(b in C); )
              b++;
            if (b >= v)
              throw new TypeError("Reduce of empty array with no initial value");
            E = C[b++];
          }
          for (; b < v; b++)
            b in C && (E = f(E, C[b], b, C));
          return E;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function(d) {
          var f = d.toString().split(".");
          return f.length < 2 ? 1 : Math.pow(10, f[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function() {
          var d = Array.prototype.slice.call(arguments);
          return d.reduce(function(f, C) {
            var v = a.multiplier(C);
            return f > v ? f : v;
          }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(d, f, C, v) {
          var b = d.toString().split("."), E = f - (v || 0), A, R, D, _;
          return b.length === 2 ? A = Math.min(Math.max(b[1].length, E), f) : A = E, D = Math.pow(10, A), _ = (C(d + "e+" + A) / D).toFixed(A), v > f - A && (R = new RegExp("\\.?0{1," + (v - (f - A)) + "}$"), _ = _.replace(R, "")), _;
        }
      }, i.options = j, i.formats = l, i.locales = c, i.locale = function(d) {
        return d && (j.currentLocale = d.toLowerCase()), j.currentLocale;
      }, i.localeData = function(d) {
        if (!d)
          return c[j.currentLocale];
        if (d = d.toLowerCase(), !c[d])
          throw new Error("Unknown locale : " + d);
        return c[d];
      }, i.reset = function() {
        for (var d in m)
          j[d] = m[d];
      }, i.zeroFormat = function(d) {
        j.zeroFormat = typeof d == "string" ? d : null;
      }, i.nullFormat = function(d) {
        j.nullFormat = typeof d == "string" ? d : null;
      }, i.defaultFormat = function(d) {
        j.defaultFormat = typeof d == "string" ? d : "0.0";
      }, i.register = function(d, f, C) {
        if (f = f.toLowerCase(), this[d + "s"][f])
          throw new TypeError(f + " " + d + " already registered.");
        return this[d + "s"][f] = C, C;
      }, i.validate = function(d, f) {
        var C, v, b, E, A, R, D, _;
        if (typeof d != "string" && (d += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", d)), d = d.trim(), d.match(/^\d+$/))
          return !0;
        if (d === "")
          return !1;
        try {
          D = i.localeData(f);
        } catch {
          D = i.localeData(i.locale());
        }
        return b = D.currency.symbol, A = D.abbreviations, C = D.delimiters.decimal, D.delimiters.thousands === "." ? v = "\\." : v = D.delimiters.thousands, _ = d.match(/^[^\d]+/), _ !== null && (d = d.substr(1), _[0] !== b) || (_ = d.match(/[^\d]+$/), _ !== null && (d = d.slice(0, -1), _[0] !== A.thousand && _[0] !== A.million && _[0] !== A.billion && _[0] !== A.trillion)) ? !1 : (R = new RegExp(v + "{2}"), d.match(/[^\d.,]/g) ? !1 : (E = d.split(C), E.length > 2 ? !1 : E.length < 2 ? !!E[0].match(/^\d+.*\d$/) && !E[0].match(R) : E[0].length === 1 ? !!E[0].match(/^\d+$/) && !E[0].match(R) && !!E[1].match(/^\d+$/) : !!E[0].match(/^\d+.*\d$/) && !E[0].match(R) && !!E[1].match(/^\d+$/)));
      }, i.fn = h.prototype = {
        clone: function() {
          return i(this);
        },
        format: function(d, f) {
          var C = this._value, v = d || j.defaultFormat, b, E, A;
          if (f = f || Math.round, C === 0 && j.zeroFormat !== null)
            E = j.zeroFormat;
          else if (C === null && j.nullFormat !== null)
            E = j.nullFormat;
          else {
            for (b in l)
              if (v.match(l[b].regexps.format)) {
                A = l[b].format;
                break;
              }
            A = A || i._.numberToFormat, E = A(C, v, f);
          }
          return E;
        },
        value: function() {
          return this._value;
        },
        input: function() {
          return this._input;
        },
        set: function(d) {
          return this._value = Number(d), this;
        },
        add: function(d) {
          var f = a.correctionFactor.call(null, this._value, d);
          function C(v, b, E, A) {
            return v + Math.round(f * b);
          }
          return this._value = a.reduce([this._value, d], C, 0) / f, this;
        },
        subtract: function(d) {
          var f = a.correctionFactor.call(null, this._value, d);
          function C(v, b, E, A) {
            return v - Math.round(f * b);
          }
          return this._value = a.reduce([d], C, Math.round(this._value * f)) / f, this;
        },
        multiply: function(d) {
          function f(C, v, b, E) {
            var A = a.correctionFactor(C, v);
            return Math.round(C * A) * Math.round(v * A) / Math.round(A * A);
          }
          return this._value = a.reduce([this._value, d], f, 1), this;
        },
        divide: function(d) {
          function f(C, v, b, E) {
            var A = a.correctionFactor(C, v);
            return Math.round(C * A) / Math.round(v * A);
          }
          return this._value = a.reduce([this._value, d], f), this;
        },
        difference: function(d) {
          return Math.abs(i(this._value).subtract(d).value());
        }
      }, i.register("locale", "en", {
        delimiters: {
          thousands: ",",
          decimal: "."
        },
        abbreviations: {
          thousand: "k",
          million: "m",
          billion: "b",
          trillion: "t"
        },
        ordinal: function(d) {
          var f = d % 10;
          return ~~(d % 100 / 10) === 1 ? "th" : f === 1 ? "st" : f === 2 ? "nd" : f === 3 ? "rd" : "th";
        },
        currency: {
          symbol: "$"
        }
      }), function() {
        i.register("format", "bps", {
          regexps: {
            format: /(BPS)/,
            unformat: /(BPS)/
          },
          format: function(d, f, C) {
            var v = i._.includes(f, " BPS") ? " " : "", b;
            return d = d * 1e4, f = f.replace(/\s?BPS/, ""), b = i._.numberToFormat(d, f, C), i._.includes(b, ")") ? (b = b.split(""), b.splice(-1, 0, v + "BPS"), b = b.join("")) : b = b + v + "BPS", b;
          },
          unformat: function(d) {
            return +(i._.stringToNumber(d) * 1e-4).toFixed(15);
          }
        });
      }(), function() {
        var d = {
          base: 1e3,
          suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        }, f = {
          base: 1024,
          suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
        }, C = d.suffixes.concat(f.suffixes.filter(function(b) {
          return d.suffixes.indexOf(b) < 0;
        })), v = C.join("|");
        v = "(" + v.replace("B", "B(?!PS)") + ")", i.register("format", "bytes", {
          regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(v)
          },
          format: function(b, E, A) {
            var R, D = i._.includes(E, "ib") ? f : d, _ = i._.includes(E, " b") || i._.includes(E, " ib") ? " " : "", F, P, x;
            for (E = E.replace(/\s?i?b/, ""), F = 0; F <= D.suffixes.length; F++)
              if (P = Math.pow(D.base, F), x = Math.pow(D.base, F + 1), b === null || b === 0 || b >= P && b < x) {
                _ += D.suffixes[F], P > 0 && (b = b / P);
                break;
              }
            return R = i._.numberToFormat(b, E, A), R + _;
          },
          unformat: function(b) {
            var E = i._.stringToNumber(b), A, R;
            if (E) {
              for (A = d.suffixes.length - 1; A >= 0; A--) {
                if (i._.includes(b, d.suffixes[A])) {
                  R = Math.pow(d.base, A);
                  break;
                }
                if (i._.includes(b, f.suffixes[A])) {
                  R = Math.pow(f.base, A);
                  break;
                }
              }
              E *= R || 1;
            }
            return E;
          }
        });
      }(), function() {
        i.register("format", "currency", {
          regexps: {
            format: /(\$)/
          },
          format: function(d, f, C) {
            var v = i.locales[i.options.currentLocale], b = {
              before: f.match(/^([\+|\-|\(|\s|\$]*)/)[0],
              after: f.match(/([\+|\-|\)|\s|\$]*)$/)[0]
            }, E, A, R;
            for (f = f.replace(/\s?\$\s?/, ""), E = i._.numberToFormat(d, f, C), d >= 0 ? (b.before = b.before.replace(/[\-\(]/, ""), b.after = b.after.replace(/[\-\)]/, "")) : d < 0 && !i._.includes(b.before, "-") && !i._.includes(b.before, "(") && (b.before = "-" + b.before), R = 0; R < b.before.length; R++)
              switch (A = b.before[R], A) {
                case "$":
                  E = i._.insert(E, v.currency.symbol, R);
                  break;
                case " ":
                  E = i._.insert(E, " ", R + v.currency.symbol.length - 1);
                  break;
              }
            for (R = b.after.length - 1; R >= 0; R--)
              switch (A = b.after[R], A) {
                case "$":
                  E = R === b.after.length - 1 ? E + v.currency.symbol : i._.insert(E, v.currency.symbol, -(b.after.length - (1 + R)));
                  break;
                case " ":
                  E = R === b.after.length - 1 ? E + " " : i._.insert(E, " ", -(b.after.length - (1 + R) + v.currency.symbol.length - 1));
                  break;
              }
            return E;
          }
        });
      }(), function() {
        i.register("format", "exponential", {
          regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
          },
          format: function(d, f, C) {
            var v, b = typeof d == "number" && !i._.isNaN(d) ? d.toExponential() : "0e+0", E = b.split("e");
            return f = f.replace(/e[\+|\-]{1}0/, ""), v = i._.numberToFormat(Number(E[0]), f, C), v + "e" + E[1];
          },
          unformat: function(d) {
            var f = i._.includes(d, "e+") ? d.split("e+") : d.split("e-"), C = Number(f[0]), v = Number(f[1]);
            v = i._.includes(d, "e-") ? v *= -1 : v;
            function b(E, A, R, D) {
              var _ = i._.correctionFactor(E, A), F = E * _ * (A * _) / (_ * _);
              return F;
            }
            return i._.reduce([C, Math.pow(10, v)], b, 1);
          }
        });
      }(), function() {
        i.register("format", "ordinal", {
          regexps: {
            format: /(o)/
          },
          format: function(d, f, C) {
            var v = i.locales[i.options.currentLocale], b, E = i._.includes(f, " o") ? " " : "";
            return f = f.replace(/\s?o/, ""), E += v.ordinal(d), b = i._.numberToFormat(d, f, C), b + E;
          }
        });
      }(), function() {
        i.register("format", "percentage", {
          regexps: {
            format: /(%)/,
            unformat: /(%)/
          },
          format: function(d, f, C) {
            var v = i._.includes(f, " %") ? " " : "", b;
            return i.options.scalePercentBy100 && (d = d * 100), f = f.replace(/\s?\%/, ""), b = i._.numberToFormat(d, f, C), i._.includes(b, ")") ? (b = b.split(""), b.splice(-1, 0, v + "%"), b = b.join("")) : b = b + v + "%", b;
          },
          unformat: function(d) {
            var f = i._.stringToNumber(d);
            return i.options.scalePercentBy100 ? f * 0.01 : f;
          }
        });
      }(), function() {
        i.register("format", "time", {
          regexps: {
            format: /(:)/,
            unformat: /(:)/
          },
          format: function(d, f, C) {
            var v = Math.floor(d / 60 / 60), b = Math.floor((d - v * 60 * 60) / 60), E = Math.round(d - v * 60 * 60 - b * 60);
            return v + ":" + (b < 10 ? "0" + b : b) + ":" + (E < 10 ? "0" + E : E);
          },
          unformat: function(d) {
            var f = d.split(":"), C = 0;
            return f.length === 3 ? (C = C + Number(f[0]) * 60 * 60, C = C + Number(f[1]) * 60, C = C + Number(f[2])) : f.length === 2 && (C = C + Number(f[0]) * 60, C = C + Number(f[1])), Number(C);
          }
        });
      }(), i;
    });
  }(hs)), hs.exports;
}
(function(r, i) {
  (function(a, s) {
    r.exports = s(b1, C1(), j1());
  })(self, function(a, s, l) {
    return (() => {
      var c = { 605: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = { margin: { top: 20, right: 30, bottom: 20, left: 40 }, yTicks: 4, xFormat: x.format(",.0f"), yFormat: x.format("s") }, N = G - (ie = Object.assign({}, K, ie)).margin.left - ie.margin.right, B = X - ie.margin.top - ie.margin.bottom, oe = x.scaleLinear().domain(x.extent(I, function(U) {
                return U.x;
              })).range([0, N]), ne = x.scaleLinear().domain([0, x.max(I, function(U) {
                return U.y;
              })]).range([B, 0]), re = x.axisBottom().scale(oe).tickFormat(ie.xFormat).ticks(10), je = x.axisLeft().scale(ne).tickFormat(ie.yFormat).ticks(ie.yTicks), Z = x.area().x(function(U) {
                return oe(U.x);
              }).y0(B).y1(function(U) {
                return ne(U.y);
              }), de = this.createSvg(k, G, X).append("g").attr("transform", "translate(" + ie.margin.left + "," + ie.margin.top + ")");
              de.append("path").data([I]).attr("class", "area").attr("d", Z), de.append("g").attr("class", "x axis").attr("transform", "translate(0," + B + ")").call(re), de.append("g").attr("class", "y axis").call(je);
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 648: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = this.getOptions({ maxPercent: 100 }, ie), N = this.createSvg(k, G, X), B = N.append("g").attr("transform", "translate(".concat(G / 2, ", ").concat(X / 2, ")")), oe = Math.min(G - 10, X - 10) / 2, ne = 0.3 * oe, re = x.scaleLinear().domain([0, K.maxPercent]).range([ne, oe]), je = x.arc().innerRadius(ne).outerRadius(function(ye) {
                return re(ye.data.percent);
              }), Z = x.arc().innerRadius(ne).outerRadius(oe), de = [0, 2 * Math.PI], U = x.pie().sort(null).startAngle(de[0]).endAngle(de[1]).value(function(ye) {
                return ye.weight;
              });
              I.length > 1 && U.padAngle(0.01), B.selectAll(".solidArc").data(U(I)).enter().append("path").attr("fill", function(ye) {
                return K.colors(ye.data.id);
              }).attr("class", "solidArc").attr("d", je), B.selectAll(".outlineArc").data(U(I)).enter().append("path").attr("fill", "none").attr("stroke", function(ye) {
                return K.colors(ye.data.id);
              }).attr("class", "outlineArc").attr("d", Z), K.asterLabel && N.append("svg:text").attr("class", "aster-label").attr("dy", ".35em").attr("text-anchor", "middle").text(asterLabel());
              for (var ce = B.append("g").attr("class", "axisWrapper"), fe = Math.ceil(K.maxPercent / 25), he = 1; he < fe; he++) ce.append("circle").attr("class", "gridCircle").attr("r", re(25 * he)).style("fill", "none").style("stroke", "#c5c5c5").style("stroke-width", 0.6), he % 2 == 1 && (ce.append("rect").attr("x", -8).attr("y", -re(25 * he) - 5).attr("width", 20).style("height", 10).attr("fill", "#fff"), ce.append("text").attr("class", "axisLabel").attr("x", -6).attr("y", -re(25 * he)).attr("dy", ".4em").style("font-size", "8px").attr("fill", "#737373").text(function(ye, Ee) {
                return "".concat(25 * he, "%");
              }));
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 131: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "render", value: function(I, k, G, X, ie) {
              var K = this;
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var N = this.getOptions({ label: "label", value: "value", rotate: 0, textAnchor: "middle", showLabels: !1 }, ie), B = this.createSvg(k, G, X);
              this.useTip(function(pe) {
                pe.attr("class", "d3-tip").offset([-10, 0]).html(function(se) {
                  return se.value;
                });
              });
              var oe = N.label, ne = N.value, re = 0;
              I.forEach(function(pe) {
                re += pe[ne];
              });
              var je = G - N.margins.left - N.margins.right, Z = X - N.margins.top - N.margins.bottom, de = x.scaleBand().range([0, je]).padding(0.1).round(1 / I.length), U = x.scaleLinear().range([Z, 0]), ce = x.axisBottom().scale(de).tickSize(2, 0), fe = x.axisLeft().scale(U).tickFormat(N.yFormat).ticks(5);
              de.domain(I.map(function(pe) {
                return pe[oe];
              })), U.domain([0, N.yMax || x.max(I, function(pe) {
                return pe[ne];
              })]);
              var he = B.append("g").attr("class", "axis");
              he.call(ce);
              var ye = Math.round(he.node().getBBox().height), Ee = Math.round(he.node().getBBox().width);
              Z -= ye, je -= Math.max(0, Ee - je), he.remove();
              var ue = B.append("g").attr("class", "axis");
              ue.call(fe);
              var Oe = Math.round(ue.node().getBBox().width);
              je -= Oe, ue.remove(), de.range([0, je]), U.range([Z, 0]), (B = B.append("g").attr("transform", `translate(
	          `.concat(N.margins.left + Oe, `,
	          `).concat(N.margins.top, `
	        )`))).append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(Z, ")")).call(ce).selectAll(".tick text").style("text-anchor", N.textAnchor).attr("transform", function(pe) {
                return "rotate(".concat(N.rotate, ")");
              }), N.wrap && B.selectAll(".tick text").call(this.wrap, de.bandwidth()), B.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(fe), B.selectAll(".bar").data(I).enter().append("rect").attr("class", "bar").attr("x", function(pe) {
                return de(pe[oe]);
              }).attr("width", de.bandwidth()).attr("y", function(pe) {
                return U(pe[ne]);
              }).attr("height", function(pe) {
                return Z - U(pe[ne]);
              }).attr("title", function(pe) {
                var se = "".concat(pe[oe], ": ").concat(K.formatters.commaseparated(pe[ne], ","));
                return se += " (".concat(re > 0 ? K.formatters.formatpercent(pe[ne] / re) : K.formatters.formatpercent(0), ")");
              }).style("fill", function(pe) {
                return N.colors(pe[oe]);
              }).on("mouseover", function(pe) {
                return K.tip.show(pe, event.target);
              }).on("mouseout", function(pe) {
                return K.tip.hide(pe, event.target);
              }).exit().remove(), N.showLabels && B.selectAll(".barlabel").data(I).enter().append("text").attr("class", "barlabel").text(function(pe) {
                return K.formatters.formatpercent(pe[ne] / re);
              }).attr("x", function(pe) {
                return de(pe[oe]) + de.bandwidth() / 2;
              }).attr("y", function(pe) {
                return U(pe[ne]) - 3;
              }).attr("text-anchor", "middle");
            } }, { key: "formatters", get: function() {
              return { commaseparated: x.format(","), formatpercent: x.format(".1%") };
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 316: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "defaultTip", value: function(I, k) {
              I.attr("class", "d3-tip").offset(function(G) {
                return G.tipOffset || [-10, 0];
              }).direction(function(G) {
                return G.tipDirection || "n";
              }).html(function(G) {
                return `<table class='boxplotValues'>
					<tr>
						<td>Max:</td>
						<td>`.concat(k.valueFormatter(G.max), `</td>
					</tr>
					<tr>
						<td>P90:</td>
						<td>`).concat(k.valueFormatter(G.UIF), `</td>
					</tr>
					<tr>
						<td>P75:</td>
						<td>`).concat(k.valueFormatter(G.q3), `</td>
					</tr>
					<tr>
						<td>Median:</td>
						<td>`).concat(k.valueFormatter(G.median), `</td>
					</tr>
					<tr>
						<td>P25:</td>
						<td>`).concat(k.valueFormatter(G.q1), `</td>
					</tr>
					<tr>
						<td>P10:</td>
						<td>`).concat(k.valueFormatter(G.LIF), `</td>
					</tr>
					<tr>
						<td>Min:</td>
						<td>`).concat(k.valueFormatter(G.min), `</td>
					</tr>
				</table>`);
              });
            } }, { key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = { valueFormatter: this.formatters.formatSI(3) }, N = this.getOptions(K, ie), B = this.createSvg(k, G, X);
              N.valueFormatter, this.useTip(this.defaultTip, N);
              var oe = 0, ne = 0;
              if (N.xLabel) {
                var re = B.append("g").attr("transform", "translate(".concat(G / 2, ", ").concat(X - N.margins.bottom, ")"));
                re.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(N.xLabel), oe = re.node().getBBox().height;
              }
              if (N.yLabel) {
                var je = B.append("g").attr("transform", `translate(
	            `.concat(N.margins.left, `,
	            `).concat((X - N.margins.bottom - N.margins.top) / 2 + N.margins.top, `
	          )`));
                je.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(N.yLabel), ne = je.node().getBBox().width;
              }
              var Z = G - N.margins.left - ne - N.margins.right, de = X - N.margins.top - oe - N.margins.bottom, U = x.scaleBand().range([0, Z]).round(1 / I.length).domain(I.map(function(xe) {
                return xe.Category;
              })), ce = x.scaleLinear().range([de, 0]).domain([N.yMin || 0, N.yMax || x.max(I, function(xe) {
                return xe.max;
              })]), fe = x.axisBottom().scale(U), he = x.axisLeft().scale(ce).tickFormat(N.yFormat).ticks(5), ye = B.append("g").attr("class", "axis");
              ye.call(fe);
              var Ee = Math.round(ye.node().getBBox().height), ue = Math.round(ye.node().getBBox().width);
              de -= Ee, Z -= Math.max(0, ue - Z), ye.remove();
              var Oe = B.append("g").attr("class", "axis");
              Oe.call(he);
              var pe = Math.round(Oe.node().getBBox().width);
              Z -= pe, Oe.remove(), U.range([0, Z]), ce.range([de, 0]);
              var se = U.bandwidth() / 2 - 5, Ae = U.bandwidth() / 2 - 2.5, He = B.append("g").attr("transform", `translate(
	          `.concat(N.margins.left + ne + pe, `,
	          `).concat(N.margins.top, `
	        )`)), qe = He.selectAll(".boxplot").data(I).enter().append("g").attr("class", "boxplot").attr("transform", function(xe) {
                return "translate(".concat(U(xe.Category), ", 0)");
              }), Ce = this;
              qe.each(function(xe) {
                var Se = x.select(this);
                xe.LIF != xe.q1 && (Se.append("line").attr("class", "bar").attr("x1", Ae).attr("y1", ce(xe.LIF)).attr("x2", Ae + 5).attr("y2", ce(xe.LIF)), Se.append("line").attr("class", "whisker").attr("x1", U.bandwidth() / 2).attr("y1", ce(xe.LIF)).attr("x2", U.bandwidth() / 2).attr("y2", ce(xe.q1))), Se.append("rect").attr("class", "box").attr("x", se).attr("y", ce(xe.q3)).attr("width", 10).attr("height", Math.max(1, ce(xe.q1) - ce(xe.q3))).on("mouseover", function(Te) {
                  return Ce.tip.show(Te, event.target);
                }).on("mouseout", function(Te) {
                  return Ce.tip.hide(Te, event.target);
                }), Se.append("line").attr("class", "median").attr("x1", se).attr("y1", ce(xe.median)).attr("x2", se + 10).attr("y2", ce(xe.median)), xe.UIF != xe.q3 && (Se.append("line").attr("class", "bar").attr("x1", Ae).attr("y1", ce(xe.UIF)).attr("x2", U.bandwidth() - Ae).attr("y2", ce(xe.UIF)), Se.append("line").attr("class", "whisker").attr("x1", U.bandwidth() / 2).attr("y1", ce(xe.UIF)).attr("x2", U.bandwidth() / 2).attr("y2", ce(xe.q3)));
              }), He.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(de, ")")).call(fe), He.selectAll(".tick text").call(this.wrap, U.bandwidth() || U.range()), He.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(he);
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 842: (h, d, f) => {
        var C, v;
        function b(E, A) {
          for (var R = 0; R < A.length; R++) {
            var D = A[R];
            D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(E, D.key, D);
          }
        }
        C = [f(680), f(92), f(383)], v = (function(E, A, R) {
          var D = function() {
            function _() {
              (function(p, y) {
                if (!(p instanceof y)) throw new TypeError("Cannot call a class as a function");
              })(this, _);
            }
            var F, P, x;
            return F = _, P = [{ key: "render", value: function(p, y, w, M, V) {
              var q = this;
              typeof y == "string" && (y = document.querySelector(y)), this.cachedData = p, this.doResize || (this.doResize = A.debounce(function() {
                q.render(q.cachedData, y, y.clientWidth, y.clientHeight, V);
              }, 250), window.addEventListener("resize", this.doResize));
            } }, { key: "getOptions", value: function(p, y) {
              return Object.assign({}, { margins: { top: 10, right: 10, bottom: 10, left: 10 }, xFormat: E.format(",.0f"), yFormat: E.format("s"), colors: E.scaleOrdinal(E.schemeCategory20.concat(E.schemeCategory20c)) }, Object.assign({}, p), Object.assign({}, y));
            } }, { key: "createSvg", value: function(p, y, w) {
              this.destroyTipIfExists();
              var M = E.select(p);
              M.select("svg").remove();
              var V = M.append("svg").attr("preserveAspectRatio", "xMinYMin meet").attr("viewBox", `
	        0
	        0
	        `.concat(y, `
	        `).concat(w)).append("g").attr("class", "chart");
              return this.chart = V, V;
            } }, { key: "useTip", value: function() {
              var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
              }, y = arguments.length > 1 ? arguments[1] : void 0;
              return this.destroyTipIfExists(), this.tip = R().attr("class", "d3-tip"), p(this.tip, y), this.chart && this.chart.call(this.tip), this.tip;
            } }, { key: "destroyTipIfExists", value: function() {
              this.tip && this.tip.destroy();
            } }, { key: "truncate", value: function(p, y) {
              p.each(function() {
                for (var w = E.select(this), M = w.text(), V = w.node().getComputedTextLength(), q = w.text(); V > y && q.length > 0; ) q = q.slice(0, -1), w.text("".concat(q, "...")), V = w.node().getComputedTextLength();
                w.append("title").text(M);
              });
            } }, { key: "wrap", value: function(p, y, w) {
              p.each(function() {
                for (var M, V = E.select(this), q = V.text(), $ = V.text().split(/\s+/).reverse(), I = [], k = 0, G = 0, X = V.attr("y"), ie = parseFloat(V.attr("dy")), K = V.text(null).append("tspan").attr("x", 0).attr("y", X).attr("dy", "".concat(ie, "em")); M = $.pop(); ) if (I.push(M), K.text(I.join(" ")), K.node().getComputedTextLength() > y) {
                  if (I.length > 1) {
                    I.pop(), $.push(M);
                    var N = w && ++G === w ? "".concat(I.splice(0, I.length - 1).join(" "), "...") : I.join(" ");
                    K.text(N);
                  }
                  if (I = [], K = V.append("tspan").attr("x", 0).attr("y", X).attr("dy", "".concat(1.1 * ++k + ie, "em")), w && w === G) {
                    K.remove();
                    break;
                  }
                }
                V.append("title").text(q);
              });
            } }, { key: "tooltipFactory", value: function(p) {
              return function(y) {
                var w = "";
                if (p !== void 0) for (var M = 0; M < p.length; M += 1) {
                  var V = p[M].accessor(y);
                  p[M].format !== void 0 && (V = p[M].format(V)), w += "".concat(p[M].label, ": ").concat(V, "</br>");
                }
                return w;
              };
            } }, { key: "lineDefaultTooltip", value: function(p, y, w, M, V, q, $) {
              return function(I) {
                var k = "";
                return $(I) && (k = "Series: ".concat($(I), "</br>")), k += "".concat(p, ": ").concat(y(w(I)), "</br>"), k += "".concat(M, ": ").concat(V(q(I)));
              };
            } }, { key: "donutDefaultTooltip", value: function(p, y, w) {
              return function(M) {
                return "".concat(p(M), ": ").concat(y(M), " (").concat(w(M), ")");
              };
            } }, { key: "dispose", value: function() {
              this.destroyTipIfExists(), this.doResize && window.removeEventListener("resize", this.doResize);
            } }, { key: "formatters", get: function() {
              return { formatSI: function(p) {
                p = p || 0;
                var y = E.format(",.".concat(p, "s"));
                return function(w) {
                  return w < 1 ? w.toFixed(p).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "") : y(w).replace(new RegExp("(\\.0*|(?<=(\\.[0-9]*))0*)$"), "");
                };
              } };
            } }], x = [{ key: "normalizeDataframe", value: function(p) {
              var y = E.keys(p), w = Object.assign({}, p);
              return y.forEach(function(M) {
                p[M] instanceof Array || (w[M] = [p[M]]);
              }), w;
            } }, { key: "dataframeToArray", value: function(p) {
              var y = E.keys(p);
              return p[y[0]] instanceof Array ? p[y[0]].map(function(w, M) {
                var V = {};
                return y.forEach(function(q) {
                  V[q] = p[q][M];
                }), V;
              }) : [p];
            } }, { key: "mapMonthYearDataToSeries", value: function(p, y) {
              var w = Object.assign({}, { dateField: "x", yValue: "y", yPercent: "p" }, y), M = { name: "All Time", values: [] };
              return p[w.dateField].map(function(V, q) {
                M.values.push({ xValue: new Date(Math.floor(p[w.dateField][q] / 100), p[w.dateField][q] % 100 - 1, 1), yValue: p[w.yValue][q], yPercent: p[w.yPercent][q] });
              }), M.values.sort(function(V, q) {
                return V.xValue - q.xValue;
              }), [M];
            } }, { key: "prepareData", value: function(p, y) {
              if (y === this.chartTypes.BOXPLOT) {
                if (!p.CATEGORY.length) return null;
                var w = p.CATEGORY.map(function(M, V) {
                  return { Category: p.CATEGORY[V], min: p.MIN_VALUE[V], max: p.MAX_VALUE[V], median: p.MEDIAN_VALUE[V], LIF: p.P10_VALUE[V], q1: p.P25_VALUE[V], q3: p.P75_VALUE[V], UIF: p.P90_VALUE[V] };
                }, p);
                return Object.values(w).reduce(function(M, V) {
                  return M.concat(V);
                }, []).length ? w : null;
              }
            } }, { key: "chartTypes", get: function() {
              return { AREA: "AREA", BOXPLOT: "BOXPLOT", DONUT: "DONUT", HISTOGRAM: "HISTOGRAM", LINE: "LINE", TRELLISLINE: "TRELLISLINE" };
            } }], P && b(F.prototype, P), x && b(F, x), _;
          }();
          return D;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 535: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(756), f(842)], v = (function(x, p, y) {
          var w = function(M) {
            (function(k, G) {
              if (typeof G != "function" && G !== null) throw new TypeError("Super expression must either be null or a function");
              k.prototype = Object.create(G && G.prototype, { constructor: { value: k, writable: !0, configurable: !0 } }), G && D(k, G);
            })(I, M);
            var V, q, $ = _(I);
            function I() {
              return E(this, I), $.apply(this, arguments);
            }
            return V = I, (q = [{ key: "render", value: function(k, G, X, ie, K) {
              var N = this;
              R(P(I.prototype), "render", this).call(this, k, G, X, ie, K);
              var B = this.getOptions(K), oe = this.createSvg(G, X, ie), ne = 0;
              k.forEach(function(ue) {
                ne += +ue.value;
              });
              var re = this.donutDefaultTooltip(function(ue) {
                return ue.label;
              }, function(ue) {
                return p(ue.value).format("0,0");
              }, function(ue) {
                return N.formatters.formatpercent(ne != 0 ? ue.value / ne : 0);
              });
              if (this.useTip(function(ue) {
                return ue.attr("class", "d3-tip").direction("s").offset([3, 0]).html(re);
              }), k.length > 0) {
                var je = oe.append("g").attr("id", "chart"), Z = x.drag().on("drag", function() {
                  var ue = x.select(this), Oe = event.y - parseFloat(ue.attr("initialY"));
                  if (isNaN(Oe)) return !1;
                  ue.attr("transform", `translate(
	        `.concat(parseFloat(ue.attr("initialPositionX")), `,
	        `).concat(parseFloat(ue.attr("initialPositionY")) + Oe, `
	      )`));
                }).on("start", function() {
                  var ue = x.select(this);
                  ue.attr("initialX", event.x), ue.attr("initialY", event.y);
                }).on("end", function() {
                  var ue = x.select(this);
                  ue.transition().duration(300).attr("transform", `translate(
	          `.concat(ue.attr("initialPositionX"), `,
	          `).concat(ue.attr("initialPositionY"), `
	        )`));
                }), de = oe.append("g").attr("class", "legend").call(Z);
                de.selectAll("rect").data(k).enter().append("rect").attr("x", 0).attr("y", function(ue, Oe) {
                  return 15 * Oe;
                }).attr("width", 10).attr("height", 10).style("fill", function(ue) {
                  return B.colors(ue.id);
                });
                var U = 0, ce = de.selectAll("g.legend-item").data(k).enter().append("g").attr("class", "legend-item");
                ce.append("text").attr("x", 12).attr("y", function(ue, Oe) {
                  return 15 * Oe + 9;
                }).text(function(ue) {
                  return ue.label;
                }), ce.append("title").attr("x", 12).attr("y", function(ue, Oe) {
                  return 15 * Oe + 9;
                }).text(function(ue) {
                  return ue.label;
                }), ce.each(function() {
                  var ue = this.getBBox().width;
                  ue > U && U + ue < 0.75 * X && (U = ue);
                }), U += 12, de.attr("transform", `translate(
	            `.concat(X - U - B.margins.right, `,
	            `).concat(B.margins.top, `
	          )`)).attr("initialPositionX", X - U - B.margins.right).attr("initialPositionY", B.margins.top), je.attr("transform", "translate(".concat((X - U) / 2, ", ").concat(ie / 2, ")"));
                var fe = Math.min(ie, X - U) / 2 - B.margins.top, he = Math.min(ie, X - U) / 6 - B.margins.top, ye = x.arc().innerRadius(he).outerRadius(fe), Ee = x.pie().value(function(ue) {
                  return ue.value > 0 ? Math.max(ue.value, 0.015 * ne) : 0;
                });
                je.selectAll("g.slice").data(Ee(k)).enter().append("g").attr("class", "slice").append("path").attr("fill", function(ue) {
                  return B.colors(ue.data.id);
                }).attr("stroke", "#fff").attr("stroke-width", 5).attr("title", function(ue) {
                  return ue.label;
                }).on("mouseover", function(ue) {
                  return N.tip.show(ue.data, event.target);
                }).on("mouseout", function(ue) {
                  return N.tip.hide(ue.data, event.target);
                }).attr("d", ye);
              } else oe.append("text").attr("transform", "translate(".concat(X / 2, ", ").concat(ie / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "formatters", get: function() {
              return { formatpercent: x.format(".1%") };
            } }]) && A(V.prototype, q), I;
          }(y);
          return w;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 502: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(756), f(842)], v = (function(x, p, y) {
          var w = function(M) {
            (function(G, X) {
              if (typeof X != "function" && X !== null) throw new TypeError("Super expression must either be null or a function");
              G.prototype = Object.create(X && X.prototype, { constructor: { value: G, writable: !0, configurable: !0 } }), X && D(G, X);
            })(k, M);
            var V, q, $, I = _(k);
            function k() {
              return E(this, k), I.apply(this, arguments);
            }
            return V = k, $ = [{ key: "mapHistogram", value: function(G) {
              for (var X = [], ie = G.OFFSET || 0, K = G.INTERVAL_SIZE, N = this.normalizeDataframe(G.DATA), B = 0; B < G.INTERVALS; B += 1) {
                var oe = {};
                oe.x = ie + 1 * N.INTERVAL_INDEX[B] * K, oe.dx = K, oe.y = N.COUNT_VALUE[B] || 0, X.push(oe);
              }
              return X;
            } }], (q = [{ key: "drawBoxplot", value: function(G, X, ie, K) {
              var N = G, B = this.xScale, oe = K / 2;
              X.LIF !== X.q1 && (N.append("line").attr("class", "bar").attr("x1", B(X.LIF)).attr("y1", K / 2 - oe / 2).attr("x2", B(X.LIF)).attr("y2", K / 2 + oe / 2), N.append("line").attr("class", "whisker").attr("x1", B(X.LIF)).attr("y1", K / 2).attr("x2", B(X.q1)).attr("y2", K / 2)), N.append("rect").attr("class", "box").attr("x", B(X.q1)).attr("width", B(X.q3) - B(X.q1)).attr("height", K), N.append("line").attr("class", "median").attr("x1", B(X.median)).attr("y1", 0).attr("x2", B(X.median)).attr("y2", K), X.UIF !== X.q3 && (N.append("line").attr("class", "bar").attr("x1", B(X.UIF)).attr("y1", K / 2 - oe / 2).attr("x2", B(X.UIF)).attr("y2", K / 2 + oe / 2), N.append("line").attr("class", "whisker").attr("x1", B(X.q3)).attr("y1", K / 2).attr("x2", B(X.UIF)).attr("y2", K / 2));
            } }, { key: "render", value: function(G, X, ie, K, N) {
              var B = this;
              R(P(k.prototype), "render", this).call(this, G, X, ie, K, N);
              var oe = { ticks: 10, yTicks: 4, yScale: x.scaleLinear(), boxplotHeight: 10, getTooltipBuilder: null }, ne = this.getOptions(oe, N), re = this.createSvg(X, ie, K);
              this.xScale = {};
              var je = G || [], Z = typeof ne.getTooltipBuilder == "function" ? ne.getTooltipBuilder(ne) : function(Te) {
                return p(Te.y).format("0,0");
              };
              this.useTip(function(Te) {
                Te.attr("class", "d3-tip").offset([-10, 0]).html(Z);
              });
              var de = 0, U = 0;
              if (ne.xLabel) {
                var ce = re.append("g").attr("transform", "translate(".concat(ie / 2, ", ").concat(K - ne.margins.bottom, ")"));
                ce.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(ne.xLabel), de = ce.node().getBBox().height;
              }
              if (ne.yLabel) {
                var fe = re.append("g").attr("transform", `translate(
	            `.concat(ne.margins.left, `,
	            `).concat((K - ne.margins.bottom - ne.margins.top) / 2 + ne.margins.top, `
	          )`));
                fe.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(ne.yLabel), U = 1.5 * fe.node().getBBox().width;
              }
              var he = ie - ne.margins.left - ne.margins.right - U, ye = K - ne.margins.top - ne.margins.bottom - de, Ee = this.xScale = x.scaleLinear().domain(ne.xDomain || [x.min(je, function(Te) {
                return Te.x;
              }), x.max(je, function(Te) {
                return Te.x + Te.dx;
              })]).range([0, he]), ue = x.axisBottom().scale(Ee).ticks(ne.ticks).tickFormat(ne.xFormat), Oe = ne.yScale.domain([0, ne.yMax || x.max(je, function(Te) {
                return Te.y;
              })]).range([ye, 0]), pe = x.axisLeft().scale(Oe).ticks(ne.yTicks).tickFormat(ne.yFormat), se = re.append("g").attr("class", "axis");
              se.call(ue);
              var Ae = Math.round(se.node().getBBox().height), He = Math.round(se.node().getBBox().width);
              ye -= Ae, he -= Math.max(0, He - he), se.remove();
              var qe = re.append("g").attr("class", "axis");
              qe.call(pe);
              var Ce = Math.round(qe.node().getBBox().width);
              if (he -= Ce, qe.remove(), ne.boxplot) {
                ye -= 12;
                var xe = re.append("g").attr("class", "boxplot").attr("transform", "translate(".concat(ne.margins.left + U + Ce, `,
	          `).concat(ne.margins.top + ye + Ae, ")"));
                this.drawBoxplot(xe, ne.boxplot, he, 8);
              }
              Ee.range([0, he]), Oe.range([ye, 0]);
              var Se = re.append("g").attr("transform", `translate(
	        `.concat(ne.margins.left + U + Ce, `,
	        `).concat(ne.margins.top, ")"));
              Se.selectAll(".bar").data(je).enter().append("g").attr("class", "bar").attr("transform", function(Te) {
                return "translate(".concat(Ee(Te.x), ", ").concat(Oe(Te.y), ")");
              }).on("mouseover", function(Te) {
                return B.tip.show(Te, event.target);
              }).on("mouseout", function(Te) {
                return B.tip.hide(Te, event.target);
              }).append("rect").attr("x", 1).attr("width", function(Te) {
                return Math.max(Ee(Te.x + Te.dx) - Ee(Te.x) - 1, 0.5);
              }).attr("height", function(Te) {
                return ye - Oe(Te.y);
              }), Se.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ye, ")")).call(ue), Se.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(pe);
            } }]) && A(V.prototype, q), $ && A(V, $), k;
          }(y);
          return w;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 487: (h, d, f) => {
        var C, v;
        function b(P) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, b(P);
        }
        function E(P, x) {
          if (!(P instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function A(P, x) {
          for (var p = 0; p < x.length; p++) {
            var y = x[p];
            y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(P, y.key, y);
          }
        }
        function R(P, x) {
          return R = Object.setPrototypeOf || function(p, y) {
            return p.__proto__ = y, p;
          }, R(P, x);
        }
        function D(P) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var p, y = F(P);
            if (x) {
              var w = F(this).constructor;
              p = Reflect.construct(y, arguments, w);
            } else p = y.apply(this, arguments);
            return _(this, p);
          };
        }
        function _(P, x) {
          return !x || b(x) !== "object" && typeof x != "function" ? function(p) {
            if (p === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p;
          }(P) : x;
        }
        function F(P) {
          return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, F(P);
        }
        C = [f(680), f(316)], v = (function(P, x) {
          var p = function(y) {
            (function($, I) {
              if (typeof I != "function" && I !== null) throw new TypeError("Super expression must either be null or a function");
              $.prototype = Object.create(I && I.prototype, { constructor: { value: $, writable: !0, configurable: !0 } }), I && R($, I);
            })(q, y);
            var w, M, V = D(q);
            function q() {
              return E(this, q), V.apply(this, arguments);
            }
            return w = q, (M = [{ key: "render", value: function($, I, k, G, X) {
              var ie = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 4 } }, K = this.getOptions(ie, X), N = G < $.length * K.boxHeight ? $.length * K.boxHeight : G, B = this.createSvg(I, k, N), oe = K.valueFormatter;
              this.useTip(this.defaultTip, K), $.forEach(function(xe) {
                return xe.Category = xe.Category || "Default";
              });
              var ne = k - K.margins.left - K.margins.right;
              N = N - K.margins.top - K.margins.bottom;
              var re = P.scaleLinear().range([0, ne]).domain([K.xMin || P.min($, function(xe) {
                return xe.min;
              }), K.xMax || P.max($, function(xe) {
                return xe.max;
              })]).nice(), je = P.scaleBand().range([0, N]).round(1 / $.length).domain($.map(function(xe) {
                return xe.Category;
              })), Z = P.axisBottom().scale(re).tickFormat(oe), de = P.axisLeft().scale(je), U = P.scaleOrdinal().domain($.map(function(xe) {
                return xe.Category;
              })).range(["#ff9315", "#0d61ff", "gold", "blue", "green", "red", "black", "orange", "brown", "grey", "slateblue", "grey1", "darkgreen"]), ce = 0, fe = ce;
              if (K.showXAxis) {
                var he = B.append("g").attr("class", "axis");
                he.call(Z), ce = Math.round(he.node().getBBox().height) + 2, fe = Math.round(he.node().getBBox().width) + 4, N -= ce, ne -= Math.max(0, fe - ne), he.remove();
              }
              var ye = 0;
              if (K.showYAxis) {
                var Ee = B.append("g").attr("class", "axis");
                Ee.call(de), ne -= ye = Math.round(Ee.node().getBBox().width), Ee.remove();
              }
              var ue = K.boxHeight, Oe = je.bandwidth() / 2 - ue / 2, pe = ue / 2, se = pe / 10;
              K.showMinMarkers && (ne -= se > ye ? 2 * se - ye : se), re.range([0, ne]), je.range([N, 0]);
              var Ae = B.append("g").attr("transform", `translate(
	          `.concat(K.margins.left + Math.max(ye, se), `,
	          `).concat(K.margins.top, `
	        )`)), He = Ae.selectAll(".boxplot").data($).enter().append("g").attr("class", "boxplot").attr("transform", function(xe) {
                return "translate(0, ".concat(je(xe.Category), ")");
              }), qe = this, Ce = P.scaleLinear().range([ue / 2, 0]).domain([0, ue]);
              He.each(function(xe) {
                var Se = xe, Te = P.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(Oe, ")");
                }).append("g").datum(xe);
                Se.LIF != Se.q1 && (Te.append("line").attr("class", "bar").attr("x1", re(Se.LIF)).attr("y1", Ce(1.5 * pe)).attr("x2", re(Se.LIF)).attr("y2", Ce(0.5 * pe)).style("stroke", U(Se.Category)), Te.append("line").attr("class", "whisker").attr("x1", re(Se.LIF)).attr("y1", Ce(pe)).attr("x2", re(Se.q1)).attr("y2", Ce(pe)).style("stroke", U(Se.Category))), Te.append("rect").attr("class", "box").attr("x", re(Se.q1)).attr("y", Math.min(Ce(0), Ce(ue))).attr("width", Math.max(1, re(Se.q3) - re(Se.q1))).attr("height", Math.abs(Ce(0) - Ce(ue))).style("fill", U(Se.Category)).style("stroke", U(Se.Category)).style("fill-opacity", 0.4).on("mouseover", function(me) {
                  return qe.tip.show(me, event.target);
                }).on("mouseout", function(me) {
                  return qe.tip.hide(me, event.target);
                }), Te.append("line").attr("class", "median").attr("x1", re(Se.median)).attr("y1", Ce(0)).attr("x2", re(Se.median)).attr("y2", Ce(ue)).style("stroke", U(Se.Category)), Se.UIF != Se.q3 && (Te.append("line").attr("class", "bar").attr("x1", re(Se.UIF)).attr("y1", Ce(1.5 * pe)).attr("x2", re(Se.UIF)).attr("y2", Ce(0.5 * pe)).style("stroke", U(Se.Category)), Te.append("line").attr("class", "whisker").attr("x1", re(Se.q3)).attr("y1", Ce(pe)).attr("x2", re(Se.UIF)).attr("y2", Ce(pe)).style("stroke", U(Se.Category))), K.showMinMarkers && Te.append("circle").attr("cx", re(Se.min)).attr("cy", Ce(pe)).attr("r", se).style("fill", U(Se.Category)).style("stroke", U(Se.Category)).style("fill-opacity", 0.4), K.showMaxMarkers && Te.append("circle").attr("cx", re(Se.max)).attr("cy", Ce(pe)).attr("r", se).style("fill", U(Se.Category)).style("stroke", U(Se.Category)).style("fill-opacity", 0.4);
              }), K.showXAxis && Ae.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(N, ")")).call(Z), K.showYAxis && Ae.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(de).selectAll(".tick text").call(this.wrap, je.bandwidth() || je.range()).selectAll(".tick text tspan").attr("x", -9);
            } }]) && A(w.prototype, M), q;
          }(x);
          return p;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 557: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(k, G) {
              if (typeof G != "function" && G !== null) throw new TypeError("Super expression must either be null or a function");
              k.prototype = Object.create(G && G.prototype, { constructor: { value: k, writable: !0, configurable: !0 } }), G && D(k, G);
            })(I, w);
            var M, V, q, $ = _(I);
            function I() {
              return E(this, I), $.apply(this, arguments);
            }
            return M = I, q = [{ key: "convertData", value: function(k) {
              return k[0].hasOwnProperty("values") || (k = [{ name: "", values: k }]), k;
            } }, { key: "getMinValue", value: function(k, G) {
              return x.min(k, function(X) {
                return x.min(X.values, function(ie) {
                  return ie[G];
                });
              });
            } }, { key: "getMaxValue", value: function(k, G) {
              return x.max(k, function(X) {
                return x.max(X.values, function(ie) {
                  return ie[G];
                });
              });
            } }, { key: "getZeroBasedY", value: function(k) {
              var G = k.data, X = k.yValue, ie = k.height, K = I.getMaxValue(G, X);
              return x.scaleLinear().domain([0, K]).range([ie, 0]);
            } }, { key: "getRelativeY", value: function(k) {
              var G = k.data, X = k.yValue, ie = X === void 0 ? "yValue" : X, K = k.height, N = k.yRangePadding, B = N === void 0 ? 0.1 : N, oe = k.defaultYRangePadding, ne = oe === void 0 ? 10 : oe;
              G = I.convertData(G);
              var re = I.getMinValue(G, ie), je = I.getMaxValue(G, ie), Z = (je - re) * B || ne;
              return x.scaleLinear().domain([re - Z, je + Z]).range([K, 0]);
            } }], (V = [{ key: "render", value: function(k, G, X, ie, K) {
              R(P(I.prototype), "render", this).call(this, k, G, X, ie, K), typeof G == "string" && (G = document.querySelector(G));
              var N = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: this.interpolation.linear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, getTooltipBuilder: null }, B = this.getOptions(N, K), oe = this.createSvg(G, X, ie), ne = typeof B.getTooltipBuilder == "function" ? B.getTooltipBuilder(B) : this.lineDefaultTooltip(B.xLabel || "x", B.xFormat, function(Be) {
                return Be[B.xValue];
              }, B.yLabel || "y", B.yFormat, function(Be) {
                return Be[B.yValue];
              }, function(Be) {
                return Be[B.seriesName];
              });
              if (k.length > 0) {
                k = I.convertData(k), this.useTip(function(Be) {
                  Be.attr("class", "d3-tip").offset([-10, 0]).html(ne);
                });
                var re = 0, je = 0;
                if (B.xLabel) {
                  var Z = oe.append("g").attr("transform", "translate(".concat(X / 2, ", ").concat(ie - B.margins.bottom, ")"));
                  Z.append("text").attr("class", "axislabel").style("text-anchor", "middle").text(B.xLabel), re += Z.node().getBBox().height;
                }
                if (B.yLabel) {
                  var de = oe.append("g").attr("transform", `translate(
	              `.concat(B.margins.left, `,
	              `).concat((ie - B.margins.bottom - B.margins.top) / 2 + B.margins.top, `
	            )`));
                  de.append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(B.yLabel), je = 1.2 * de.node().getBBox().width;
                }
                var U = 0;
                if (B.showLegend) {
                  var ce = oe.append("g").attr("class", "legend"), fe = 0;
                  k.forEach(function(Be, xt) {
                    ce.append("rect").attr("x", 0).attr("y", 15 * xt).attr("width", 10).attr("height", 10).style("fill", B.colors(Be.name));
                    var jt = ce.append("text").attr("x", 12).attr("y", 15 * xt + 9).text(Be.name);
                    fe = Math.max(jt.node().getBBox().width + 12, fe);
                  }), ce.attr("transform", `translate(
	          `.concat(X - B.margins.right - fe, `,
	          `).concat(B.margins.top, `
	        )`)), (U += fe + 5) > X / 3 && ce.style("display", "none");
                }
                var he = X - B.margins.left - B.margins.right - je - (U > X / 5 ? 0 : U), ye = ie - B.margins.top - B.margins.bottom - re, Ee = B.xScale || x.scaleLinear().domain([x.min(k, function(Be) {
                  return x.min(Be.values, function(xt) {
                    return xt[B.xValue];
                  });
                }), x.max(k, function(Be) {
                  return x.max(Be.values, function(xt) {
                    return xt[B.xValue];
                  });
                })]), ue = x.axisBottom().scale(Ee).ticks(B.ticks);
                B.tickFormat ? ue.tickFormat(B.tickFormat) : ue.tickFormat(B.xFormat), typeof Ee.rangePoints == "function" ? Ee.rangePoints([0, he]) : Ee.range([0, he]);
                var Oe = B.yScale || I.getZeroBasedY({ data: k, height: ye, yValue: B.yValue }), pe = x.axisLeft().scale(Oe).tickFormat(B.yFormat).ticks(B.yTicks), se = oe.append("g").attr("class", "axis");
                se.call(ue);
                var Ae = Math.round(se.node().getBBox().height), He = Math.round(se.node().getBBox().width);
                ye -= Ae, he -= Math.max(0, He - he), se.remove();
                var qe = B.yAxisWidth;
                if (B.yAxisWidth == null) {
                  var Ce = oe.append("g").attr("class", "axis");
                  Ce.call(pe), qe = Math.round(Ce.node().getBBox().width), Ce.remove();
                }
                he -= qe, typeof Ee.rangePoints == "function" ? Ee.rangePoints([0, he]) : Ee.range([0, he]), Oe.range([ye, 0]);
                var xe = x.line().x(function(Be) {
                  return Ee(Be[B.xValue]);
                }).y(function(Be) {
                  return Oe(Be[B.yValue]);
                }).curve(B.interpolate), Se = oe.append("g").attr("class", B.cssClass).attr("transform", `translate(
	            `.concat(B.margins.left + je + qe, `,
	            `).concat(B.margins.top, `
	          )`)), Te = Se.selectAll(".series").data(k).enter().append("g"), me = Te.append("path").attr("class", "line").attr("d", function(Be) {
                  return xe(Be.values.sort(function(xt, jt) {
                    return x.ascending(xt[B.xValue], jt[B.xValue]);
                  }));
                });
                B.colors && me.style("stroke", function(Be, xt) {
                  return B.colors(Be.name);
                }), B.showSeriesLabel && Te.append("text").datum(function(Be) {
                  return { name: Be.name, value: Be.values[Be.values.length - 1] };
                }).attr("transform", function(Be) {
                  return "translate(".concat(Ee(Be.value[B.xValue]), ", ").concat(Oe(Be.value[B.yValue]), ")");
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(Be) {
                  return Be.name;
                });
                var et = { x: 0, y: 0 };
                Se.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ye, ")")).call(ue), Se.append("g").attr("class", "y axis").call(pe), B.labelIndexDate && Se.append("rect").attr("transform", "translate(".concat(et.x - 0.5, ", ").concat(et.y, ")")).attr("width", 1).attr("height", ye), this.appendTracker({ vis: Se, data: k, width: he, height: ye, x: Ee, y: Oe, options: B });
              } else oe.append("text").attr("transform", "translate(".concat(X / 2, ", ").concat(ie / 2, ")")).style("text-anchor", "middle").text("No Data");
            } }, { key: "appendTracker", value: function(k) {
              var G = this, X = k.vis, ie = k.data, K = k.width, N = k.height, B = k.x, oe = k.y, ne = k.options, re = X.append("g").attr("class", "current-focus").style("display", "none"), je = re.append("line").attr("class", "x-hover-line").style("stroke-width", "2px").style("stroke-dasharray", "3,3").attr("y1", 0), Z = re.append("circle").attr("r", 2), de = X.append("rect").style("opacity", 0), U = x.quadtree().x(function(fe) {
                return B(fe[ne.xValue]);
              }).y(function(fe) {
                return oe(fe[ne.yValue]);
              }), ce = ie.reduce(function(fe, he) {
                return fe.concat(he.values.map(function(ye) {
                  return ye.name = he.name, ye;
                }));
              }, []);
              U.addAll(ce), de.attr("class", "overlay").attr("width", K).attr("height", N).attr("pointer-events", "all").on("mouseover", function() {
                return re.style("display", null);
              }).on("mouseout", function() {
                re.style("display", "none"), G.tip.hide({}, re.node());
              }), de.on("mousemove", function() {
                var fe = x.event, he = x.mouse(fe.target), ye = U.find(he[0], he[1]);
                Z.style("fill", ne.colors(ye.name)), je.style("stroke", ne.colors(ye.name)), je.attr("y2", N - oe(ye[ne.yValue])), re.attr("transform", "translate(" + B(ye[ne.xValue]) + "," + oe(ye[ne.yValue]) + ")"), G.tip.show(ye, re.node());
              });
            } }, { key: "interpolation", get: function() {
              return { linear: x.curveLinear, curveStep: x.curveStep, curveStepBefore: x.curveStepBefore, curveStepAfter: x.curveStepAfter, curveBasis: x.curveBasis, curveCardinal: x.curveCardinal, curveMonotoneX: x.curveMonotoneX, curveCatmullRom: x.curveCatmullRom };
            } }]) && A(M.prototype, V), q && A(M, q), I;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 76: (h, d, f) => {
        var C;
        h = f.nmd(h), C = (function(v) {
          var b = { version: "0.0.1" }, E = f(842), A = f(648), R = f(605), D = f(131), _ = f(316), F = f(535), P = f(502), x = f(487), p = f(557), y = f(775), w = f(312), M = f(345), V = f(255), q = f(587), $ = f(132);
          return b.chart = E, b.aster = A, b.areachart = R, b.barchart = D, b.boxplot = _, b.donut = F, b.histogram = P, b.horizontalBoxplot = x, b.line = p, b.trellisline = y, b.treemap = w, b.scatterplot = M, b.splitBoxplot = V, b.sunburst = q, b.util = $, b;
        }).call(d, f, d, h), C === void 0 || (h.exports = C);
      }, 345: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = { xFormat: this.formatters.formatSI(3), yFormat: this.formatters.formatSI(3), interpolate: x.curveLinear, seriesName: "SERIES_NAME", xValue: "xValue", yValue: "yValue", cssClass: "lineplot", ticks: 10, yTicks: 4, showSeriesLabel: !1, labelIndexDate: !1, colorBasedOnIndex: !1, truncateLabelAtLine: 2, showXAxis: !0, tooltip: function(me) {
                return "<div>Series: ".concat(me.seriesName, `</div>
					<div>X: `).concat(me[N.xValue], `</div>
					<div>Y: `).concat(me[N.yValue], `</div>
					`);
              }, circleRadius: 1, addDiagonal: !1, diagonalColor: "#ccc" }, N = this.getOptions(K, ie);
              ie.colors ? N.colors = x.scaleOrdinal(Object.values(ie.colors)).domain(Object.keys(ie.colors)) : N.colors = x.scaleOrdinal(x.schemeCategory20).domain(I.map(function(me) {
                return me.name;
              }));
              var B = this.createSvg(k, G, X);
              if (I.length > 0) {
                I[0].hasOwnProperty("values") || (I = [{ name: "", values: I }]), this.useTip(function(me) {
                  me.attr("class", "d3-tip").offset([-10, 0]).html(N.tooltip);
                });
                var oe, ne, re = 0, je = 0;
                N.xLabel && ((oe = B.append("g")).append("text").attr("class", "axislabel").attr("dy", 0).attr("y", 0).style("text-anchor", "middle").text(N.xLabel), re += oe.node().getBBox().height), N.yLabel && ((ne = B.append("g")).append("text").attr("class", "axislabel").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em").style("text-anchor", "middle").text(N.yLabel), je = 1.5 * ne.node().getBBox().width);
                var Z = 0;
                if (N.showLegend) {
                  var de = B.append("g").attr("class", "legend"), U = 0;
                  I.forEach(function(me, et) {
                    de.append("rect").attr("x", 0).attr("y", 15 * et).attr("width", 10).attr("height", 10).style("fill", N.colors(me.name));
                    var Be = de.append("text").attr("x", 12).attr("y", 15 * et + 9).text(me.name);
                    U = Math.max(Be.node().getBBox().width + 12, U);
                  }), de.attr("transform", "translate(" + (G - N.margins.right - U) + ",0)"), Z += U + 5;
                }
                var ce = G - N.margins.left - N.margins.right - je - Z, fe = X - N.margins.top - N.margins.bottom - re, he = N.xScale || x.scaleLinear().domain([x.min(I, function(me) {
                  return x.min(me.values, function(et) {
                    return et[N.xValue];
                  });
                }), x.max(I, function(me) {
                  return x.max(me.values, function(et) {
                    return et[N.xValue];
                  });
                })]), ye = x.axisBottom().scale(he).ticks(N.ticks);
                N.tickFormat ? ye.tickFormat(N.tickFormat) : ye.tickFormat(N.xFormat), typeof he.rangePoints == "function" ? he.rangePoints([0, ce]) : he.range([0, ce]);
                var Ee = N.yScale || x.scaleLinear().domain([0, x.max(I, function(me) {
                  return x.max(me.values, function(et) {
                    return et[N.yValue];
                  });
                })]).range([fe, 0]), ue = x.axisLeft().scale(Ee).tickFormat(N.yFormat).ticks(N.yTicks), Oe = B.append("g").attr("class", "axis");
                Oe.call(ye);
                var pe = Math.round(Oe.node().getBBox().height), se = Math.round(Oe.node().getBBox().width);
                fe -= pe, ce -= Math.max(0, se - ce), Oe.remove();
                var Ae = B.append("g").attr("class", "axis");
                Ae.call(ue);
                var He = Math.round(Ae.node().getBBox().width);
                if (ce -= He, Ae.remove(), N.xLabel && oe) {
                  oe.selectAll("text").call(this.wrap, ce, N.truncateLabelAtLine);
                  var qe = oe.node().getBBox().height;
                  fe -= qe, oe.attr("transform", `translate(
								`.concat(je + He + N.margins.left + ce / 2, `,
								`).concat(X - N.margins.bottom - qe, `
							)`));
                }
                N.yLabel && ne && (ne.attr("transform", `translate(
							`.concat(N.margins.left, `,
							`).concat(N.margins.bottom + fe / 2, `
						)`)).selectAll("text").call(this.wrap, fe, N.truncateLabelAtLine), je = ne.node().getBBox().width), typeof he.rangePoints == "function" ? he.rangePoints([0, ce]) : he.range([0, ce]), Ee.range([fe, 0]);
                var Ce = B.append("g").attr("class", N.cssClass).attr("transform", "translate(" + (N.margins.left + je + He) + "," + N.margins.top + ")"), xe = Ce.selectAll(".series").data(I).enter().append("g");
                xe.selectAll(".dot").data(function(me) {
                  return me.values.map(function(et) {
                    return Object.assign({}, et, { seriesName: me.name });
                  });
                }).enter().append("circle").attr("class", "dot").attr("r", N.circleRadius).style("fill", function(me, et) {
                  return N.colors(me.seriesName);
                }).attr("transform", function(me) {
                  return "translate(" + he(me[N.xValue]) + "," + Ee(me[N.yValue]) + ")";
                }), N.addDiagonal && xe.append("line").attr("x1", 0).attr("y1", fe).attr("x2", ce).attr("y2", 0).attr("stroke-width", 1).attr("stroke", N.diagonalColor).attr("stroke-dasharray", "5,5"), N.showSeriesLabel && xe.append("text").datum(function(me) {
                  return { name: me.name, value: me.values[me.values.length - 1] };
                }).attr("transform", function(me) {
                  return "translate(" + he(me.value[N.xValue]) + "," + Ee(me.value[N.yValue]) + ")";
                }).attr("x", 3).attr("dy", 2).style("font-size", "8px").text(function(me) {
                  return me.name;
                });
                var Se = { x: 0, y: 0 }, Te = this;
                xe.selectAll(".focus").data(function(me) {
                  return me.values.map(function(et) {
                    return Object.assign({}, et, { seriesName: me.name });
                  });
                }).enter().append("circle").attr("class", "focus").attr("r", N.circleRadius).attr("transform", function(me) {
                  var et = he(me[N.xValue]), Be = Ee(me[N.yValue]);
                  return me[N.xValue] === 0 && Se.y === 0 && (Se.x = et, Se.y = Be), "translate(" + et + "," + Be + ")";
                }).on("mouseover", function(me) {
                  x.select(this).style("opacity", "1").style("stroke", N.colors(me.seriesName)).style("stroke-width", N.circleRadius / 2), Te.tip.show(me, event.target);
                }).on("mouseout", function(me) {
                  x.select(this).style("opacity", "0"), Te.tip.hide(me, event.target);
                }), N.showXAxis && Ce.append("g").attr("class", "x axis").attr("transform", "translate(0," + fe + ")").call(ye), Ce.append("g").attr("class", "y axis").call(ue), N.labelIndexDate && Ce.append("rect").attr("transform", function() {
                  return "translate(" + (Se.x - 0.5) + "," + Se.y + ")";
                }).attr("width", 1).attr("height", fe);
              } else B.append("text").attr("transform", "translate(" + G / 2 + "," + X / 2 + ")").style("text-anchor", "middle").text("No Data");
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 255: (h, d, f) => {
        var C, v;
        function b(P) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, b(P);
        }
        function E(P, x) {
          if (!(P instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function A(P, x) {
          for (var p = 0; p < x.length; p++) {
            var y = x[p];
            y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(P, y.key, y);
          }
        }
        function R(P, x) {
          return R = Object.setPrototypeOf || function(p, y) {
            return p.__proto__ = y, p;
          }, R(P, x);
        }
        function D(P) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var p, y = F(P);
            if (x) {
              var w = F(this).constructor;
              p = Reflect.construct(y, arguments, w);
            } else p = y.apply(this, arguments);
            return _(this, p);
          };
        }
        function _(P, x) {
          return !x || b(x) !== "object" && typeof x != "function" ? function(p) {
            if (p === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p;
          }(P) : x;
        }
        function F(P) {
          return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, F(P);
        }
        C = [f(680), f(316)], v = (function(P, x) {
          var p = function(y) {
            (function($, I) {
              if (typeof I != "function" && I !== null) throw new TypeError("Super expression must either be null or a function");
              $.prototype = Object.create(I && I.prototype, { constructor: { value: $, writable: !0, configurable: !0 } }), I && R($, I);
            })(q, y);
            var w, M, V = D(q);
            function q() {
              return E(this, q), V.apply(this, arguments);
            }
            return w = q, (M = [{ key: "render", value: function($, I, k, G, X) {
              var ie = { showXAxis: !0, showMinMarkers: !0, showMaxMarkers: !0, boxHeight: 10, valueFormatter: this.formatters.formatSI(3), margins: { top: 0, right: 0, bottom: 0, left: 0 } }, K = this.getOptions(ie, X), N = this.createSvg(I, k, G), B = K.valueFormatter;
              this.useTip(this.defaultTip, K), $.forEach(function(me) {
                return me.Category = me.Category || "Default";
              });
              var oe = k - K.margins.left - K.margins.right, ne = G - K.margins.top - K.margins.bottom, re = P.scaleLinear().range([0, oe]).domain([K.xMin || P.min($, function(me) {
                return Math.min(me.target.min, me.compare.min);
              }), K.xMax || P.max($, function(me) {
                return Math.max(me.target.max, me.compare.max);
              })]), je = P.scaleBand().range([0, ne]).round(1 / $.length).domain($.map(function(me) {
                return me.Category;
              })), Z = P.axisBottom().scale(re).tickFormat(B).ticks(5), de = P.axisLeft().scale(je), U = 0, ce = U;
              if (K.showXAxis) {
                var fe = N.append("g").attr("class", "axis");
                fe.call(Z), U = Math.round(fe.node().getBBox().height) + 2, ce = Math.round(fe.node().getBBox().width) + 4, ne -= U, oe -= Math.max(0, ce - oe), fe.remove();
              }
              var he = 0;
              if (K.showYAxis) {
                var ye = N.append("g").attr("class", "axis");
                ye.call(de), oe -= he = Math.round(ye.node().getBBox().width), ye.remove();
              }
              var Ee = K.boxHeight, ue = je.bandwidth() / 2 - Ee / 2, Oe = Ee / 2, pe = Oe / 10;
              K.showMinMarkers && (oe -= pe > he ? 2 * pe - he : pe), re.range([0, oe]), je.range([ne, 0]);
              var se = N.append("g").attr("transform", `translate(
	          `.concat(K.margins.left + Math.max(he, pe), `,
	          `).concat(K.margins.top, `
	        )`));
              if (K.showLegend) {
                var Ae = N.append("g").attr("class", "legend"), He = Ae.append("g"), qe = Ae.append("g");
                He.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "target"), He.append("text").attr("x", 15).attr("y", 9).text("Target"), qe.append("rect").attr("x", He.node().getBBox().width + 10).attr("y", 0).attr("width", 10).attr("height", 10).attr("class", "compare"), qe.append("text").attr("x", He.node().getBBox().width + 25).attr("y", 9).text("Compare"), Ae.attr("transform", `translate(
					`.concat((k - Ae.node().getBBox().width) / 2, `,
					0
				)`));
              }
              var Ce = se.selectAll(".boxplot").data($).enter().append("g").attr("class", "boxplot").attr("transform", function(me) {
                return "translate(0, ".concat(je(me.Category), ")");
              }), xe = this, Se = P.scaleLinear().range([Ee / 2, 0]).domain([0, Ee]), Te = P.scaleLinear().range([0, Ee / 2]).domain([0, Ee]);
              je.bandwidth(), Ce.each(function(me) {
                var et = P.select(this).append("g").attr("transform", function() {
                  return "translate(0, ".concat(ue, ")");
                }), Be = et.append("g").datum(me.target).attr("class", "target"), xt = et.append("g").datum(me.compare).attr("class", "compare").attr("transform", function() {
                  return "translate(0, ".concat(Ee / 2 + 2, ")");
                });
                [{ boxPlotData: me.target, boxplot: Be, boxScale: Se }, { boxPlotData: me.compare, boxplot: xt, boxScale: Te, tipDirection: "s", tipOffset: [10, 0] }].forEach(function(jt) {
                  var ut = jt.boxPlotData, Qe = jt.boxplot, pt = jt.boxScale;
                  ut.LIF != ut.q1 && (Qe.append("line").attr("class", "bar").attr("x1", re(ut.LIF)).attr("y1", pt(0)).attr("x2", re(ut.LIF)).attr("y2", pt(Oe)), Qe.append("line").attr("class", "whisker").attr("x1", re(ut.LIF)).attr("y1", pt(0)).attr("x2", re(ut.q1)).attr("y2", pt(0))), Qe.append("rect").attr("class", "box").attr("x", re(ut.q1)).attr("y", Math.min(pt(0), pt(Ee))).attr("width", Math.max(1, re(ut.q3) - re(ut.q1))).attr("height", Math.abs(pt(0) - pt(Ee))).on("mouseover", function(Rn) {
                    return xe.tip.show(Object.assign({}, Rn, { tipDirection: jt.tipDirection, tipOffset: jt.tipOffset }), event.target);
                  }).on("mouseout", function(Rn) {
                    return xe.tip.hide(Rn, event.target);
                  }), Qe.append("line").attr("class", "median").attr("x1", re(ut.median)).attr("y1", pt(0)).attr("x2", re(ut.median)).attr("y2", pt(Ee)), ut.UIF != ut.q3 && (Qe.append("line").attr("class", "bar").attr("x1", re(ut.UIF)).attr("y1", pt(0)).attr("x2", re(ut.UIF)).attr("y2", pt(Oe)), Qe.append("line").attr("class", "whisker").attr("x1", re(ut.q3)).attr("y1", pt(0)).attr("x2", re(ut.UIF)).attr("y2", pt(0))), K.showMinMarkers && Qe.append("circle").attr("cx", re(ut.min)).attr("cy", pt(Oe / 2)).attr("r", pe), K.showMaxMarkers && Qe.append("circle").attr("cx", re(ut.max)).attr("cy", pt(Oe / 2)).attr("r", pe);
                });
              }), K.showXAxis && se.append("g").attr("class", "x axis").attr("transform", "translate(0, ".concat(ne, ")")).call(Z), K.showYAxis && se.append("g").attr("class", "y axis").attr("transform", "translate(0, 0)").call(de).selectAll(".tick text").call(this.wrap, je.bandwidth() || je.range());
            } }]) && A(w.prototype, M), q;
          }(x);
          return p;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 587: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "getTipDirection", value: function(I) {
              return "n";
            } }, { key: "getTipOffset", value: function(I, k) {
              var G = event.target.getBBox(), X = k.centroid(I), ie = Math.abs(G.x - X[0]) - G.width / 2;
              return [Math.abs(G.y - X[1]) - 10, ie];
            } }, { key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = this.getOptions({ tooltip: function(U) {
                return "<div>No Tooltip Set</div>";
              }, minRadians: 5e-3 }, ie), N = this.createSvg(k, G, X);
              N.attr("class", "sunburst"), this.useTip(function(U, ce) {
                U.attr("class", "d3-tip ".concat(ce.tipClass || "")).offset(function(fe) {
                  return fe.tipOffset || [-10, 0];
                }).direction(function(fe) {
                  return fe.tipDirection || "n";
                }).html(function(fe) {
                  return ce.tooltip(fe);
                });
              }, K);
              var B = N.append("svg:g").attr("transform", "translate(" + G / 2 + "," + X / 2 + ")"), oe = Math.min(G, X) / 2, ne = x.partition().size([2 * Math.PI, oe]), re = x.arc().startAngle(function(U) {
                return U.x0;
              }).endAngle(function(U) {
                return U.x1;
              }).innerRadius(function(U) {
                return U.y0;
              }).outerRadius(function(U) {
                return U.y1;
              });
              B.append("svg:circle").attr("r", oe).style("opacity", 0);
              var je = ne(x.hierarchy(I).sum(function(U) {
                return U.size;
              }).sort(function(U, ce) {
                return ce.value - U.value;
              })).descendants().filter(function(U) {
                return U.x1 - U.x0 > K.minRadians;
              }).reverse();
              if (K.split) {
                var Z = je.reduce(function(U, ce) {
                  var fe = K.split(ce);
                  return fe.length > 1 && (ce.isSplit = !0, U = U.concat(fe.map(function(he) {
                    return Object.assign(he, { isPartialNode: !0 });
                  }))), U;
                }, []);
                B.data([I]).selectAll("partialnode").data(Z).enter().append("svg:path").attr("d", re).attr("fill-rule", "evenodd").attr("class", "partial").style("fill", function(U) {
                  return K.colors(U.data.name);
                });
              }
              var de = this;
              B.data([I]).selectAll("pathnode").data(je).enter().append("svg:path").attr("display", function(U) {
                return U.depth ? null : "none";
              }).attr("d", re).attr("fill-rule", "evenodd").attr("class", function(U) {
                return K.nodeClass && K.nodeClass(U) || "node";
              }).style("fill", function(U) {
                return U.isSplit ? "#000" : K.colors(U.data.name);
              }).style("opacity", function(U) {
                return U.isSplit ? 0 : 1;
              }).on("mouseover", function(U) {
                return de.tip.show(Object.assign({}, U, { tipDirection: de.getTipDirection(U), tipOffset: de.getTipOffset(U, re) }), event.target);
              }).on("mouseout", function(U) {
                return de.tip.hide(U, event.target);
              }).on("click", function(U) {
                return K.onclick && K.onclick(U);
              });
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 312: (h, d, f) => {
        var C, v;
        function b(P) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, b(P);
        }
        function E(P, x) {
          if (!(P instanceof x)) throw new TypeError("Cannot call a class as a function");
        }
        function A(P, x) {
          for (var p = 0; p < x.length; p++) {
            var y = x[p];
            y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(P, y.key, y);
          }
        }
        function R(P, x) {
          return R = Object.setPrototypeOf || function(p, y) {
            return p.__proto__ = y, p;
          }, R(P, x);
        }
        function D(P) {
          var x = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var p, y = F(P);
            if (x) {
              var w = F(this).constructor;
              p = Reflect.construct(y, arguments, w);
            } else p = y.apply(this, arguments);
            return _(this, p);
          };
        }
        function _(P, x) {
          return !x || b(x) !== "object" && typeof x != "function" ? function(p) {
            if (p === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p;
          }(P) : x;
        }
        function F(P) {
          return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(x) {
            return x.__proto__ || Object.getPrototypeOf(x);
          }, F(P);
        }
        C = [f(680), f(842)], v = (function(P, x) {
          var p = function(y) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && R(I, k);
            })($, y);
            var w, M, V, q = D($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return w = $, M = [{ key: "render", value: function(I, k, G, X, ie) {
              var K = this, N = this.getOptions(ie), B = this.createSvg(k, G, X), oe = P.scaleLinear().range([0, G]), ne = P.scaleLinear().range([0, X]);
              P.select(k).select(".treemap_zoomtarget").text("");
              var re = 0, je = P.treemap().round(!1).size([G, X]), Z = P.hierarchy(I, function(se) {
                return se.children;
              }).sum(N.getsizevalue), de = je(Z);
              function U(se) {
                var Ae = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], He = G / (se.x1 - se.x0) || G, qe = X / (se.y1 - se.y0) || X;
                se.x1 && se.y1 ? (oe.domain([se.x0, se.x0 + (se.x1 - se.x0)]), ne.domain([se.y0, se.y0 + (se.y1 - se.y0)])) : (oe.domain([0, G]), ne.domain([0, X]));
                var Ce = P.select(k).select(".treemap_zoomtarget");
                if (Ce.size()) if (se.data.name === "root") Ce.text("");
                else {
                  var xe = Ce.text();
                  Ce.text("".concat(xe, " > ").concat(se.data.name));
                }
                var Se = B.selectAll("g.cell, .grouper");
                Ae && (Se = Se.transition().duration(750)), Se.attr("transform", function(Te) {
                  return "translate(".concat(oe(Te.x0), ", ").concat(ne(Te.y0), ")");
                }).on("end", function() {
                  B.selectAll(".grouper").attr("display", "block");
                }), Se.select("rect").attr("width", function(Te) {
                  return Math.max(0, He * (Te.x1 - Te.x0) - 1);
                }).attr("height", function(Te) {
                  return Math.max(0, qe * (Te.y1 - Te.y0) - 1);
                }), event && event.stopPropagation(), N.onZoom && N.onZoom(se);
              }
              function ce(se) {
                var Ae = G / (se.x1 - se.x0), He = X / (se.y1 - se.y0), qe = de.children.filter(function(Ce) {
                  return Ce.parent === se;
                });
                B.selectAll(".grouper").remove(), B.selectAll(".grouper").data(qe).enter().append("g").attr("class", "grouper").attr("transform", function(Ce) {
                  return "translate(".concat(Ce.x0 + 1, ", ").concat(Ce.y0 + 1, ")");
                }).attr("display", "none").append("rect").attr("width", function(Ce) {
                  return Math.max(0, Ae * (Ce.x1 - Ce.x0) - 1);
                }).attr("height", function(Ce) {
                  return Math.max(0, He * (Ce.y1 - Ce.y0) - 1);
                }).attr("title", function(Ce) {
                  return Ce.name;
                }).attr("id", function(Ce) {
                  return Ce.id;
                });
              }
              var fe, he = de.leaves().filter(function(se) {
                return N.getsizevalue(se.data);
              }), ye = P.extent(he, function(se) {
                return N.getcolorvalue(se.data);
              }), Ee = P.median(he, function(se) {
                return N.getcolorvalue(se.data);
              });
              fe = N.getcolorrange ? N.getcolorrange() : ["#E4FF7A", "#FC7F00"];
              var ue = [ye[0], Ee, ye[1]];
              N.getcolorscale && (ue = N.getcolorscale());
              var Oe = P.scaleLinear().domain(ue).range(fe), pe = B.selectAll("g").data(he).enter().append("g").attr("class", "cell").attr("transform", function(se) {
                return "translate(".concat(se.x0, ", ").concat(se.y0, ")");
              });
              pe.append("rect").attr("width", function(se) {
                return Math.max(0, se.x1 - se.x0 - 1);
              }).attr("height", function(se) {
                return Math.max(0, se.y1 - se.y0 - 1);
              }).attr("id", function(se) {
                return se.id;
              }).style("fill", function(se) {
                return Oe(N.getcolorvalue(se.data));
              }).on("click", function(se) {
                if (N.useTip && K.tip.hide(), event.altKey) U(Z), ce(Z);
                else if (event.ctrlKey) {
                  for (var Ae = se; Ae.depth !== re + 1; ) Ae = Ae.parent;
                  re = Ae.depth, Ae.children && Ae.children.length > 1 ? (ce(Ae), U(Ae)) : (re = 0, ce(Z), U(Z));
                } else N.onclick(se.data);
              }), N.useTip ? (this.useTip(function(se) {
                se.attr("class", "d3-tip").direction(function(Ae) {
                  var He = oe.domain()[1] === 1 ? G : oe.domain()[1];
                  return Ae.x1 >= He - He / 10 ? "w" : Ae.x0 <= He / 10 ? "e" : "n";
                }).offset([3, 0]).html(function(Ae) {
                  return "".concat(N.gettitle(Ae.data), "<br/><br/>").concat(N.getcontent(Ae.data));
                });
              }), pe.on("mouseover", function(se) {
                return K.tip.show(se, event.target);
              }).on("mouseout", function(se) {
                return K.tip.hide(se, event.target);
              })) : pe.attr("data-container", "body").attr("data-toggle", "popover").attr("data-trigger", "hover").attr("data-placement", "top").attr("data-html", !0).attr("data-title", function(se) {
                return N.gettitle(se.data);
              }).attr("data-content", function(se) {
                return N.getcontent(se.data);
              }), N.initialZoomedConcept ? (ce(N.initialZoomedConcept), U(N.initialZoomedConcept, !1)) : ce(Z), B.selectAll(".grouper").attr("display", "block");
            } }, { key: "formatters", get: function() {
              return { format_pct: P.format(".2%"), format_fixed: P.format(".2f"), format_comma: P.format(",") };
            } }], V = [{ key: "buildHierarchyFromJSON", value: function(I, k, G) {
              var X = 0, ie = { name: "root", children: [] };
              return I.PERCENT_PERSONS.forEach(function(K) {
                X += K;
              }), I.CONCEPT_PATH.forEach(function(K, N) {
                for (var B = K.split("||"), oe = ie, ne = function(je) {
                  var Z = oe.children, de = B[je], U = void 0;
                  if (je + 1 < B.length) {
                    var ce = !1;
                    Z.forEach(function(fe) {
                      fe.name === de && (U = fe, ce = !0);
                    }), ce || (U = { name: de, children: [] }, Z.push(U)), oe = U;
                  } else U = G(de, N, I), I.PERCENT_PERSONS[N] / X > k && Z.push(U);
                }, re = 0; re < B.length; re += 1) ne(re);
              }), ie;
            } }], M && A(w.prototype, M), V && A(w, V), $;
          }(x);
          return p;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 775: (h, d, f) => {
        var C, v;
        function b(x) {
          return b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
            return typeof p;
          } : function(p) {
            return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
          }, b(x);
        }
        function E(x, p) {
          if (!(x instanceof p)) throw new TypeError("Cannot call a class as a function");
        }
        function A(x, p) {
          for (var y = 0; y < p.length; y++) {
            var w = p[y];
            w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(x, w.key, w);
          }
        }
        function R(x, p, y) {
          return R = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(w, M, V) {
            var q = function(I, k) {
              for (; !Object.prototype.hasOwnProperty.call(I, k) && (I = P(I)) !== null; ) ;
              return I;
            }(w, M);
            if (q) {
              var $ = Object.getOwnPropertyDescriptor(q, M);
              return $.get ? $.get.call(V) : $.value;
            }
          }, R(x, p, y || x);
        }
        function D(x, p) {
          return D = Object.setPrototypeOf || function(y, w) {
            return y.__proto__ = w, y;
          }, D(x, p);
        }
        function _(x) {
          var p = function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }();
          return function() {
            var y, w = P(x);
            if (p) {
              var M = P(this).constructor;
              y = Reflect.construct(w, arguments, M);
            } else y = w.apply(this, arguments);
            return F(this, y);
          };
        }
        function F(x, p) {
          return !p || b(p) !== "object" && typeof p != "function" ? function(y) {
            if (y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y;
          }(x) : p;
        }
        function P(x) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, P(x);
        }
        C = [f(680), f(842)], v = (function(x, p) {
          var y = function(w) {
            (function(I, k) {
              if (typeof k != "function" && k !== null) throw new TypeError("Super expression must either be null or a function");
              I.prototype = Object.create(k && k.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), k && D(I, k);
            })($, w);
            var M, V, q = _($);
            function $() {
              return E(this, $), q.apply(this, arguments);
            }
            return M = $, (V = [{ key: "render", value: function(I, k, G, X, ie) {
              R(P($.prototype), "render", this).call(this, I, k, G, X, ie);
              var K = { trellisSet: x.keys(I), yTicks: 4, xFormat: x.format("d"), yFormat: x.format("d"), interpolate: x.curveLinear }, N = this.getOptions(K, ie), B = this.createSvg(k, G, X);
              function oe() {
                var Me = Ce.invert(x.mouse(event.target)[0]);
                Qe.selectAll(".g-label-value.g-start").call(ne, Me), Qe.selectAll(".g-label-year.g-start").call(re, Me), Qe.selectAll(".g-value").attr("transform", function(Fe) {
                  var Xe = Fe.values;
                  if (Xe) {
                    var at = Xe[de(Xe, Me, 0, Xe.length - 1)], Bt = at.Y_PREVALENCE_1000PP === 0 || at.Y_PREVALENCE_1000PP ? at.Y_PREVALENCE_1000PP : at.yPrevalence1000Pp;
                    return at && at.date ? "translate(" + Ce(at.date) + "," + xe(Bt) + ")" : "translate(0,0);";
                  }
                });
              }
              function ne(Me, Fe) {
                var Xe = x.scaleLinear().domain(Ce.range()), at = {};
                Me.each(function(Bt, Ut) {
                  var Tr = x.select(this), gt = Bt.values, Gt = de(gt, Fe, 0, gt.length - 1), Pn = Math.round(Gt / (gt.length - 1) * (gt.length - 12)), Lt = gt[Gt];
                  if (Lt && Lt.date) {
                    var _r = Ce(Lt.date), cr = Lt.Y_PREVALENCE_1000PP === 0 || Lt.Y_PREVALENCE_1000PP ? Lt.Y_PREVALENCE_1000PP : Lt.yPrevalence1000Pp, Ri = Xe.range([0, qe.bandwidth()])(_r), Ua = xe(x.max(gt.slice(Pn, Pn + 12), function(Pi) {
                      return cr;
                    })), Er = Lt.TRELLIS_NAME || Lt.trellisName;
                    if (Er) {
                      !at[Er] && (at[Er] = []);
                      var Ga = Lt.date.getTime() === ce.getTime() ? "end" : (Lt.date.getTime(), U.getTime(), "start");
                      at[Er].push({ y: Ua, x: Ri, textAnchor: Ga, value: cr, text: Tr, color: N.colors(Bt.key) });
                    }
                  }
                }), Object.keys(at).forEach(function(Bt) {
                  var Ut = at[Bt];
                  Ut.sort(function(gt, Gt) {
                    return gt.y - Gt.y;
                  }), Ut.forEach(function(gt, Gt) {
                    if (Gt > 0) {
                      var Pn = Ut[Gt - 1].y;
                      Ut[Gt].y += Math.max(0, Pn + 15 - Ut[Gt].y);
                    }
                  });
                  var Tr = Ut.filter(function(gt) {
                    return gt.value <= 20;
                  });
                  Ut.forEach(function(gt) {
                    var Gt = gt.text, Pn = gt.x, Lt = gt.y, _r = (gt.color, gt.textAnchor), cr = gt.value;
                    Gt.text(N.yFormat(cr)).style("display", "block").style("text-anchor", _r).attr("transform", `translate(
	              `.concat(_r === "start" ? Pn + 4 : Pn - 4, `,
	              `).concat(cr <= 20 && Tr.length !== 1 ? Lt - 20 : Lt, `
	            )`));
                  });
                });
              }
              function re(Me, Fe) {
                var Xe = x.scaleLinear().domain(Ce.range()), at = I[0] && I[0].values[0] && I[0].values[0].values || [], Bt = at[de(at, Fe, 0, at.length - 1)];
                if (Bt && Bt.date) {
                  var Ut = Ce(Bt.date);
                  Me.each(function(Tr) {
                    x.select(this).text(Bt.date.getFullYear()).attr("transform", `translate(
	              `.concat(Xe.range([0, qe.bandwidth() - this.getComputedTextLength()])(Ut), `,
	              `).concat(He + 6, `
	              )`)).style("display", null);
                  });
                }
              }
              var je, Z, de = x.bisector(function(Me) {
                return Me.date;
              }).left, U = x.min(I, function(Me) {
                return x.min(Me.values, function(Fe) {
                  return x.min(Fe.values, function(Xe) {
                    return Xe.date;
                  });
                });
              }), ce = x.max(I, function(Me) {
                return x.max(Me.values, function(Fe) {
                  return x.max(Fe.values, function(Xe) {
                    return Xe.date;
                  });
                });
              }), fe = x.min(I, function(Me) {
                return x.min(Me.values, function(Fe) {
                  return x.min(Fe.values, function(Xe) {
                    return Xe.Y_PREVALENCE_1000PP === 0 || Xe.Y_PREVALENCE_1000PP ? Xe.Y_PREVALENCE_1000PP : Xe.yPrevalence1000Pp;
                  });
                });
              }), he = x.max(I, function(Me) {
                return x.max(Me.values, function(Fe) {
                  return x.max(Fe.values, function(Xe) {
                    return Xe.Y_PREVALENCE_1000PP === 0 || Xe.Y_PREVALENCE_1000PP ? Xe.Y_PREVALENCE_1000PP : Xe.yPrevalence1000Pp;
                  });
                });
              }), ye = 0;
              N.seriesLabel && ((je = B.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(N.seriesLabel), (ye = je.node()) && (ye = je.node().getBBox().height + 10));
              var Ee, ue, Oe, pe = 0;
              N.trellisLabel && ((Z = B.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").attr("dy", ".79em").text(N.trellisLabel), pe = Z.node().getBBox().height + 10), (Ee = B.append("g").attr("class", "g-label-trellis")).append("text").text(N.trellisSet.join("")), ue = Ee.node().getBBox().height + 10, Ee.remove();
              var se = 0;
              N.yLabel && ((Oe = B.append("g")).append("text").attr("class", "axislabel").style("text-anchor", "middle").text(N.yLabel), se = Oe.node().getBBox().height + 4);
              var Ae = G - N.margins.left - se - N.margins.right, He = X - N.margins.top - pe - ue - ye - 2 * N.margins.bottom, qe = x.scaleBand().domain(N.trellisSet).range([0, Ae]).paddingOuter(0.2).paddingInner(0.25), Ce = x.scaleTime().domain([U, ce]).range([0, qe.bandwidth()]), xe = x.scaleLinear().domain([fe, he]).range([He, 0]), Se = x.axisLeft().scale(xe).tickFormat(N.yFormat).ticks(N.yTicks), Te = x.axisBottom().scale(Ce), me = B.append("g").attr("class", "axis");
              me.call(Te);
              var et = Math.round(me.node().getBBox().height), Be = Math.round(me.node().getBBox().width);
              He -= et, Ae -= Math.max(0, Be - Ae), me.remove();
              var xt = B.append("g").attr("class", "axis");
              xt.call(Se);
              var jt = Math.round(xt.node().getBBox().width);
              Ae -= jt, xt.remove(), qe.range([0, Ae]).paddingOuter(0.2).paddingInner(0.25), Ce.range([0, qe.bandwidth()]), xe.range([He, 0]), N.trellisLabel && Z.attr("transform", `translate(
	        `.concat(Ae / 2 + N.margins.left, `,
	        `).concat(N.margins.top, `
	      )`)), N.seriesLabel && je.attr("transform", `translate(
	        `.concat(Ae / 2 + N.margins.left, `,
	        `).concat(pe + He + et + ye + 2 * N.margins.top, `
	      )`)), N.yLabel && (Oe.attr("transform", `translate(
	        `.concat(N.margins.left, `,
	        `).concat(He / 2 + pe + ue, `
	      )`)), Oe.select("text").attr("transform", "rotate(-90)").attr("y", 0).attr("x", 0).attr("dy", "1em"));
              var ut = x.line().x(function(Me) {
                return Ce(Me.date);
              }).y(function(Me) {
                return xe(Me.Y_PREVALENCE_1000PP === 0 || Me.Y_PREVALENCE_1000PP ? Me.Y_PREVALENCE_1000PP : Me.yPrevalence1000Pp);
              }).curve(N.interpolate), Qe = x.select(B.node()).append("g").attr("transform", function(Me) {
                return `translate(
	        `.concat(se + jt + N.margins.left, `,
	        `).concat(pe, `
	      )`);
              }).selectAll(".g-trellis").data(qe.domain()).enter().append("g").attr("class", "g-trellis").attr("transform", function(Me) {
                return "translate(".concat(qe(Me), ", ").concat(ue, ")");
              }), pt = x.axisBottom().scale(Ce).tickFormat("").tickSize(-He), Rn = x.axisLeft().scale(xe).tickFormat("").tickSize(-qe.bandwidth()).ticks(8);
              Qe.append("g").attr("class", "x-guide").attr("transform", "translate(0, ".concat(He, ")")).call(pt), Qe.append("g").attr("class", "y-guide").call(Rn);
              var Gn = Qe.selectAll(".g-series").data(function(Me) {
                var Fe = I.filter(function(Xe) {
                  return Xe.key === Me;
                });
                return Fe.length > 0 ? Fe[0].values : [];
              }).enter().append("g").attr("class", "g-series lineplot");
              Gn.append("path").attr("class", "line").attr("d", function(Me) {
                return ut(Me.values.sort(function(Fe, Xe) {
                  return x.ascending(Fe.date, Xe.date);
                }));
              }).style("stroke", function(Me) {
                return N.colors(Me.key);
              }), Gn.append("circle").attr("class", "g-value").attr("transform", function(Me) {
                var Fe = Me.values;
                if (Fe && Fe[Fe.length - 1] && Fe[Fe.length - 1].date && Fe[Fe.length - 1] && (Fe[Fe.length - 1].Y_PREVALENCE_1000PP || Fe[Fe.length - 1].yPrevalence1000Pp)) {
                  var Xe = Fe[Fe.length - 1].Y_PREVALENCE_1000PP === 0 || Fe[Fe.length - 1].Y_PREVALENCE_1000PP ? Fe[Fe.length - 1].Y_PREVALENCE_1000PP : Fe[Fe.length - 1].yPrevalence1000Pp;
                  return "translate(".concat(Ce(Fe[Fe.length - 1].date), ", ").concat(xe(Xe), ")");
                }
                return "translate(0, 0)";
              }).attr("r", 2.5).style("display", "none"), Gn.append("text").attr("class", "g-label-value g-start").call(ne, U), Gn.append("text").attr("class", "g-label-value g-end").call(ne, ce), Qe.append("text").attr("class", "g-label-year g-start").attr("dy", ".71em").call(re, U), Qe.append("text").attr("class", "g-label-year g-end").attr("dy", ".71em").call(re, ce), Qe.append("g").attr("class", "x axis").append("line").attr("x2", qe.bandwidth()).attr("y1", xe(fe)).attr("y2", xe(fe)), Qe.append("g").attr("class", "g-label-trellis").attr("transform", function(Me) {
                return "translate(".concat(qe.bandwidth() / 2, ", 0)");
              }).append("text").attr("dy", "-1em").style("text-anchor", "middle").text(function(Me) {
                return Me;
              }), Qe.append("rect").attr("class", "g-overlay").attr("x", -4).attr("width", qe.bandwidth() + 8).attr("height", He + 18).on("mouseover", function() {
                Qe.selectAll(".g-end").style("display", "none"), Qe.selectAll(".g-value").style("display", null), oe.call(this);
              }).on("mousemove", oe).on("mouseout", function() {
                Qe.selectAll(".g-end").style("display", null), Qe.selectAll(".g-label-value.g-start").call(ne, U), Qe.selectAll(".g-label-year.g-start").call(re, U), Qe.selectAll(".g-label-year.g-end").call(re, ce), Qe.selectAll(".g-value").style("display", "none");
              }), x.select(Qe.nodes()[0]).append("g").attr("class", "y axis").attr("transform", "translate(-4,0)").call(Se), B.append("g").attr("transform", "translate(".concat(N.margins.left, ", ").concat(N.margins.top, ")")).call(function(Me) {
                var Fe = 0;
                N.colors.domain().forEach(function(Xe) {
                  var at = Me.append("g").attr("class", "trellisLegend"), Bt = at.append("text").text(Xe), Ut = at.node().getBBox();
                  Bt.attr("x", 12).attr("y", Ut.height), at.append("line").attr("x1", 0).attr("y1", 10).attr("x2", 10).attr("y2", 10).style("stroke", function() {
                    return N.colors(Xe);
                  }), at.attr("transform", "translate(".concat(Fe, ", 0)")), Fe += at.node().getBBox().width + 5;
                });
              });
            } }]) && A(M.prototype, V), $;
          }(p);
          return y;
        }).apply(d, C), v === void 0 || (h.exports = v);
      }, 132: (h, d, f) => {
        var C, v;
        C = [f(680)], (v = (function(b) {
          var E = b.format(",.3r");
          return { wrap: function(A, R) {
            A.each(function() {
              for (var D, _ = b.select(this), F = _.text().split(/\s+/).reverse(), P = [], x = 0, p = _.attr("y"), y = parseFloat(_.attr("dy")), w = _.text(null).append("tspan").attr("x", 0).attr("y", p).attr("dy", y + "em"); D = F.pop(); ) P.push(D), w.text(P.join(" ")), w.node().getComputedTextLength() > R && (P.length > 1 && (P.pop(), F.push(D), w.text(P.join(" "))), P = [], x += 1, w = _.append("tspan").attr("x", 0).attr("y", p).attr("dy", 1.1 * x + y + "em"));
            });
          }, formatInteger: function(A) {
            return E(A);
          }, formatSI: function(A) {
            return A = A || 0, function(R) {
              if (R < 1) return b.round(R, A);
              var D = b.formatPrefix(R);
              return b.round(D.scale(R), A) + D.symbol;
            };
          }, buildHierarchy: function(A, R, D) {
            for (var _ = R || function(X) {
              return X[0];
            }, F = D || function(X) {
              return X[1];
            }, P = { name: "root", children: [] }, x = 0; x < A.length; x++) {
              var p = _(A[x]), y = +F(A[x]);
              if (!isNaN(y)) for (var w = p.split("-"), M = P, V = 0; V < w.length; V++) {
                var q, $ = M.children, I = w[V];
                if (V + 1 < w.length) {
                  for (var k = !1, G = 0; G < $.length; G++) if ($[G].name == I && $[G].children) {
                    q = $[G], k = !0;
                    break;
                  }
                  k || (q = { name: I, children: [] }, $.push(q)), M = q;
                } else q = { name: I, size: y }, $.push(q);
              }
            }
            return P;
          } };
        }).apply(d, C)) === void 0 || (h.exports = v);
      }, 383: function(h, d, f) {
        var C, v, b;
        v = [f(680)], C = function(E) {
          return function() {
            var A = y, R = w, D = M, _ = B(), F = null, P = null, x = null;
            function p(Z) {
              F = oe(Z), P = F.createSVGPoint(), document.body.appendChild(_);
            }
            function y() {
              return "n";
            }
            function w() {
              return [0, 0];
            }
            function M() {
              return " ";
            }
            p.show = function() {
              var Z = Array.prototype.slice.call(arguments);
              Z[Z.length - 1] instanceof SVGElement && (x = Z.pop());
              var de, U = D.apply(this, Z), ce = R.apply(this, Z), fe = A.apply(this, Z), he = ne(), ye = q.length, Ee = document.documentElement.scrollTop || document.body.scrollTop, ue = document.documentElement.scrollLeft || document.body.scrollLeft;
              for (he.html(U).style("opacity", 1).style("pointer-events", "all"); ye--; ) he.classed(q[ye], !1);
              return de = V.get(fe).apply(this), he.classed(fe, !0).style("top", de.top + ce[0] + Ee + "px").style("left", de.left + ce[1] + ue + "px"), p;
            }, p.hide = function() {
              return ne().style("opacity", 0).style("pointer-events", "none"), p;
            }, p.attr = function(Z, de) {
              if (arguments.length < 2 && typeof Z == "string") return ne().attr(Z);
              var U = Array.prototype.slice.call(arguments);
              return E.selection.prototype.attr.apply(ne(), U), p;
            }, p.style = function(Z, de) {
              if (arguments.length < 2 && typeof Z == "string") return ne().style(Z);
              var U = Array.prototype.slice.call(arguments);
              return E.selection.prototype.style.apply(ne(), U), p;
            }, p.direction = function(Z) {
              return arguments.length ? (A = Z == null ? Z : je(Z), p) : A;
            }, p.offset = function(Z) {
              return arguments.length ? (R = Z == null ? Z : je(Z), p) : R;
            }, p.html = function(Z) {
              return arguments.length ? (D = Z == null ? Z : je(Z), p) : D;
            }, p.destroy = function() {
              return _ && (ne().remove(), _ = null), p;
            };
            var V = E.map({ n: $, s: I, e: k, w: G, nw: X, ne: ie, sw: K, se: N }), q = V.keys();
            function $() {
              var Z = re();
              return { top: Z.n.y - _.offsetHeight, left: Z.n.x - _.offsetWidth / 2 };
            }
            function I() {
              var Z = re();
              return { top: Z.s.y, left: Z.s.x - _.offsetWidth / 2 };
            }
            function k() {
              var Z = re();
              return { top: Z.e.y - _.offsetHeight / 2, left: Z.e.x };
            }
            function G() {
              var Z = re();
              return { top: Z.w.y - _.offsetHeight / 2, left: Z.w.x - _.offsetWidth };
            }
            function X() {
              var Z = re();
              return { top: Z.nw.y - _.offsetHeight, left: Z.nw.x - _.offsetWidth };
            }
            function ie() {
              var Z = re();
              return { top: Z.ne.y - _.offsetHeight, left: Z.ne.x };
            }
            function K() {
              var Z = re();
              return { top: Z.sw.y, left: Z.sw.x - _.offsetWidth };
            }
            function N() {
              var Z = re();
              return { top: Z.se.y, left: Z.e.x };
            }
            function B() {
              var Z = E.select(document.createElement("div"));
              return Z.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), Z.node();
            }
            function oe(Z) {
              return (Z = Z.node()).tagName.toLowerCase() === "svg" ? Z : Z.ownerSVGElement;
            }
            function ne() {
              return _ === null && (_ = B(), document.body.appendChild(_)), E.select(_);
            }
            function re() {
              for (var Z = x || E.event.target; Z.getScreenCTM === void 0 && Z.parentNode === "undefined"; ) Z = Z.parentNode;
              var de = {}, U = Z.getScreenCTM(), ce = Z.getBBox(), fe = ce.width, he = ce.height, ye = ce.x, Ee = ce.y;
              return P.x = ye, P.y = Ee, de.nw = P.matrixTransform(U), P.x += fe, de.ne = P.matrixTransform(U), P.y += he, de.se = P.matrixTransform(U), P.x -= fe, de.sw = P.matrixTransform(U), P.y -= he / 2, de.w = P.matrixTransform(U), P.x += fe, de.e = P.matrixTransform(U), P.x -= fe / 2, P.y -= he / 2, de.n = P.matrixTransform(U), P.y += he, de.s = P.matrixTransform(U), de;
            }
            function je(Z) {
              return typeof Z == "function" ? Z : function() {
                return Z;
              };
            }
            return p;
          };
        }, (b = typeof C == "function" ? C.apply(d, v) : C) === void 0 || (h.exports = b);
      }, 680: (h) => {
        h.exports = a;
      }, 756: (h) => {
        h.exports = l;
      }, 92: (h) => {
        h.exports = s;
      } }, m = {};
      function j(h) {
        if (m[h]) return m[h].exports;
        var d = m[h] = { id: h, loaded: !1, exports: {} };
        return c[h].call(d.exports, d, d.exports, j), d.loaded = !0, d.exports;
      }
      return j.nmd = (h) => (h.paths = [], h.children || (h.children = []), h), j(76);
    })();
  });
})(kd);
var S1 = kd.exports;
const nS = () => ({
  allowRepeats: !1,
  combinationWindow: 0,
  eventCohorts: [],
  maxDepth: 5,
  minCellCount: 0,
  targetCohorts: []
}), rS = (r) => {
  var i;
  return `${te(((i = r == null ? void 0 : r.eventCodes) == null ? void 0 : i.length) || 0)} codes`;
}, iS = (r, i) => ({
  ...i,
  name: i.title || i.name,
  type: r.type
});
function w1(r, i = [], a = !1, s) {
  const l = i.map((m) => m.id), c = [];
  if (!r) return null;
  if (a)
    r.pathwayGroups.forEach((m) => {
      const j = Iu(r, m, void 0, s);
      c.push(j);
    });
  else {
    if (l.length == 0) return null;
    l.forEach((m) => {
      let j = r.pathwayGroups.find(
        (h) => m == h.targetCohortUid
      );
      if (j) {
        const h = Iu(r, j, m, s);
        c.push(h);
      }
    });
  }
  return c;
}
function zd(r) {
  return r.children ? r.children.reduce((i, a) => i + zd(a), 0) : r.size;
}
function T1(r, i) {
  return {
    versionId: i == null ? void 0 : i.versionId,
    name: i == null ? void 0 : i.name,
    targetCohortCount: te(r.cohortPersons),
    personsReported: te(r.pathwayPersons),
    personsReportedPct: La(
      r.pathwayPersons / r.cohortPersons
    )
  };
}
function _1(r, i) {
  return {
    totalPathways: zd(i),
    cohortPersons: r.targetCohortCount,
    pathwayPersons: r.totalPathwaysCount
  };
}
function Iu(r, i, a, s) {
  var c;
  let l = d1(i, s);
  if (l) {
    const m = S1.util.buildHierarchy(
      l.pathways,
      (C) => C.path,
      (C) => C.personCount
    ), j = (c = r.targetCohorts) == null ? void 0 : c.find((C) => a == C.id), h = _1(l, m), d = T1(h, j);
    return {
      pathway: m,
      targetCohort: d,
      summary: h
      // pathDetails: ko.observable(),
    };
  }
}
const E1 = ({ colors: r, eventCohorts: i, targetCohort: a, summary: s, pathway: l, legacy: c }) => {
  const [m, j] = be(null), h = (d) => c1(d, r, i);
  return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
    Re,
    {
      collapsible: !c,
      defaultState: !0,
      title: a.name,
      isDark: !0,
      size: "dense",
      children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 6, md: 5.5, lg: 5, pr: 2, children: /* @__PURE__ */ t.jsx(
          v1,
          {
            eventCohorts: i,
            colors: r,
            pathData: m,
            targetCohort: a,
            summary: s
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { xs: 6, md: 6.5, lg: 7, item: !0, children: /* @__PURE__ */ t.jsx(Hn, { elevation: 3, sx: { p: 1, height: "calc(100% - 16px)" }, children: /* @__PURE__ */ t.jsx(g, { sx: { minHeight: "550px" }, container: !0, children: /* @__PURE__ */ t.jsx(
          Ur,
          {
            type: "sunburst",
            chartData: l,
            fileName: a.name,
            options: () => ({
              colors: r,
              split: u1,
              onclick: j,
              tooltip: h,
              minRadians: 0
            })
          }
        ) }) }) })
      ] })
    }
  ) });
}, aS = $e(({ analysisInfo: r, data: i }) => {
  var f, C, v, b, E;
  const a = (i == null ? void 0 : i.targetCohorts) === void 0 || (i == null ? void 0 : i.targetCohorts.length) === 0, s = i.targetCohorts || [], [l, c] = be(s || []), m = w1(
    i,
    l,
    a,
    (f = r.design) == null ? void 0 : f.maxDepth
  ), j = i.eventCodes ? (C = i.eventCodes) == null ? void 0 : C.filter((A) => !A.combo) : [], h = J0(
    j.length > 10 ? Q0 : dd
  ), d = (A) => h1[A] || h(A);
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
    g,
    {
      container: !0,
      minHeight: "calc(100vh - 280px)",
      alignContent: "flex-start",
      spacing: 2,
      p: 2,
      children: ((v = i == null ? void 0 : i.eventCodes) == null ? void 0 : v.length) > 0 && ((b = i.pathwayGroups) == null ? void 0 : b.length) > 0 ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        ((E = i.targetCohorts) == null ? void 0 : E.length) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          y1,
          {
            value: l,
            options: s,
            onChange: c
          }
        ) }),
        m != null && m.length ? m.map(
          ({ pathway: A, summary: R, targetCohort: D }, _) => /* @__PURE__ */ t.jsx(
            E1,
            {
              pathway: A,
              summary: R,
              targetCohort: D,
              eventCohorts: j,
              legacy: a,
              colors: d
            },
            _
          )
        ) : /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(js, { children: "No results found" }) })
      ] }) : /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(js, { children: "No results found" }) })
    }
  ) });
}), A1 = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
], oS = (r) => {
  const { onChange: i, prop: a } = r;
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
    Zt,
    {
      name: "templateProp",
      textLabel: "Template attribute",
      required: !0,
      children: /* @__PURE__ */ t.jsx(
        mn,
        {
          className: "",
          name: "templateProp",
          disablePortal: !0,
          id: "templateProp",
          options: A1,
          value: a,
          placeholder: "Select attribute",
          onChange: i,
          fullWidth: !0
        }
      )
    }
  ) }) });
}, sS = $e(
  (r) => {
    var C, v, b, E, A;
    const {
      subModules: i,
      parentId: a,
      design: s,
      id: l,
      typeContainer: c,
      updateDesign: m,
      analysisName: j,
      viewMode: h
    } = r, d = (R) => (D) => {
      m(R, D);
    }, f = (R) => {
      let D = 0;
      return Object.keys(R || {}).forEach((_) => {
        const F = R[_];
        if (F) {
          if (Array.isArray(F)) {
            D += F.length;
            return;
          }
          D += 1;
        }
      }), D;
    };
    return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
      (!h || h && ((C = s == null ? void 0 : s.targetCohorts) == null ? void 0 : C.length) > 0) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(wi, { children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx("b", { children: "Feasibility" }),
          " analysis helps verify if data sources have enough data of interest to run a study. It runs on multiple data sources and provides a ranking of data sources from feasibility perspective. Target cohorts define the main population of interest. Event cohort represent events/concepts of interest for the study."
        ] }) }) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          i.cohort,
          {
            type: "component",
            name: "widget-cohort-import-button",
            subModules: i,
            path: It(c, l, a),
            config: {
              buttonText: "Import target cohort",
              titleText: /* @__PURE__ */ t.jsx(
                Ot,
                {
                  title: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                    "Target cohorts",
                    /* @__PURE__ */ t.jsx("sup", { className: "required-star", children: "*" })
                  ] }),
                  count: (v = s == null ? void 0 : s.targetCohorts) == null ? void 0 : v.length
                }
              ),
              classNameContainer: "target-import-button",
              typeContainer: c,
              initialData: s == null ? void 0 : s.targetCohorts,
              onChange: d("targetCohorts"),
              isSelect: !0,
              parentId: a,
              returnEntityText: j,
              collapsible: !0,
              defaultState: !0,
              viewMode: h,
              required: !0,
              description: "Target cohorts define main data of interest from the perspective of your study. At least one target cohort must be specified."
            }
          }
        ) })
      ] }),
      (!h || h && ((b = s == null ? void 0 : s.eventCohorts) == null ? void 0 : b.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        i.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: i,
          path: It(c, l, a),
          config: {
            buttonText: "Import event cohort",
            titleText: /* @__PURE__ */ t.jsx(
              Ot,
              {
                title: "Event cohorts",
                count: (E = s == null ? void 0 : s.eventCohorts) == null ? void 0 : E.length
              }
            ),
            classNameContainer: "event-import-button",
            typeContainer: c,
            initialData: s == null ? void 0 : s.eventCohorts,
            onChange: d("eventCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: j,
            collapsible: !0,
            defaultState: h,
            viewMode: h,
            description: "Event cohort represent additional data to be verified for existence. Additionally, for each target and event cohort  an intersection will be calculated. Both Event cohort data and Intersection data will affect the final data source scoring."
          }
        }
      ) }),
      (!h || h && ((A = Object.keys(s.groups || {})) == null ? void 0 : A.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          collapsible: !0,
          title: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Additional attributes",
              count: (s == null ? void 0 : s.groups) && f(s == null ? void 0 : s.groups) || 0
            }
          ),
          defaultState: h,
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsx(
            i.cohort,
            {
              type: "component",
              name: "widget-criteria-attributes",
              subModules: i,
              config: {
                typeContainer: c,
                onChange: (R) => {
                  m("groups", R);
                },
                values: s == null ? void 0 : s.groups,
                viewMode: h
              }
            }
          )
        }
      ) })
    ] });
  }
), O1 = ({ getValue: r }) => /* @__PURE__ */ t.jsx(
  O0,
  {
    name: "rating",
    defaultValue: r() || 0,
    precision: 0.1,
    readOnly: !0
  }
), R1 = [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: lr,
    size: 36,
    maxSize: 36,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  Ti({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 300
  }),
  {
    id: "raiting",
    header: "Feasibility rating",
    accessorFn: (r) => r.resultInfo.summary.rating * 5 / r.resultInfo.summary.maxRating,
    cell: O1,
    minSize: 150,
    maxSize: 150,
    enableResizing: !1,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetNotEmpty",
    header: "Target cohorts",
    size: 120,
    accessorFn: (r) => `${r.resultInfo.summary.targetNotEmpty} / ${r.resultInfo.summary.targetTotal}`,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetPersonCount",
    header: "Target cohort PC",
    accessorKey: "resultInfo.summary.targetPersonCount",
    cell: ({ getValue: r }) => te(r()),
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "targetCohorts",
    header: () => /* @__PURE__ */ t.jsxs(le, { sx: { whiteSpace: "wrap" }, children: [
      "Target cohort",
      /* @__PURE__ */ t.jsx("br", {}),
      "additional attributes"
    ] }),
    accessorFn: (r) => `${r.resultInfo.summary.mandatoryNotEmpty} / ${r.resultInfo.summary.mandatoryTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "eventTotal",
    header: "Event cohorts",
    accessorFn: (r) => `${r.resultInfo.summary.eventNotEmpty} / ${r.resultInfo.summary.eventTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "eventPersonCount",
    header: "Event cohort PC",
    accessorKey: "resultInfo.summary.eventPersonCount",
    cell: ({ getValue: r }) => te(r()),
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "intersection",
    header: () => /* @__PURE__ */ t.jsxs(le, { sx: { whiteSpace: "wrap" }, children: [
      "Target-Event",
      /* @__PURE__ */ t.jsx("br", {}),
      "cohort intersection"
    ] }),
    accessorFn: (r) => `${r.resultInfo.summary.intersection} / ${r.resultInfo.summary.intersectionTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  },
  {
    id: "intersection-attributes",
    header: () => /* @__PURE__ */ t.jsxs(le, { sx: { whiteSpace: "wrap" }, children: [
      "Target-Event intersection",
      /* @__PURE__ */ t.jsx("br", {}),
      "additional attributes"
    ] }),
    accessorFn: (r) => `${r.resultInfo.summary.intersectionWithGroups} / ${r.resultInfo.summary.intersectionWithGroupsTotal}`,
    size: 120,
    meta: {
      align: "center",
      headerAlign: "center"
    }
  }
], P1 = ({
  resultData: r
}) => /* @__PURE__ */ t.jsx(
  Ct,
  {
    variant: "uncontrolled",
    hideSettings: !0,
    columns: R1,
    data: r
  }
), lS = () => ({
  targetCohorts: [],
  eventCohorts: [],
  groups: {}
}), cS = (r) => `Rating ${te(
  (r == null ? void 0 : r.summary.rating) * 5 / r.summary.maxRating || 0,
  2,
  2
)}`, uS = (r, i) => ({
  ...i,
  name: i.title || i.name,
  type: r.type
}), Oi = {
  observation: "Observation",
  condition_occurrence: "Condition",
  drug_exposure: "Drug",
  measurement: "Measurement",
  procedure_occurrence: "Procedure",
  device_exposure: "Device",
  visit_occurrence: "Visit",
  death: "Death",
  cost: "Cost"
  // location: 'Location',
  // provider: 'Provider',
  // provider_visit: 'Visit Provider',
}, D1 = [
  {
    title: "Person",
    value: "",
    end: !0
  },
  {
    title: "Attrition",
    value: "attrition"
  },
  {
    title: "Demographics",
    value: "demographics"
  },
  ...Object.entries(Oi).map(([r, i]) => ({
    title: i,
    value: `domain/${r}`
  })),
  {
    title: "Health System",
    value: "health-system"
  }
], Ss = ({
  getValue: r,
  maxWidth: i = 500,
  color: a = "success.light"
}) => {
  var c, m, j;
  const s = {
    pc: r().progress * 100 / r().maxProgress,
    totalPc: r().totalProgress * 100 / r().maxProgress,
    diff: ((r().totalProgress || r().maxProgress) - r().progress) * 100 / r().maxProgress
  }, l = 18;
  return /* @__PURE__ */ t.jsxs(
    le,
    {
      minWidth: ((c = String(r().totalProgress)) == null ? void 0 : c.length) * 8,
      maxWidth: i,
      width: s.totalPc + "%",
      display: "flex",
      children: [
        /* @__PURE__ */ t.jsx(Nt, { text: te(r().progress), children: /* @__PURE__ */ t.jsx(
          le,
          {
            minWidth: ((m = String(r().progress)) == null ? void 0 : m.length) * 8 + 6,
            sx: {
              height: l,
              lineHeight: l + "px",
              width: s.pc + "%",
              backgroundColor: a,
              position: "relative",
              textAlign: "right",
              fontSize: 11,
              boxSizing: "border-box",
              cursor: "default",
              px: 0.5,
              maxWidth: "100%",
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(92%)"
              }
            },
            children: te(r().progress)
          }
        ) }),
        /* @__PURE__ */ t.jsx(Nt, { text: te(r().totalProgress), children: /* @__PURE__ */ t.jsx(
          le,
          {
            height: l,
            minWidth: ((j = String(r().totalProgress)) == null ? void 0 : j.length) * 8 + 6,
            width: s.diff + "%",
            sx: {
              height: l,
              lineHeight: l + "px",
              backgroundColor: "backgroundColor.dark",
              position: "relative",
              textAlign: "right",
              fontSize: 11,
              boxSizing: "border-box",
              cursor: "default",
              px: 0.5,
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(92%)"
              }
            },
            children: te(r().totalProgress)
          }
        ) })
      ]
    }
  );
}, N1 = {
  [rt.LESS_THAN]: "less than",
  [rt.LESS_OR_EQUAL_TO]: "less or equal to",
  [rt.EQUAL_TO]: "equal to",
  [rt.GREATER_THAN]: "greater than",
  [rt.GREATER_OR_EQUAL_TO]: "greater or equal to",
  [rt.BETWEEN]: "between",
  [rt.NOT_BETWEEN]: "not between"
}, I1 = [rt.BETWEEN, rt.NOT_BETWEEN].map(
  String
), L1 = (r) => typeof r == "string" ? r : r == null ? void 0 : r.CONCEPT_NAME, Lu = (r, i) => {
  if ((i == null ? void 0 : i.Value) === void 0 || (i == null ? void 0 : i.Value) === null)
    return null;
  const a = i.Op || rt.GREATER_THAN, s = N1[a] || a, l = I1.includes(a) && i.Extent !== void 0 && i.Extent !== null ? ` and ${i.Extent}` : "";
  return `${r} = ${s} ${i.Value}${l}`;
}, Bd = (r = {}) => {
  var s;
  const i = [];
  ["race", "gender", "ethnicity"].forEach((l) => {
    var c;
    (c = r == null ? void 0 : r[l]) == null || c.map(L1).filter(Boolean).forEach((m) => {
      i.push(`${l} = ${m}`);
    });
  }), (s = r == null ? void 0 : r.age) == null || s.map((l) => Lu("Age Range", l)).filter(Boolean).forEach((l) => i.push(l));
  const a = (r == null ? void 0 : r.dateRanges) || (r == null ? void 0 : r.indexDate);
  return a == null || a.map((l) => Lu("Date Range", l)).filter(Boolean).forEach((l) => i.push(l)), i;
}, F1 = (r = {}, i) => Array.from(
  /* @__PURE__ */ new Set([
    ...Object.keys(r || {}),
    ...Bd(i)
  ])
).sort(), M1 = (r, i) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: lr,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  Ti({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Person count",
    size: 830,
    accessorKey: `resultInfo.personDetails.${r}.personCount`,
    cell: ({ row: a, getValue: s, ...l }) => /* @__PURE__ */ t.jsx(
      Ss,
      {
        getValue: () => ({
          progress: s() || 0,
          totalProgress: a.original.resultInfo.summary.totalPersonCount,
          maxProgress: i
        }),
        ...l
      }
    )
  }
], k1 = (r, i) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: lr,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  Ti({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    id: "criteriaGroup",
    header: "",
    size: 120,
    enableResizing: !1
  },
  {
    header: "Criteria",
    size: 200
  },
  {
    header: "Person count",
    size: 630
  }
], z1 = (r, i) => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: lr,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  Ti({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Event cohort",
    size: 200
  },
  {
    header: "Person count",
    size: 300
  },
  {
    header: "Intersection",
    size: 300
  }
], Fu = ({ rowSpan: r, name: i, id: a }) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
  /* @__PURE__ */ t.jsx(
    le,
    {
      component: "td",
      rowSpan: r,
      className: "td",
      sx: { verticalAlign: "top", maxWidth: 36 },
      width: 36,
      children: /* @__PURE__ */ t.jsx(lr, { value: a })
    }
  ),
  /* @__PURE__ */ t.jsx(
    le,
    {
      component: "td",
      rowSpan: r,
      className: "td",
      sx: {
        verticalAlign: "top",
        fontWeight: 500,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "250px",
        overflow: "hidden",
        paddingTop: "8px"
      },
      children: i
    }
  )
] }), $d = ({ name: r, id: i }) => /* @__PURE__ */ t.jsxs(le, { display: "flex", alignItems: "center", children: [
  /* @__PURE__ */ t.jsx(lr, { value: i, size: 18 }),
  /* @__PURE__ */ t.jsx(le, { ml: 1, fontWeight: 500, color: "primary.main", children: r })
] }), B1 = ({
  getValue: r,
  maxWidth: i = 500,
  intersectionTooltip: a
}) => {
  var c, m, j;
  const s = {
    left: r().left * 100 / r().total,
    right: r().right * 100 / r().total,
    intersection: r().intersection * 100 / r().total,
    total: r().total * 100 / r().total
  }, l = 18;
  return /* @__PURE__ */ t.jsxs(le, { maxWidth: i || "100%", height: l, sx: { display: "flex" }, children: [
    /* @__PURE__ */ t.jsx(Nt, { text: te(r().left), children: /* @__PURE__ */ t.jsx(
      le,
      {
        sx: {
          height: l,
          lineHeight: l + "px",
          width: s.left + "%",
          cursor: "default",
          position: "relative",
          textAlign: "center",
          fontSize: 11,
          boxSizing: "border-box",
          px: 0.5,
          minWidth: ((c = String(r().left)) == null ? void 0 : c.length) * 8 + 6,
          maxWidth: "100%",
          backgroundColor: "success.light",
          transition: "all 300ms",
          ":hover": {
            filter: "brightness(95%)"
          }
        },
        children: te(r().left)
      }
    ) }),
    r().intersection > 0 && /* @__PURE__ */ t.jsx(
      Nt,
      {
        text: a || te(r().intersection),
        children: /* @__PURE__ */ t.jsx(
          le,
          {
            sx: {
              height: l,
              lineHeight: l - 4 + "px",
              width: s.intersection + "%",
              minWidth: ((m = String(r().intersection)) == null ? void 0 : m.length) * 8 + 6,
              backgroundColor: "backgroundColor.dark",
              position: "relative",
              textAlign: "center",
              fontSize: 11,
              boxSizing: "border-box",
              px: 0.5,
              cursor: "default",
              borderTop: "3px solid",
              borderTopColor: "success.light",
              borderBottom: "3px solid",
              borderBottomColor: "info.light",
              transition: "all 300ms",
              ":hover": {
                filter: "brightness(95%)"
              }
            },
            children: te(r().intersection)
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(Nt, { text: te(r().right), children: /* @__PURE__ */ t.jsx(
      le,
      {
        sx: {
          height: l,
          lineHeight: l + "px",
          width: s.right + "%",
          minWidth: ((j = String(r().right)) == null ? void 0 : j.length) * 8 + 6,
          cursor: "default",
          position: "relative",
          textAlign: "center",
          fontSize: 11,
          boxSizing: "border-box",
          px: 0.5,
          pl: r().right ? 0.5 : 0,
          maxWidth: "100%",
          backgroundColor: "info.light",
          transition: "all 300ms",
          ":hover": {
            filter: "brightness(95%)"
          }
        },
        children: te(r().right)
      }
    ) })
  ] });
}, $1 = ({ color: r }) => /* @__PURE__ */ t.jsx(
  le,
  {
    sx: {
      backgroundColor: Array.isArray(r) ? r[0] : r,
      width: 12,
      height: 12,
      borderRadius: "50%",
      boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
      cursor: "pointer",
      transition: "300ms",
      position: "relative",
      filter: "brightness(96%)",
      ":hover": {
        filter: "brightness(90%)"
      },
      ...Array.isArray(r) ? {
        ":before": {
          content: "''",
          height: 6,
          position: "absolute",
          bottom: 0,
          width: 12,
          borderRadius: "0 0 6px 6px",
          boxShadow: "inset -3px -3px 6px rgba(255,255,255,.4)",
          backgroundColor: r[1]
        }
      } : {}
    }
  }
), Cr = ({ config: r }) => /* @__PURE__ */ t.jsx(le, { mt: 0.5, display: "flex", children: /* @__PURE__ */ t.jsx(g, { container: !0, spacing: 2, children: r.map((i, a) => /* @__PURE__ */ t.jsxs(g, { item: !0, display: "flex", alignItems: "center", children: [
  /* @__PURE__ */ t.jsx($1, { color: i.color }),
  /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", ml: 0.5, children: [
    "— ",
    i.text
  ] })
] }, "legend" + a)) }) }), W1 = ({ selectedCohort: r, eventCohorts: i = [], data: a, analysis: s }) => {
  var C;
  const l = Math.max(
    ...a.map((v) => v.resultInfo.summary.totalPersonCount)
  ), c = Math.max(
    ...a.map(
      (v) => {
        var b;
        return (b = v.resultInfo.personDetails[r == null ? void 0 : r.id]) == null ? void 0 : b.personCount;
      }
    )
  ), m = Vn(i, "id"), j = (i == null ? void 0 : i.length) > 0, h = a.some(
    (v) => {
      var b, E;
      return Object.keys(
        ((E = (b = v.resultInfo) == null ? void 0 : b.personDetails[r == null ? void 0 : r.id]) == null ? void 0 : E.groups) || {}
      ).length;
    }
  ), d = Bd(
    (C = s == null ? void 0 : s.design) == null ? void 0 : C.groups
  ), f = h || d.length > 0;
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
      Re,
      {
        title: "Cohort counts" + (r ? ` for ${r.name}` : ""),
        children: [
          /* @__PURE__ */ t.jsx(
            Ct,
            {
              data: a,
              columns: M1(
                r == null ? void 0 : r.id,
                l
              ),
              hideSettings: !0
            }
          ),
          /* @__PURE__ */ t.jsx(
            Cr,
            {
              config: [
                {
                  color: "success.light",
                  text: `persons in cohort (${r.name})`
                },
                {
                  color: "backgroundColor.dark",
                  text: "persons in data source"
                }
              ]
            }
          )
        ]
      }
    ) }),
    f && /* @__PURE__ */ t.jsx(
      g,
      {
        item: !0,
        xs: 12,
        sx: {
          ".td": {
            textTransform: "capitalize"
          }
        },
        children: /* @__PURE__ */ t.jsxs(Re, { title: "Additional attributes", children: [
          /* @__PURE__ */ t.jsx(
            Ct,
            {
              data: a,
              columns: k1(
                r == null ? void 0 : r.id
              ),
              customTableRow: ({ data: v, ...b }) => {
                var D;
                const E = v.resultInfo.personDetails[r == null ? void 0 : r.id], A = (E == null ? void 0 : E.groups) || {}, R = F1(
                  A,
                  (D = s == null ? void 0 : s.design) == null ? void 0 : D.groups
                );
                return /* @__PURE__ */ t.jsx(t.Fragment, { children: R.map((_, F) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                  F === 0 && /* @__PURE__ */ t.jsx("tr", { ...b, children: /* @__PURE__ */ t.jsx(
                    Fu,
                    {
                      rowSpan: (R == null ? void 0 : R.length) + 1,
                      name: v.dataSource.name,
                      id: v.dataSource.id
                    }
                  ) }),
                  /* @__PURE__ */ t.jsxs("tr", { ...b, children: [
                    /* @__PURE__ */ t.jsx("td", { className: "td", children: _.split(" = ")[0] }),
                    /* @__PURE__ */ t.jsx("td", { className: "td", children: _.split(" = ")[1] }),
                    /* @__PURE__ */ t.jsx("td", { className: "td", children: /* @__PURE__ */ t.jsx(
                      Ss,
                      {
                        color: "analysesColors.teal.main",
                        getValue: () => {
                          var P;
                          return {
                            progress: A[_] || 0,
                            totalProgress: ((P = v.resultInfo.personDetails[r == null ? void 0 : r.id]) == null ? void 0 : P.personCount) || 0,
                            maxProgress: c
                          };
                        }
                      }
                    ) })
                  ] })
                ] })) });
              },
              hideSettings: !0
            }
          ),
          /* @__PURE__ */ t.jsx(
            Cr,
            {
              config: [
                {
                  color: "analysesColors.teal.main",
                  text: `persons in cohort (${r.name}) with this criteria`
                },
                {
                  color: "backgroundColor.dark",
                  text: `persons in cohort (${r.name})`
                }
              ]
            }
          )
        ] })
      }
    ),
    j && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { title: "Event cohorts", children: [
      /* @__PURE__ */ t.jsx(
        Ct,
        {
          data: a,
          columns: z1(
            r == null ? void 0 : r.id
          ),
          customTableRow: ({ data: v, ...b }) => {
            const E = v.resultInfo.personDetails[r == null ? void 0 : r.id];
            return /* @__PURE__ */ t.jsx(t.Fragment, { children: i.map((A, R) => {
              var p, y, w;
              const D = v.resultInfo.eventCounts[A.id], _ = E.personCount - (((p = E.eventPersonIntersections) == null ? void 0 : p[A.id]) || 0), F = D.personCount - (((y = E.eventPersonIntersections) == null ? void 0 : y[A.id]) || 0), P = ((w = E.eventPersonIntersections) == null ? void 0 : w[A.id]) || 0, x = _ + P + F;
              return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                R === 0 && /* @__PURE__ */ t.jsx("tr", { ...b, children: /* @__PURE__ */ t.jsx(
                  Fu,
                  {
                    rowSpan: (i == null ? void 0 : i.length) + 1,
                    name: v.dataSource.name,
                    id: v.dataSource.id
                  }
                ) }),
                /* @__PURE__ */ t.jsxs("tr", { ...b, children: [
                  /* @__PURE__ */ t.jsx("td", { className: "td", children: m[A.id].name }),
                  /* @__PURE__ */ t.jsx("td", { className: "td", children: /* @__PURE__ */ t.jsx(
                    Ss,
                    {
                      getValue: () => ({
                        progress: D.personCount,
                        totalProgress: v.resultInfo.summary.totalPersonCount,
                        maxProgress: l
                      }),
                      color: "info.light"
                    }
                  ) }),
                  /* @__PURE__ */ t.jsx("td", { className: "td", children: !isNaN(x) && /* @__PURE__ */ t.jsx(
                    B1,
                    {
                      getValue: () => ({
                        left: _,
                        right: F,
                        intersection: P,
                        total: x
                      }),
                      intersectionTooltip: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                        /* @__PURE__ */ t.jsx("b", { children: te(P) }),
                        " ",
                        "persons in both cohorts",
                        /* @__PURE__ */ t.jsx("br", {}),
                        "(",
                        A.name,
                        " and",
                        " ",
                        r.name,
                        ")"
                      ] })
                    }
                  ) })
                ] })
              ] });
            }) });
          },
          hideSettings: !0
        }
      ),
      /* @__PURE__ */ t.jsx(
        Cr,
        {
          config: [
            {
              color: "info.light",
              text: "persons in event cohort"
            },
            {
              color: "backgroundColor.dark",
              text: "persons in data source"
            },
            {
              color: "success.light",
              text: "persons in target cohort"
            },
            {
              color: ["success.light", "info.light"],
              text: "persons in both cohorts (event and target)"
            }
          ]
        }
      )
    ] }) })
  ] });
};
Le.div`
  font-size: 12px;
  text-align: center;
  min-height: 14px;
`;
Le.div``;
Le.div`
  width: 100%;
  height: 15px;
  background-color: #7bb209;
`;
const Wd = Le.div`
  width: ${(r) => r.width};
  background-color: ${(r) => r.color};
  height: 15px !important;
  text-align: center;
  margin: 0 auto;
`;
Le.div`
  th {
    /* padding-bottom: 0px !important; */
    padding: 11.5px;
  }
  tbody {
    td {
      padding: 8.75px;
      /* padding-bottom: 10px; */
    }
  }
`;
const ar = ({ description: r, title: i }) => /* @__PURE__ */ t.jsx(Nt, { text: r, children: i }), Mu = (r, i, a, s, l) => [
  {
    header: () => /* @__PURE__ */ t.jsx(
      ar,
      {
        title: "Inclusion rule",
        description: "Inclusion rules are based on inclusion rule section in the cohort builder"
      }
    ),
    id: "inclusionRule",
    accessorFn: (c) => c.id >= 0 ? `${c.id + 1}. ${c.name}` : c.name,
    disableSorting: !0
  },
  ...r.map((c) => {
    const m = c.dataSource.id;
    return {
      header: () => /* @__PURE__ */ t.jsx($d, { name: c.dataSource.name, id: c.dataSource.id }),
      id: c.dataSource.id,
      // we need this id to identifiy data for chart
      enableHiding: !1,
      columns: [
        {
          header: () => /* @__PURE__ */ t.jsx(
            ar,
            {
              title: "N",
              description: "Number of persons that satisfy all inclusion rules applied consecutively in an order specified in the cohort builder"
            }
          ),
          id: `countSatisfying___${m + a}`,
          accessorKey: `${m}.${i}.countSatisfying`,
          cell: ({ getValue: j }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: j() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ t.jsx(
            ar,
            {
              title: "% Satisfied",
              description: "Persons that satisfy all consecutive inclusion rules expressed as % of the base cohort count"
            }
          ),
          id: `percentSatisfying___${m + a}`,
          accessorKey: `${m}.${i}.percentSatisfying`,
          cell: ({ getValue: j }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: j() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ t.jsx(
            ar,
            {
              title: "% to gain",
              description: "% to gain represents the % of population that can be recovered by relaxing the inclusion rule"
            }
          ),
          id: `percentExcluded___${m + a}`,
          accessorKey: `${m}.${i}.percentExcluded`,
          cell: ({ getValue: j }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: j() || "-" }),
          enableSorting: !1,
          size: 100
        },
        {
          header: () => /* @__PURE__ */ t.jsx(
            Nt,
            {
              text: s === "attrition" ? "The Attrition view allows users to visualize a classic attrition funnel, where each consecutive rule further restricts the population. The order of criteria affects the statistics." : "The Intersect view allows users to visualize how individual inclusion rules or combinations of these rules affect results, regardless of the sequence in which the rules are applied.Hovering over each box allows to see statistical information about the subgroups that either satisfied or did not satisfy specific inclusion criteria. The failed criteria is highlighted in red.",
              children: /* @__PURE__ */ t.jsxs(
                ct,
                {
                  variant: "text",
                  startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "reload" }),
                  onClick: () => l(),
                  size: "small",
                  color: "primary",
                  children: [
                    "Switch to",
                    " ",
                    s === "intersect" ? "attrition view" : "intersect view"
                  ]
                }
              )
            }
          ),
          id: `percentSatisfying-chart___${m + a}`,
          accessorKey: `${m}.${i}.percentSatisfying`,
          enableSorting: !1,
          // enableHiding: false,
          size: 320,
          meta: {
            headerAlign: "center",
            columnName: "Chart"
          },
          cell: (j) => {
            var f, C;
            const h = c.resultInfo.inclusionRuleReports[a][i], d = ((C = (f = c.resultInfo.inclusionRuleReports[a]) == null ? void 0 : f[i]) == null ? void 0 : C.summary.baseCount) ?? c.resultInfo.personDetails[a].personCount;
            return /* @__PURE__ */ t.jsx(
              Nt,
              {
                text: j.row.original.id !== -1 ? Fd(j.row.original.id, h) : `${j.row.original.name}: ${d}, 100.00%`,
                color: "primary",
                width: "auto",
                children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
                  Wd,
                  {
                    color: Id(parseFloat(j.getValue()) / 100),
                    width: j.getValue()
                  }
                ) })
              }
            );
          }
        }
      ]
    };
  })
];
function ku(r, i, a) {
  r.forEach((s) => {
    const l = s.dataSource.id, { personDetails: c, inclusionRuleReports: m } = s.resultInfo;
    Object.entries(m).forEach(([j, h]) => {
      var C, v, b, E;
      const d = {
        id: -1,
        name: "Base count (Entry events)",
        percentExcluded: "0.00%",
        percentSatisfying: "100.00%",
        dataSourceId: l
      }, f = {
        byPerson: {
          ...d,
          countSatisfying: ((v = (C = m[j]) == null ? void 0 : C.byPerson) == null ? void 0 : v.summary.baseCount) ?? c[j].personCount
        },
        byEvent: {
          ...d,
          countSatisfying: ((E = (b = m[j]) == null ? void 0 : b.byEvent) == null ? void 0 : E.summary.baseCount) ?? c[j].personCount
        }
      };
      a[j] || (a[j] = { 0: d }), a[j][0][l] = f, Object.entries(h).forEach(([A, R]) => {
        R[i].forEach((D) => {
          const _ = D.id + 1;
          a[j][_] || (a[j][_] = {
            name: D.name,
            id: D.id
          }), a[j][_][l] = {
            ...a[j][_][l],
            [A]: D
          };
        });
      });
    });
  });
}
function H1(r) {
  let i = { intersect: {}, attrition: {} };
  return ku(r, "inclusionRuleStats", i.intersect), ku(r, "attritions", i.attrition), i;
}
const V1 = ({ count: r }) => /* @__PURE__ */ t.jsx(Nt, { text: "Final count of persons in a cohort after applying all inclusion rules", children: /* @__PURE__ */ t.jsxs(
  g,
  {
    item: !0,
    alignItems: "center",
    flexWrap: "nowrap",
    display: "flex",
    justifyContent: "flex-start",
    children: [
      /* @__PURE__ */ t.jsx(
        g,
        {
          item: !0,
          sx: {
            backgroundColor: "backgroundColor.main",
            p: 2,
            borderRadius: "50%",
            mr: 2,
            svg: {
              color: "primary.main"
            },
            width: 62,
            height: 62
          },
          children: /* @__PURE__ */ t.jsx(bt, { iconName: "users", sx: { fontSize: 30 }, color: "info" })
        }
      ),
      /* @__PURE__ */ t.jsx(ve, { variant: "h2", children: r })
    ]
  }
) }), Hd = ({ resultData: r, setPassedAndFailed: i, analysisName: a }) => {
  const [s, l] = be(null), c = Pe(() => r == null ? void 0 : r.inclusionRuleStats, [r.inclusionRuleStats]), m = Jt(
    (h, d) => {
      var A;
      let f = 0, C = 0, v = [], b, E = [];
      for (let R = 0; R < h.length; R++)
        h[R] === "1" ? (v.push(c[R]), f++) : (E.push(c[R]), C++);
      (r == null ? void 0 : r.summary.baseCount) > 0 && (b = (d / ((A = r == null ? void 0 : r.summary) == null ? void 0 : A.baseCount) * 100).toFixed(2)), i == null || i({ passed: v, failed: E }), l((R) => ({
        ...R,
        passCount: f,
        failCount: C,
        passed: v,
        failed: E,
        size: d,
        percentage: b
      }));
    },
    [c, i]
  ), j = () => {
    l(null), i({ passed: [], failed: [] });
  };
  return /* @__PURE__ */ t.jsxs(
    g,
    {
      container: !0,
      height: "100%",
      onMouseOut: j,
      textAlign: "center",
      alignContent: "flex-start",
      children: [
        /* @__PURE__ */ t.jsx(
          ve,
          {
            variant: "subtitle2",
            minHeight: 24,
            textAlign: "center",
            width: "100%",
            children: s && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              s.size,
              " people (",
              s.percentage,
              "%),",
              " ",
              s.passCount,
              " criteria passed, ",
              s.failCount,
              " ",
              "criteria failed."
            ] })
          }
        ),
        /* @__PURE__ */ t.jsx(
          g,
          {
            container: !0,
            height: "calc(100% - 24px)",
            width: "calc(100% - 8px)",
            pl: 2,
            children: JSON.parse(r.treemapData) && /* @__PURE__ */ t.jsx(
              Ur,
              {
                type: "treeMapCustom",
                chartData: JSON.parse(r.treemapData),
                fileName: a,
                options: {
                  handleCellOver: m,
                  handleCellOut: j,
                  selectedConcepts: [],
                  allAny: "ANY",
                  passedFailed: "PASSED"
                  //   setSummaryValue: setSummaryValue,
                  //   setSummaryPercent: setSummaryPercent,
                },
                report: r
              }
            )
          }
        )
      ]
    }
  );
}, U1 = ({
  analysis: r,
  data: i,
  row: a,
  setPassedAndFailed: s,
  passedAndFailed: l,
  ...c
}) => {
  const m = Jt(
    (j) => {
      var h;
      return !!((h = l == null ? void 0 : l.failed) != null && h.find(
        (d) => d.id === a.original.id && d.dataSourceId === j
      ));
    },
    [l.failed]
  );
  return /* @__PURE__ */ Yu(
    "tr",
    {
      ...c,
      className: c.className + (a.index === 0 ? " no-hover" : ""),
      key: i.activeView + i.activeTab + i.selectedCohortId + a.id
    },
    a.getVisibleCells().map((j) => {
      var v, b, E;
      const h = j.column.getIsPinned(), d = (A) => {
        const R = A.getIsPinned();
        return {
          left: R === "left" ? `${A.getStart("left")}px` : void 0,
          right: R === "right" ? `${A.getAfter("right")}px` : void 0,
          opacity: R ? 0.95 : 1,
          position: R ? "sticky" : "relative",
          width: A.getSize(),
          zIndex: R ? 2 : 0,
          backgroundColor: R ? "ffffffe0" : "inherit"
        };
      }, f = (v = Object.values(
        i.tableData[i.selectedCohortId]
      )) == null ? void 0 : v.length, C = (b = j.column.parent) == null ? void 0 : b.id;
      if (i.activeView == "intersect" && j.id.includes("percentSatisfying-chart")) {
        const A = i.treemapData[C][i.selectedCohortId][i.activeTab], R = !!(A != null && A.treemapData);
        if (a.index == 0)
          return /* @__PURE__ */ t.jsx(
            le,
            {
              component: "td",
              className: `${h ? "pinned " : ""} td`,
              rowSpan: f > 6 ? f : 6,
              sx: {
                fontSize: "10px !important",
                padding: "4px 0 ",
                height: R ? "250px" : "",
                textAlign: "center",
                backgroundColor: R ? "white" : "transparent",
                position: "relative",
                ...d(j.column)
              },
              children: R ? /* @__PURE__ */ t.jsx(
                Hd,
                {
                  resultData: {
                    ...A,
                    inclusionRuleStats: (E = A.inclusionRuleStats) == null ? void 0 : E.map(
                      (D) => ({
                        ...D,
                        dataSourceId: C
                      })
                    )
                  },
                  analysisName: r == null ? void 0 : r.title,
                  setPassedAndFailed: s
                }
              ) : "N/A"
            },
            j.id
          );
      } else
        return /* @__PURE__ */ t.jsx(
          le,
          {
            component: "td",
            className: `${h ? "pinned " : ""} td`,
            sx: {
              color: m(C) ? "red" : "",
              ...d(j.column)
            },
            children: Xu(j.column.columnDef.cell, {
              ...j.getContext()
            })
          },
          j.id
        );
    })
  );
}, zu = ({
  columns: r,
  tableData: i,
  treemapData: a,
  selectedCohortId: s,
  activeTab: l,
  activeView: c,
  analysis: m
}) => {
  const [j, h] = be({
    passed: [],
    failed: []
  }), d = Jt(
    (f) => {
      Os(j, f) || h(f);
    },
    [j]
  );
  return /* @__PURE__ */ t.jsx(
    Ct,
    {
      data: Object.values(i[s]),
      columns: r,
      customTableRow: (f) => /* @__PURE__ */ t.jsx(
        U1,
        {
          ...f,
          setPassedAndFailed: d,
          passedAndFailed: j,
          analysis: m,
          data: {
            tableData: i,
            treemapData: a,
            selectedCohortId: s,
            activeTab: l,
            activeView: c
          }
        }
      ),
      withDuplicates: !0,
      pinnedColumns: { left: ["inclusionRule"] }
    }
  );
}, G1 = ({ cohorts: r = [], data: i, selectedCohort: a, analysis: s }) => {
  const [l, c] = be(
    r.filter((b) => b.id !== a.id)
  ), [m, j] = be("byPerson"), [h, d] = be("attrition"), f = Pe(() => i.reduce((b, E) => {
    const A = E.dataSource.id;
    return b[A] = E.resultInfo.inclusionRuleReports, b;
  }, {}), []), C = H1(i), v = () => {
    d((b) => b === "attrition" ? "intersect" : "attrition");
  };
  return kt(() => {
    c(
      r.filter((b) => b.id !== a.id)
    );
  }, [a]), /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        title: a.name,
        actions: /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs(Es, { children: [
          /* @__PURE__ */ t.jsx(
            ct,
            {
              onClick: () => j("byPerson"),
              variant: m === "byPerson" ? "contained" : "outlined",
              color: "info",
              children: "By person"
            }
          ),
          /* @__PURE__ */ t.jsx(
            ct,
            {
              onClick: () => j("byEvent"),
              variant: m === "byEvent" ? "contained" : "outlined",
              color: "info",
              children: "By event"
            }
          )
        ] }) }),
        children: /* @__PURE__ */ t.jsx(
          zu,
          {
            tableData: C[h],
            columns: Mu(
              i,
              m,
              a.id,
              h,
              v
            ),
            treemapData: f,
            activeTab: m,
            selectedCohortId: a.id,
            activeView: h,
            analysis: s
          }
        )
      }
    ) }),
    (r == null ? void 0 : r.length) > 1 && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { children: [
      /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", mb: 2, children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Compare to:" }) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
          Vt,
          {
            multiple: !0,
            fullWidth: !0,
            value: l || [],
            onChange: (b, E) => c(E),
            options: r.filter(
              (b) => b.id !== a.id
            ),
            placeholder: "Select cohort for comparison...",
            getOptionLabel: function(b) {
              var E;
              return b.name || ((E = r.find((A) => A.id === b)) == null ? void 0 : E.name);
            },
            isOptionEqualToValue: (b, E) => b.id === E.id || b.id === E
          }
        ) })
      ] }),
      /* @__PURE__ */ t.jsx(g, { container: !0, spacing: 1, children: l.map((b) => /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(
          ve,
          {
            fontSize: 14,
            fontWeight: 600,
            variant: "h6",
            color: "primary.main",
            mb: 1,
            children: b.name
          }
        ),
        /* @__PURE__ */ t.jsx(zt, { sx: { mb: 1.5 } }),
        /* @__PURE__ */ t.jsx(
          zu,
          {
            tableData: C[h],
            columns: Mu(
              i,
              m,
              b.id,
              h,
              v
            ),
            treemapData: f,
            activeTab: m,
            selectedCohortId: b.id,
            activeView: h,
            analysis: s
          }
        )
      ] })) })
    ] }) })
  ] });
}, K1 = ({
  data: r,
  selectedCohort: i,
  analysis: a
}) => {
  const s = Pe(() => {
    const l = {}, c = (m, j) => ({
      ...m,
      records: [{ ...m, cohortId: j }]
    });
    return r.forEach((m) => {
      Object.entries(
        m.resultInfo.demographics[i.id]
      ).forEach(([j, h]) => {
        const d = j === "age_group" ? "ageGroup" : j;
        l.hasOwnProperty(d) ? h.forEach((f) => {
          l[d][f.covariateId] ? l[d][f.covariateId].records.push({
            ...f,
            // this is inaccurate, should be fixed to some random identifier name
            cohortId: m.dataSource.id
          }) : l[d][f.covariateId] = c(
            f,
            m.dataSource.id
          );
        }) : l[d] = Vn(
          h.map(
            (f) => c(f, m.dataSource.id)
          ),
          "covariateId"
        );
      });
    }), Object.entries(l).forEach(
      ([m, j]) => l[m] = Object.values(j)
    ), Md(l, a);
  }, [r, i]);
  return /* @__PURE__ */ t.jsx(g, { container: !0, rowGap: 1, children: s.map((l) => /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
    $a,
    {
      name: l.name,
      report: l,
      cohorts: r.map((c) => c.dataSource) || [],
      analysis: a
    }
  ) }, l.id + l.name + i.id)) });
}, Bu = ({ getValue: r, maxWidth: i = 500, color: a = "success" }) => {
  var j;
  const s = r() || [], l = s.reduce((h, d, f) => {
    var C;
    return h.push(d.value - (((C = s[f - 1]) == null ? void 0 : C.value) || 0)), h;
  }, []), c = [a + ".light", "#D6D3D1", "backgroundColor.dark"], m = 18;
  return /* @__PURE__ */ t.jsx(
    le,
    {
      minWidth: ((j = String(r().totalProgress)) == null ? void 0 : j.length) * 8,
      maxWidth: i,
      width: "100%",
      display: "flex",
      children: s.map(({ value: h, tooltip: d }, f) => {
        var C;
        return /* @__PURE__ */ t.jsx(
          Nt,
          {
            text: d ?? te(h) ?? "",
            children: /* @__PURE__ */ t.jsx(
              le,
              {
                minWidth: ((C = String(h)) == null ? void 0 : C.length) * 8 + 6,
                sx: {
                  height: m,
                  lineHeight: m + "px",
                  width: l[f] * 100 / l[l.length - 1] + "%",
                  backgroundColor: c[f],
                  position: "relative",
                  textAlign: "right",
                  fontSize: 11,
                  boxSizing: "border-box",
                  px: 0.5,
                  maxWidth: "100%",
                  cursor: "default",
                  transition: "all 300ms",
                  ":hover": {
                    filter: "brightness(95%)"
                  }
                },
                children: te(h)
              },
              f
            )
          },
          "progress-" + f
        );
      })
    }
  );
}, Wa = (r, i, a = "domains") => [
  {
    id: "logo",
    header: "",
    accessorKey: "dataSource.id",
    enableHiding: !1,
    cell: lr,
    size: 36,
    maxSize: 36,
    meta: {
      columnType: "action"
    }
  },
  Ti({
    header: "Data source",
    accessorKey: "dataSource.name",
    size: 250
  }),
  {
    header: "Person count (PC)",
    accessorKey: `resultInfo.${a}.${r}.counts.${i}.personCount`,
    minSize: 300,
    maxSize: 500,
    cell: ({ row: s, getValue: l, ...c }) => {
      const m = s.original.resultInfo;
      return /* @__PURE__ */ t.jsx(
        Bu,
        {
          getValue: () => {
            var j;
            return [
              { value: l() ?? 0, tooltip: null },
              {
                value: (j = m.personDetails[r]) == null ? void 0 : j.personCount,
                tooltip: null
              },
              { value: m.summary.totalPersonCount, tooltip: null }
            ];
          },
          ...c
        }
      );
    }
  },
  {
    header: "Record count (RC)",
    accessorKey: `resultInfo.${a}.${r}.counts.${i}.recordCount`,
    minSize: 300,
    maxSize: 500,
    cell: ({ row: s, getValue: l, ...c }) => {
      const m = s.original.resultInfo;
      return /* @__PURE__ */ t.jsx(
        Bu,
        {
          getValue: () => [
            { value: l() ?? 0, tooltip: null },
            {
              value: m.domains[r].eventCount,
              tooltip: null
            },
            { value: m.summary.totalEventCount, tooltip: null }
          ],
          ...c
        }
      );
    }
  }
], Ha = (r, i) => [
  ...i !== "location" ? [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      enableColumnFilter: !1,
      size: 80,
      maxSize: 100,
      cell: ({ getValue: a }) => a() != -1 ? a() : "Undefined"
    }
  ] : [],
  ...i === "provider" ? [
    {
      header: "NPI",
      accessorKey: "npi",
      id: "npi",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    }
  ] : [],
  {
    header: "Name",
    accessorKey: "name",
    id: "name",
    size: 180,
    filterFn: (a, s, l) => [
      a.original.id,
      a.original.name,
      a.original.personCount,
      a.original.prevalence,
      a.original.npi,
      a.original.specialty,
      a.original.specialtySource,
      a.original.placeOfServiceConceptId,
      a.original.placeOfServiceConceptName
    ].some(
      (c) => String(c).toLowerCase().includes(l[0].toLowerCase())
    ),
    meta: {
      filterVariant: "value"
    }
  },
  ...i === "provider" || i === "provider_visit" ? [
    {
      header: "Specialty (Source)",
      accessorKey: "specialtySource",
      id: "specialtySource",
      enableColumnFilter: !1,
      size: 150
    },
    {
      header: "Specialty",
      accessorKey: "specialty",
      id: "specialty",
      enableColumnFilter: !1,
      size: 150
    }
  ] : [],
  ...i === "caresite" || i === "caresite_visit" ? [
    {
      header: "Place of service id",
      accessorKey: "placeOfServiceConceptId",
      id: "placeOfServiceConceptId",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    },
    {
      header: "Place of service",
      accessorKey: "placeOfServiceConceptName",
      id: "placeOfServiceConceptName",
      enableColumnFilter: !1,
      size: 120
      // cell: ({ getValue }) => (getValue() != -1 ? getValue() : 'Undefined'),
    }
  ] : [],
  ...r.map((a) => {
    const s = a.dataSource.id;
    return {
      header: () => /* @__PURE__ */ t.jsx($d, { name: a.dataSource.name, id: a.dataSource.id }),
      id: s,
      // we need this id to identifiy data for chart
      columns: [
        {
          header: "Person Count",
          accessorFn: (l) => {
            var c;
            return ((c = l == null ? void 0 : l[s]) == null ? void 0 : c.personCount) || 0;
          },
          id: "personCount___" + s,
          enableColumnFilter: !1,
          size: 110,
          sortingFn: "alphanumeric"
          // cell: ({ getValue }) => getValue() || 0,
        },
        {
          header: "Prevalence",
          id: "prevalence___" + s,
          accessorFn: (l) => {
            var c;
            return ((c = l == null ? void 0 : l[s]) == null ? void 0 : c.prevalence) || 0;
          },
          enableColumnFilter: !1,
          size: 100,
          cell: ({ getValue: l }) => (te(l() * 100, 2, 2) || 0) + "%"
        },
        {
          header: () => /* @__PURE__ */ t.jsx(le, { whiteSpace: "wrap", children: "Avg. records per person" }),
          id: "recordsPerPerson___" + s,
          accessorFn: (l) => {
            var m, j;
            return ((m = l[s]) == null ? void 0 : m.recordCount) / ((j = l[s]) == null ? void 0 : j.personCount) || 0;
          },
          enableColumnFilter: !1,
          size: 100,
          cell: ({ getValue: l }) => te(l(), 2, 2) || "0",
          sortingFn: "alphanumeric"
        }
      ]
    };
  })
];
function Va(r, i, a, s = "domains") {
  return Object.values(
    r.reduce((l, c) => {
      var m, j, h, d, f, C;
      return (C = (f = (d = (h = ((m = c.resultInfo) == null ? void 0 : m[s]) ?? ((j = c.resultInfo) == null ? void 0 : j.domains)) == null ? void 0 : h[i]) == null ? void 0 : d.prevalence) == null ? void 0 : f[a]) == null || C.forEach((v) => {
        l[v.id] ? l[v.id] = {
          ...l[v.id],
          ...[
            "name",
            "npi",
            "specialty",
            "specialtySource",
            "placeOfServiceConceptId",
            "placeOfServiceConceptName"
          ].reduce((b, E) => (b[E] = l[v.id][E] || v[E], b), {})
        } : l[v.id] = {
          name: v.name,
          id: v.id,
          npi: v.npi,
          placeOfServiceConceptId: v.placeOfServiceConceptId,
          placeOfServiceConceptName: v.placeOfServiceConceptName,
          specialty: v.specialty,
          specialtySource: v.specialtySource
        }, l[v.id][c.dataSource.id] = v;
      }), l;
    }, {})
  );
}
const q1 = ({ data: r, selectedCohort: i }) => {
  const { domainId: a } = hy(), s = Wa(i.id, a), l = Ha(r, a), c = Oi[a];
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { title: c, children: [
      /* @__PURE__ */ t.jsx(Ct, { data: r, columns: s, hideSettings: !0 }),
      /* @__PURE__ */ t.jsx(
        Cr,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ") with",
                " ",
                c,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ t.jsx(t.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Prevalence", children: /* @__PURE__ */ t.jsx(
      Ct,
      {
        variant: "uncontrolled",
        data: Va(r, i.id, a),
        columns: l,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      a
    ) }, a) })
  ] });
};
function Is(r, i, a, s) {
  return r.every((l) => {
    var m, j;
    const c = l.resultInfo[s ? "healthSystems" : "domains"][a];
    return !((m = c == null ? void 0 : c.counts) != null && m[i]) && !((j = c == null ? void 0 : c.prevalence) != null && j[i]);
  });
}
const ci = [
  "#7ba9ff",
  "#ff9315",
  "#DC6BAD",
  "#55DBCB",
  "#79d082",
  // original
  "#a1c2ff",
  "#568dff",
  "#ffd28c",
  "#ffb34d",
  "#e893c1",
  "#f4afd8",
  "#7ee0d4",
  "#3dc4b3",
  "#9ce4a5",
  "#5bbd67",
  "#c3d6ff",
  "#96afff",
  "#ffe0b3",
  "#ffbe66",
  "#e3a6cb",
  "#f7c4e1",
  "#b3eee4"
], Y1 = ({
  cx: r,
  cy: i,
  midAngle: a,
  innerRadius: s,
  outerRadius: l,
  percent: c,
  payload: m
}) => {
  const j = m.payload.isEmpty, h = c * 100, d = Math.PI / 180, f = s + (l - s) * 0.4, C = r + f * Math.cos(-a * d), v = i + f * Math.sin(-a * d);
  return /* @__PURE__ */ t.jsx(
    "text",
    {
      x: C,
      y: v,
      fill: "white",
      textAnchor: C > r ? "start" : "end",
      dominantBaseline: "central",
      fontSize: 12,
      children: `${j ? "0.00%" : h.toFixed(2)}%`
    }
  );
}, X1 = ({ data: r, title: i, dataSourceId: a, index: s, isEmpty: l }) => {
  const [c, m] = be(10), j = Pe(() => {
    let d = [...r];
    d.sort((C, v) => v.personCount - C.personCount);
    const f = d.splice(20).reduce(
      (C, v) => (C.personCount += v.personCount, C.items.push(v.name), C),
      { personCount: 0, name: "Other", items: [] }
    );
    return f.personCount > 0 && d.push(f), d;
  }, [r]), h = (d) => l ? "lightgrey" : d >= ci.length ? Ma(
    `0.${d / (1 * ci.length)}`,
    ci[d % ci.length]
  ) : ci[d];
  return /* @__PURE__ */ t.jsx(g, { item: !0, textAlign: "center", xs: 6, md: 6, xl: 4, minWidth: 400, children: /* @__PURE__ */ t.jsxs(g, { container: !0, justifyContent: l ? "space-around" : "center", children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(le, { display: "flex", justifyContent: "center", alignItems: "center", children: [
      /* @__PURE__ */ t.jsx(lr, { getValue: () => a, size: 20 }),
      /* @__PURE__ */ t.jsx(ve, { variant: "body2", sx: { ml: 1 }, children: i })
    ] }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 7.5, children: /* @__PURE__ */ t.jsx(Un, { height: 300, children: /* @__PURE__ */ t.jsxs(pd, { children: [
      /* @__PURE__ */ t.jsx(
        md,
        {
          cx: "50%",
          cy: "50%",
          fill: h(s),
          data: j,
          labelLine: !1,
          label: (r == null ? void 0 : r.length) < 11 ? Y1 : void 0,
          dataKey: "personCount",
          nameKey: "name",
          children: j.map((d, f) => /* @__PURE__ */ t.jsx(Ds, { fill: h(f) }, `cell-${f}`))
        }
      ),
      !l && /* @__PURE__ */ t.jsx(
        wr,
        {
          cursor: { stroke: "white", strokeWidth: 0 },
          content: ({ payload: d, ...f }) => {
            var C, v, b, E, A, R;
            return /* @__PURE__ */ t.jsxs(
              le,
              {
                sx: {
                  bgcolor: "white",
                  borderRadius: "2px",
                  p: 1,
                  fontSize: 12,
                  textAlign: "left"
                },
                children: [
                  /* @__PURE__ */ t.jsx("b", { children: (C = d == null ? void 0 : d[0]) == null ? void 0 : C.name }),
                  /* @__PURE__ */ t.jsx("br", {}),
                  "Person count:",
                  " ",
                  /* @__PURE__ */ t.jsx("b", { children: te(Number((v = d == null ? void 0 : d[0]) == null ? void 0 : v.value)) }),
                  /* @__PURE__ */ t.jsx("br", {}),
                  ((b = d == null ? void 0 : d[0]) == null ? void 0 : b.payload.recordCount) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                    "Record count:",
                    " ",
                    /* @__PURE__ */ t.jsx("b", { children: te(
                      Number((E = d == null ? void 0 : d[0]) == null ? void 0 : E.payload.recordCount)
                    ) })
                  ] }),
                  ((A = d == null ? void 0 : d[0]) == null ? void 0 : A.payload.items) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                    "Other items:",
                    " ",
                    /* @__PURE__ */ t.jsx("b", { children: ((R = d == null ? void 0 : d[0]) == null ? void 0 : R.payload.items).join(", ") })
                  ] })
                ]
              }
            );
          }
        }
      )
    ] }) }) }),
    !l && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 4.5, children: /* @__PURE__ */ t.jsxs(le, { pt: 4, textAlign: "left", children: [
      j.slice(0, c).map((d, f) => {
        const C = h(f);
        return /* @__PURE__ */ t.jsx(
          le,
          {
            title: d.name || "",
            sx: {
              fontSize: 13,
              color: "#474850",
              mb: 0.5,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "100%",
              "::before": {
                content: '""',
                height: "8px",
                width: "8px",
                backgroundColor: C,
                borderRadius: "50%",
                display: "inline-block",
                mr: 0.5
              }
            },
            children: d.name ? "— " + d.name : ""
          },
          `item-${f}`
        );
      }),
      (r == null ? void 0 : r.length) > 10 && /* @__PURE__ */ t.jsx(le, { textAlign: "left", children: /* @__PURE__ */ t.jsx(
        ct,
        {
          color: "info",
          variant: "text",
          size: "small",
          onClick: () => {
            m(c === 10 ? r.length : 10);
          },
          children: c === 10 ? "Show more" : "Show less"
        }
      ) })
    ] }) })
  ] }) });
}, fs = (r, i, a) => (s, l) => {
  var c, m, j;
  if ("prevalence" in ((c = s.resultInfo.healthSystems) == null ? void 0 : c[r])) {
    const h = (j = ((m = s.resultInfo.healthSystems) == null ? void 0 : m[r]).prevalence) == null ? void 0 : j[i + "_" + a];
    return /* @__PURE__ */ t.jsx(
      X1,
      {
        data: h != null && h.length ? h : [
          {
            personCount: 1,
            isEmpty: !0
          }
        ],
        index: l,
        title: s.dataSource.name,
        dataSourceId: s.dataSource.id,
        isEmpty: !(h != null && h.length)
      }
    );
  }
}, Z1 = ({ providerData: r, data: i, selectedCohort: a, hasHealthSystemData: s }) => {
  const l = r === "event" ? "provider" : "provider_visit", c = Is(
    i,
    l,
    a.id,
    s
  ), m = Wa(
    a.id,
    l,
    s ? "healthSystems" : "domains"
  ), j = Ha(i, l), h = Va(
    i,
    a.id,
    l,
    s ? "healthSystems" : "domains"
  ), d = Oi[l];
  return c ? /* @__PURE__ */ t.jsx(za, { noDataText: "No data found" }) : /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ t.jsx(Ct, { data: i, columns: m, hideSettings: !0 }),
      /* @__PURE__ */ t.jsx(
        Cr,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                a.name,
                ") with",
                " ",
                d,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                a.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ t.jsx(t.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    s && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Domain", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
      g,
      {
        container: !0,
        spacing: 2,
        sx: { overflowX: "auto", overflowY: "hidden" },
        flexWrap: "nowrap",
        children: i == null ? void 0 : i.map(
          fs(a.id, l, "domain")
        )
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
      Ct,
      {
        variant: "uncontrolled",
        data: h,
        columns: j,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      l
    ) }) }),
    s && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Specialty", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
        g,
        {
          container: !0,
          spacing: 2,
          sx: { overflowX: "auto", overflowY: "hidden" },
          flexWrap: "nowrap",
          children: i == null ? void 0 : i.map(
            fs(a.id, l, "specialty")
          )
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Specialty Source", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
        g,
        {
          container: !0,
          spacing: 2,
          sx: { overflowX: "auto", overflowY: "hidden" },
          flexWrap: "nowrap",
          children: i == null ? void 0 : i.map(
            fs(
              a.id,
              l,
              "specialty_source"
            )
          )
        }
      ) }) })
    ] })
  ] });
}, J1 = ({ data: r, selectedCohort: i, hasHealthSystemData: a }) => {
  const s = "location", l = Wa(
    i.id,
    s,
    a ? "healthSystems" : "domains"
  ), c = Ha(r, s), m = Va(
    r,
    i.id,
    s,
    a ? "healthSystems" : "domains"
  ), j = Is(
    r,
    s,
    i.id,
    a
  ), h = Oi[s];
  return j ? /* @__PURE__ */ t.jsx(za, { noDataText: "No data found" }) : /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ t.jsx(Ct, { data: r, columns: l, hideSettings: !0 }),
      /* @__PURE__ */ t.jsx(
        Cr,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ") with",
                " ",
                h,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ t.jsx(t.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
      Ct,
      {
        variant: "uncontrolled",
        data: m,
        columns: c,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      s
    ) }) })
  ] });
}, Q1 = ({ data: r, selectedCohort: i, hasHealthSystemData: a }) => {
  const s = "caresite_visit", l = Wa(
    i.id,
    s,
    a ? "healthSystems" : "domains"
  ), c = Ha(r, s), m = Va(
    r,
    i.id,
    s,
    a ? "healthSystems" : "domains"
  ), j = Is(
    r,
    s,
    i.id,
    a
  ), h = Oi[s];
  return j ? /* @__PURE__ */ t.jsx(za, { noDataText: "No data found" }) : /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { title: "Counts", outlined: !0, size: "dense", children: [
      /* @__PURE__ */ t.jsx(Ct, { data: r, columns: l, hideSettings: !0 }),
      /* @__PURE__ */ t.jsx(
        Cr,
        {
          config: [
            {
              color: "success.light",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ") with",
                " ",
                h,
                " data"
              ] })
            },
            {
              color: "#D6D3D1",
              text: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                "persons/records in cohort (",
                i.name,
                ")"
              ] })
            },
            {
              color: "backgroundColor.dark",
              text: /* @__PURE__ */ t.jsx(t.Fragment, { children: "persons/records in data source" })
            }
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { title: "Prevalence", outlined: !0, size: "dense", children: /* @__PURE__ */ t.jsx(
      Ct,
      {
        variant: "uncontrolled",
        data: m,
        columns: c,
        withDuplicates: !0,
        enableFiltering: !0,
        pinnedColumns: { left: ["id", "name"] }
      },
      s
    ) }) })
  ] });
}, eC = ({
  data: r,
  selectedCohort: i
}) => {
  const [a, s] = be("event"), l = r.some((c) => "healthSystems" in c.resultInfo);
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        defaultState: !1,
        collapsible: !0,
        title: "Provider",
        actions: /* @__PURE__ */ t.jsxs(Es, { size: "small", children: [
          /* @__PURE__ */ t.jsx(
            ct,
            {
              variant: a === "event" ? "contained" : "outlined",
              color: "info",
              onClick: (c) => {
                c.stopPropagation(), s("event");
              },
              children: "By Event"
            }
          ),
          /* @__PURE__ */ t.jsx(
            ct,
            {
              variant: a === "visit" ? "contained" : "outlined",
              color: "info",
              onClick: (c) => {
                c.stopPropagation(), s("visit");
              },
              children: "By visit"
            }
          )
        ] }),
        children: /* @__PURE__ */ t.jsx(
          Z1,
          {
            data: r,
            selectedCohort: i,
            providerData: a,
            hasHealthSystemData: l
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { defaultState: !1, collapsible: !0, title: "Care Site", children: /* @__PURE__ */ t.jsx(
      Q1,
      {
        data: r,
        selectedCohort: i,
        hasHealthSystemData: l
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Re, { defaultState: !1, collapsible: !0, title: "Location", children: /* @__PURE__ */ t.jsx(
      J1,
      {
        data: r,
        selectedCohort: i,
        hasHealthSystemData: l
      }
    ) }) })
  ] });
}, dS = $e((r) => {
  const { data: i, analysisInfo: a, subModules: s } = r, l = Pe(
    () => i.submissions.filter(
      (d) => d.state === uu.AWAITING_PUBLISHING_APPROVAL || d.state === uu.PUBLISHED
    ),
    [i]
  ), c = l[0].resultInfo.targetCohorts || [], m = l[0].resultInfo.eventCohorts || [], [j, h] = be(c[0]);
  return /* @__PURE__ */ t.jsxs(
    g,
    {
      container: !0,
      spacing: 1,
      sx: {
        td: {
          height: 36,
          py: 0.5
        }
      },
      children: [
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Re,
          {
            outlined: !0,
            elevated: !0,
            collapsible: !0,
            title: "Compare results",
            size: "dense",
            children: /* @__PURE__ */ t.jsx(P1, { resultData: l })
          }
        ) }),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
          Re,
          {
            outlined: !0,
            elevated: !0,
            collapsible: !0,
            title: "Details",
            size: "dense",
            children: [
              /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", mb: 2, children: [
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
                /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
                  Vt,
                  {
                    multiple: !1,
                    fullWidth: !0,
                    value: (j == null ? void 0 : j.id) || null,
                    onChange: (d, f) => h(f),
                    options: c,
                    placeholder: "Select cohort...",
                    getOptionLabel: function(d) {
                      var f;
                      return d.name || ((f = c.find((C) => C.id === d)) == null ? void 0 : f.name);
                    },
                    isOptionEqualToValue: (d, f) => d.id === f.id || d.id === f
                  }
                ) })
              ] }),
              /* @__PURE__ */ t.jsx(zt, {}),
              /* @__PURE__ */ t.jsx(Ba, { tabs: D1, withRouting: !0, secondary: !0 }),
              /* @__PURE__ */ t.jsx(td, { children: /* @__PURE__ */ t.jsxs(fy, { children: [
                /* @__PURE__ */ t.jsx(
                  li,
                  {
                    path: "/*",
                    element: /* @__PURE__ */ t.jsx(
                      W1,
                      {
                        eventCohorts: m,
                        data: l,
                        selectedCohort: j,
                        analysis: a
                      }
                    )
                  }
                ),
                /* @__PURE__ */ t.jsx(
                  li,
                  {
                    path: "/attrition",
                    element: /* @__PURE__ */ t.jsx(
                      G1,
                      {
                        cohorts: c,
                        data: l,
                        selectedCohort: j,
                        analysis: a
                      }
                    )
                  }
                ),
                /* @__PURE__ */ t.jsx(
                  li,
                  {
                    path: "/demographics",
                    element: /* @__PURE__ */ t.jsx(
                      K1,
                      {
                        analysis: a,
                        data: l,
                        selectedCohort: j
                      }
                    )
                  }
                ),
                /* @__PURE__ */ t.jsx(
                  li,
                  {
                    path: "/domain/:domainId",
                    element: /* @__PURE__ */ t.jsx(q1, { selectedCohort: j, data: l })
                  }
                ),
                /* @__PURE__ */ t.jsx(
                  li,
                  {
                    path: "/health-system",
                    element: /* @__PURE__ */ t.jsx(
                      eC,
                      {
                        selectedCohort: j,
                        data: l
                      }
                    )
                  }
                )
              ] }) })
            ]
          }
        ) })
      ]
    }
  );
}), hS = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
];
var tC = /* @__PURE__ */ ((r) => (r[r.age_group = 0] = "age_group", r[r.ethnicity = 1] = "ethnicity", r[r.gender = 2] = "gender", r[r.race = 3] = "race", r))(tC || {});
const nC = Le.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`, fS = $e((r) => {
  const { subModules: i, parentId: a, viewMode: s } = r, [l, c] = be([]);
  return /* @__PURE__ */ t.jsx(nC, { children: /* @__PURE__ */ t.jsx(g, { container: !0, children: /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
    /* @__PURE__ */ t.jsx("h3", { children: "Target cohorts:" }),
    /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        config: {
          onChange: (m) => {
            c(m);
          },
          multiple: !0,
          parentId: a,
          viewMode: s
        }
      }
    ),
    /* @__PURE__ */ t.jsx(g, { container: !0, children: l.map((m) => /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12 })) })
  ] }) }) });
}), pS = $e((r) => /* @__PURE__ */ t.jsx(t.Fragment, { children: "results" })), mS = () => ({}), xS = (r, i) => ({
  ...i,
  type: r.type
}), gS = $e(
  (r) => {
    const {
      subModules: i,
      parentId: a,
      design: s,
      id: l,
      typeContainer: c,
      updateDesign: m,
      analysisName: j,
      viewMode: h
    } = r;
    return /* @__PURE__ */ t.jsx(t.Fragment, { children: (!h || h && s.cohortVersionId) && /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        viewMode: h,
        path: It(c, l, a),
        config: {
          buttonText: "Import cohort",
          titleText: "Target cohort",
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: s.cohortVersionId ? [s.cohort] : [],
          onChange: ([d]) => {
            m("cohort", d || {});
          },
          parentId: a,
          returnEntityText: j,
          viewMode: h
        }
      }
    ) });
  }
), rC = (r) => (i, a, s, l) => {
  var c, m, j, h;
  return ((c = i.values[s]) == null ? void 0 : c[r]) > ((m = a.values[s]) == null ? void 0 : m[r]) ? 1 : ((j = a.values[s]) == null ? void 0 : j[r]) > ((h = i.values[s]) == null ? void 0 : h[r]) ? -1 : 0;
}, iC = (r, i, a, s) => r.values[a] - i.values[a], Vd = (r, i, a, s) => Math.abs(r.values[a]) - Math.abs(i.values[a]), Ud = (r) => {
  const i = r == null ? void 0 : r[0], a = r == null ? void 0 : r[1], s = Math.sqrt(
    ((i == null ? void 0 : i.diffValue) + (a == null ? void 0 : a.diffValue)) / 2
  );
  return s == 0 ? 0 : ((i == null ? void 0 : i.avg) - (a == null ? void 0 : a.avg)) / s;
}, ws = (r = !1) => ({
  columns: [
    {
      Header: "Covariate",
      id: "covariateName",
      accessor: "covariateName",
      rowSpan: 2,
      sortType: rC("covariateName"),
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "covariateName_1",
          accessor: (i) => i.covariateName || i.name,
          isCropped: !0,
          maxWidth: 150
        }
      ]
    },
    ...r ? [] : [
      {
        Header: "Concept Id",
        id: "conceptId",
        accessor: "conceptId",
        rowSpan: 2,
        columns: [
          {
            Header: "",
            invisible: !0,
            id: "conceptId_1",
            accessor: "conceptId",
            Cell: ({ value: i }) => /* @__PURE__ */ t.jsx(Zu, { to: `modal/related/${i}`, children: i })
          }
        ]
      }
    ]
  ]
}), aC = (r, i = [], a = !0, s = !1) => {
  const l = r.designName === "DemographicsAgeGroup";
  let c = i.map((m, j) => ({
    Header: m.name,
    align: "center",
    disableSortBy: !0,
    colSpan: 2,
    columns: [
      {
        Header: "Count",
        id: `records[${m.id}].count`,
        accessor: `records[${m.id}].count`,
        Cell: ({ value: h }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(h) })
      },
      {
        Header: "Pct, %",
        id: `avg${j}`,
        accessor: `records[${m.id}].avg`,
        sortType: iC,
        Cell: (h) => {
          const d = (h.value || 0) * 100, f = te(d, 2, 2);
          return /* @__PURE__ */ t.jsx(t.Fragment, { children: a ? /* @__PURE__ */ t.jsx(vs, { width: h.value * 100, label: `${f}%` }) : /* @__PURE__ */ t.jsx(ys, { children: `${f}%` }) });
        }
      }
    ]
  }));
  return (i == null ? void 0 : i.length) === 2 && !s && (c = [
    ...c,
    {
      Header: "Std diff",
      accessor: "records",
      rowSpan: 2,
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "stdDiff",
          accessor: (m) => Ud(Object.values(m.records)),
          Cell: ({ value: m }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(m, 4, 4) }),
          sortType: Vd
        }
      ]
    }
  ]), [...ws(l).columns, ...c];
}, oC = (r, i = []) => {
  if (i.length === 1) {
    const s = [
      {
        Header: "Persons",
        accessor: `records[${i[0].id}].count`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "Avg",
        accessor: `records[${i[0].id}].avg`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "Std Dev",
        accessor: `records[${i[0].id}].stdDev`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "Min",
        accessor: `records[${i[0].id}].min`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "P10",
        accessor: `records[${i[0].id}].p10`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "P25",
        accessor: `records[${i[0].id}].p25`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "Median",
        accessor: `records[${i[0].id}].median`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "P75",
        accessor: `records[${i[0].id}].p75`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "P90",
        accessor: `records[${i[0].id}].p90`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      },
      {
        Header: "Max",
        accessor: `records[${i[0].id}].max`,
        Cell: ({ value: l }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(l) })
      }
    ];
    return [...ws().columns, ...s];
  }
  let a = i.map((s, l) => ({
    Header: s.name,
    accessor: "records",
    align: "center",
    id: s.id,
    columns: [
      {
        Header: "Persons",
        accessor: `records[${s.id}].count`,
        id: `records[${s.id}].count`,
        Cell: ({ value: c }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(c) })
      },
      {
        Header: "Avg",
        id: `records[${s.id}].avg`,
        accessor: `records[${s.id}].avg`,
        Cell: ({ value: c }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(c) })
      },
      {
        Header: "Std Dev",
        id: `records[${s.id}].stdDev`,
        accessor: `records[${s.id}].stdDev`,
        Cell: ({ value: c }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(c) })
      },
      {
        Header: "Median",
        id: `records[${s.id}].median`,
        accessor: `records[${s.id}].median`,
        Cell: ({ value: c }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(c) })
      }
    ]
  }));
  return (i == null ? void 0 : i.length) === 2 && (a = [
    ...a,
    {
      Header: "Std diff",
      accessor: "records",
      rowSpan: 2,
      columns: [
        {
          Header: "",
          invisible: !0,
          id: "stdDiff",
          accessor: (s) => Ud(Object.values(s.records)),
          Cell: ({ value: s }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(s, 4, 4) }),
          sortType: Vd
        }
      ]
    }
  ]), [...ws().columns, ...a];
}, sC = ({
  getTableProps: r,
  getTableBodyProps: i,
  // headerGroups,
  // prepareRow,
  page: a,
  // onRowClick,
  // disableRowClick,
  // columnsCnt,
  // noDataText,
  // enableSorting,
  tileView: s = !1,
  // getRowError,
  // disableRowSelect,
  cohorts: l
}) => {
  const [c] = R0();
  return /* @__PURE__ */ t.jsxs(P0, { ...r(), className: "table", children: [
    !s && /* @__PURE__ */ t.jsxs("thead", { className: "table-head", children: [
      /* @__PURE__ */ t.jsxs(lu, { className: "table-row", children: [
        /* @__PURE__ */ t.jsx("th", { rowSpan: 2, colSpan: 2, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle1", component: "span", children: "Cohort" }) }),
        /* @__PURE__ */ t.jsx(
          le,
          {
            component: "th",
            colSpan: a.length,
            align: "center",
            sx: { textAlign: "center" },
            children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle1", component: "span", children: "Covariates" })
          }
        )
      ] }, "table-header-0"),
      /* @__PURE__ */ t.jsx(lu, { className: "table-row", children: a.map((m) => /* @__PURE__ */ t.jsx(
        le,
        {
          component: "th",
          sx: {
            whiteSpace: "break-spaces",
            width: `calc(80% / ${a.length})`,
            minWidth: "70px"
          },
          children: m.original.covariateName
        }
      )) }, "table-header-1")
    ] }),
    /* @__PURE__ */ t.jsx("tbody", { ...i(), className: "table-body", children: l.map((m, j) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(as, { children: /* @__PURE__ */ t.jsx(
        si,
        {
          rowSpan: 3,
          minWidth: 50,
          maxWidth: "50%",
          width: c,
          isCropped: !0,
          children: /* @__PURE__ */ t.jsx(
            le,
            {
              sx: {
                "::before": {
                  content: '""',
                  height: "8px",
                  width: "8px",
                  backgroundColor: j >= An.length ? Ma(
                    `0.${j / (1 * An.length)}`,
                    An[j % An.length]
                  ) : An[j],
                  borderRadius: "50%",
                  display: "inline-block",
                  mr: 1
                }
              },
              children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle1", component: "span", children: m.name })
            },
            `item-${j}`
          )
        }
      ) }),
      /* @__PURE__ */ t.jsxs(as, { children: [
        /* @__PURE__ */ t.jsx(si, { width: 100, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle1", children: "Count" }) }),
        a.map((h) => {
          var d;
          return /* @__PURE__ */ t.jsx(si, { children: te(((d = h.original.records[m.id]) == null ? void 0 : d.count) || 0) });
        })
      ] }),
      /* @__PURE__ */ t.jsxs(as, { children: [
        /* @__PURE__ */ t.jsx(si, { width: 100, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle1", children: "Pct, %" }) }),
        a.map((h) => {
          var d;
          return /* @__PURE__ */ t.jsx(si, { children: te(
            (((d = h.original.records[m.id]) == null ? void 0 : d.avg) || 0) * 100,
            2,
            2
          ) });
        })
      ] })
    ] })) })
  ] });
}, lC = $e((r) => {
  var x, p;
  const { name: i, report: a, cohorts: s, allResults: l, analysis: c } = r, [m, j] = be(""), [h, d] = be([]), f = a.resultType === Dt.DISTRIBUTION, C = a.designName === "DemographicsAgeGroup", v = Pe(() => {
    var w;
    let y = (w = a == null ? void 0 : a.item) == null ? void 0 : w.map((M) => ({
      ...M,
      analysisType: M.analysisType || i,
      records: M.records.reduce((V, q) => (V[q.cohortId] = q, V), {}) || []
    }));
    return C && y.sort((M, V) => String(M.name).localeCompare(V.name)), {
      raw: y,
      groupedByPage: wd(y).list
    };
  }, [a.item]), [b, E] = be(v.raw), A = Pe(() => f ? b : [], [b, f]), R = Pe(() => {
    const y = (A == null ? void 0 : A.length) || 1, w = (s == null ? void 0 : s.length) || 1;
    return w === 2 ? Math.max(200, y * 44 + 60) : Math.max(200, y * (w * 34 + 70));
  }, [s, A]), D = od((y) => {
    const w = v.raw.filter((M) => M.covariateName.toLowerCase().includes(y.toLowerCase()) || M.conceptId.toString().toLowerCase().includes(y.toString().toLowerCase()));
    E(w);
  }, 300), _ = (y) => {
    const { value: w } = y.target;
    j(w), D(w);
  }, F = Pe(() => {
    switch (a == null ? void 0 : a.resultType) {
      case Dt.PREVALENCE:
        return aC(
          a,
          s,
          v.raw.length > 2,
          (c == null ? void 0 : c.type) === Sr.BULK_COHORT_COUNTS || (c == null ? void 0 : c.type) === Sr.FEASIBILITY
          // we don't have diff in bulk
        );
      case Dt.DISTRIBUTION:
        return oC(a, s);
      default:
        return [];
    }
  }, [a, s]), P = f || ((x = a.item) == null ? void 0 : x.length) > 8 && (s == null ? void 0 : s.length) > 2 || (s == null ? void 0 : s.length) > 3;
  return /* @__PURE__ */ t.jsx(
    Re,
    {
      elevated: !0,
      title: i,
      actions: !b.some(
        (y) => y.covariateName === null || y.covariateName === ""
      ) && v.raw.length > 1 && /* @__PURE__ */ t.jsxs(le, { display: "flex", alignItems: "center", justifyContent: "flex-end", children: [
        /* @__PURE__ */ t.jsx(le, { mr: 1, children: "Filter: " }),
        /* @__PURE__ */ t.jsx(
          $n,
          {
            id: "search",
            name: "search",
            type: "text",
            size: "medium",
            placeholder: "Search by covariate",
            value: m,
            onChange: _,
            fullWidth: !0
          }
        )
      ] }),
      children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
        !h && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(le, { display: "flex", justifyContent: "center", p: 3, children: "No items" }) }),
        /* @__PURE__ */ t.jsx(
          g,
          {
            item: !0,
            xs: P ? 12 : 7,
            lg: P ? 12 : 8,
            sx: {
              table: {
                td: {
                  fontSize: 13
                }
              }
            },
            children: h && /* @__PURE__ */ t.jsx(
              _n,
              {
                columns: F,
                data: b,
                customTable: (s == null ? void 0 : s.length) > 2 ? (y) => /* @__PURE__ */ t.jsx(sC, { ...y, cohorts: s }) : void 0,
                noDataText: "The result listing is empty because of the filter you applied",
                enableSorting: !0,
                enablePagination: !0,
                totalElements: (p = v.raw) == null ? void 0 : p.length,
                setCurrentPage: d,
                initialSort: C ? void 0 : { id: "avg0", desc: !0 },
                pageSize: (s == null ? void 0 : s.length) > 2 ? b.length : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(g, { item: !0, xs: P ? 12 : 5, lg: P ? 12 : 4, children: a.resultType !== Dt.DISTRIBUTION ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          s.length == 1 && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            a.item.length > 1 && a.item.length < 5 && /* @__PURE__ */ t.jsx(
              jd,
              {
                list: h,
                cohort: s == null ? void 0 : s[0],
                addNA: !0
              }
            ),
            a.item.length > 5 && /* @__PURE__ */ t.jsx(Cd, { list: h, cohort: s == null ? void 0 : s[0] })
          ] }),
          s.length == 2 && /* @__PURE__ */ t.jsx(
            Sd,
            {
              fullList: v.groupedByPage,
              cohorts: s,
              list: h,
              allResults: l,
              report: a
            }
          ),
          s.length > 2 && /* @__PURE__ */ t.jsx(
            Td,
            {
              cohorts: s,
              list: h,
              xAxisTickFormatter: C ? (y) => y.replace("age group:", "") : void 0
            }
          )
        ] }) : a.resultType === Dt.DISTRIBUTION && /* @__PURE__ */ t.jsx(g, { container: !0, px: 2, children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(Un, { height: R, children: /* @__PURE__ */ t.jsx(
          yd,
          {
            report: a || {},
            cohorts: s || [],
            items: A
          }
        ) }) }) }) })
      ] })
    }
  );
}), Gd = ({ analysis: r, result: i, cohorts: a }) => {
  const s = Md(i, r);
  return /* @__PURE__ */ t.jsx(g, { container: !0, p: 2, className: "simple-counts-demographics", children: /* @__PURE__ */ t.jsx(td, { children: (s == null ? void 0 : s.length) > 0 ? s.map((l) => {
    var c, m;
    return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mb: 2, children: r.type === Sr.BULK_COHORT_COUNTS ? /* @__PURE__ */ t.jsx(
      lC,
      {
        name: l.name,
        report: l,
        cohorts: a || (r != null && r.design ? [(c = r == null ? void 0 : r.design) == null ? void 0 : c.cohort] : []),
        analysis: r
      }
    ) : /* @__PURE__ */ t.jsx(
      $a,
      {
        name: l.name,
        report: l,
        cohorts: a || (r != null && r.design ? [(m = r == null ? void 0 : r.design) == null ? void 0 : m.cohort] : []),
        analysis: r
      }
    ) }, l.name);
  }) : /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(za, { noDataText: "No data currently available" }) }) }) });
}, vS = [
  {
    name: "Target cohort",
    value: "cohortVersionId"
  }
], cC = (r, i) => [
  ...i ? [
    {
      title: "Results",
      value: "results",
      onTabClick: r
    }
  ] : [
    {
      value: "byPerson",
      title: "By person",
      onTabClick: r
    },
    {
      value: "byEvent",
      title: "By event",
      onTabClick: r
    }
  ],
  {
    title: "Demographics",
    value: "demographics",
    onTabClick: r
  }
], uC = (r) => [
  {
    value: "byPerson",
    title: "By person",
    onTabClick: r
  },
  {
    value: "byEvent",
    title: "By event",
    onTabClick: r
  }
  // ...(hasDemographics
  //   ? [
  //       {
  //         title: 'Demographics',
  //         value: 'demographics',
  //         onTabClick: setActive,
  //       },
  //     ]
  //   : []),
], dC = [
  {
    header: "Match rate",
    accessorKey: "percentMatched"
  },
  {
    header: "Matches",
    accessorKey: "finalCount",
    cell: ({ getValue: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r()) })
  },
  {
    header: "Total events",
    accessorKey: "baseCount",
    cell: ({ getValue: r }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(r()) })
  }
], hC = ({ activeView: r, setActiveView: i, resultData: a }) => [
  {
    header: () => /* @__PURE__ */ t.jsx(
      ar,
      {
        title: "Inclusion rule",
        description: "Inclusion rules are based on inclusion rule section in the cohort builder"
      }
    ),
    accessorFn: (s) => s.id >= 0 ? `${s.id + 1}. ${s.name}` : s.name,
    id: "inclusionRule",
    size: 350
  },
  {
    header: () => /* @__PURE__ */ t.jsx(
      ar,
      {
        title: "N",
        description: "Number of persons that satisfy all inclusion rules applied consecutively in an order specified in the cohort builder"
      }
    ),
    accessorKey: "countSatisfying",
    cell: ({ getValue: s }) => /* @__PURE__ */ t.jsx(t.Fragment, { children: te(s()) }),
    size: 80
  },
  {
    header: () => /* @__PURE__ */ t.jsx(
      ar,
      {
        title: "% Satisfied",
        description: "Persons that satisfy all consecutive inclusion rules expressed as % of the base cohort count"
      }
    ),
    accessorKey: "percentSatisfying",
    size: 80
  },
  {
    header: () => /* @__PURE__ */ t.jsx(
      ar,
      {
        title: "% to gain",
        description: "% to gain represents the % of population that can be recovered by relaxing the inclusion rule"
      }
    ),
    accessorKey: "percentExcluded",
    size: 80
  },
  {
    header: () => /* @__PURE__ */ t.jsx(
      Nt,
      {
        text: r ? "The Attrition view allows users to visualize a classic attrition funnel, where each consecutive rule further restricts the population. The order of criteria affects the statistics." : "The Intersect view allows users to visualize how individual inclusion rules or combinations of these rules affect results, regardless of the sequence in which the rules are applied.Hovering over each box allows to see statistical information about the subgroups that either satisfied or did not satisfy specific inclusion criteria. The failed criteria is highlighted in red.",
        children: /* @__PURE__ */ t.jsxs(
          ct,
          {
            variant: "text",
            startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "reload" }),
            onClick: () => i((s) => !s),
            size: "small",
            color: "primary",
            children: [
              "Switch to ",
              r ? "intersect view" : "attrition view"
            ]
          }
        )
      }
    ),
    id: "percentSatisfying-chart",
    accessorKey: "percentSatisfying",
    enableSorting: !1,
    // enableHiding: false,
    size: 320,
    meta: {
      headerAlign: "center",
      columnName: "Chart"
    },
    cell: (s) => {
      const l = a.summary.baseCount;
      return /* @__PURE__ */ t.jsx(
        Nt,
        {
          text: s.row.original.id !== -1 ? Fd(s.row.original.id, a) : `${s.row.original.name}: ${l}, 100.00%`,
          color: "primary",
          width: "auto",
          children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
            Wd,
            {
              color: Id(parseFloat(s.getValue()) / 100),
              width: s.getValue()
            }
          ) })
        }
      );
    }
  }
], fC = ({
  analysis: r,
  data: i,
  row: a,
  setPassedAndFailed: s,
  passedAndFailed: l,
  index: c,
  ...m
}) => {
  var C, v;
  const j = Jt(() => {
    var b;
    return !!((b = l == null ? void 0 : l.failed) != null && b.find((E) => E.id === a.original.id));
  }, [l.failed]), h = 10, d = new Array(
    h - ((C = Object.values(i.inclusionRuleStats)) == null ? void 0 : C.length)
  ).fill(null), f = i.activeView == "intersect" && c === ((v = Object.values(i.inclusionRuleStats)) == null ? void 0 : v.length);
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      le,
      {
        component: "tr",
        ...m,
        className: m.className + (c === 0 ? " no-hover" : ""),
        children: a.getVisibleCells().map((b) => {
          const E = b.column.getIsPinned();
          if (i.activeView == "intersect" && b.id.includes("percentSatisfying-chart")) {
            const A = !!i.treemapData;
            if (c == 0)
              return /* @__PURE__ */ t.jsx(
                le,
                {
                  component: "td",
                  className: `${E ? "pinned " : ""} td`,
                  rowSpan: h,
                  sx: {
                    fontSize: "10px !important",
                    padding: "4px 0 ",
                    height: A ? "300px" : "",
                    textAlign: "center",
                    backgroundColor: A ? "white" : "transparent",
                    position: "relative",
                    borderBottom: A ? "none" : void 0
                  },
                  children: A ? /* @__PURE__ */ t.jsx(
                    Hd,
                    {
                      resultData: i,
                      setPassedAndFailed: s,
                      analysisName: r == null ? void 0 : r.title
                    }
                  ) : "N/A"
                }
              );
          } else
            return /* @__PURE__ */ t.jsx(
              le,
              {
                component: "td",
                className: `${E ? "pinned " : ""} td`,
                sx: {
                  color: j() ? "red" : ""
                },
                children: Xu(b.column.columnDef.cell, {
                  ...b.getContext()
                })
              }
            );
        })
      }
    ),
    f && d.map(() => /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", {}),
      /* @__PURE__ */ t.jsx("td", {}),
      /* @__PURE__ */ t.jsx("td", {}),
      /* @__PURE__ */ t.jsx("td", {})
    ] }))
  ] });
}, Kd = ({ legacy: r, resultsCount: i, activeTab: a, analysisInfo: s, count: l }) => {
  var b;
  const [c, m] = be(!0), j = s.type === Sr.BULK_COHORT_COUNTS, h = Pe(() => {
    var E;
    return j ? i == null ? void 0 : i.find((A) => A.type === a) : ((E = i == null ? void 0 : i.inclusionRuleReport) == null ? void 0 : E[a]) || [];
  }, [a]), d = Pe(() => c ? (h == null ? void 0 : h.attritions) || [] : h == null ? void 0 : h.inclusionRuleStats, [a, c]), [f, C] = be({
    passed: [],
    failed: []
  }), v = Jt(
    (E) => {
      Os(f, E) || C(E);
    },
    [f]
  );
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, p: 2, children: [
    /* @__PURE__ */ t.jsx(V1, { count: l }),
    !r && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, pt: 2, children: /* @__PURE__ */ t.jsx(zt, {}) }),
      (h == null ? void 0 : h.summary) && (h == null ? void 0 : h.summary.length) > 0 && /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 10, children: [
        /* @__PURE__ */ t.jsx(
          Ta,
          {
            title: "Summary statistics",
            startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "list" })
          }
        ),
        /* @__PURE__ */ t.jsx(g, { container: !0, py: 2, children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, className: "table-cohorts", children: /* @__PURE__ */ t.jsx(
          Ct,
          {
            columns: dC,
            data: h != null && h.summary ? [h == null ? void 0 : h.summary] : [],
            loadingMessage: "",
            totalElements: (b = h == null ? void 0 : h.summary) == null ? void 0 : b.length
          }
        ) }) })
      ] })
    ] }),
    !r && /* @__PURE__ */ t.jsx(g, { container: !0, item: !0, xs: 12, mt: 3, children: /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
      Ct,
      {
        columns: hC({
          activeView: c,
          setActiveView: m,
          resultData: h
        }),
        data: [
          {
            countSatisfying: h.summary.baseCount,
            id: -1,
            name: "Base count (Entry events)",
            percentExcluded: "0.00%",
            percentSatisfying: "100.00%"
          },
          ...d
        ],
        customTableRow: (E) => /* @__PURE__ */ t.jsx(
          fC,
          {
            ...E,
            setPassedAndFailed: v,
            passedAndFailed: f,
            analysis: s,
            data: {
              ...h,
              activeTab: a,
              activeView: c ? "attrition" : "intersect"
            }
          }
        )
      }
    ) }) })
  ] }) });
}, pC = $e((r) => {
  const { data: i, analysisInfo: a } = r, s = Pa(i) ? i : null, l = !(s != null && s.inclusionRuleReport) || !(Object.keys(s.inclusionRuleReport).length > 0), c = (s == null ? void 0 : s.personCount) != null, m = (s == null ? void 0 : s.recordCount) != null, j = c || m, [h, d] = be(
    l && !j ? "results" : "byPerson"
  ), { selectedConcepts: f, detectSelectedAction: C } = ly(
    {},
    "id"
  ), v = a.type === Sr.SIMPLE_COUNTS_CHARACTERIZATION, b = Pe(() => {
    if (!Pa(i))
      return `${te(i)} ${i != null ? "Persons" : ""}`;
    if (h === "byEvent") {
      const R = (s == null ? void 0 : s.recordCount) ?? (s == null ? void 0 : s.personCount);
      return `${R != null ? te(R) : "N/A"} ${R != null ? "Records" : ""}`;
    }
    const A = (s == null ? void 0 : s.personCount) ?? (s == null ? void 0 : s.recordCount);
    return `${A != null ? te(A) : "N/A"} ${A != null ? "Persons" : ""}`;
  }, [h, i]), E = Jt((A, R) => {
    const D = {};
    A == null || A.forEach((_) => {
      D[_.id] = _;
    }), C(D, R);
  }, []);
  return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
    (!l || v || j) && /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx(
        Ba,
        {
          tabs: (
            // not clean - hot fix
            v ? cC(d, l && !j) : uC(d)
          ),
          active: h
        }
      ),
      /* @__PURE__ */ t.jsx(zt, {})
    ] }),
    h !== "demographics" && /* @__PURE__ */ t.jsx(
      Kd,
      {
        legacy: l,
        resultsCount: i,
        activeTab: h,
        analysisInfo: a,
        detectSelectedAction: E,
        count: b
      }
    ),
    v && h === "demographics" && /* @__PURE__ */ t.jsx(
      Gd,
      {
        analysis: r.analysisInfo,
        result: i
      }
    )
  ] });
}), yS = $e(
  (r) => {
    const {
      subModules: i,
      parentId: a,
      design: s,
      id: l,
      typeContainer: c,
      updateDesign: m,
      analysisName: j,
      viewMode: h
    } = r;
    return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      (!h || h && s.cohortVersionId) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        i.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: i,
          viewMode: h,
          path: It(c, l, a),
          config: {
            buttonText: "Import cohort",
            titleText: "Target cohort",
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: s.cohortVersionId ? [s.cohort] : [],
            onChange: ([d]) => {
              m("cohort", d || {});
            },
            parentId: a,
            returnEntityText: j,
            viewMode: h
          }
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ t.jsx(
        Re,
        {
          title: "Characterization settings",
          elevated: !0,
          outlined: !0,
          children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Ke,
              {
                htmlFor: "useAgeGroups",
                textLabel: "Age Group",
                description: "Calculate age groups covariates prevalence statistics with 5 year interval.",
                labelSize: 3,
                children: /* @__PURE__ */ t.jsx(
                  At,
                  {
                    id: "useAgeGroups",
                    name: "useAgeGroups",
                    onChange: () => {
                      m("useAgeGroups", !s.useAgeGroups);
                    },
                    checked: s.useAgeGroups,
                    disabled: h,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Ke,
              {
                htmlFor: "useEthnicity",
                textLabel: "Ethnic Groups",
                description: "Calculate ethnicity covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ t.jsx(
                  At,
                  {
                    id: "useEthnicity",
                    name: "useEthnicity",
                    onChange: () => {
                      m("useEthnicity", !s.useEthnicity);
                    },
                    checked: s.useEthnicity,
                    disabled: h,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Ke,
              {
                htmlFor: "useGender",
                textLabel: "Gender",
                description: "Calculate gender covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ t.jsx(
                  At,
                  {
                    id: "useGender",
                    name: "useGender",
                    onChange: () => {
                      m("useGender", !s.useGender);
                    },
                    checked: s.useGender,
                    disabled: h,
                    size: "small"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
              Ke,
              {
                htmlFor: "useRace",
                textLabel: "Race",
                description: "Calculate race covariates prevalence statistics.",
                labelSize: 3,
                children: /* @__PURE__ */ t.jsx(
                  At,
                  {
                    id: "useRace",
                    name: "useRace",
                    onChange: () => {
                      m("useRace", !s.useRace);
                    },
                    checked: s.useRace,
                    disabled: h,
                    size: "small"
                  }
                )
              }
            ) })
          ] })
        }
      ) })
    ] });
  }
), mC = (r) => {
  switch (r) {
    case En.SCANNING:
      return "warning";
    case En.OK:
      return "success";
    case En.INFECTED:
      return "error";
    case En.NOT_SCANNED:
    case En.WILL_NOT_SCAN:
      return "secondary";
  }
}, xC = (r, i) => As.post(`analysis/strategus/${r}/upload`, i), gC = $e((r) => {
  const { id: i, afterCreate: a, onCancel: s, subModules: l, originalEntity: c, parentId: m } = r, [j, h] = be(!1), [d, f] = be(!1), [C, v] = be(), [b, E] = be(), [A, R] = be({
    title: c.title,
    analysisType: nd.find(
      (P) => P.value === c.type
    ).name || "-",
    analysisName: c == null ? void 0 : c.title,
    studyId: m,
    studyName: null,
    design: {
      analysisJsonFile: null
    }
  }), D = Jt(() => {
    h(!0);
    let P = new FormData();
    P.append(
      "dto",
      new Blob([JSON.stringify(A)], {
        type: "application/json"
      })
    ), P.append("file", b), xC(i, P).then((x) => {
      h(!1), a == null || a(x);
    });
  }, [C, A]), _ = (P) => {
    try {
      if (P) {
        const x = JSON.parse(P);
        v(x), f(!1);
      } else
        v(void 0), f(!1);
    } catch {
      f(!0);
    }
  }, F = Pe(() => !d && C, [C, d]);
  return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsx(Ci, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, display: "flex", flexWrap: "wrap", children: [
      /* @__PURE__ */ t.jsxs(g, { item: !0, mr: 2, children: [
        /* @__PURE__ */ t.jsx(
          ve,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Analysis name:"
          }
        ),
        /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", component: "span", fontWeight: 700, children: A.analysisName })
      ] }),
      /* @__PURE__ */ t.jsxs(g, { item: !0, mr: 2, children: [
        /* @__PURE__ */ t.jsx(
          ve,
          {
            variant: "subtitle2",
            component: "label",
            sx: { mr: 0.5 },
            children: "Analysis type:"
          }
        ),
        /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", component: "span", fontWeight: 700, children: A.analysisType })
      ] })
    ] }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      l.documents,
      {
        type: "component",
        name: "import-json-file",
        subModules: l,
        config: {
          titleButton: "Upload json",
          onChange: (P, x) => {
            v(P), E(x);
          }
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      $0,
      {
        data: C || "",
        height: "63vh",
        fileName: `${c.title}.${c.type}`,
        language: ud(Ra.JSON),
        onChange: _,
        readOnly: !0,
        fileExtension: Ra.JSON,
        contentType: W0.APPLICATION_JSON
      }
    ) }),
    d && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      ve,
      {
        variant: "subtitle2",
        fontWeight: 700,
        color: "error.main",
        children: "Invalid json"
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Ju, { children: [
      /* @__PURE__ */ t.jsx(
        ct,
        {
          variant: "outlined",
          onClick: s,
          startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "deactivate" }),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ t.jsx(
        ct,
        {
          disabled: j || !F,
          onClick: D,
          variant: "contained",
          color: "success",
          startIcon: j ? /* @__PURE__ */ t.jsx(ka, { size: 16 }) : /* @__PURE__ */ t.jsx(bt, { iconName: "submit" }),
          children: "Save design"
        }
      )
    ] }) })
  ] }) }) });
});
Le.div`
  background: #ffffff;
  padding: 15px;
  h3 {
    font-size: 14px;
  }
  .message {
    font-size: 12px;
  }
`;
const vC = Le(g)`
  font-size: 14px;
  color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.primary.main;
}};
  font-weight: 700;
  border-bottom: 1px solid
    ${({ theme: r }) => r.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: r, theme: i }) => r ? i.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: r, isActive: i }) => r.palette.info.main + (i ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, bS = $e(
  (r) => {
    var E, A, R;
    const {
      subModules: i,
      parentId: a,
      design: s,
      originalEntity: l,
      id: c,
      typeContainer: m,
      updateDesign: j,
      viewMode: h
    } = r, { openModal: d, closeModal: f } = qu(xd), [C, v] = be(
      s.analysisJsonFile || null
    ), b = () => {
      d(
        () => /* @__PURE__ */ t.jsx(
          gC,
          {
            id: c,
            subModules: i,
            originalEntity: l,
            onCancel: f,
            parentId: a,
            afterCreate: (D) => {
              v(D.design.analysisJsonFile), j("analysisJsonFile", D.design.analysisJsonFile), f();
            }
          }
        ),
        "Upload analysis",
        {
          closeOnClickOutside: !0,
          onClose: f
        }
      );
    };
    return Pe(
      () => C == null ? void 0 : C.title,
      [C == null ? void 0 : C.title]
    ), Pe(
      () => ud(Ra.JSON),
      []
    ), /* @__PURE__ */ t.jsx(Ci, { children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, px: 2, children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        H0,
        {
          title: "",
          customButtons: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            (s == null ? void 0 : s.analysisJsonFile) && /* @__PURE__ */ t.jsx(
              ct,
              {
                onClick: (D) => {
                  D.stopPropagation(), window.location.href = `/api/analysis/strategus/${c}/download`;
                },
                variant: "outlined",
                startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "download" }),
                sx: {
                  mr: 2,
                  px: 2,
                  color: "info.main",
                  borderColor: "borderColor.main",
                  ".start-icon-small svg": {
                    fontSize: 16
                  }
                },
                className: "download-files",
                name: "download-files",
                children: "Download file"
              }
            ),
            !h && /* @__PURE__ */ t.jsx(
              ct,
              {
                onClick: b,
                variant: "contained",
                color: "info",
                startIcon: /* @__PURE__ */ t.jsx(
                  bt,
                  {
                    iconName: "download",
                    sx: { transform: "rotate(180deg)" }
                  }
                ),
                name: "upload",
                children: "Upload"
              }
            )
          ] })
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: (s == null ? void 0 : s.analysisJsonFile) && /* @__PURE__ */ t.jsx(Ci, { children: /* @__PURE__ */ t.jsx(
        g,
        {
          container: !0,
          spacing: 2,
          py: 2,
          className: "block-analysisJsonFile",
          children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(
            vC,
            {
              xs: 12,
              px: 1,
              py: 0.5,
              isActive: !0,
              children: [
                /* @__PURE__ */ t.jsx(
                  bt,
                  {
                    iconName: sd(Ra.JSON),
                    iconStatus: mC(
                      (E = s == null ? void 0 : s.analysisJsonFile) == null ? void 0 : E.antivirusFileStatusDto
                    ),
                    sx: { fontSize: 30 }
                  }
                ),
                /* @__PURE__ */ t.jsx("span", { children: (A = s == null ? void 0 : s.analysisJsonFile) == null ? void 0 : A.realName })
              ]
            },
            (R = s == null ? void 0 : s.analysisJsonFile) == null ? void 0 : R.path
          ) })
        }
      ) }) })
    ] }) });
  }
), CS = $e((r) => /* @__PURE__ */ t.jsx(t.Fragment, { children: "results" })), yC = [
  "PERSON",
  "OBSERVATION_PERIOD",
  "VISIT_OCCURRENCE",
  "VISIT_DETAIL",
  "CONDITION_OCCURRENCE",
  "DRUG_EXPOSURE",
  "PROCEDURE_OCCURRENCE",
  "DEVICE_EXPOSURE",
  "MEASUREMENT",
  "OBSERVATION",
  "DEATH",
  "NOTE",
  "NOTE_NLP",
  "SPECIMEN",
  "FACT_RELATIONSHIP"
], bC = ["METADATA", "CDM_SOURCE"], CC = ["LOCATION", "CARE_SITE", "PROVIDER"], jC = ["PAYER_PLAN_PERIOD", "COST"], SC = [
  "CONCEPT",
  "VOCABULARY",
  "DOMAIN",
  "CONCEPT_CLASS",
  "CONCEPT_RELATIONSHIP",
  "RELATIONSHIP",
  "CONCEPT_SYNONYM",
  "CONCEPT_ANCESTOR",
  "SOURCE_TO_CONCEPT_MAP",
  "DRUG_STRENGTH",
  "COHORT_DEFINITION",
  "ATTRIBUTE_DEFINITION"
], ps = [
  ...yC.map((r) => ({
    name: r,
    group: "Clinical Data Tables"
  })),
  ...bC.map((r) => ({
    name: r,
    group: "Metadata Tables"
  })),
  ...CC.map((r) => ({
    name: r,
    group: "Health System"
  })),
  ...jC.map((r) => ({
    name: r,
    group: "Health Economics"
  })),
  ...SC.map((r) => ({
    name: r,
    group: "Vocabularies"
  }))
], $u = {
  "Metadata Tables": { header: "#d2f7f3", options: "#ebf7f7" },
  "Clinical Data Tables": { header: "#d9ecff", options: "#f4f9ff" },
  "Health Economics": { header: "#d4f7d2", options: "#ecfceb" },
  "Health System": { header: "#fceeca", options: "#fcf5e3" },
  Vocabularies: { header: "#f6ebfc", options: "#fcf7ff" },
  selectAll: { header: "#ffffff", options: "#ffffff" }
}, wC = Le.div`
  padding: 8px 10px;
  position: sticky;
  background-color: ${({ color: r }) => (r == null ? void 0 : r.header) || "#ffffff"};
  z-index: 2;
  top: 0;
`, TC = Le.div`
  background-color: ${({ color: r }) => (r == null ? void 0 : r.options) || "#ffffff"};
  min-height: 34px;
  cursor: pointer;
`, _C = Le.div`
  padding: 8px 10px;
  cursor: pointer;

  /* pointer-events: ${({ disabled: r }) => r ? "none" : "all"}; */
  position: sticky;
  top: 0;
`, EC = ({
  updateDesign: r,
  design: i,
  disabled: a
}) => {
  var d;
  const s = ps.length, [l, c] = be(
    ((d = Object.keys(i.includedTables)) == null ? void 0 : d.length) === s
  );
  kt(() => {
    var f;
    ((f = Object.keys(i.includedTables)) == null ? void 0 : f.length) === s ? c(!0) : c(!1);
  }, [i.includedTables]);
  const m = (f, C) => {
    const v = C.map((b) => typeof b == "object" ? b.name : b).reduce((b, E) => (b[E] = !0, b), {});
    r("includedTables", v);
  }, j = (f) => {
    f.preventDefault(), l ? r("includedTables", []) : r(
      "includedTables",
      ps.reduce((C, v) => (C[v.name] = !0, C), {})
    );
  }, h = Jt(({ children: f, ...C }) => /* @__PURE__ */ t.jsx(
    Hn,
    {
      ...C,
      sx: {
        ".MuiAutocomplete-listbox": {
          p: 0,
          pb: 1,
          li: {
            pointerEvents: a ? "none" : "all"
          }
        },
        position: "relative"
      },
      children: f
    }
  ), []);
  return /* @__PURE__ */ t.jsx(
    Vt,
    {
      disableCloseOnSelect: !0,
      id: "includedTables",
      name: "includedTables",
      onChange: m,
      options: [{ name: "Select all", group: "selectAll" }, ...ps],
      value: Object.keys(i.includedTables) || [],
      multiple: !0,
      getOptionLabel: function(f) {
        return f.name || f;
      },
      PaperComponent: h,
      groupBy: (f) => f.group,
      OptionComponent: (f, C, { selected: v }) => /* @__PURE__ */ t.jsxs(le, { ...f, sx: { fontSize: "13px", height: "28px" }, children: [
        /* @__PURE__ */ t.jsx(
          At,
          {
            sx: { mr: "8px" },
            checked: C.group === "selectAll" ? l : v,
            size: "small"
          }
        ),
        C.name
      ] }),
      isOptionEqualToValue: (f, C) => f.name === C,
      disableClearable: a,
      renderTags: (f, C) => /* @__PURE__ */ t.jsxs(
        le,
        {
          sx: {
            px: 1,
            fontSize: 14,
            color: "textColor.label"
          },
          children: [
            f != null && f.length ? (f == null ? void 0 : f.length) === s ? "All tables" : f == null ? void 0 : f.length : "None",
            " ",
            "selected..."
          ]
        },
        "tag-props"
      ),
      renderGroup: (f) => /* @__PURE__ */ t.jsx("li", { children: f.group === "selectAll" ? /* @__PURE__ */ t.jsxs(
        _C,
        {
          onMouseDown: (C) => C.preventDefault(),
          onClick: j,
          disabled: a,
          children: [
            /* @__PURE__ */ t.jsx(
              At,
              {
                sx: { marginRight: "8px" },
                checked: l,
                size: "small"
              }
            ),
            "Select All"
          ]
        }
      ) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(wC, { color: $u[f.group], children: f.group }),
        /* @__PURE__ */ t.jsx(TC, { color: $u[f.group], children: f.children })
      ] }) }, f.key),
      disabled: a
    }
  );
}, jS = (r) => {
  var d;
  const {
    subModules: i,
    parentId: a,
    design: s,
    id: l,
    typeContainer: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    (!h || h && ((d = s == null ? void 0 : s.cohorts) == null ? void 0 : d.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        viewMode: h,
        path: It(c, l, a),
        config: {
          buttonText: "Import cohorts",
          titleText: "Target cohorts",
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: s == null ? void 0 : s.cohorts,
          onChange: (f) => {
            m("cohorts", f);
          },
          parentId: a,
          returnEntityText: j,
          viewMode: h,
          isSelect: !0
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ t.jsx(Re, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsx(g, { container: !0, children: /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
      /* @__PURE__ */ t.jsx(
        Ke,
        {
          textLabel: "OMOP CDM tables",
          description: "All tables are selected by default",
          labelSize: 4,
          htmlFor: "includedTables",
          required: !0,
          children: /* @__PURE__ */ t.jsx(
            EC,
            {
              design: s,
              updateDesign: m,
              disabled: h
            }
          )
        }
      ),
      /* @__PURE__ */ t.jsx(
        Ke,
        {
          htmlFor: "cohortOption",
          textLabel: "Data to export",
          description: "",
          labelSize: 4,
          required: !0,
          children: /* @__PURE__ */ t.jsxs(g, { container: !0, fontSize: 13, color: "textColor.main", children: [
            /* @__PURE__ */ t.jsxs(le, { mr: 3, component: "label", children: [
              /* @__PURE__ */ t.jsx(
                cu,
                {
                  checked: s.cohortOption === "COHORT_DATA",
                  value: "COHORT_DATA",
                  onChange: function(f) {
                    m("cohortOption", "COHORT_DATA");
                  },
                  size: "small",
                  sx: { mr: 0.5 },
                  disabled: h
                }
              ),
              "Cohort Data"
            ] }),
            /* @__PURE__ */ t.jsxs(le, { component: "label", children: [
              /* @__PURE__ */ t.jsx(
                cu,
                {
                  checked: s.cohortOption === "FULL_PATIENT_RECORD",
                  value: "FULL_PATIENT_RECORD",
                  onChange: function(f) {
                    m("cohortOption", "FULL_PATIENT_RECORD");
                  },
                  size: "small",
                  sx: { mr: 0.5 },
                  disabled: h
                }
              ),
              "Full patient record"
            ] })
          ] })
        }
      )
    ] }) }) }) })
  ] });
}, SS = $e((r) => /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, bgcolor: "backgroundColor.dark", children: [
  r.data.map((i, a) => /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, sx: { ".simple-counts-demographics": { p: 0 } }, children: /* @__PURE__ */ t.jsx(
    Re,
    {
      collapsible: !0,
      title: i.name,
      size: "dense",
      defaultState: !a,
      children: /* @__PURE__ */ t.jsx(
        pC,
        {
          analysisInfo: {
            ...r.analysisInfo,
            // fast workaround add cohort to design which is connected to exact results
            design: { ...r.analysisInfo.design, cohort: i }
          },
          data: i.result
        }
      )
    }
  ) })),
  " "
] })), wS = () => ({
  cohort: [],
  includedTables: [],
  cohortOption: []
}), TS = (r) => "", _S = (r, i) => ({
  ...i,
  type: r.type
}), ES = [
  {
    name: "Target cohorts",
    value: "cohorts"
  }
], AS = $e((r) => {
  var f, C;
  const {
    subModules: i,
    parentId: a,
    design: s,
    id: l,
    typeContainer: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r, d = (v) => (b) => {
    m(v, b);
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    (!h || h && ((f = s == null ? void 0 : s.cohorts) == null ? void 0 : f.length) > 0) && /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        path: It(c, l, a),
        config: {
          buttonText: "Import target cohort",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Target cohorts",
              count: (C = s == null ? void 0 : s.cohorts) == null ? void 0 : C.length
            }
          ),
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: s == null ? void 0 : s.cohorts,
          onChange: d("cohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: j,
          collapsible: !0,
          defaultState: !0,
          viewMode: h
        }
      }
    ) }) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mt: 1.5, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        title: "Characterization settings",
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "useAgeGroups",
              textLabel: "Age Group",
              description: "Calculate age groups covariates prevalence statistics with 5 year interval.",
              labelSize: 3,
              children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "useAgeGroups",
                  name: "useAgeGroups",
                  onChange: () => {
                    m("useAgeGroups", !s.useAgeGroups);
                  },
                  checked: s.useAgeGroups,
                  disabled: h,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "useEthnicity",
              textLabel: "Ethnic Groups",
              description: "Calculate ethnicity covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "useEthnicity",
                  name: "useEthnicity",
                  onChange: () => {
                    m("useEthnicity", !s.useEthnicity);
                  },
                  checked: s.useEthnicity,
                  disabled: h,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "useGender",
              textLabel: "Gender",
              description: "Calculate gender covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "useGender",
                  name: "useGender",
                  onChange: () => {
                    m("useGender", !s.useGender);
                  },
                  checked: s.useGender,
                  disabled: h,
                  size: "small"
                }
              )
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "useRace",
              textLabel: "Race",
              description: "Calculate race covariates prevalence statistics.",
              labelSize: 3,
              children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "useRace",
                  name: "useRace",
                  onChange: () => {
                    m("useRace", !s.useRace);
                  },
                  checked: s.useRace,
                  disabled: h,
                  size: "small"
                }
              )
            }
          ) })
        ] })
      }
    ) })
  ] });
}), OS = [
  {
    name: "Target cohort",
    value: "cohorts"
  }
], AC = (r) => [
  {
    value: "summary",
    title: "Summary",
    onTabClick: r
  },
  {
    value: "byPerson",
    title: "By person",
    onTabClick: r
  },
  {
    value: "byEvent",
    title: "By event",
    onTabClick: r
  },
  {
    title: "Demographics",
    value: "demographics",
    onTabClick: r
  }
];
Le.div`
  width: 100%;
  height: 15px;
  background-color: #7bb209;
`;
Le.div`
  width: ${(r) => r.width};
  background-color: ${(r) => r.color};
  height: 15px !important;
  text-align: center;
  margin: 0 auto;
`;
const OC = Le.div`
  text-align: center;
  font-size: 16px;
  padding: 16px 0;
  color: ${({ theme: r }) => {
  var i;
  return (i = r.palette) == null ? void 0 : i.grey[400];
}};
  width: 100%;
`, RC = Le.table`
  border-collapse: collapse;
  width: 100%;
  border: 1px solid ${({ theme: r }) => r.palette.borderColor.main};
  font-size: 12px;
  tr:nth-of-type(2) td {
    border-top-color: ${({ theme: r }) => r.palette.borderColor.main + 80};
  }
  tr.active {
    background-color: ${({ theme: r }) => r.palette.info.main + "10"};
  }
  font-size: 12px;
  h1 {
    display: none;
  }

  section,
  ul {
    margin: 8px 0;
  }
`, nr = Le("th", {
  shouldForwardProp: (r) => r !== "align"
})(({ align: r, theme: i }) => ({
  border: "1px solid" + i.palette.borderColor.main + 80,
  backgroundColor: i.palette.backgroundColor.dark,
  textAlign: r || "left",
  padding: "4px 8px",
  fontSize: 13
})), yr = Le("td", {
  shouldForwardProp: (r) => r !== "align" && r !== "noData" && r !== "fontSize" && r !== "color" && r !== "percent"
})(({ align: r, theme: i, noData: a, fontSize: s, bold: l, percent: c, color: m }) => {
  var j;
  return {
    border: "1px solid" + i.palette.borderColor.main + 80,
    textAlign: r || "left",
    fontSize: s || 12,
    padding: "4px 8px",
    fontWeight: l ? "bold" : 400,
    position: "relative",
    span: {
      display: "none"
    },
    "::before": {
      content: '""',
      width: c,
      height: "100%",
      backgroundColor: m,
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0.9
    },
    "::after": {
      content: c ? `"${c}"` : '""',
      display: "inline",
      position: "relative"
      // left: '-50%',
    },
    ...a ? {
      "&::after": {
        content: '"N/A"',
        display: "inline",
        color: (j = i.palette) == null ? void 0 : j.grey[400],
        position: "relative"
      }
    } : {}
  };
}), RS = (r) => {
  var a, s;
  let i = ((a = r == null ? void 0 : r.cohorts) == null ? void 0 : a.length) == 1 ? "Cohort" : "Cohorts";
  return `${te(((s = r == null ? void 0 : r.cohorts) == null ? void 0 : s.length) || 0)} ${i}`;
}, PC = hd().domain([0.1, 0.25, 0.5, 0.75]).range(["#FF3D19", "#E77F13", "#C9C40D", "#95B90A", "#7BB209"]), PS = (r, i) => ({
  title: i.title,
  description: i.description,
  type: r.type,
  cohorts: i.cohorts,
  characterizedExpression: i.characterizedExpression
}), DS = () => ({
  cohorts: []
});
function DC(r) {
  return Object.keys(r).reduce((i, a) => (["ethnicity", "gender", "race", "ageGroup"].includes(a) && (i[a] = Object.values(
    r[a].reduce((s, l) => (s[l.covariateId] || (s[l.covariateId] = {
      name: l.name,
      conceptId: l.conceptId,
      covariateId: l.covariateId,
      records: []
    }), s[l.covariateId].records.push(l), s), {})
  )), i), {});
}
function NC(r, i) {
  let a = r.cloneNode(!0);
  return a.querySelectorAll(i).forEach((s) => s.remove()), a;
}
function qd(r, i) {
  var a;
  return r.style && (r.style.fontSize = i + "px", r.style.fontWeight = "300"), (a = r.childNodes) != null && a.length && r.childNodes.forEach((s) => qd(s, i)), r;
}
function IC(r, i) {
  if (i.preventDefault(), r) {
    let a = qd(NC(r, ".no-copy"), 12);
    const s = new Blob([a.outerHTML], { type: "text/html" }), l = new ClipboardItem({ "text/html": s });
    navigator.clipboard.write([l]).then(
      function() {
        console.log("Async: Copying to clipboard was successful!");
      },
      function(c) {
        console.error("Async: Could not copy text: ", c);
      }
    );
  }
}
const LC = ({
  subModules: r,
  cohort: i
}) => {
  const a = wa(null), [s, l] = be(!1), c = wa(0), m = wa(s);
  kt(() => {
    if (s && !m.current) {
      const h = ls("dialog") + 1;
      c.current = h, cy("dialog", h);
    }
    m.current = s;
  }, [s]), kt(() => {
    const h = (d) => {
      s && ls("dialog", d.state) < c.current && l(!1);
    };
    return window.addEventListener("popstate", h), () => {
      window.removeEventListener("popstate", h);
    };
  }, [s]);
  const j = Jt(() => {
    s && (l(!1), m.current = !1, ls("dialog") >= c.current && window.history.back());
  }, [s]);
  return Pe(
    () => /* @__PURE__ */ t.jsx(
      r.cohort,
      {
        type: "component",
        name: "cohort-view-mode",
        subModules: r,
        config: {
          initialData: i
        }
      }
    ),
    [i]
  ), /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      le,
      {
        sx: {
          lineHeight: "1.4em",
          maxHeight: "19.6em",
          overflow: "hidden",
          position: "relative",
          "*": {
            margin: 0
          }
        },
        children: /* @__PURE__ */ t.jsx(su, { children: i.printFriendlyExpression })
      }
    ),
    /* @__PURE__ */ t.jsx(
      le,
      {
        sx: {
          "::before ": {
            content: '""',
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0,
            background: "linear-gradient(transparent 0, white 96%)"
          }
        }
      }
    ),
    /* @__PURE__ */ t.jsx(le, { textAlign: "right", sx: { position: "absolute", right: 0, bottom: 0 }, children: /* @__PURE__ */ t.jsx(
      ct,
      {
        size: "small",
        onClick: () => l(!0),
        className: "no-copy",
        sx: {
          fontSize: 12,
          color: "textColor.secondary"
        },
        children: "Show more..."
      }
    ) }),
    /* @__PURE__ */ t.jsxs(D0, { open: s, onClose: j, fullWidth: !0, maxWidth: "lg", children: [
      /* @__PURE__ */ t.jsxs(g, { container: !0, justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ t.jsx(N0, { children: /* @__PURE__ */ t.jsx(ve, { variant: "h1", children: i.name }) }),
        /* @__PURE__ */ t.jsx(I0, { size: "small", sx: { mx: 2 }, onClick: j, children: /* @__PURE__ */ t.jsx(bt, { iconName: "close" }) })
      ] }),
      /* @__PURE__ */ t.jsx(zt, {}),
      /* @__PURE__ */ t.jsx(L0, { sx: { h1: { display: "none" } }, children: /* @__PURE__ */ t.jsx(ve, { ref: a, children: /* @__PURE__ */ t.jsx(su, { children: i.printFriendlyExpression }) }) })
    ] })
  ] });
}, FC = ({ cohorts: r, resultsCount: i, subModules: a }) => {
  const [s, l] = be(-1), c = wa(null), m = (j) => ({
    className: j === s ? "active" : "",
    onMouseOver: () => {
      l(j);
    },
    onMouseLeave: () => {
      l(-1);
    }
  });
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(le, { textAlign: "right", mb: 0.5, children: /* @__PURE__ */ t.jsx(
      ct,
      {
        onClick: (j) => IC(c == null ? void 0 : c.current, j),
        startIcon: /* @__PURE__ */ t.jsx(bt, { iconName: "copy", fontSize: "small" }),
        children: "Copy table"
      }
    ) }),
    /* @__PURE__ */ t.jsxs(RC, { ref: c, children: [
      /* @__PURE__ */ t.jsxs("colgroup", { children: [
        /* @__PURE__ */ t.jsx("col", { width: "20%" }),
        /* @__PURE__ */ t.jsx("col", { width: "40%" }),
        /* @__PURE__ */ t.jsx("col", { width: "12%" }),
        /* @__PURE__ */ t.jsx("col", { width: "7%" }),
        /* @__PURE__ */ t.jsx("col", { width: "7%" }),
        /* @__PURE__ */ t.jsx("col", { width: "7%" }),
        /* @__PURE__ */ t.jsx("col", { width: "7%" })
      ] }),
      /* @__PURE__ */ t.jsxs("thead", { children: [
        /* @__PURE__ */ t.jsxs("tr", { children: [
          /* @__PURE__ */ t.jsx(nr, { rowSpan: 2, children: "Cohort name" }),
          /* @__PURE__ */ t.jsx(nr, { rowSpan: 2, children: "Cohort definition" }),
          /* @__PURE__ */ t.jsx(nr, { rowSpan: 2, children: "Attrition Criteria" }),
          /* @__PURE__ */ t.jsx(nr, { rowSpan: 1, colSpan: 4, align: "center", children: "Counts / %" })
        ] }),
        /* @__PURE__ */ t.jsxs("tr", { children: [
          /* @__PURE__ */ t.jsx(nr, { children: "N" }),
          /* @__PURE__ */ t.jsx(nr, { children: "% satisfied" }),
          /* @__PURE__ */ t.jsx(nr, { children: "% to-gain" }),
          /* @__PURE__ */ t.jsx(nr, { children: "Total Count" })
        ] })
      ] }),
      /* @__PURE__ */ t.jsx("tbody", { children: r.map((j, h) => {
        var v;
        const d = (v = i.inclusionRuleReports[j.id]) == null ? void 0 : v.find((b) => b.type === "byPerson"), f = d == null ? void 0 : d.inclusionRuleStats, C = f == null ? void 0 : f.length;
        return (f || [{}]).map((b, E) => {
          var R;
          const A = i.cohortCounts.find(
            (D) => D.cohortId === j.id
          );
          return /* @__PURE__ */ t.jsxs("tr", { ...m(h), children: [
            E === 0 && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsx(yr, { rowSpan: C || 1, fontSize: 13, bold: !0, children: j.name }),
              /* @__PURE__ */ t.jsx(yr, { rowSpan: C, children: /* @__PURE__ */ t.jsx(
                LC,
                {
                  subModules: a,
                  cohort: j
                }
              ) })
            ] }),
            /* @__PURE__ */ t.jsx(yr, { noData: !C, children: b.name }),
            /* @__PURE__ */ t.jsx(yr, { noData: !C, children: te(b.countSatisfying) }),
            /* @__PURE__ */ t.jsx(
              yr,
              {
                noData: !C,
                percent: b.percentSatisfying,
                color: PC(
                  parseFloat(
                    ((R = b.percentSatisfying) == null ? void 0 : R.replace("%", "")) || 0
                  ) / 100
                ),
                children: /* @__PURE__ */ t.jsx("span", { children: b.percentSatisfying })
              }
            ),
            /* @__PURE__ */ t.jsx(yr, { noData: !C, children: b.percentExcluded }),
            E === 0 && /* @__PURE__ */ t.jsx(yr, { rowSpan: C, children: A.personCount ? te(A.personCount) : 0 })
          ] }, E);
        });
      }) })
    ] })
  ] });
}, NS = $e(
  (r) => {
    const { data: i, analysisInfo: a, subModules: s } = r, [l, c] = be("summary"), [m, j] = be(i.cohorts || []), h = Pe(
      () => DC(i),
      [i]
    );
    return /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, px: 2, pt: 2, pb: 1, children: /* @__PURE__ */ t.jsx(
        Vt,
        {
          name: "covariate",
          value: m,
          options: i.cohorts,
          multiple: !0,
          onChange: function(d, f) {
            j(f);
          },
          getOptionLabel: function(d) {
            return d.name;
          },
          isOptionEqualToValue: (d, f) => d.id === f.id,
          fullWidth: !0
        }
      ) }),
      /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
        /* @__PURE__ */ t.jsx(Ba, { tabs: AC(c), active: l }),
        /* @__PURE__ */ t.jsx(zt, {})
      ] }),
      m.length ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        l === "summary" && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsx(
          FC,
          {
            cohorts: m,
            resultsCount: i,
            subModules: s
          }
        ) }),
        (l === "byPerson" || l === "byEvent") && /* @__PURE__ */ t.jsx(g, { container: !0, spacing: 2, p: 2, children: m.map((d, f) => {
          var D, _;
          const C = (D = i == null ? void 0 : i.inclusionRuleReports) == null ? void 0 : D[d.id], v = !Pa(C) || !i.inclusionRuleReports || !(Object.keys(
            i.inclusionRuleReports[d.id] || {}
          ).length > 0), b = C, E = (_ = i.cohortCounts) == null ? void 0 : _.find(
            (F) => F.cohortId === d.id
          ), A = l === "byEvent" ? (E == null ? void 0 : E.recordCount) ?? (E == null ? void 0 : E.personCount) : (E == null ? void 0 : E.personCount) ?? (E == null ? void 0 : E.recordCount), R = A != null ? `${te(A)} ${l === "byEvent" ? "Records" : "Persons"}` : "N/A";
          return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Re,
            {
              collapsible: !0,
              outlined: !0,
              title: d.name,
              defaultState: f === 0,
              size: "dense",
              children: /* @__PURE__ */ t.jsx(
                Kd,
                {
                  legacy: v,
                  resultsCount: b,
                  activeTab: l,
                  analysisInfo: a,
                  count: R
                }
              )
            }
          ) });
        }) }),
        l === "demographics" && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
          Gd,
          {
            analysis: a,
            result: h,
            cohorts: m
          }
        ) })
      ] }) : /* @__PURE__ */ t.jsx(OC, { children: "Select a cohort" })
    ] });
  }
), IS = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  },
  {
    name: "Event cohorts",
    value: "eventCohorts"
  }
];
function Yd(r, i, a) {
  return (s) => {
    var l;
    return `${r}__${i}__${((l = a.split("=")) == null ? void 0 : l[1]) || a}__${s}`;
  };
}
function MC(r) {
  const i = r.toString(), a = i.indexOf(".");
  return a === -1 ? 0 : i.length - a - 1;
}
function kC(r, i, a = 6) {
  if (!i)
    return {
      domain: [0, 1],
      ticks: [0, 0.25, 0.5, 0.75, 1],
      step: 0.25,
      decimalPlaces: 2
    };
  const s = r.flatMap((R) => Object.entries(R).filter(([_]) => _.includes("__area")).map(([_, F]) => F).flat()), l = Math.min(...s), c = Math.max(...s), j = (c - l) / (a - 1), h = [
    1e-5,
    2e-5,
    5e-5,
    1e-4,
    2e-4,
    5e-4,
    1e-3,
    2e-3,
    5e-3,
    0.01,
    0.02,
    0.025,
    0.05,
    0.1,
    0.15,
    0.2,
    0.25
  ];
  let d = j;
  for (const R of h)
    if (R >= j) {
      d = R;
      break;
    }
  j > h[h.length - 1] && (d = h[h.length - 1]);
  const f = MC(d), C = Math.pow(10, f), v = Math.floor(l * C / d) * d / C, b = [];
  let E = v;
  for (; E <= c + d; ) {
    const R = E * C / C;
    R <= 1 && b.push(R), E += d;
  }
  b[b.length - 1] !== 1 && c > 0.99 && b.push(1);
  const A = [...new Set(b)].sort((R, D) => R - D);
  return A.length < 3 ? {
    domain: [0, 1],
    ticks: [0, 0.25, 0.5, 0.75, 1],
    step: 0.25
  } : {
    domain: [Math.max(0, v - d * 0.5), 1],
    // Add small padding below
    ticks: A,
    step: d,
    decimalPlaces: f
  };
}
function zC(r, i, a) {
  const s = /* @__PURE__ */ new Set();
  let l = {};
  const c = /* @__PURE__ */ new Set(), m = r.reduce((j, h) => {
    var f, C;
    const d = ((f = a.survivalData[h.id]) == null ? void 0 : f[i.id]) || {};
    return (C = d.overall || []) == null || C.forEach((v) => {
      c.add(v.time), l[h.id] = l[h.id] || {}, l[h.id][v.time] = v.nrisk, l[h.id].targetCohort = h;
    }), Object.entries(d).forEach(([v, b]) => {
      s.add(v), b.forEach((E) => {
        j[E.time] = j[E.time] || {}, j[E.time] = Object.keys(E).reduce((A, R) => {
          if (R !== "time") {
            const D = Yd(h.id, i.id, v);
            R === "lower" || R === "upper" ? A[D("area")] = A[D("area")] ? [...A[D("area")], E[R]] : [E[R]] : A[D(R)] = E[R];
          }
          return A.time = E.time, A;
        }, j[E.time]);
      });
    }, {}), j;
  }, {});
  return {
    data: Object.values(m),
    stratas: Array.from(s),
    nRisk: Object.values(l),
    timeScale: Array.from(c).sort((j, h) => j - h)
  };
}
const ui = [
  "#FF0000",
  "#00A08A",
  "#F2AD00",
  "#F98400",
  "#5BBCD6",
  "#ECCBAE",
  "#046C9A",
  "#D69C4E",
  "#ABDDDE",
  "#000000"
], sr = (r, i) => i ? "lightgrey" : r >= ui.length ? Ma(`0.${r / (1 * ui.length)}`, ui[r % ui.length]) : ui[r];
function BC(r) {
  const i = Math.min(...r), a = Math.max(...r);
  return $C(i, a);
}
function $C(r, i, a = 10) {
  const s = i - r;
  if (s === 0)
    return [r];
  let l;
  s <= 12 ? l = 1 : s <= 21 ? l = 2 : s <= 35 ? l = 3 : s <= 56 ? l = 5 : s <= 80 ? l = 7 : s <= 105 ? l = 10 : s <= 180 ? l = 15 : s <= 315 ? l = 30 : s <= 480 ? l = 45 : s <= 630 ? l = 60 : s <= 960 ? l = 90 : s <= 1260 ? l = 120 : s <= 2e3 ? l = 180 : s <= 2700 ? l = 250 : s <= 3285 || s <= 3850 ? l = 300 : s <= 5840 ? l = 550 : s <= 8e3 ? l = 730 : s <= 10950 ? l = 1e3 : s <= 16e3 ? l = 1500 : (s <= 21e3, l = 3e3);
  const c = [];
  let m = Math.floor(r / l) * l;
  for (m < r - l * 0.5 && (m = r); m <= i; )
    m >= r && c.push(m), m += l;
  c[0] !== r && Math.abs(c[0] - r) > l * 0.1 && c.unshift(r), c[c.length - 1] !== i && Math.abs(c[c.length - 1] - i) > l * 0.1 && c.push(i);
  const j = [...new Set(c)].sort((h, d) => h - d);
  if (j.length > a * 1.5) {
    const h = Math.ceil(j.length / a);
    return j.filter(
      (f, C) => C % h === 0 || C === j.length - 1
    );
  }
  return j;
}
const Wu = [
  {
    name: "cohort start date",
    value: "cohort_start_date"
  },
  {
    name: "cohort end date",
    value: "cohort_end_date"
  }
], Hu = [
  "Infinity",
  1,
  2,
  3,
  4,
  5,
  10,
  15,
  20,
  30,
  50,
  60,
  90,
  180
].map((r) => ({
  name: String(r),
  value: r === "Infinity" ? null : r
})), WC = [
  {
    header: "Target Cohort",
    accessorKey: "targetCohort.name",
    size: 250
  },
  {
    header: "Number records",
    accessorKey: "n",
    size: 200,
    cell: ({ getValue: r }) => r() != null ? te(r()) : "-"
  },
  {
    header: "Number events",
    accessorKey: "events",
    size: 200,
    cell: ({ getValue: r }) => r() != null ? te(r()) : "-"
  },
  {
    header: "Median survival (95% CI)",
    accessorKey: "medianSurvival",
    size: 200,
    cell: ({ getValue: r, row: i }) => r() != null ? `${te(r())} [${i.original.medianSurvivalLowerCI || "-"}, ${i.original.medianSurvivalUpperCI || "-"}]` : "-"
  },
  {
    header: "Restricted mean survival (SE)",
    accessorKey: "meanSurvival",
    size: 200,
    cell: ({ getValue: r }) => r() != null ? te(r()) : "-"
  }
], ja = [
  { name: "Gender", value: "gender" },
  { name: "Age group", value: "age_group" }
];
function HC(r) {
  var a;
  const i = {};
  return r.forEach((s) => {
    const [l, c] = s.split("=");
    i[l] ? i[l].push(c) : i[l] = [c];
  }), (a = i.age_group) == null || a.sort((s, l) => s.localeCompare(l)), i;
}
function VC(r) {
  let i = JSON.parse(JSON.stringify(r));
  return r.eventCohorts.forEach((a) => {
    r.targetCohorts.forEach((s) => {
      var l, c;
      (c = (l = r.survivalData) == null ? void 0 : l[s.id]) != null && c[a.id] && (i.survivalData[s.id][a.id] = Object.entries(
        r.survivalData[s.id][a.id]
      ).reduce((m, [j, h]) => {
        m[j] = [h[0]];
        let d = h[0], f = null, C = 1;
        for (; C < h.length; )
          f = h[C], f.time - d.time === 1 ? C++ : f.time - d.time > 1 && (f = { ...d, time: d.time + 1 }), m[j].push(f), d = f;
        return m;
      }, {}));
    });
  }), i;
}
const LS = $e((r) => {
  var b, E, A, R, D;
  const {
    subModules: i,
    parentId: a,
    design: s,
    id: l,
    typeContainer: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r, d = (_) => (F) => {
    m(_, F);
  }, [f, C] = be(
    () => {
      var _;
      return ((_ = s.ageBreaks) == null ? void 0 : _.map((F) => ({
        ...F,
        id: F.id ? F.id : ss()
      }))) || [];
    }
  ), v = (b = s.strata) == null ? void 0 : b.some(
    (_) => _ === "age_group" || (_ == null ? void 0 : _.value) === "age_group"
  );
  return /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
    (!h || h && ((E = s == null ? void 0 : s.targetCohorts) == null ? void 0 : E.length) > 0) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(wi, { children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx("b", { children: "Time to Event analysis" }),
        " - leverages standardized clinical data to perform time-to-event calculations, providing robust estimates of survival probabilities. It generates visually compelling Kaplan–Meier curves, delivers clear milestone summaries, and enables insightful subgroup comparisons—all while accurately accounting for censoring to ensure reliable results."
      ] }) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        i.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: i,
          path: It(c, l, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ t.jsx(
              Ot,
              {
                title: "Target cohorts",
                count: (A = s == null ? void 0 : s.targetCohorts) == null ? void 0 : A.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: s == null ? void 0 : s.targetCohorts,
            onChange: d("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: j,
            collapsible: !0,
            defaultState: !0,
            viewMode: h
          }
        }
      ) })
    ] }),
    (!h || h && ((R = s == null ? void 0 : s.eventCohorts) == null ? void 0 : R.length) > 0) && /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.cohort,
      {
        type: "component",
        name: "widget-cohort-import-button",
        subModules: i,
        path: It(c, l, a),
        config: {
          buttonText: "Import outcome cohort",
          titleText: /* @__PURE__ */ t.jsx(
            Ot,
            {
              title: "Outcome cohorts",
              count: (D = s == null ? void 0 : s.eventCohorts) == null ? void 0 : D.length
            }
          ),
          classNameContainer: "event-import-button",
          typeContainer: c,
          initialData: s == null ? void 0 : s.eventCohorts,
          onChange: d("eventCohorts"),
          isSelect: !0,
          parentId: a,
          returnEntityText: j,
          collapsible: !0,
          defaultState: h,
          viewMode: h
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        collapsible: !0,
        title: "Analysis Settings",
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, px: 1, children: [
            /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the analysis." }),
            /* @__PURE__ */ t.jsx(zt, { sx: { borderColor: "borderColor.light" } })
          ] }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "outcomeDateVariable",
              textLabel: "Outcome date variable",
              description: "Variable containing date of outcome event.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 270, children: /* @__PURE__ */ t.jsx(
                Vt,
                {
                  className: "",
                  name: "outcomeDateVariable",
                  id: "outcomeDateVariable",
                  options: Wu,
                  value: s.outcomeDateVariable,
                  placeholder: "Select days...",
                  onChange: (_, F) => {
                    m(
                      "outcomeDateVariable",
                      F.value
                    );
                  },
                  disabled: h,
                  getOptionLabel: function(_) {
                    var F;
                    return (F = Wu.find(
                      (P) => P.value === _ || P.value === _.value
                    )) == null ? void 0 : F.name;
                  },
                  isOptionEqualToValue: (_, F) => _.value === F
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "outcomeWashout",
              textLabel: "Outcome washout",
              description: "Washout time in days for the outcome.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  name: "outcomeWashout",
                  disablePortal: !0,
                  id: "outcomeWashout",
                  options: Hu,
                  value: s.outcomeWashout || "",
                  placeholder: "Select days...",
                  onChange: (_) => {
                    m("outcomeWashout", _);
                  },
                  disabled: h,
                  dontResetOnEnter: !0
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "censorOnCohortExit",
              textLabel: "Censor on cohort exit",
              description: "If enabled, an individual’s follow up will be censored at their cohort exit.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "censorOnCohortExit",
                  name: "censorOnCohortExit",
                  onChange: () => {
                    m(
                      "censorOnCohortExit",
                      !s.censorOnCohortExit
                    );
                  },
                  checked: s.censorOnCohortExit,
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "addDay",
              textLabel: "Same day event 1 day adjustment",
              description: "Adjust outcome event start date for events that happen on the same day as patient cohort entry date.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "addDay",
                  name: "addDay",
                  onChange: () => {
                    m("addDay", !s.addDay);
                  },
                  checked: s.addDay,
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "censorOnDate",
              textLabel: "Censor on date",
              description: "If provided, an individual’s follow up will be censored at the given date.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                jr,
                {
                  id: "censorOnDate",
                  name: "censorOnDate",
                  value: s.censorOnDate,
                  onChange: function(_) {
                    m("censorOnDate", _);
                  }
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "restrictedMeanFollowup",
              textLabel: "Restricted mean follow-up",
              description: "Number of days of follow-up to take into account when calculating restricted (mean for all cohorts).",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  name: "restrictedMeanFollowup",
                  disablePortal: !0,
                  id: "restrictedMeanFollowup",
                  options: Hu,
                  value: s.restrictedMeanFollowup || "",
                  placeholder: "Select days...",
                  onChange: (_) => {
                    m(
                      "restrictedMeanFollowup",
                      _
                    );
                  },
                  disabled: h,
                  dontResetOnEnter: !0,
                  disableClearable: !1
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "minDaysToEvent",
              textLabel: "Minimum days to event",
              description: "Minimum number of days person should be in cohort before the event (Exclude person if his time to event is less than this value).",
              children: /* @__PURE__ */ t.jsx(le, { width: 150, children: /* @__PURE__ */ t.jsx(
                On,
                {
                  name: "minDaysToEvent",
                  disablePortal: !0,
                  id: "minDaysToEvent",
                  options: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    10,
                    15,
                    20,
                    30,
                    50,
                    60,
                    90,
                    180
                  ].map((_) => ({
                    name: String(_),
                    value: _
                  })),
                  value: s.minDaysToEvent,
                  placeholder: "Select days...",
                  onChange: (_) => {
                    m("minDaysToEvent", _);
                  },
                  disabled: h,
                  dontResetOnEnter: !0,
                  disableClearable: !1
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "strata",
              textLabel: "Stratification criteria",
              children: /* @__PURE__ */ t.jsx(le, { width: 270, children: /* @__PURE__ */ t.jsx(
                Vt,
                {
                  name: "strata",
                  multiple: !0,
                  id: "strata",
                  options: ja,
                  value: s.strata,
                  placeholder: "Select...",
                  onChange: (_, F) => {
                    m(
                      "strata",
                      F.map(
                        (P) => typeof P == "object" ? P.value : P
                      )
                    );
                  },
                  disabled: h,
                  disableClearable: !1,
                  getOptionLabel: function(_) {
                    var F;
                    return ((F = ja == null ? void 0 : ja.find((P) => P.value === _)) == null ? void 0 : F.name) ?? (_ == null ? void 0 : _.name) ?? _;
                  },
                  isOptionEqualToValue: (_, F) => _.value === F || _.value === (F == null ? void 0 : F.value)
                }
              ) })
            }
          ) }),
          v && /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
            /* @__PURE__ */ t.jsx(zt, { sx: { mb: 1 } }),
            /* @__PURE__ */ t.jsxs(le, { fontSize: 12, children: [
              /* @__PURE__ */ t.jsx(
                Ke,
                {
                  htmlFor: "ageBreaks",
                  textLabel: "Age breaks",
                  children: /* @__PURE__ */ t.jsx(le, { textAlign: "right", children: /* @__PURE__ */ t.jsx(
                    F0,
                    {
                      title: "Add Age Break",
                      onClick: () => {
                        C((_) => {
                          const F = _ ? [..._, { Op: "gt", id: ss() }] : [{ Op: "gt", id: ss() }];
                          return m("ageBreaks", F), F;
                        });
                      },
                      color: "info",
                      iconName: "add",
                      disabled: h,
                      name: "age-break-button",
                      noCollapse: !0
                    }
                  ) })
                }
              ),
              f == null ? void 0 : f.map((_, F) => /* @__PURE__ */ t.jsxs(
                g,
                {
                  container: !0,
                  mb: 1,
                  alignItems: "center",
                  children: [
                    /* @__PURE__ */ t.jsx(g, { item: !0, px: 1, children: /* @__PURE__ */ t.jsx(
                      i.cohort,
                      {
                        type: "component",
                        name: "widget-attribute-value",
                        subModules: i,
                        config: {
                          id: F + _.id,
                          value: _,
                          typeContainer: c,
                          startText: "with age in years",
                          onChange: (P, x) => {
                            C((p) => {
                              const y = [...p];
                              return y[F] = {
                                id: _.id,
                                ...x
                              }, m("ageBreaks", y), y;
                            });
                          },
                          values: _,
                          viewMode: h
                        }
                      }
                    ) }),
                    /* @__PURE__ */ t.jsx(g, { item: !0, px: 1, children: /* @__PURE__ */ t.jsx(
                      V0,
                      {
                        iconName: "delete",
                        title: "Delete",
                        noExpand: !0,
                        onClick: () => {
                          C((P) => {
                            const x = P.filter(
                              (p, y) => y !== F
                            );
                            return m("ageBreaks", x), x;
                          });
                        },
                        size: "small",
                        color: "error"
                      }
                    ) })
                  ]
                },
                _.id
              ))
            ] })
          ] })
        ] })
      }
    ) })
  ] });
}), Xd = ({
  data: r,
  targetCohorts: i,
  eventCohort: a,
  stratas: s,
  autoScale: l,
  height: c = 400,
  ticks: m,
  summaries: j = {},
  formatTicks: h,
  showStrata: d = !1,
  dataConfig: f = {}
}) => {
  const C = Vn(i, "id"), v = Pe(
    () => kC(r, l),
    [l, r]
  ), b = r.length === 0, E = Vn(
    j,
    (A) => `${A.targetCohortId}-${A.outcomeCohortId}`
  );
  return /* @__PURE__ */ t.jsx(g, { container: !0, sx: { position: "relative", height: c, zIndex: 2 }, children: /* @__PURE__ */ t.jsx(Un, { height: c, children: /* @__PURE__ */ t.jsxs(
    ay,
    {
      style: {
        fontSize: "12px"
      },
      data: r,
      margin: {
        top: 20,
        right: 0,
        bottom: 20,
        left: 10
      },
      children: [
        /* @__PURE__ */ t.jsx(_i, { stroke: "#e3e3e3ff", strokeDasharray: "3 3" }),
        /* @__PURE__ */ t.jsx(
          Ei,
          {
            dataKey: "time",
            name: "months",
            type: "number",
            domain: [0, Math.max(...r.map((A) => A.time))],
            ticks: m,
            allowDataOverflow: !1,
            ...m ? { ticks: m } : { tickCount: 10 },
            tickFormatter: h,
            label: {
              value: "Time",
              position: "insideBottom",
              offset: -10
            }
          }
        ),
        /* @__PURE__ */ t.jsx(
          Ai,
          {
            name: "probability",
            type: "number",
            domain: v.domain,
            ticks: v.ticks,
            tickFormatter: (A) => A.toFixed(
              v.decimalPlaces ? v.decimalPlaces > 4 ? 4 : v.decimalPlaces : 2
            ),
            label: {
              value: "Probability",
              angle: -90,
              position: "insideLeft",
              offset: -5
            }
          }
        ),
        /* @__PURE__ */ t.jsx(
          pu,
          {
            y: 0.5,
            label: {
              value: 0.5,
              position: "insideBottomLeft"
            },
            strokeDasharray: "3 3",
            stroke: "#000000"
          }
        ),
        i.map((A, R) => s.map((D, _) => {
          var w, M, V;
          const F = ((M = (w = f == null ? void 0 : f[A.id]) == null ? void 0 : w[D]) == null ? void 0 : M.color) ?? sr(R + _ * (s.length + _), b), P = Yd(
            A.id,
            a.id,
            D
          ), x = P("area"), p = P("survival"), y = (V = E[`${A.id}-${a.id}`]) == null ? void 0 : V.medianSurvival;
          return [
            /* @__PURE__ */ t.jsx(
              oy,
              {
                dataKey: x,
                strokeWidth: 0,
                fillOpacity: 0.2,
                type: "stepAfter",
                fill: F,
                stroke: F,
                connectNulls: !0,
                dot: !1
              },
              x
            ),
            /* @__PURE__ */ t.jsx(
              sy,
              {
                dataKey: p,
                type: "stepAfter",
                dot: !1,
                name: A.name,
                connectNulls: !0,
                stroke: F,
                fill: F
              },
              p
            ),
            y != null ? /* @__PURE__ */ t.jsx(
              pu,
              {
                x: y,
                label: {
                  value: y,
                  position: "insideBottomLeft"
                },
                strokeDasharray: "3 3",
                stroke: F
              },
              x + p
            ) : ""
          ];
        })),
        /* @__PURE__ */ t.jsx(
          wr,
          {
            content: ({ payload: A }) => {
              var D;
              let R = [];
              return A.forEach((_, F) => {
                var P, x, p;
                if (F % 2 !== 0) {
                  const y = _ == null ? void 0 : _.dataKey, [w, M, V, q] = (y == null ? void 0 : y.split("__")) || [], $ = (_ == null ? void 0 : _.color) || (_ == null ? void 0 : _.fill), I = `${w}__${M}__${V}__`, k = _ == null ? void 0 : _.payload[I + "area"];
                  w && R.push(
                    /* @__PURE__ */ t.jsxs(
                      le,
                      {
                        color: $,
                        p: 1,
                        bgcolor: "white",
                        boxShadow: 1,
                        children: [
                          /* @__PURE__ */ t.jsx("b", { children: "Target cohort" }),
                          " : ",
                          (P = C[w]) == null ? void 0 : P.name,
                          /* @__PURE__ */ t.jsx("br", {}),
                          /* @__PURE__ */ t.jsx("b", { children: "Probability" }),
                          " : ",
                          (p = (x = _ == null ? void 0 : _.payload) == null ? void 0 : x[y]) == null ? void 0 : p.toFixed(4),
                          " ",
                          "[",
                          k == null ? void 0 : k.map((G) => (G == null ? void 0 : G.toFixed(4)) || "N/A").join(", "),
                          "]",
                          d && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                            /* @__PURE__ */ t.jsx("br", {}),
                            /* @__PURE__ */ t.jsx("b", { children: "Strata" }),
                            " : ",
                            V
                          ] }),
                          /* @__PURE__ */ t.jsx("br", {})
                        ]
                      },
                      I
                    )
                  );
                }
              }), /* @__PURE__ */ t.jsxs(le, { children: [
                /* @__PURE__ */ t.jsxs(le, { p: 1, bgcolor: "white", boxShadow: 1, children: [
                  /* @__PURE__ */ t.jsx("b", { children: "Time" }),
                  " : ",
                  (D = A[0]) == null ? void 0 : D.payload.time
                ] }, "time"),
                R
              ] });
            }
          }
        )
      ]
    }
  ) }) });
}, Zd = ({
  items: r,
  isEmpty: i
}) => /* @__PURE__ */ t.jsx(le, { pt: 1, textAlign: "left", children: r.map((a, s) => {
  const l = a.color || sr(s, i);
  return /* @__PURE__ */ t.jsx(
    le,
    {
      title: a.name || "",
      sx: {
        fontSize: 13,
        color: "#474850",
        mb: 0.5,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        "::before": {
          content: '""',
          height: "8px",
          width: "8px",
          backgroundColor: l,
          borderRadius: "50%",
          display: "inline-block",
          mr: 0.5
        }
      },
      children: a.name ? "— " + a.name : ""
    },
    `item-${s}`
  );
}) }), UC = ({
  setTimesUnit: r,
  timesUnit: i,
  targetCohorts: a,
  isEmpty: s
}) => /* @__PURE__ */ t.jsxs(le, { children: [
  /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, textAlign: "right", mt: 1, children: /* @__PURE__ */ t.jsxs(Es, { children: [
    /* @__PURE__ */ t.jsx(
      ct,
      {
        variant: i === "days" ? "contained" : "outlined",
        onClick: () => r("days"),
        color: "info",
        children: "days"
      }
    ),
    /* @__PURE__ */ t.jsx(
      ct,
      {
        variant: i === "months" ? "contained" : "outlined",
        onClick: () => r("months"),
        color: "info",
        children: "months"
      }
    ),
    /* @__PURE__ */ t.jsx(
      ct,
      {
        variant: i === "years" ? "contained" : "outlined",
        onClick: () => r("years"),
        color: "info",
        children: "years"
      }
    )
  ] }) }),
  !s && /* @__PURE__ */ t.jsx(Zd, { items: a })
] }), GC = ({ data: r, targetCohorts: i = [], selectedCohorts: a }) => {
  const s = rd(r, "targetCohortId"), l = Pe(() => i.reduce((c, m) => (c[m.id] = m, c), {}), [i]);
  return /* @__PURE__ */ t.jsx(g, { container: !0, spacing: 2, children: Object.keys(s).map(
    (c) => a.find((m) => m.id == c) ? /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, sm: 6, md: 4, xl: 3, children: [
      /* @__PURE__ */ t.jsx(
        ve,
        {
          variant: "subtitle2",
          component: "span",
          sx: { color: "#0d1b40", fontWeight: 600 },
          children: l[c].name
        }
      ),
      /* @__PURE__ */ t.jsx(Ci, { outlined: !0, children: /* @__PURE__ */ t.jsx(
        Ct,
        {
          columns: [
            {
              header: "Comparison",
              accessorFn: (m) => m.stratum1 === "all" ? "Overall" : m.stratum1 + " vs " + m.stratum2,
              size: 180
            },
            {
              header: "Chi-square",
              accessorKey: "chisq",
              cell: ({ getValue: m }) => m().toFixed(4),
              size: 100
            },
            {
              header: "P-value",
              accessorKey: "pvalue",
              cell: ({ getValue: m }) => m().toFixed(4),
              size: 100
            }
          ],
          data: s[c],
          hideSettings: !0,
          hidePagination: !0
        }
      ) })
    ] }, c) : ""
  ) });
}, KC = {
  overall: "Total",
  age_group: "Age Groups",
  gender: "Gender"
}, qC = ({
  stratas: r,
  data: i,
  targetCohorts: a,
  title: s,
  eventCohort: l,
  autoScale: c = !1,
  ticks: m,
  summaries: j,
  formatTicks: h,
  pValueData: d
}) => {
  var A;
  const [f, C] = xs.useState(
    a.slice(0, 1)
  ), [v, b] = xs.useState(r), E = Pe(
    () => a == null ? void 0 : a.reduce((R, D, _) => (R[D.id] = r.reduce((F, P, x) => {
      var w;
      const p = ((w = P.split("=")) == null ? void 0 : w[1]) || P, y = sr(_ + x * (r.length + x), !1);
      return F[p] = { name: p, color: y, cohortName: D.name }, F;
    }, {}), R), {}),
    [a, r]
  );
  return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, mt: 1, children: /* @__PURE__ */ t.jsxs(
    Re,
    {
      title: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        KC[s] || s,
        " ",
        /* @__PURE__ */ t.jsxs(ve, { fontWeight: 400, component: "span", fontSize: "small", children: [
          ": ",
          v.join(", ")
        ] })
      ] }),
      size: "dense",
      outlined: !0,
      children: [
        /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", mb: 1, spacing: 2, children: [
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, sm: 7, md: 8, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              Vt,
              {
                multiple: !0,
                fullWidth: !0,
                value: f || [],
                onChange: (R, D) => C(D),
                options: a,
                placeholder: "Select cohort...",
                getOptionLabel: function(R) {
                  var D;
                  return R.name || ((D = a.find((_) => _.id === R)) == null ? void 0 : D.name);
                },
                isOptionEqualToValue: (R, D) => R.id === D.id || R.id === D
              }
            ) })
          ] }),
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, sm: 5, md: 4, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Strata:" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              Vt,
              {
                multiple: !0,
                fullWidth: !0,
                value: v || [],
                onChange: (R, D) => b(D),
                options: r,
                placeholder: "Select stratas...",
                getOptionLabel: function(R) {
                  return R;
                },
                isOptionEqualToValue: (R, D) => R === D
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ t.jsx(g, { item: !0, maxWidth: "calc(100% - 300px)", flexGrow: 1, flexBasis: "75%", children: /* @__PURE__ */ t.jsx(
            Xd,
            {
              data: i,
              stratas: v,
              targetCohorts: f,
              eventCohort: l,
              autoScale: c,
              height: 400,
              ticks: m,
              summaries: j,
              formatTicks: h,
              showStrata: !0,
              dataConfig: E
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, minWidth: 300, flexBasis: "25%", children: (A = Object.entries(E)) == null ? void 0 : A.map(([R, D]) => f.find((_) => _.id == R) ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mt: 1, children: Object.values(D)[0].cohortName }, R + "title"),
            /* @__PURE__ */ t.jsx(le, { ml: 1, children: /* @__PURE__ */ t.jsx(
              Zd,
              {
                items: Object.values(D).filter(
                  (_) => v.includes(_.name)
                )
              }
            ) }, R + "legend")
          ] }) : "") })
        ] }),
        /* @__PURE__ */ t.jsx(g, { container: !0, mt: 2, children: /* @__PURE__ */ t.jsx(
          GC,
          {
            data: d,
            targetCohorts: a,
            selectedCohorts: f
          }
        ) })
      ]
    }
  ) });
}, YC = ({
  targetCohorts: r,
  eventCohort: i,
  data: a
}) => {
  var R, D;
  const [s, l] = be(r), [c, m] = xs.useState(!1), [j, h] = be("days"), d = Pe(
    () => a.survivalSummaries.filter(
      (_) => _.outcomeCohortId === i.id && s.some((F) => F.id === _.targetCohortId) && _.stratum === "overall"
    ).map((_) => ({
      ..._,
      targetCohort: r.find((F) => F.id === _.targetCohortId)
    })),
    [a, i, s, r]
  ), f = Pe(() => r.reduce((_, F) => {
    var P, x;
    return _[F.id] || (_[F.id] = (x = (P = a.survivalData[F.id]) == null ? void 0 : P[i.id]) == null ? void 0 : x.overall), _;
  }, {}), [a, r, i]), C = Pe(() => {
    const _ = s.reduce((F, P) => (F.push(...(f == null ? void 0 : f[P.id]) || []), F), []) || [];
    return BC(_.map((F) => F.time));
  }, []), v = Pe(() => zC(s, i, a), [f, s]), b = Pe(() => HC(
    v.stratas.filter(
      (_) => typeof _ == "string" && _ !== "overall"
    )
  ), [v.stratas]), E = Jt(
    (_) => _.filter((F) => F.outcomeCohortId === i.id),
    [a, i]
  ), A = Jt(
    (_) => {
      switch (j) {
        case "days":
          return _;
        case "months": {
          const F = Math.floor(_ / 30);
          return F > 0 ? F : "";
        }
        case "years": {
          const F = Math.floor(_ / 360);
          return F > 0 ? F : "0";
        }
      }
    },
    [j]
  );
  return /* @__PURE__ */ t.jsxs(
    g,
    {
      container: !0,
      sx: {
        ".content-block__title": {
          padding: 0
        }
      },
      children: [
        /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
          /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", mb: 1, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Cohort:" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              Vt,
              {
                multiple: !0,
                fullWidth: !0,
                value: s || [],
                onChange: (_, F) => l(F),
                options: r,
                placeholder: "Select cohort...",
                getOptionLabel: function(_) {
                  var F;
                  return _.name || ((F = r.find((P) => P.id === _)) == null ? void 0 : F.name);
                },
                isOptionEqualToValue: (_, F) => _.id === F.id || _.id === F
              }
            ) })
          ] }),
          v.data.length !== 0 && /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
            /* @__PURE__ */ t.jsx(Ta, { title: "Kaplan-Meier curve", children: /* @__PURE__ */ t.jsxs(
              le,
              {
                component: "label",
                sx: {
                  fontSize: 12
                },
                children: [
                  "Auto-adjust Y-axis",
                  /* @__PURE__ */ t.jsx(
                    At,
                    {
                      checked: c,
                      onChange: (_) => m(_.target.checked),
                      size: "small",
                      sx: { ml: 1 }
                    }
                  )
                ]
              }
            ) }),
            /* @__PURE__ */ t.jsx(le, { height: "400px", children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
              /* @__PURE__ */ t.jsx(
                g,
                {
                  item: !0,
                  maxWidth: "calc(100% - 300px)",
                  flexGrow: 1,
                  flexBasis: "75%",
                  children: /* @__PURE__ */ t.jsx(
                    Xd,
                    {
                      data: v.data,
                      stratas: ["overall"],
                      targetCohorts: s,
                      eventCohort: i,
                      autoScale: c,
                      ticks: C,
                      summaries: d,
                      formatTicks: A
                    }
                  )
                }
              ),
              /* @__PURE__ */ t.jsx(g, { item: !0, minWidth: 300, flexBasis: "25%", children: /* @__PURE__ */ t.jsx(
                UC,
                {
                  targetCohorts: s,
                  setTimesUnit: h,
                  timesUnit: j,
                  isEmpty: ((R = v.data) == null ? void 0 : R.length) === 0
                }
              ) })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
          /* @__PURE__ */ t.jsx(Ta, { title: "# at risk" }),
          /* @__PURE__ */ t.jsx(
            Ct,
            {
              columns: [
                {
                  header: "Target Cohort / Time",
                  accessorKey: "targetCohort.name",
                  size: 250
                },
                ...C.map((_) => ({
                  header: _.toString(),
                  accessorKey: _.toString(),
                  size: 80,
                  meta: { align: "center", headerAlign: "center" },
                  cell: ({ getValue: F }) => F() != null ? te(F()) : "-"
                }))
              ],
              data: v.nRisk,
              hasFilters: !0,
              hideSettings: !0
            }
          )
        ] }),
        /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, children: [
          /* @__PURE__ */ t.jsx(Ta, { title: "Estimate summary" }),
          /* @__PURE__ */ t.jsx(
            Ct,
            {
              data: d,
              columns: WC,
              hideSettings: !0
            }
          )
        ] }),
        ((D = Object.keys(b)) == null ? void 0 : D.length) > 0 && Object.keys(b).map(
          (_) => {
            var F;
            return (F = b[_]) != null && F.length ? /* @__PURE__ */ t.jsx(
              qC,
              {
                stratas: b[_],
                data: v.data,
                targetCohorts: r,
                title: _,
                eventCohort: i,
                autoScale: c,
                ticks: C,
                summaries: d.filter((P) => P.stratum === _),
                formatTicks: A,
                pValueData: E(
                  _ === "gender" ? a.logRankGender : a.logRankAgeGroup
                )
              }
            ) : "";
          }
        )
      ]
    }
  );
}, FS = $e((r) => {
  const { data: i } = r, a = i.targetCohorts, s = i.eventCohorts, l = Pe(() => VC(i), [i]);
  return s.map((c) => /* @__PURE__ */ t.jsx(le, { mb: 2, children: /* @__PURE__ */ t.jsx(
    Re,
    {
      elevated: !0,
      outlined: !0,
      collapsible: !0,
      title: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx("b", { children: "Outcome: " }),
        c.name
      ] }),
      size: "dense",
      children: /* @__PURE__ */ t.jsx(
        YC,
        {
          targetCohorts: a,
          eventCohort: c,
          data: l
        }
      )
    },
    c.id
  ) }, c.id));
}), Ts = [
  { name: "Total cost", value: "total_cost" },
  { name: "Total paid", value: "total_paid" },
  { name: "Paid by payer", value: "paid_by_payer" },
  { name: "Paid by patient", value: "paid_by_patient" },
  { name: "Paid by patient copay", value: "paid_patient_copay" },
  { name: "Paid patient coinsurance", value: "paid_patient_coinsurance" },
  { name: "Paid patient deductible", value: "paid_patient_deductible" },
  { name: "Total charge", value: "total_charge" }
], XC = 100;
function ZC(r, i) {
  const a = (s) => s >= 1e6 ? `${(s / 1e6).toFixed(2)}M` : s >= 1e3 ? `${(s / 1e3).toFixed(2)}k` : `${s}`;
  return `${a(r)}-${a(i)}`;
}
function Jd(r) {
  const i = Math.max(0, Math.abs(r));
  return i <= 100 ? 1 : i <= 1e3 ? 10 : i <= 1e4 ? 100 : i <= 1e5 ? 1e3 : i <= 1e6 ? 1e4 : 1e5;
}
function JC(r, i) {
  const [a, s] = i, l = r.data.filter((j) => j.max >= a && j.min <= s).map((j) => j.min), c = r.data.map((j) => j.min), m = l.length > 0 ? l : c;
  return m.length ? Jd(Math.min(...m)) : 1;
}
function QC(r, i) {
  const a = [];
  let s = 1;
  for (; s <= i; )
    s >= r && a.push(s), s *= 10;
  return a.length ? a : [Math.max(1, r)];
}
function ej(r, i) {
  if (!r.length)
    return [];
  const [a, s] = i, l = Math.max(0, s - a), c = Jd(l), m = r.reduce((d, f) => Math.max(d, JC(f, i)), 1), j = Math.max(c, m), h = Math.max(j, l);
  return QC(j, h);
}
function tj(r, i, a = XC) {
  const s = Math.max(1, i), l = Math.max(0, r[1] - r[0]), c = l === 0 ? 1 : Math.ceil(l / s);
  return Math.max(1, Math.min(a, c));
}
function Qd(r) {
  if (!r.length)
    return { minCost: 0, maxCost: 0 };
  const i = r.flatMap((c) => c.data.map((m) => m.min)), a = r.flatMap((c) => c.data.map((m) => m.max));
  if (!i.length || !a.length)
    return { minCost: 0, maxCost: 0 };
  const s = Math.min(...i), l = Math.max(...a);
  return { minCost: s, maxCost: l };
}
function nj(r, i, a) {
  if (r > i) {
    const s = r - i;
    return Math.max(1, Math.trunc(s / a));
  }
  return 1;
}
function rj(r, i = 10, a, s) {
  if (!r.length || !r[0].data.length)
    return { bins: [], minCost: 0, maxCost: 0, binSize: 0 };
  const { minCost: l, maxCost: c } = Qd(r);
  let m = l, j = c;
  s && s.length === 2 && (m = Math.max(m, s[0]), j = Math.min(j, s[1])), j < m && (j = m);
  const h = Math.max(1, i), d = Math.max(
    1,
    a || nj(j, m, h)
  ), f = [];
  for (let C = 0; C < h; C++) {
    const v = m + C * d, b = v + d, E = {
      range: ZC(Math.round(v), Math.round(b)),
      rangeStart: Math.round(v),
      rangeEnd: Math.round(b)
    };
    r.forEach(({ data: A, id: R }) => {
      const _ = A.filter((F) => {
        const P = (F.min + F.max) / 2;
        return P >= v && P < b || C === h - 1 && P === b;
      }).reduce((F, P) => F + P.personCount, 0);
      E[R] = _;
    }), f.push(E);
  }
  return { bins: f, minCost: m, maxCost: j, binSize: d };
}
const ij = [
  {
    header: "Target Cohort / Time",
    accessorKey: "targetCohort.name"
  },
  {
    header: "Avg",
    accessorKey: "avgValue",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 100
  },
  {
    header: "Std dev",
    accessorKey: "stdevValue",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 100
  },
  {
    header: "Min",
    accessorKey: "minValue",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "P10",
    accessorKey: "p10Value",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "P25",
    accessorKey: "p25Value",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Median",
    accessorKey: "medianValue",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "P75",
    accessorKey: "p75Value",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "P90",
    accessorKey: "p90Value",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Max",
    accessorKey: "maxValue",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Total cost",
    accessorKey: "totalCost",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPM",
    accessorKey: "costPppm",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPQ",
    accessorKey: "costPppq",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  },
  {
    header: "Cost PPPY",
    accessorKey: "costPppy",
    cell: ({ getValue: r }) => te(r(), 2, 2),
    size: 80
  }
], MS = [
  {
    name: "Target cohorts",
    value: "targetCohorts"
  }
], aj = [
  { value: rt.LESS_THAN, name: "less than" },
  { value: rt.LESS_OR_EQUAL_TO, name: "less or equal to" },
  { value: rt.EQUAL_TO, name: "equal to" },
  { value: rt.GREATER_THAN, name: "greater than" },
  { value: rt.GREATER_OR_EQUAL_TO, name: "greater or equal to" },
  { value: rt.BETWEEN, name: "between" },
  { value: rt.NOT_BETWEEN, name: "not between" }
], Aa = [rt.BETWEEN, rt.NOT_BETWEEN], Vu = "Start value must be less than end value", oj = "Start date cannot be later than end date", sj = "Both dates must be filled or left empty", eh = "__select_all__", Uu = { name: "Select all", value: eh }, lj = (r, i) => r.name.localeCompare(i.name), cj = (r, i) => r.localeCompare(i), Sa = [...Ts].sort(lj), ms = [
  "Condition",
  "Device",
  "Drug",
  "Measurement",
  "Observation",
  "Procedure",
  "Visit"
].sort(cj), Gu = (r) => {
  const i = gs(r, Tt.ISO_DATE);
  return !i || i === "Invalid date" ? null : i;
}, Fa = (r) => {
  if (r == null || r === "")
    return null;
  const i = Number(r);
  return Number.isNaN(i) ? null : Math.max(i, 0);
}, uj = (r) => {
  if (!r)
    return {
      Op: rt.GREATER_THAN,
      Value: null,
      Extent: null
    };
  const i = r.Op, a = i === rt.BETWEEN || i === "between" || i === "beetwen" ? rt.BETWEEN : i === rt.NOT_BETWEEN || i === "not between" || i === "not beetwen" ? rt.NOT_BETWEEN : i === rt.LESS_THAN || i === rt.LESS_OR_EQUAL_TO || i === rt.EQUAL_TO || i === rt.GREATER_THAN || i === rt.GREATER_OR_EQUAL_TO ? i : rt.GREATER_THAN;
  return {
    Op: a,
    Value: Fa(r.Value),
    Extent: Aa.includes(a) ? Fa(r.Extent) : null
  };
}, dj = (r) => ({
  StartDate: (r == null ? void 0 : r.StartDate) || null,
  EndDate: (r == null ? void 0 : r.EndDate) || null
}), bi = (r) => (r == null ? void 0 : r.value) === eh, Ku = (r, i) => (a, s, { selected: l }) => [
  /* @__PURE__ */ t.jsxs(
    le,
    {
      ...a,
      sx: { fontSize: 13, height: "28px" },
      onClick: bi(s) ? i : a.onClick,
      children: [
        /* @__PURE__ */ t.jsx(
          At,
          {
            sx: { mr: 1 },
            checked: bi(s) ? r : l,
            size: "small"
          }
        ),
        s.name || s
      ]
    }
  ),
  bi(s) ? /* @__PURE__ */ t.jsx(zt, {}, "divider") : ""
], kS = $e((r) => {
  var ie, K;
  const {
    subModules: i,
    parentId: a,
    design: s,
    id: l,
    typeContainer: c,
    updateDesign: m,
    analysisName: j,
    viewMode: h
  } = r, [d, f] = be(
    s.window || {
      startWith: "start",
      startOffset: 0,
      endWith: "start",
      endOffset: 365
    }
  ), [C, v] = be(
    uj(s.visitLength)
  ), [b, E] = be(
    dj({
      StartDate: s.dateRangeStart,
      EndDate: s.dateRangeEnd
    })
  ), A = Aa.includes(
    C.Op
  ), R = A && C.Value !== null && C.Extent !== null && Number(C.Value) >= Number(C.Extent), D = A && R, _ = b.StartDate ?? null, F = b.EndDate ?? null, P = !!_ != !!F, x = !!(_ && F && _ > F), p = P || x, y = P ? sj : x ? oj : "", w = (N) => (B) => {
    m(N, B);
  }, M = s.costMeasures || [], V = M.length === Sa.length, q = s.domainsToUse || [], $ = q.length === ms.length, I = () => {
    m(
      "costMeasures",
      V ? [] : Sa.map((N) => N.value)
    );
  }, k = (N) => {
    N.preventDefault(), I();
  }, G = () => {
    m("domainsToUse", $ ? [] : ms);
  }, X = (N) => {
    N.preventDefault(), G();
  };
  return kt(() => {
    m("window", d);
  }, [d]), kt(() => {
    m("visitLength", {
      Op: C.Op,
      Value: C.Value,
      Extent: C.Extent
    });
  }, [C]), kt(() => {
    m("dateRangeStart", b.StartDate), m("dateRangeEnd", b.EndDate);
  }, [b]), /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, children: [
    (!h || h && ((ie = s == null ? void 0 : s.targetCohorts) == null ? void 0 : ie.length) > 0) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(wi, { children: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx("b", { children: "Cost utilization" }),
        " measures and normalizes healthcare costs from standardized data, enabling breakdowns by clinical areas or defined concept sets."
      ] }) }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        i.cohort,
        {
          type: "component",
          name: "widget-cohort-import-button",
          subModules: i,
          path: It(c, l, a),
          config: {
            buttonText: "Import target cohort",
            titleText: /* @__PURE__ */ t.jsx(
              Ot,
              {
                title: "Target cohorts",
                count: (K = s == null ? void 0 : s.targetCohorts) == null ? void 0 : K.length
              }
            ),
            classNameContainer: "target-import-button",
            typeContainer: c,
            initialData: s == null ? void 0 : s.targetCohorts,
            onChange: w("targetCohorts"),
            isSelect: !0,
            parentId: a,
            returnEntityText: j,
            collapsible: !0,
            defaultState: !0,
            viewMode: h
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      i.concept,
      {
        type: "component",
        name: "widget-concept-set-import-button",
        subModules: i,
        viewMode: h,
        config: {
          buttonText: "Import Concept Sets",
          titleText: "Concept Sets",
          classNameContainer: "target-import-button",
          typeContainer: c,
          initialData: s == null ? void 0 : s.conceptSets,
          onChange: (N) => {
            m("conceptSets", N);
          },
          parentId: a,
          returnEntityText: j,
          viewMode: h,
          description: "Additionally calculate cost associated with specific concept sets (one chart).",
          isSelect: !0
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      Re,
      {
        collapsible: !0,
        title: "Analysis Settings",
        defaultState: h,
        elevated: !0,
        outlined: !0,
        children: /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
          /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, px: 1, children: [
            /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mb: 1, children: "The following set of parameters will be used when performing the analysis." }),
            /* @__PURE__ */ t.jsx(zt, { sx: { borderColor: "borderColor.light" } })
          ] }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "costMeasures",
              textLabel: "Cost measures",
              labelSize: 5,
              description: "Select one or more cost measures to compute.",
              children: /* @__PURE__ */ t.jsx(
                Vt,
                {
                  name: "costMeasures",
                  multiple: !0,
                  id: "costMeasures",
                  options: [Uu, ...Sa],
                  value: M,
                  placeholder: "Select...",
                  fullWidth: !0,
                  onChange: (N, B) => {
                    if (B.some(bi)) {
                      I();
                      return;
                    }
                    m(
                      "costMeasures",
                      B.map(
                        (oe) => typeof oe == "string" ? oe : oe.value
                      )
                    );
                  },
                  disabled: h,
                  disableCloseOnSelect: !0,
                  disableClearable: !1,
                  OptionComponent: Ku(
                    V,
                    k
                  ),
                  getOptionLabel: function(N) {
                    var B;
                    return (N == null ? void 0 : N.name) ?? ((B = Sa.find(
                      (oe) => oe.value === N || oe.value === (N == null ? void 0 : N.value)
                    )) == null ? void 0 : B.name) ?? N;
                  },
                  isOptionEqualToValue: (N, B) => N.value === B || N.value === (B == null ? void 0 : B.value)
                }
              )
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "excludeNegativeCosts",
              textLabel: "Exclude negative costs",
              labelSize: 5,
              description: "Filter out events with negative cost values from analyses.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "excludeNegativeCosts",
                  name: "excludeNegativeCosts",
                  onChange: () => {
                    m(
                      "excludeNegativeCosts",
                      !s.excludeNegativeCosts
                    );
                  },
                  checked: s.excludeNegativeCosts,
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "excludeZeroCostPatients",
              textLabel: "Exclude zero costs",
              labelSize: 5,
              description: "Filter out patients (and their person-time) if their total cost for the specific analysis is zero.",
              children: /* @__PURE__ */ t.jsx(g, { item: !0, width: 150, children: /* @__PURE__ */ t.jsx(
                At,
                {
                  id: "excludeZeroCostPatients",
                  name: "excludeZeroCostPatients",
                  onChange: () => {
                    m(
                      "excludeZeroCostPatients",
                      !s.excludeZeroCostPatients
                    );
                  },
                  checked: s.excludeZeroCostPatients,
                  disabled: h
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ t.jsx(
            g,
            {
              item: !0,
              xs: 12,
              alignItems: "center",
              sx: {
                ".attribute-vocabulary .chip": { mb: 0.5 },
                ".start-text": { display: "none" }
              },
              children: /* @__PURE__ */ t.jsx(
                Ke,
                {
                  htmlFor: "visitConceptIds",
                  textLabel: "Visit",
                  labelSize: 5,
                  description: "Filter events to specific visit types.",
                  children: /* @__PURE__ */ t.jsx(
                    i.cohort,
                    {
                      type: "component",
                      name: "widget-attribute-vocabulary",
                      subModules: i,
                      config: {
                        id: "visitConceptIds",
                        value: s.visitConceptIds,
                        typeContainer: c,
                        // startText: 'Select',
                        attrName: "concepts",
                        domainId: "Visit",
                        onChange: (N, B) => {
                          m("visitConceptIds", B);
                        },
                        viewMode: h,
                        showSelectAll: !1
                      }
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "periodLength",
              textLabel: "Visit length",
              labelSize: 5,
              description: "Filter event from visits with corresponding duration.",
              children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, alignItems: "center", children: [
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  mn,
                  {
                    id: "periodLengthOp",
                    value: C.Op,
                    onChange: (N) => {
                      const B = N;
                      v((oe) => ({
                        ...oe,
                        Op: B,
                        Extent: Aa.includes(B) ? 1 : null
                      }));
                    },
                    options: aj,
                    placeholder: "Select option..."
                  }
                ) }),
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  Nt,
                  {
                    text: D ? Vu : "",
                    disabled: !D,
                    children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(
                      $n,
                      {
                        value: C.Value,
                        type: "number",
                        onChange: (N) => v((B) => ({
                          ...B,
                          Value: Fa(N.target.value)
                        })),
                        min: 0,
                        error: D,
                        sx: { width: 180 }
                      }
                    ) })
                  }
                ) }),
                Aa.includes(C.Op) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
                  /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { fontSize: 13, children: "and" }) }),
                  /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                    Nt,
                    {
                      text: D ? Vu : "",
                      disabled: !D,
                      children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(
                        $n,
                        {
                          value: C.Extent,
                          type: "number",
                          onChange: (N) => v((B) => ({
                            ...B,
                            Extent: Fa(
                              N.target.value
                            )
                          })),
                          min: 0,
                          error: D,
                          sx: { width: 180 }
                        }
                      ) })
                    }
                  ) })
                ] }),
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { fontSize: 13, children: "days" }) })
              ] })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "eventDateRange",
              textLabel: "Event date range",
              labelSize: 5,
              description: "Filter events to ones starting/ending within the specified date range.",
              children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 2, alignItems: "center", children: [
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { fontSize: 13, children: "event start date" }) }),
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  Nt,
                  {
                    text: y,
                    disabled: !p,
                    children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(
                      jr,
                      {
                        fullWidth: !1,
                        value: b.StartDate,
                        error: p,
                        format: Tt.DATEPICKER_DATE,
                        onChange: (N) => E((B) => ({
                          ...B,
                          StartDate: Gu(N)
                        })),
                        name: "eventDateRangeStartDate"
                      }
                    ) })
                  }
                ) }),
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { fontSize: 13, children: "event end date" }) }),
                /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(
                  Nt,
                  {
                    text: y,
                    disabled: !p,
                    children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(
                      jr,
                      {
                        fullWidth: !1,
                        value: b.EndDate,
                        error: p,
                        format: Tt.DATEPICKER_DATE,
                        onChange: (N) => E((B) => ({
                          ...B,
                          EndDate: Gu(N)
                        })),
                        name: "eventDateRangeEndDate"
                      }
                    ) })
                  }
                ) })
              ] })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "window",
              textLabel: "Window",
              labelSize: 5,
              description: "Analysis time window adjustments.",
              children: /* @__PURE__ */ t.jsxs(g, { container: !0, spacing: 1, children: [
                /* @__PURE__ */ t.jsxs(
                  g,
                  {
                    item: !0,
                    flexWrap: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ t.jsx(ve, { fontSize: 13, mr: 1, children: "starting with" }),
                      /* @__PURE__ */ t.jsx(
                        mn,
                        {
                          id: "startWith",
                          value: d.startWith,
                          onChange: (N) => f((B) => ({ ...B, startWith: N })),
                          options: [
                            { value: "end", name: "end" },
                            { value: "start", name: "start" }
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t.jsxs(
                  g,
                  {
                    item: !0,
                    flexWrap: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ t.jsx(ve, { fontSize: 13, mr: 1, children: "+" }),
                      /* @__PURE__ */ t.jsx(
                        $n,
                        {
                          value: d.startOffset,
                          type: "number",
                          onChange: (N) => f((B) => ({
                            ...B,
                            startOffset: Number(N.target.value)
                          })),
                          sx: { width: 100 }
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t.jsxs(
                  g,
                  {
                    item: !0,
                    flexWrap: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ t.jsx(ve, { fontSize: 13, mr: 1, children: "days ending with" }),
                      /* @__PURE__ */ t.jsx(
                        mn,
                        {
                          name: "endWith",
                          value: d.endWith,
                          onChange: (N) => f((B) => ({ ...B, endWith: N })),
                          options: [
                            { value: "end", name: "end" },
                            { value: "start", name: "start" }
                          ],
                          placeholder: "start with..."
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t.jsxs(
                  g,
                  {
                    item: !0,
                    flexWrap: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ t.jsx(ve, { fontSize: 13, mr: 1, children: "+" }),
                      /* @__PURE__ */ t.jsx(
                        $n,
                        {
                          value: d.endOffset,
                          type: "number",
                          onChange: (N) => f((B) => ({
                            ...B,
                            endOffset: Number(N.target.value)
                          })),
                          min: 0,
                          sx: { width: 100 }
                        }
                      ),
                      /* @__PURE__ */ t.jsx(ve, { fontSize: 13, ml: 1, children: "days" })
                    ]
                  }
                )
              ] })
            }
          ) }),
          /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
            Ke,
            {
              htmlFor: "domainsToUse",
              textLabel: "Domains",
              description: "Additionally calculate cost associated with specific selected domain(s) (one chart per domain).",
              labelSize: 5,
              children: /* @__PURE__ */ t.jsx(
                Vt,
                {
                  name: "domainsToUse",
                  multiple: !0,
                  id: "domainsToUse",
                  options: [Uu, ...ms],
                  value: q,
                  placeholder: "Select...",
                  onChange: (N, B) => {
                    if (B.some(bi)) {
                      G();
                      return;
                    }
                    m(
                      "domainsToUse",
                      B.map((oe) => oe)
                    );
                  },
                  disabled: h,
                  disableCloseOnSelect: !0,
                  disableClearable: !1,
                  OptionComponent: Ku(
                    $,
                    X
                  ),
                  getOptionLabel: function(N) {
                    return (N == null ? void 0 : N.name) || N;
                  },
                  isOptionEqualToValue: (N, B) => N === B
                }
              )
            }
          ) })
        ] })
      }
    ) })
  ] });
}), hj = ({ histogramData: r, datasets: i, targetCohorts: a }) => {
  const s = Vn(i, "id"), l = Vn(a, "id");
  return /* @__PURE__ */ t.jsx(Un, { width: "100%", height: "100%", children: /* @__PURE__ */ t.jsxs(
    Rs,
    {
      data: r,
      margin: { top: 20, right: 10, left: 10, bottom: 60 },
      children: [
        /* @__PURE__ */ t.jsx(_i, { strokeDasharray: "3 3", stroke: "#e5e7eb" }),
        /* @__PURE__ */ t.jsx(
          Ei,
          {
            dataKey: "range",
            angle: -45,
            textAnchor: "end",
            style: { fontSize: "12px" }
          }
        ),
        /* @__PURE__ */ t.jsx(
          Ai,
          {
            label: {
              value: "Number of People",
              angle: -90,
              position: "insideLeft",
              fontSize: "12px"
            },
            style: { fontSize: "12px" },
            type: "number",
            domain: [0, "dataMax"]
          }
        ),
        /* @__PURE__ */ t.jsx(
          wr,
          {
            contentStyle: {
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              border: "1px solid #e5e7eb",
              borderRadius: "6px"
            },
            content: ({ payload: c }) => {
              var d, f, C, v;
              const m = (f = (d = c[0]) == null ? void 0 : d.payload) == null ? void 0 : f.rangeEnd, j = (v = (C = c[0]) == null ? void 0 : C.payload) == null ? void 0 : v.rangeStart;
              let h = [
                /* @__PURE__ */ t.jsxs(le, { p: 1, bgcolor: "white", boxShadow: 3, children: [
                  "Range: ",
                  te(j),
                  " - ",
                  te(m)
                ] }, "range")
              ];
              return c.forEach((b, E) => {
                var D, _, F;
                const A = b == null ? void 0 : b.dataKey, R = (b == null ? void 0 : b.color) || (b == null ? void 0 : b.fill);
                A && h.push(
                  /* @__PURE__ */ t.jsxs(
                    le,
                    {
                      color: R,
                      p: 1,
                      bgcolor: "white",
                      boxShadow: 3,
                      children: [
                        /* @__PURE__ */ t.jsx("b", { children: "Target cohort" }),
                        " : ",
                        (D = s[A]) == null ? void 0 : D.name,
                        /* @__PURE__ */ t.jsx("br", {}),
                        /* @__PURE__ */ t.jsx("b", { children: "Number of People" }),
                        " :",
                        " ",
                        (F = (_ = b == null ? void 0 : b.payload) == null ? void 0 : _[A]) == null ? void 0 : F.toFixed(0)
                      ]
                    },
                    A
                  )
                );
              }), /* @__PURE__ */ t.jsx(le, { fontSize: 13, children: h });
            }
          }
        ),
        i.map(
          (c, m) => l[c.id] ? /* @__PURE__ */ t.jsx(
            Ps,
            {
              dataKey: c.id,
              fill: Wn(0.5, c.color || sr(m, !1))
            },
            c.id
          ) : ""
        )
      ]
    }
  ) });
}, fj = py(dy);
function pj(r, i) {
  return r.map((s, l) => [
    {
      type: "box",
      name: s.cohortName,
      y: [s.cohortName],
      lowerfence: [s.p10Value],
      q1: [s.p25Value],
      median: [s.medianValue],
      q3: [s.p75Value],
      upperfence: [s.p90Value],
      line: {
        width: 1
      },
      jitter: 0.3,
      pointpos: -1.8,
      orientation: "h",
      marker: {
        color: Wn(0.5, s.color || sr(l, !1))
      },
      hoverinfo: "skip",
      showlegend: !1
    },
    // this scatter is used to show detailed hover info, since box plot hover is very limited
    // I suggest we keep it like this until plotly supports better hover for box plots or we create custom tooltip
    {
      type: "scatter",
      mode: "markers",
      x: [s.medianValue || s.maxValue || s.minValue],
      y: [s.cohortName],
      marker: {
        size: 10,
        opacity: 0
      },
      hovertemplate: "Min: " + s.minValue + "<br>P10: " + s.p10Value + "<br>P25: " + s.p25Value + "<br>Median: " + s.medianValue + "<br>P75: " + s.p75Value + "<br>P90: " + s.p90Value + "<br>Max: " + s.maxValue + "<extra></extra>",
      showlegend: !1
    },
    ...i ? [] : [
      {
        type: "scatter",
        mode: "markers",
        name: `${s.cohortName} Min`,
        x: [s.minValue],
        y: [s.cohortName],
        marker: {
          size: 8,
          color: Wn(0.5, s.color || sr(l, !1)),
          symbol: "circle",
          line: { color: "white", width: 2 }
        },
        hoverinfo: "skip",
        showlegend: !1
      },
      {
        type: "scatter",
        mode: "markers",
        name: `${s.cohortName} Max`,
        x: [s.maxValue],
        y: [s.cohortName],
        marker: {
          size: 8,
          color: Wn(0.5, s.color || sr(l, !1)),
          symbol: "circle",
          line: { color: "white", width: 2 }
        },
        hoverinfo: "skip",
        showlegend: !1
      }
    ]
  ]).flat();
}
const mj = {
  xaxis: {
    gridcolor: "#e5e7eb"
  },
  yaxis: {
    visible: !1,
    zeroline: !1
  },
  showlegend: !1,
  hovermode: "y unified",
  margin: {
    l: 0,
    // Left margin
    r: 20,
    // Right margin
    b: 40,
    // Bottom margin
    t: 40,
    // Top margin
    pad: 5
    // Padding between the plot area and the axis labels/titles
  }
}, xj = {
  responsive: !0,
  displayModeBar: !0,
  displaylogo: !1,
  modeBarButtonsToRemove: [
    "pan2d",
    "lasso2d",
    "select2d",
    "resetScale2d",
    "zoom"
  ]
}, gj = ({ data: r }) => {
  const [i, a] = be(!1), s = (r == null ? void 0 : r.length) * 40 + 60, l = Pe(
    () => pj(r, i),
    [r, i]
  );
  return /* @__PURE__ */ t.jsxs(
    le,
    {
      sx: {
        minHeight: s,
        position: "relative",
        ".main-svg": {
          overflow: "visible",
          ".hoverlayer": {
            zIndex: 2
          }
        }
      },
      children: [
        /* @__PURE__ */ t.jsx(le, { sx: { minHeight: s }, children: /* @__PURE__ */ t.jsx(
          fj,
          {
            data: l,
            config: xj,
            style: { width: "100%", height: "100%" },
            layout: {
              ...mj,
              height: s
            }
          }
        ) }),
        /* @__PURE__ */ t.jsxs(
          le,
          {
            component: "label",
            sx: {
              fontSize: 12
            },
            children: [
              /* @__PURE__ */ t.jsx(
                At,
                {
                  checked: i,
                  onChange: (c) => a(c.target.checked),
                  size: "small",
                  sx: { mr: 1 }
                }
              ),
              "Hide Min/Max"
            ]
          }
        )
      ]
    }
  );
}, vj = ({
  data: r,
  title: i,
  targetCohorts: a,
  costMeasures: s,
  outliersDetectionMethods: l
}) => {
  const [c, m] = be(
    a ?? []
  ), [j, h] = be(s == null ? void 0 : s[0]), [d, f] = be(null), [C, v] = be([0, 0]), b = Pe(
    () => a.reduce((y, w, M) => (y[w.id] = sr(M, !1), y), {}),
    [a]
  ), E = Pe(
    () => a.reduce((y, w) => (Object.keys((r == null ? void 0 : r[w.id]) || {}).forEach((V) => y.add(V)), y), /* @__PURE__ */ new Set()),
    [r, a]
  );
  kt(() => {
    h([...E][0] ?? "total_chrge");
  }, [E]), kt(() => {
    m(a ?? []);
  }, [a]);
  const A = Pe(() => j ? c.reduce((y, w) => {
    var V, q;
    const M = (q = (V = r[w.id]) == null ? void 0 : V[j]) == null ? void 0 : q.histogram;
    if (M) {
      const $ = M.map((I) => ({
        ...I,
        personCount: d && I.outlierMethod ? I.outlierMethod[d] ?? I.personCount : I.personCount
      }));
      y.push({
        name: w.name,
        id: w.id,
        data: $,
        color: b[w.id]
      });
    }
    return y;
  }, []) : [], [r, j, d, c, b]), { minCost: R, maxCost: D } = Pe(
    () => Qd(A),
    [A]
  ), _ = Pe(
    () => ej(A, C)[0] ?? 1,
    [A, C]
  ), F = Pe(
    () => c.reduce((y, w) => {
      var $, I, k, G, X, ie;
      const M = (k = (I = ($ = r[w.id]) == null ? void 0 : $[j]) == null ? void 0 : I.distribution) == null ? void 0 : k.find(
        (K) => K.outlierMethod === (d || "No Outlier Removal")
      ), V = (ie = (X = (G = r[w.id]) == null ? void 0 : G[j]) == null ? void 0 : X.summary) == null ? void 0 : ie.find(
        (K) => K.outlierMethod === (d || "No Outlier Removal")
      ), q = {
        ...M ?? [],
        ...V ?? [],
        targetCohort: w
      };
      return q && y.push(q), y;
    }, []),
    [r, c, j, d]
  ), P = Pe(
    () => c.reduce((y, w) => {
      var q, $, I;
      const M = (I = ($ = (q = r[w.id]) == null ? void 0 : q[j]) == null ? void 0 : $.distribution) == null ? void 0 : I.find(
        (k) => k.outlierMethod === (d || "No Outlier Removal")
      ), V = {
        ...M ?? [],
        cohortId: w.id,
        cohortName: w.name,
        color: b[w.id]
        //   targetCohort: tc,
      };
      return M && y.push(V), y;
    }, []),
    [r, c, j, d]
  ), x = Pe(() => {
    const y = A.map((M) => ({
      ...M,
      data: M.data.filter(
        (V) => V.max >= C[0] && V.min <= C[1]
      )
    })), w = tj(C, _);
    return rj(
      y,
      w,
      _,
      C
    );
  }, [A, C, _]);
  kt(() => {
    v([R, D]);
  }, [R, D]);
  const p = (y, w) => {
    typeof w == "number" && v([R, w]);
  };
  return /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Re, { elevated: !0, outlined: !0, title: i, children: [
    /* @__PURE__ */ t.jsx(le, { display: "flex", alignItems: "center", children: /* @__PURE__ */ t.jsx(le, { flexGrow: 1, children: /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", flexWrap: "nowrap", children: [
      /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Cohorts:" }) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
        Vt,
        {
          multiple: !0,
          fullWidth: !0,
          value: c,
          onChange: (y, w) => m(w),
          options: a,
          placeholder: "Select cohort...",
          getOptionLabel: function(y) {
            var w;
            return y.name || ((w = a.find((M) => M.id === y)) == null ? void 0 : w.name);
          },
          isOptionEqualToValue: (y, w) => y.id === w.id || y.id === w
        }
      ) })
    ] }) }) }),
    /* @__PURE__ */ t.jsxs(g, { container: !0, children: [
      /* @__PURE__ */ t.jsxs(g, { item: !0, xs: 12, minHeight: 400, display: "flex", children: [
        /* @__PURE__ */ t.jsx(le, { flex: 1, children: /* @__PURE__ */ t.jsx(
          hj,
          {
            histogramData: x.bins,
            datasets: A,
            targetCohorts: c
          }
        ) }),
        /* @__PURE__ */ t.jsxs(le, { minWidth: 250, width: "25%", pl: 1, children: [
          /* @__PURE__ */ t.jsx(le, { pt: 2, children: /* @__PURE__ */ t.jsxs(le, { flexGrow: 1, children: [
            /* @__PURE__ */ t.jsx(g, { item: !0, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Cost measures:" }) }),
            /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
              Vt,
              {
                fullWidth: !0,
                value: j || null,
                onChange: (y, w) => h(w.value),
                options: Ts.filter(
                  (y) => E.has(y.value)
                ),
                placeholder: "Select cohort...",
                getOptionLabel: function(y) {
                  var w;
                  return y.name || ((w = Ts.find((M) => M.value === y)) == null ? void 0 : w.name);
                },
                isOptionEqualToValue: (y, w) => y.value === w.value || y.value === w,
                disableClearable: !0
              }
            ) })
          ] }) }),
          /* @__PURE__ */ t.jsx(le, { pt: 2, textAlign: "left", children: c.map((y, w) => {
            const M = b[y.id];
            return /* @__PURE__ */ t.jsx(
              le,
              {
                title: y.name || "",
                sx: {
                  fontSize: 13,
                  color: "#474850",
                  mb: 0.5,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  "::before": {
                    content: '""',
                    height: "8px",
                    width: "8px",
                    backgroundColor: Wn(0.5, M),
                    borderRadius: "50%",
                    display: "inline-block",
                    mr: 0.5
                  }
                },
                children: y.name ? "— " + y.name : ""
              },
              `item-${w}`
            );
          }) }),
          /* @__PURE__ */ t.jsx(zt, { sx: { mt: 2 } }),
          /* @__PURE__ */ t.jsxs(le, { pt: 2, children: [
            /* @__PURE__ */ t.jsx(le, { flexGrow: 1, children: /* @__PURE__ */ t.jsxs(g, { container: !0, alignItems: "center", mb: 2, children: [
              /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(ve, { variant: "subtitle2", mr: 1, children: "Exclude outliers method:" }) }),
              /* @__PURE__ */ t.jsx(g, { item: !0, flexGrow: 1, children: /* @__PURE__ */ t.jsx(
                Vt,
                {
                  fullWidth: !0,
                  value: d || null,
                  onChange: (y, w) => {
                    f(w);
                  },
                  options: l,
                  placeholder: "Select method...",
                  getOptionLabel: function(y) {
                    return y || "";
                  },
                  isOptionEqualToValue: (y, w) => y === w
                }
              ) })
            ] }) }),
            /* @__PURE__ */ t.jsxs(ve, { variant: "subtitle2", mr: 1, children: [
              "Cost range: ",
              te(R),
              " -",
              " ",
              te(C[1])
            ] }),
            /* @__PURE__ */ t.jsx(
              M0,
              {
                getAriaLabel: () => "Cost range",
                value: C[1],
                onChange: p,
                valueLabelDisplay: "auto",
                min: R,
                max: D,
                valueLabelFormat: te,
                getAriaValueText: te,
                size: "small",
                color: "info"
              }
            ),
            /* @__PURE__ */ t.jsxs(
              le,
              {
                sx: { display: "flex", justifyContent: "space-between" },
                mx: -0.75,
                mt: -1,
                fontSize: 12,
                children: [
                  /* @__PURE__ */ t.jsx(ve, { variant: "body2", sx: { cursor: "pointer" }, children: te(R, 0, 0) }),
                  /* @__PURE__ */ t.jsx(ve, { variant: "body2", sx: { cursor: "pointer" }, children: te(D, 0, 0) })
                ]
              }
            )
          ] })
        ] })
      ] }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        Ct,
        {
          hideSettings: !0,
          hidePagination: !0,
          columns: ij,
          data: F
        }
      ) }),
      /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(le, { children: /* @__PURE__ */ t.jsx(gj, { data: P }) }) })
    ] })
  ] }) });
}, zS = ({ data: r }) => {
  const {
    targetCohorts: i,
    costMeasures: a,
    domainsToUse: s,
    conceptSetNames: l,
    outliersDetectionMethods: c,
    ...m
  } = r;
  return /* @__PURE__ */ t.jsx(g, { container: !0, spacing: 2, children: Object.entries(m).map(
    ([j, h]) => h ? /* @__PURE__ */ t.jsx(g, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      vj,
      {
        data: h,
        title: /* @__PURE__ */ t.jsx(le, { sx: { textTransform: "capitalize" }, children: j === "overall" ? "Totals" : j === "conceptSet" ? "Concept set" : j }),
        targetCohorts: i,
        costMeasures: a,
        outliersDetectionMethods: c
      }
    ) }, j) : null
  ) });
};
export {
  AS as BulkCohortCounts,
  NS as BulkCohortCountsResults,
  gi as CaliperScale,
  Nj as Characterization,
  Iy as CharacterizationFaTypes,
  Ny as CharacterizationResultTypes,
  kj as CharacterizationResults,
  jS as CohortBasedDataCut,
  SS as CohortBasedDataCutResults,
  pi as ConvergenceType,
  kS as CostUtilization,
  zS as CostUtilizationResults,
  zj as Custom,
  Bj as CustomResults,
  Si as CvType,
  tC as Demographics,
  Hj as Estimation,
  Vj as EstimationResults,
  sS as Feasibility,
  dS as FeasibilityResults,
  Gj as Incidence,
  Zj as IncidenceResults,
  bn as MatchStratify,
  Tn as ModelType,
  mi as NoiseLevel,
  Cs as OccurrenceType,
  Jj as Pathway,
  aS as PathwayResults,
  oS as PathwayTemplate,
  fS as Prediction,
  pS as PredictionResults,
  br as PriorType,
  fi as RemoveDuplicateSubject,
  xi as SelectorType,
  gS as SimpleCount,
  pC as SimpleCountResults,
  yS as SimpleCountWithCharacterization,
  pC as SimpleCountWithCharacterizationResults,
  bS as Strategus,
  CS as StrategusResults,
  vi as StratificationBaseSelection,
  LS as TimeToEvent,
  FS as TimeToEventResult,
  Cn as Trim,
  OS as bulkCohortCountsTemplateList,
  Mj as characterizationTemplateList,
  ES as cohortBasedDataCutTemplateList,
  Uj as estimationTemplateList,
  hS as feasibilityTemplateList,
  DS as getBulkCohortCountsTemplate,
  Ij as getCharacterizationTemplate,
  wS as getDataCutTemplate,
  $j as getEstimationTemplate,
  lS as getFeasibilityTemplate,
  qj as getIncidenceTemplate,
  nS as getPathwayTemplate,
  mS as getPredictionTemplate,
  Qj as getSimpleCohortCharacterizationTemplate,
  Qj as getSimpleCohortTemplate,
  Kj as incidenceRateTemplateList,
  PS as parseBulkCohortCountsDesign,
  RS as parseBulkCohortCountsFormatResults,
  Fj as parseCharacterizationDesign,
  Lj as parseCharacterizationFormatResult,
  _S as parseDataCutDesign,
  TS as parseDataCutFormatResult,
  Wj as parseEstimationDesign,
  uS as parseFeasibilityDesign,
  cS as parseFeasibilityFormatResult,
  Xj as parseIncidenceDesign,
  Yj as parseIncidenceFormatResult,
  iS as parsePathwayDesign,
  rS as parsePathwayFormatResult,
  xS as parsePredictionDesign,
  tS as parseSimpleCountCharacterizationDesign,
  eS as parseSimpleCountCharacterizationFormatResult,
  tS as parseSimpleCountDesign,
  eS as parseSimpleCountFormatResult,
  A1 as pathwayTemplateList,
  vS as simpleCountCharacterizationTemplateList,
  vS as simpleCountTemplateList,
  MS as templateCostUtilization,
  IS as templateListTimeToEvent
};
//# sourceMappingURL=plugins.js.map
